import * as P from "react";
import ce, { createContext as Et, useMemo as qe, createElement as I, useContext as Ye, useCallback as Ie, useLayoutEffect as Ua, useRef as Z, useEffect as Ee, useState as Ce, forwardRef as M, Children as Tn, isValidElement as Oa, cloneElement as fr, Fragment as Jt, useReducer as mr, createRef as op, useImperativeHandle as t1 } from "react";
import * as Wr from "react-dom";
import ap, { flushSync as Vr, createPortal as ip } from "react-dom";
var n1 = (e) => e.type === "checkbox", r1 = (e) => e instanceof Date, sp = (e) => e == null;
const o1 = (e) => typeof e == "object";
var Ho = (e) => !sp(e) && !Array.isArray(e) && o1(e) && !r1(e), a1 = (e) => Ho(e) && e.target ? n1(e.target) ? e.target.checked : e.target.value : e, i1 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, s1 = (e, t) => e.has(i1(t)), c1 = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Ho(t) && t.hasOwnProperty("isPrototypeOf");
}, l1 = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Xl(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(l1 && (e instanceof Blob || e instanceof FileList)) && (n || Ho(e)))
    if (t = n ? [] : {}, !n && !c1(e))
      t = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (t[r] = Xl(e[r]));
  else
    return e;
  return t;
}
var cp = (e) => Array.isArray(e) ? e.filter(Boolean) : [], al = (e) => e === void 0, un = (e, t, n) => {
  if (!t || !Ho(e))
    return n;
  const r = cp(t.split(/[,[\].]+?/)).reduce((o, a) => sp(o) ? o : o[a], e);
  return al(r) || r === e ? al(e[t]) ? n : e[t] : r;
}, Nd = (e) => typeof e == "boolean", u1 = (e) => /^\w*$/.test(e), d1 = (e) => cp(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Rd = (e, t, n) => {
  let r = -1;
  const o = u1(t) ? [t] : d1(t), a = o.length, i = a - 1;
  for (; ++r < a; ) {
    const s = o[r];
    let c = n;
    if (r !== i) {
      const l = e[s];
      c = Ho(l) || Array.isArray(l) ? l : isNaN(+o[r + 1]) ? {} : [];
    }
    if (s === "__proto__")
      return;
    e[s] = c, e = e[s];
  }
  return e;
};
const Md = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, il = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, lp = ce.createContext(null), Es = () => ce.useContext(lp), f1 = (e) => {
  const { children: t, ...n } = e;
  return ce.createElement(lp.Provider, { value: n }, t);
};
var m1 = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(o, a, {
      get: () => {
        const i = a;
        return t._proxyFormState[i] !== il.all && (t._proxyFormState[i] = !r || il.all), n && (n[i] = !0), e[i];
      }
    });
  return o;
}, p1 = (e) => Ho(e) && !Object.keys(e).length, h1 = (e, t, n, r) => {
  n(e);
  const { name: o, ...a } = e;
  return p1(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((i) => t[i] === (!r || il.all));
}, v1 = (e) => Array.isArray(e) ? e : [e], up = (e, t, n) => !e || !t || e === t || v1(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function dp(e) {
  const t = ce.useRef(e);
  t.current = e, ce.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function g1(e) {
  const t = Es(), { control: n = t.control, disabled: r, name: o, exact: a } = e || {}, [i, s] = ce.useState(n._formState), c = ce.useRef(!0), l = ce.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), d = ce.useRef(o);
  return d.current = o, dp({
    disabled: r,
    next: (u) => c.current && up(d.current, u.name, a) && h1(u, l.current, n._updateFormState) && s({
      ...n._formState,
      ...u
    }),
    subject: n._subjects.state
  }), ce.useEffect(() => (c.current = !0, l.current.isValid && n._updateValid(!0), () => {
    c.current = !1;
  }), [n]), m1(i, n, l.current, !1);
}
var b1 = (e) => typeof e == "string", y1 = (e, t, n, r, o) => b1(e) ? (r && t.watch.add(e), un(n, e, o)) : Array.isArray(e) ? e.map((a) => (r && t.watch.add(a), un(n, a))) : (r && (t.watchAll = !0), n);
function x1(e) {
  const t = Es(), { control: n = t.control, name: r, defaultValue: o, disabled: a, exact: i } = e || {}, s = ce.useRef(r);
  s.current = r, dp({
    disabled: a,
    subject: n._subjects.values,
    next: (d) => {
      up(s.current, d.name, i) && l(Xl(y1(s.current, n._names, d.values || n._formValues, !1, o)));
    }
  });
  const [c, l] = ce.useState(n._getWatch(r, o));
  return ce.useEffect(() => n._removeUnmounted()), c;
}
function w1(e) {
  const t = Es(), { name: n, disabled: r, control: o = t.control, shouldUnregister: a } = e, i = s1(o._names.array, n), s = x1({
    control: o,
    name: n,
    defaultValue: un(o._formValues, n, un(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), c = g1({
    control: o,
    name: n
  }), l = ce.useRef(o.register(n, {
    ...e.rules,
    value: s,
    ...Nd(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return ce.useEffect(() => {
    const d = o._options.shouldUnregister || a, u = (v, m) => {
      const b = un(o._fields, v);
      b && b._f && (b._f.mount = m);
    };
    if (u(n, !0), d) {
      const v = Xl(un(o._options.defaultValues, n));
      Rd(o._defaultValues, n, v), al(un(o._formValues, n)) && Rd(o._formValues, n, v);
    }
    return () => {
      (i ? d && !o._state.action : d) ? o.unregister(n) : u(n, !1);
    };
  }, [n, o, i, a]), ce.useEffect(() => {
    un(o._fields, n) && o._updateDisabledField({
      disabled: r,
      fields: o._fields,
      name: n,
      value: un(o._fields, n)._f.value
    });
  }, [r, n, o]), {
    field: {
      name: n,
      value: s,
      ...Nd(r) || c.disabled ? { disabled: c.disabled || r } : {},
      onChange: ce.useCallback((d) => l.current.onChange({
        target: {
          value: a1(d),
          name: n
        },
        type: Md.CHANGE
      }), [n]),
      onBlur: ce.useCallback(() => l.current.onBlur({
        target: {
          value: un(o._formValues, n),
          name: n
        },
        type: Md.BLUR
      }), [n, o]),
      ref: (d) => {
        const u = un(o._fields, n);
        u && d && (u._f.ref = {
          focus: () => d.focus(),
          select: () => d.select(),
          setCustomValidity: (v) => d.setCustomValidity(v),
          reportValidity: () => d.reportValidity()
        });
      }
    },
    formState: c,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!un(c.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!un(c.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!un(c.touchedFields, n)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!un(c.validatingFields, n)
      },
      error: {
        enumerable: !0,
        get: () => un(c.errors, n)
      }
    })
  };
}
const E1 = (e) => e.render(w1(e));
var jt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $s(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var sl = { exports: {} }, aa = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dd;
function $1() {
  if (Dd)
    return aa;
  Dd = 1;
  var e = ce, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, c, l) {
    var d, u = {}, v = null, m = null;
    l !== void 0 && (v = "" + l), c.key !== void 0 && (v = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (d in c)
      r.call(c, d) && !a.hasOwnProperty(d) && (u[d] = c[d]);
    if (s && s.defaultProps)
      for (d in c = s.defaultProps, c)
        u[d] === void 0 && (u[d] = c[d]);
    return { $$typeof: t, type: s, key: v, ref: m, props: u, _owner: o.current };
  }
  return aa.Fragment = n, aa.jsx = i, aa.jsxs = i, aa;
}
var ia = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Id;
function T1() {
  return Id || (Id = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ce, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), b = Symbol.iterator, x = "@@iterator";
    function g(R) {
      if (R === null || typeof R != "object")
        return null;
      var ue = b && R[b] || R[x];
      return typeof ue == "function" ? ue : null;
    }
    var k = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(R) {
      {
        for (var ue = arguments.length, Re = new Array(ue > 1 ? ue - 1 : 0), Be = 1; Be < ue; Be++)
          Re[Be - 1] = arguments[Be];
        T("error", R, Re);
      }
    }
    function T(R, ue, Re) {
      {
        var Be = k.ReactDebugCurrentFrame, ut = Be.getStackAddendum();
        ut !== "" && (ue += "%s", Re = Re.concat([ut]));
        var gt = Re.map(function(rt) {
          return String(rt);
        });
        gt.unshift("Warning: " + ue), Function.prototype.apply.call(console[R], console, gt);
      }
    }
    var S = !1, C = !1, N = !1, U = !1, L = !1, j;
    j = Symbol.for("react.module.reference");
    function q(R) {
      return !!(typeof R == "string" || typeof R == "function" || R === r || R === a || L || R === o || R === l || R === d || U || R === m || S || C || N || typeof R == "object" && R !== null && (R.$$typeof === v || R.$$typeof === u || R.$$typeof === i || R.$$typeof === s || R.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      R.$$typeof === j || R.getModuleId !== void 0));
    }
    function V(R, ue, Re) {
      var Be = R.displayName;
      if (Be)
        return Be;
      var ut = ue.displayName || ue.name || "";
      return ut !== "" ? Re + "(" + ut + ")" : Re;
    }
    function Q(R) {
      return R.displayName || "Context";
    }
    function ke(R) {
      if (R == null)
        return null;
      if (typeof R.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof R == "function")
        return R.displayName || R.name || null;
      if (typeof R == "string")
        return R;
      switch (R) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case s:
            var ue = R;
            return Q(ue) + ".Consumer";
          case i:
            var Re = R;
            return Q(Re._context) + ".Provider";
          case c:
            return V(R, R.render, "ForwardRef");
          case u:
            var Be = R.displayName || null;
            return Be !== null ? Be : ke(R.type) || "Memo";
          case v: {
            var ut = R, gt = ut._payload, rt = ut._init;
            try {
              return ke(rt(gt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, X = 0, he, $e, Te, fe, Y, O, G;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function ae() {
      {
        if (X === 0) {
          he = console.log, $e = console.info, Te = console.warn, fe = console.error, Y = console.group, O = console.groupCollapsed, G = console.groupEnd;
          var R = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: R,
            log: R,
            warn: R,
            error: R,
            group: R,
            groupCollapsed: R,
            groupEnd: R
          });
        }
        X++;
      }
    }
    function te() {
      {
        if (X--, X === 0) {
          var R = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, R, {
              value: he
            }),
            info: H({}, R, {
              value: $e
            }),
            warn: H({}, R, {
              value: Te
            }),
            error: H({}, R, {
              value: fe
            }),
            group: H({}, R, {
              value: Y
            }),
            groupCollapsed: H({}, R, {
              value: O
            }),
            groupEnd: H({}, R, {
              value: G
            })
          });
        }
        X < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var se = k.ReactCurrentDispatcher, Se;
    function me(R, ue, Re) {
      {
        if (Se === void 0)
          try {
            throw Error();
          } catch (ut) {
            var Be = ut.stack.trim().match(/\n( *(at )?)/);
            Se = Be && Be[1] || "";
          }
        return `
` + Se + R;
      }
    }
    var ne = !1, ye;
    {
      var ze = typeof WeakMap == "function" ? WeakMap : Map;
      ye = new ze();
    }
    function pe(R, ue) {
      if (!R || ne)
        return "";
      {
        var Re = ye.get(R);
        if (Re !== void 0)
          return Re;
      }
      var Be;
      ne = !0;
      var ut = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var gt;
      gt = se.current, se.current = null, ae();
      try {
        if (ue) {
          var rt = function() {
            throw Error();
          };
          if (Object.defineProperty(rt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(rt, []);
            } catch ($t) {
              Be = $t;
            }
            Reflect.construct(R, [], rt);
          } else {
            try {
              rt.call();
            } catch ($t) {
              Be = $t;
            }
            R.call(rt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch ($t) {
            Be = $t;
          }
          R();
        }
      } catch ($t) {
        if ($t && Be && typeof $t.stack == "string") {
          for (var xe = $t.stack.split(`
`), D = Be.stack.split(`
`), de = xe.length - 1, Pe = D.length - 1; de >= 1 && Pe >= 0 && xe[de] !== D[Pe]; )
            Pe--;
          for (; de >= 1 && Pe >= 0; de--, Pe--)
            if (xe[de] !== D[Pe]) {
              if (de !== 1 || Pe !== 1)
                do
                  if (de--, Pe--, Pe < 0 || xe[de] !== D[Pe]) {
                    var Xe = `
` + xe[de].replace(" at new ", " at ");
                    return R.displayName && Xe.includes("<anonymous>") && (Xe = Xe.replace("<anonymous>", R.displayName)), typeof R == "function" && ye.set(R, Xe), Xe;
                  }
                while (de >= 1 && Pe >= 0);
              break;
            }
        }
      } finally {
        ne = !1, se.current = gt, te(), Error.prepareStackTrace = ut;
      }
      var Ht = R ? R.displayName || R.name : "", Mt = Ht ? me(Ht) : "";
      return typeof R == "function" && ye.set(R, Mt), Mt;
    }
    function mt(R, ue, Re) {
      return pe(R, !1);
    }
    function Ae(R) {
      var ue = R.prototype;
      return !!(ue && ue.isReactComponent);
    }
    function K(R, ue, Re) {
      if (R == null)
        return "";
      if (typeof R == "function")
        return pe(R, Ae(R));
      if (typeof R == "string")
        return me(R);
      switch (R) {
        case l:
          return me("Suspense");
        case d:
          return me("SuspenseList");
      }
      if (typeof R == "object")
        switch (R.$$typeof) {
          case c:
            return mt(R.render);
          case u:
            return K(R.type, ue, Re);
          case v: {
            var Be = R, ut = Be._payload, gt = Be._init;
            try {
              return K(gt(ut), ue, Re);
            } catch {
            }
          }
        }
      return "";
    }
    var ie = Object.prototype.hasOwnProperty, ve = {}, Me = k.ReactDebugCurrentFrame;
    function Ue(R) {
      if (R) {
        var ue = R._owner, Re = K(R.type, R._source, ue ? ue.type : null);
        Me.setExtraStackFrame(Re);
      } else
        Me.setExtraStackFrame(null);
    }
    function it(R, ue, Re, Be, ut) {
      {
        var gt = Function.call.bind(ie);
        for (var rt in R)
          if (gt(R, rt)) {
            var xe = void 0;
            try {
              if (typeof R[rt] != "function") {
                var D = Error((Be || "React class") + ": " + Re + " type `" + rt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof R[rt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw D.name = "Invariant Violation", D;
              }
              xe = R[rt](ue, rt, Be, Re, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (de) {
              xe = de;
            }
            xe && !(xe instanceof Error) && (Ue(ut), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Be || "React class", Re, rt, typeof xe), Ue(null)), xe instanceof Error && !(xe.message in ve) && (ve[xe.message] = !0, Ue(ut), $("Failed %s type: %s", Re, xe.message), Ue(null));
          }
      }
    }
    var et = Array.isArray;
    function Nt(R) {
      return et(R);
    }
    function Vt(R) {
      {
        var ue = typeof Symbol == "function" && Symbol.toStringTag, Re = ue && R[Symbol.toStringTag] || R.constructor.name || "Object";
        return Re;
      }
    }
    function Rt(R) {
      try {
        return sn(R), !1;
      } catch {
        return !0;
      }
    }
    function sn(R) {
      return "" + R;
    }
    function _n(R) {
      if (Rt(R))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Vt(R)), sn(R);
    }
    var Jn = k.ReactCurrentOwner, Kr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ft, Or, Mn;
    Mn = {};
    function Nr(R) {
      if (ie.call(R, "ref")) {
        var ue = Object.getOwnPropertyDescriptor(R, "ref").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return R.ref !== void 0;
    }
    function er(R) {
      if (ie.call(R, "key")) {
        var ue = Object.getOwnPropertyDescriptor(R, "key").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return R.key !== void 0;
    }
    function cn(R, ue) {
      if (typeof R.ref == "string" && Jn.current && ue && Jn.current.stateNode !== ue) {
        var Re = ke(Jn.current.type);
        Mn[Re] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ke(Jn.current.type), R.ref), Mn[Re] = !0);
      }
    }
    function Dn(R, ue) {
      {
        var Re = function() {
          Ft || (Ft = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        Re.isReactWarning = !0, Object.defineProperty(R, "key", {
          get: Re,
          configurable: !0
        });
      }
    }
    function hr(R, ue) {
      {
        var Re = function() {
          Or || (Or = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        Re.isReactWarning = !0, Object.defineProperty(R, "ref", {
          get: Re,
          configurable: !0
        });
      }
    }
    var xn = function(R, ue, Re, Be, ut, gt, rt) {
      var xe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: R,
        key: ue,
        ref: Re,
        props: rt,
        // Record the component responsible for creating this element.
        _owner: gt
      };
      return xe._store = {}, Object.defineProperty(xe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(xe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Be
      }), Object.defineProperty(xe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ut
      }), Object.freeze && (Object.freeze(xe.props), Object.freeze(xe)), xe;
    };
    function Xr(R, ue, Re, Be, ut) {
      {
        var gt, rt = {}, xe = null, D = null;
        Re !== void 0 && (_n(Re), xe = "" + Re), er(ue) && (_n(ue.key), xe = "" + ue.key), Nr(ue) && (D = ue.ref, cn(ue, ut));
        for (gt in ue)
          ie.call(ue, gt) && !Kr.hasOwnProperty(gt) && (rt[gt] = ue[gt]);
        if (R && R.defaultProps) {
          var de = R.defaultProps;
          for (gt in de)
            rt[gt] === void 0 && (rt[gt] = de[gt]);
        }
        if (xe || D) {
          var Pe = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
          xe && Dn(rt, Pe), D && hr(rt, Pe);
        }
        return xn(R, xe, D, ut, Be, Jn.current, rt);
      }
    }
    var Bn = k.ReactCurrentOwner, Zr = k.ReactDebugCurrentFrame;
    function tr(R) {
      if (R) {
        var ue = R._owner, Re = K(R.type, R._source, ue ? ue.type : null);
        Zr.setExtraStackFrame(Re);
      } else
        Zr.setExtraStackFrame(null);
    }
    var Dt;
    Dt = !1;
    function ge(R) {
      return typeof R == "object" && R !== null && R.$$typeof === t;
    }
    function wn() {
      {
        if (Bn.current) {
          var R = ke(Bn.current.type);
          if (R)
            return `

Check the render method of \`` + R + "`.";
        }
        return "";
      }
    }
    function fn(R) {
      {
        if (R !== void 0) {
          var ue = R.fileName.replace(/^.*[\\\/]/, ""), Re = R.lineNumber;
          return `

Check your code at ` + ue + ":" + Re + ".";
        }
        return "";
      }
    }
    var Wt = {};
    function Qe(R) {
      {
        var ue = wn();
        if (!ue) {
          var Re = typeof R == "string" ? R : R.displayName || R.name;
          Re && (ue = `

Check the top-level render call using <` + Re + ">.");
        }
        return ue;
      }
    }
    function mn(R, ue) {
      {
        if (!R._store || R._store.validated || R.key != null)
          return;
        R._store.validated = !0;
        var Re = Qe(ue);
        if (Wt[Re])
          return;
        Wt[Re] = !0;
        var Be = "";
        R && R._owner && R._owner !== Bn.current && (Be = " It was passed a child from " + ke(R._owner.type) + "."), tr(R), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Re, Be), tr(null);
      }
    }
    function Zo(R, ue) {
      {
        if (typeof R != "object")
          return;
        if (Nt(R))
          for (var Re = 0; Re < R.length; Re++) {
            var Be = R[Re];
            ge(Be) && mn(Be, ue);
          }
        else if (ge(R))
          R._store && (R._store.validated = !0);
        else if (R) {
          var ut = g(R);
          if (typeof ut == "function" && ut !== R.entries)
            for (var gt = ut.call(R), rt; !(rt = gt.next()).done; )
              ge(rt.value) && mn(rt.value, ue);
        }
      }
    }
    function Qo(R) {
      {
        var ue = R.type;
        if (ue == null || typeof ue == "string")
          return;
        var Re;
        if (typeof ue == "function")
          Re = ue.propTypes;
        else if (typeof ue == "object" && (ue.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ue.$$typeof === u))
          Re = ue.propTypes;
        else
          return;
        if (Re) {
          var Be = ke(ue);
          it(Re, R.props, "prop", Be, R);
        } else if (ue.PropTypes !== void 0 && !Dt) {
          Dt = !0;
          var ut = ke(ue);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ut || "Unknown");
        }
        typeof ue.getDefaultProps == "function" && !ue.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Jo(R) {
      {
        for (var ue = Object.keys(R.props), Re = 0; Re < ue.length; Re++) {
          var Be = ue[Re];
          if (Be !== "children" && Be !== "key") {
            tr(R), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Be), tr(null);
            break;
          }
        }
        R.ref !== null && (tr(R), $("Invalid attribute `ref` supplied to `React.Fragment`."), tr(null));
      }
    }
    var ea = {};
    function En(R, ue, Re, Be, ut, gt) {
      {
        var rt = q(R);
        if (!rt) {
          var xe = "";
          (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var D = fn(ut);
          D ? xe += D : xe += wn();
          var de;
          R === null ? de = "null" : Nt(R) ? de = "array" : R !== void 0 && R.$$typeof === t ? (de = "<" + (ke(R.type) || "Unknown") + " />", xe = " Did you accidentally export a JSX literal instead of a component?") : de = typeof R, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", de, xe);
        }
        var Pe = Xr(R, ue, Re, ut, gt);
        if (Pe == null)
          return Pe;
        if (rt) {
          var Xe = ue.children;
          if (Xe !== void 0)
            if (Be)
              if (Nt(Xe)) {
                for (var Ht = 0; Ht < Xe.length; Ht++)
                  Zo(Xe[Ht], R);
                Object.freeze && Object.freeze(Xe);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Zo(Xe, R);
        }
        if (ie.call(ue, "key")) {
          var Mt = ke(R), $t = Object.keys(ue).filter(function(Xt) {
            return Xt !== "key";
          }), pn = $t.length > 0 ? "{key: someKey, " + $t.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ea[Mt + pn]) {
            var Rr = $t.length > 0 ? "{" + $t.join(": ..., ") + ": ...}" : "{}";
            $(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, pn, Mt, Rr, Mt), ea[Mt + pn] = !0;
          }
        }
        return R === r ? Jo(Pe) : Qo(Pe), Pe;
      }
    }
    function Qr(R, ue, Re) {
      return En(R, ue, Re, !0);
    }
    function ta(R, ue, Re) {
      return En(R, ue, Re, !1);
    }
    var na = ta, ra = Qr;
    ia.Fragment = r, ia.jsx = na, ia.jsxs = ra;
  }()), ia;
}
process.env.NODE_ENV === "production" ? sl.exports = $1() : sl.exports = T1();
var w = sl.exports;
function fp(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = fp(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function S1() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = fp(e)) && (r && (r += " "), r += t);
  return r;
}
const jd = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, Ld = S1, Wn = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return Ld(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, i = Object.keys(o).map((l) => {
    const d = n == null ? void 0 : n[l], u = a == null ? void 0 : a[l];
    if (d === null)
      return null;
    const v = jd(d) || jd(u);
    return o[l][v];
  }), s = n && Object.entries(n).reduce((l, d) => {
    let [u, v] = d;
    return v === void 0 || (l[u] = v), l;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, d) => {
    let { class: u, className: v, ...m } = d;
    return Object.entries(m).every((b) => {
      let [x, g] = b;
      return Array.isArray(g) ? g.includes({
        ...a,
        ...s
      }[x]) : {
        ...a,
        ...s
      }[x] === g;
    }) ? [
      ...l,
      u,
      v
    ] : l;
  }, []);
  return Ld(e, i, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function mp(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = mp(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function pp() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = mp(e)) && (r && (r += " "), r += t);
  return r;
}
function k1() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = hp(t)) && (r && (r += " "), r += n);
  return r;
}
function hp(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = hp(e[r])) && (n && (n += " "), n += t);
  return n;
}
var Zl = "-";
function _1(e) {
  var t = P1(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function a(s) {
    var c = s.split(Zl);
    return c[0] === "" && c.length !== 1 && c.shift(), vp(c, t) || C1(s);
  }
  function i(s, c) {
    var l = n[s] || [];
    return c && o[s] ? [].concat(l, o[s]) : l;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: i
  };
}
function vp(e, t) {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), o = r ? vp(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length !== 0) {
    var a = e.join(Zl);
    return (i = t.validators.find(function(s) {
      var c = s.validator;
      return c(a);
    })) == null ? void 0 : i.classGroupId;
  }
}
var Fd = /^\[(.+)\]$/;
function C1(e) {
  if (Fd.test(e)) {
    var t = Fd.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function P1(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = O1(Object.entries(e.classGroups), n);
  return o.forEach(function(a) {
    var i = a[0], s = a[1];
    cl(s, r, i, t);
  }), r;
}
function cl(e, t, n, r) {
  e.forEach(function(o) {
    if (typeof o == "string") {
      var a = o === "" ? t : Wd(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (A1(o)) {
        cl(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(i) {
      var s = i[0], c = i[1];
      cl(c, Wd(t, s), n, r);
    });
  });
}
function Wd(e, t) {
  var n = e;
  return t.split(Zl).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function A1(e) {
  return e.isThemeGetter;
}
function O1(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], o = n[1], a = o.map(function(i) {
      return typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(function(s) {
        var c = s[0], l = s[1];
        return [t + c, l];
      })) : i;
    });
    return [r, a];
  }) : e;
}
function N1(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(a, i) {
    n.set(a, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(i) {
      var s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set: function(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}
var gp = "!";
function R1(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], o = t.length;
  return function(i) {
    for (var s = [], c = 0, l = 0, d, u = 0; u < i.length; u++) {
      var v = i[u];
      if (c === 0) {
        if (v === r && (n || i.slice(u, u + o) === t)) {
          s.push(i.slice(l, u)), l = u + o;
          continue;
        }
        if (v === "/") {
          d = u;
          continue;
        }
      }
      v === "[" ? c++ : v === "]" && c--;
    }
    var m = s.length === 0 ? i : i.substring(l), b = m.startsWith(gp), x = b ? m.substring(1) : m, g = d && d > l ? d - l : void 0;
    return {
      modifiers: s,
      hasImportantModifier: b,
      baseClassName: x,
      maybePostfixModifierPosition: g
    };
  };
}
function M1(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var o = r[0] === "[";
    o ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function D1(e) {
  return {
    cache: N1(e.cacheSize),
    splitModifiers: R1(e),
    ..._1(e)
  };
}
var I1 = /\s+/;
function j1(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, o = t.getConflictingClassGroupIds, a = /* @__PURE__ */ new Set();
  return e.trim().split(I1).map(function(i) {
    var s = n(i), c = s.modifiers, l = s.hasImportantModifier, d = s.baseClassName, u = s.maybePostfixModifierPosition, v = r(u ? d.substring(0, u) : d), m = !!u;
    if (!v) {
      if (!u)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (v = r(d), !v)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      m = !1;
    }
    var b = M1(c).join(":"), x = l ? b + gp : b;
    return {
      isTailwindClass: !0,
      modifierId: x,
      classGroupId: v,
      originalClassName: i,
      hasPostfixModifier: m
    };
  }).reverse().filter(function(i) {
    if (!i.isTailwindClass)
      return !0;
    var s = i.modifierId, c = i.classGroupId, l = i.hasPostfixModifier, d = s + c;
    return a.has(d) ? !1 : (a.add(d), o(c, l).forEach(function(u) {
      return a.add(s + u);
    }), !0);
  }).reverse().map(function(i) {
    return i.originalClassName;
  }).join(" ");
}
function Hd() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, o, a, i = s;
  function s(l) {
    var d = t[0], u = t.slice(1), v = u.reduce(function(m, b) {
      return b(m);
    }, d());
    return r = D1(v), o = r.cache.get, a = r.cache.set, i = c, c(l);
  }
  function c(l) {
    var d = o(l);
    if (d)
      return d;
    var u = j1(l, r);
    return a(l, u), u;
  }
  return function() {
    return i(k1.apply(null, arguments));
  };
}
function It(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var bp = /^\[(?:([a-z-]+):)?(.+)\]$/i, L1 = /^\d+\/\d+$/, F1 = /* @__PURE__ */ new Set(["px", "full", "screen"]), W1 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, H1 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, U1 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Gn(e) {
  return ao(e) || F1.has(e) || L1.test(e) || ll(e);
}
function ll(e) {
  return ho(e, "length", Y1);
}
function B1(e) {
  return ho(e, "size", yp);
}
function z1(e) {
  return ho(e, "position", yp);
}
function V1(e) {
  return ho(e, "url", K1);
}
function hi(e) {
  return ho(e, "number", ao);
}
function ao(e) {
  return !Number.isNaN(Number(e));
}
function G1(e) {
  return e.endsWith("%") && ao(e.slice(0, -1));
}
function sa(e) {
  return Ud(e) || ho(e, "number", Ud);
}
function st(e) {
  return bp.test(e);
}
function ca() {
  return !0;
}
function Dr(e) {
  return W1.test(e);
}
function q1(e) {
  return ho(e, "", X1);
}
function ho(e, t, n) {
  var r = bp.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function Y1(e) {
  return H1.test(e);
}
function yp() {
  return !1;
}
function K1(e) {
  return e.startsWith("url(");
}
function Ud(e) {
  return Number.isInteger(Number(e));
}
function X1(e) {
  return U1.test(e);
}
function Bd() {
  var e = It("colors"), t = It("spacing"), n = It("blur"), r = It("brightness"), o = It("borderColor"), a = It("borderRadius"), i = It("borderSpacing"), s = It("borderWidth"), c = It("contrast"), l = It("grayscale"), d = It("hueRotate"), u = It("invert"), v = It("gap"), m = It("gradientColorStops"), b = It("gradientColorStopPositions"), x = It("inset"), g = It("margin"), k = It("opacity"), $ = It("padding"), T = It("saturate"), S = It("scale"), C = It("sepia"), N = It("skew"), U = It("space"), L = It("translate"), j = function() {
    return ["auto", "contain", "none"];
  }, q = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, V = function() {
    return ["auto", st, t];
  }, Q = function() {
    return [st, t];
  }, ke = function() {
    return ["", Gn];
  }, H = function() {
    return ["auto", ao, st];
  }, X = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, he = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, $e = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, Te = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, fe = function() {
    return ["", "0", st];
  }, Y = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, O = function() {
    return [ao, hi];
  }, G = function() {
    return [ao, st];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [ca],
      spacing: [Gn],
      blur: ["none", "", Dr, st],
      brightness: O(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Dr, st],
      borderSpacing: Q(),
      borderWidth: ke(),
      contrast: O(),
      grayscale: fe(),
      hueRotate: G(),
      invert: fe(),
      gap: Q(),
      gradientColorStops: [e],
      gradientColorStopPositions: [G1, ll],
      inset: V(),
      margin: V(),
      opacity: O(),
      padding: Q(),
      saturate: O(),
      scale: O(),
      sepia: fe(),
      skew: G(),
      space: Q(),
      translate: Q()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", st]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Dr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": Y()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": Y()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(X(), [st])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: q()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": q()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": q()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: j()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": j()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": j()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [x]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [x]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [x]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [x]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [x]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [x]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [x]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [x]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [x]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", sa]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: V()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", st]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: fe()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: fe()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", sa]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [ca]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", sa]
        }, st]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": H()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": H()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [ca]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [sa]
        }, st]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": H()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": H()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", st]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", st]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [v]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [v]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [v]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(Te())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(Te(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(Te(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [$]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [$]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [$]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [$]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [$]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [$]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [$]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [$]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [$]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [U]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [U]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", st, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", st, Gn]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Dr]
        }, Dr, st]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [st, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", st, Gn]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [st, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Dr, ll]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", hi]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ca]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", st]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ao, hi]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", st, Gn]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", st]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", st]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [k]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [k]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(he(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Gn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", st, Gn]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: Q()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", st]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", st]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [k]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(X(), [z1])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", B1]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, V1]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [b]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [b]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [b]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [k]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(he(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [k]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: he()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(he())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [st, Gn]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Gn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ke()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [k]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Gn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Dr, q1]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [ca]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [k]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": $e()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": $e()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Dr, st]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [T]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [C]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [k]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [T]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [C]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", st]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: G()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", st]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: G()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", st]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [sa, st]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [L]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [L]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [N]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [N]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", st]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", st]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": Q()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": Q()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": Q()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": Q()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": Q()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": Q()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": Q()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": Q()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": Q()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": Q()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": Q()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": Q()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": Q()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": Q()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": Q()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": Q()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": Q()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": Q()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", st]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Gn, hi]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function Z1(e, t) {
  for (var n in t)
    xp(e, n, t[n]);
  return e;
}
var Q1 = Object.prototype.hasOwnProperty, J1 = /* @__PURE__ */ new Set(["string", "number", "boolean"]);
function xp(e, t, n) {
  if (!Q1.call(e, t) || J1.has(typeof n) || n === null) {
    e[t] = n;
    return;
  }
  if (Array.isArray(n) && Array.isArray(e[t])) {
    e[t] = e[t].concat(n);
    return;
  }
  if (typeof n == "object" && typeof e[t] == "object") {
    if (e[t] === null) {
      e[t] = n;
      return;
    }
    for (var r in n)
      xp(e[t], r, n[r]);
  }
}
function ey(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return typeof e == "function" ? Hd.apply(void 0, [Bd, e].concat(n)) : Hd.apply(void 0, [function() {
    return Z1(Bd(), e);
  }].concat(n));
}
const ty = ey({
  classGroups: {
    "font-size": [
      "text-display",
      "text-heading-1",
      "text-heading-2",
      "text-heading-3",
      "text-body",
      "text-title",
      "text-label-l",
      "text-label-m",
      "text-label-s",
      "text-label-xs"
    ]
  }
});
function z(...e) {
  return ty(pp(e));
}
const ny = (e, t) => {
  const n = new RegExp(t, "gi");
  return e.replace(n, (r) => `<strong>${r}</strong>`);
}, ry = Wn(
  "relative w-full rounded px-4 pb-2 text-sm [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-3 [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-sky.8 [&>h5]:text-sky.1 [&>svg]:text-sky.1",
        danger: "bg-berry.7 [&>h5]:text-berry.1 [&>svg]:text-berry.1"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), oy = P.forwardRef(
  ({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ w.jsx(
    "div",
    {
      ref: r,
      role: "alert",
      className: z(ry({ variant: t }), e),
      ...n
    }
  )
);
oy.displayName = "Alert";
const ay = P.forwardRef(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsx(
    "h5",
    {
      ref: r,
      className: z(
        "mb-1 pb-1 pt-4 font-medium leading-none tracking-tight",
        e
      ),
      ...n,
      children: t
    }
  )
);
ay.displayName = "AlertTitle";
const iy = P.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "div",
  {
    ref: r,
    className: z("pb-1 text-sm leading-relaxed", e),
    ...n,
    children: t
  }
));
iy.displayName = "AlertDescription";
function oe() {
  return oe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, oe.apply(null, arguments);
}
function sy(e, t) {
  const n = /* @__PURE__ */ Et(t);
  function r(a) {
    const { children: i, ...s } = a, c = qe(
      () => s,
      Object.values(s)
    );
    return /* @__PURE__ */ I(n.Provider, {
      value: c
    }, i);
  }
  function o(a) {
    const i = Ye(n);
    if (i)
      return i;
    if (t !== void 0)
      return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [
    r,
    o
  ];
}
function Hn(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = /* @__PURE__ */ Et(i), c = n.length;
    n = [
      ...n,
      i
    ];
    function l(u) {
      const { scope: v, children: m, ...b } = u, x = (v == null ? void 0 : v[e][c]) || s, g = qe(
        () => b,
        Object.values(b)
      );
      return /* @__PURE__ */ I(x.Provider, {
        value: g
      }, m);
    }
    function d(u, v) {
      const m = (v == null ? void 0 : v[e][c]) || s, b = Ye(m);
      if (b)
        return b;
      if (i !== void 0)
        return i;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [
      l,
      d
    ];
  }
  const o = () => {
    const a = n.map((i) => /* @__PURE__ */ Et(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return qe(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: c
          }
        }),
        [
          s,
          c
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    cy(o, ...t)
  ];
}
function cy(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(a)[`__scope${l}`];
        return {
          ...s,
          ...u
        };
      }, {});
      return qe(
        () => ({
          [`__scope${t.scopeName}`]: i
        }),
        [
          i
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function ly(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ts(...e) {
  return (t) => e.forEach(
    (n) => ly(n, t)
  );
}
function ct(...e) {
  return Ie(Ts(...e), e);
}
function Le(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
const qt = globalThis != null && globalThis.document ? Ua : () => {
}, uy = P["useId".toString()] || (() => {
});
let dy = 0;
function Ln(e) {
  const [t, n] = P.useState(uy());
  return qt(() => {
    e || n(
      (r) => r ?? String(dy++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function wt(e) {
  const t = Z(e);
  return Ee(() => {
    t.current = e;
  }), qe(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function fy({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = my({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = wt(n), c = Ie((l) => {
    if (a) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    c
  ];
}
function my({ defaultProp: e, onChange: t }) {
  const n = Ce(e), [r] = n, o = Z(r), a = wt(t);
  return Ee(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
const Tr = /* @__PURE__ */ M((e, t) => {
  const { children: n, ...r } = e, o = Tn.toArray(n), a = o.find(py);
  if (a) {
    const i = a.props.children, s = o.map((c) => c === a ? Tn.count(i) > 1 ? Tn.only(null) : /* @__PURE__ */ Oa(i) ? i.props.children : null : c);
    return /* @__PURE__ */ I(ul, oe({}, r, {
      ref: t
    }), /* @__PURE__ */ Oa(i) ? /* @__PURE__ */ fr(i, void 0, s) : null);
  }
  return /* @__PURE__ */ I(ul, oe({}, r, {
    ref: t
  }), n);
});
Tr.displayName = "Slot";
const ul = /* @__PURE__ */ M((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Oa(n) ? /* @__PURE__ */ fr(n, {
    ...hy(r, n.props),
    ref: t ? Ts(t, n.ref) : n.ref
  }) : Tn.count(n) > 1 ? Tn.only(null) : null;
});
ul.displayName = "SlotClone";
const Ql = ({ children: e }) => /* @__PURE__ */ I(Jt, null, e);
function py(e) {
  return /* @__PURE__ */ Oa(e) && e.type === Ql;
}
function hy(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...a
    } : r === "className" && (n[r] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const vy = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], lt = vy.reduce((e, t) => {
  const n = /* @__PURE__ */ M((r, o) => {
    const { asChild: a, ...i } = r, s = a ? Tr : t;
    return Ee(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ I(s, oe({}, i, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function wp(e, t) {
  e && Vr(
    () => e.dispatchEvent(t)
  );
}
function gy(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(e);
  Ee(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const dl = "dismissableLayer.update", by = "dismissableLayer.pointerDownOutside", yy = "dismissableLayer.focusOutside";
let zd;
const Ep = /* @__PURE__ */ Et({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ba = /* @__PURE__ */ M((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: a, onFocusOutside: i, onInteractOutside: s, onDismiss: c, ...l } = e, d = Ye(Ep), [u, v] = Ce(null), m = (n = u == null ? void 0 : u.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, b] = Ce({}), x = ct(
    t,
    (L) => v(L)
  ), g = Array.from(d.layers), [k] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), $ = g.indexOf(k), T = u ? g.indexOf(u) : -1, S = d.layersWithOutsidePointerEventsDisabled.size > 0, C = T >= $, N = wy((L) => {
    const j = L.target, q = [
      ...d.branches
    ].some(
      (V) => V.contains(j)
    );
    !C || q || (a == null || a(L), s == null || s(L), L.defaultPrevented || c == null || c());
  }, m), U = Ey((L) => {
    const j = L.target;
    [
      ...d.branches
    ].some(
      (V) => V.contains(j)
    ) || (i == null || i(L), s == null || s(L), L.defaultPrevented || c == null || c());
  }, m);
  return gy((L) => {
    T === d.layers.size - 1 && (o == null || o(L), !L.defaultPrevented && c && (L.preventDefault(), c()));
  }, m), Ee(() => {
    if (u)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (zd = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(u)), d.layers.add(u), Vd(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = zd);
      };
  }, [
    u,
    m,
    r,
    d
  ]), Ee(() => () => {
    u && (d.layers.delete(u), d.layersWithOutsidePointerEventsDisabled.delete(u), Vd());
  }, [
    u,
    d
  ]), Ee(() => {
    const L = () => b({});
    return document.addEventListener(dl, L), () => document.removeEventListener(dl, L);
  }, []), /* @__PURE__ */ I(lt.div, oe({}, l, {
    ref: x,
    style: {
      pointerEvents: S ? C ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Le(e.onFocusCapture, U.onFocusCapture),
    onBlurCapture: Le(e.onBlurCapture, U.onBlurCapture),
    onPointerDownCapture: Le(e.onPointerDownCapture, N.onPointerDownCapture)
  }));
}), xy = /* @__PURE__ */ M((e, t) => {
  const n = Ye(Ep), r = Z(null), o = ct(t, r);
  return Ee(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [
    n.branches
  ]), /* @__PURE__ */ I(lt.div, oe({}, e, {
    ref: o
  }));
});
function wy(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(e), r = Z(!1), o = Z(() => {
  });
  return Ee(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          $p(by, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, {
          once: !0
        })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Ey(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(e), r = Z(!1);
  return Ee(() => {
    const o = (a) => {
      a.target && !r.current && $p(yy, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Vd() {
  const e = new CustomEvent(dl);
  document.dispatchEvent(e);
}
function $p(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? wp(o, a) : o.dispatchEvent(a);
}
const $y = Ba, Ty = xy, pc = "focusScope.autoFocusOnMount", hc = "focusScope.autoFocusOnUnmount", Gd = {
  bubbles: !1,
  cancelable: !0
}, Jl = /* @__PURE__ */ M((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: a, ...i } = e, [s, c] = Ce(null), l = wt(o), d = wt(a), u = Z(null), v = ct(
    t,
    (x) => c(x)
  ), m = Z({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Ee(() => {
    if (r) {
      let x = function(T) {
        if (m.paused || !s)
          return;
        const S = T.target;
        s.contains(S) ? u.current = S : jr(u.current, {
          select: !0
        });
      }, g = function(T) {
        if (m.paused || !s)
          return;
        const S = T.relatedTarget;
        S !== null && (s.contains(S) || jr(u.current, {
          select: !0
        }));
      }, k = function(T) {
        if (document.activeElement === document.body)
          for (const C of T)
            C.removedNodes.length > 0 && jr(s);
      };
      document.addEventListener("focusin", x), document.addEventListener("focusout", g);
      const $ = new MutationObserver(k);
      return s && $.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", x), document.removeEventListener("focusout", g), $.disconnect();
      };
    }
  }, [
    r,
    s,
    m.paused
  ]), Ee(() => {
    if (s) {
      Yd.add(m);
      const x = document.activeElement;
      if (!s.contains(x)) {
        const k = new CustomEvent(pc, Gd);
        s.addEventListener(pc, l), s.dispatchEvent(k), k.defaultPrevented || (Sy(Ay(Tp(s)), {
          select: !0
        }), document.activeElement === x && jr(s));
      }
      return () => {
        s.removeEventListener(pc, l), setTimeout(() => {
          const k = new CustomEvent(hc, Gd);
          s.addEventListener(hc, d), s.dispatchEvent(k), k.defaultPrevented || jr(x ?? document.body, {
            select: !0
          }), s.removeEventListener(hc, d), Yd.remove(m);
        }, 0);
      };
    }
  }, [
    s,
    l,
    d,
    m
  ]);
  const b = Ie((x) => {
    if (!n && !r || m.paused)
      return;
    const g = x.key === "Tab" && !x.altKey && !x.ctrlKey && !x.metaKey, k = document.activeElement;
    if (g && k) {
      const $ = x.currentTarget, [T, S] = ky($);
      T && S ? !x.shiftKey && k === S ? (x.preventDefault(), n && jr(T, {
        select: !0
      })) : x.shiftKey && k === T && (x.preventDefault(), n && jr(S, {
        select: !0
      })) : k === $ && x.preventDefault();
    }
  }, [
    n,
    r,
    m.paused
  ]);
  return /* @__PURE__ */ I(lt.div, oe({
    tabIndex: -1
  }, i, {
    ref: v,
    onKeyDown: b
  }));
});
function Sy(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (jr(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function ky(e) {
  const t = Tp(e), n = qd(t, e), r = qd(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Tp(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function qd(e, t) {
  for (const n of e)
    if (!_y(n, {
      upTo: t
    }))
      return n;
}
function _y(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Cy(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function jr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Cy(e) && t && e.select();
  }
}
const Yd = Py();
function Py() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Kd(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Kd(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Kd(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Ay(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Ss = /* @__PURE__ */ M((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ ap.createPortal(/* @__PURE__ */ I(lt.div, oe({}, o, {
    ref: t
  })), r) : null;
});
function Oy(e, t) {
  return mr((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const ks = (e) => {
  const { present: t, children: n } = e, r = Ny(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Tn.only(n), a = ct(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ fr(o, {
    ref: a
  }) : null;
};
ks.displayName = "Presence";
function Ny(e) {
  const [t, n] = Ce(), r = Z({}), o = Z(e), a = Z("none"), i = e ? "mounted" : "unmounted", [s, c] = Oy(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const l = vi(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), qt(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, m = vi(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && v !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), qt(() => {
    if (t) {
      const l = (u) => {
        const m = vi(r.current).includes(u.animationName);
        u.target === t && m && Vr(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (a.current = vi(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Ie((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function vi(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let vc = 0;
function eu() {
  Ee(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Xd()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Xd()), vc++, () => {
      vc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), vc--;
    };
  }, []);
}
function Xd() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var or = function() {
  return or = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, or.apply(this, arguments);
};
function Sp(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Ry(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Bi = "right-scroll-bar-position", zi = "width-before-scroll-bar", My = "with-scroll-bars-hidden", Dy = "--removed-body-scroll-bar-size";
function gc(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Iy(e, t) {
  var n = Ce(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var jy = typeof window < "u" ? P.useLayoutEffect : P.useEffect, Zd = /* @__PURE__ */ new WeakMap();
function Ly(e, t) {
  var n = Iy(t || null, function(r) {
    return e.forEach(function(o) {
      return gc(o, r);
    });
  });
  return jy(function() {
    var r = Zd.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), i = n.current;
      o.forEach(function(s) {
        a.has(s) || gc(s, null);
      }), a.forEach(function(s) {
        o.has(s) || gc(s, i);
      });
    }
    Zd.set(n, e);
  }, [e]), n;
}
function Fy(e) {
  return e;
}
function Wy(e, t) {
  t === void 0 && (t = Fy);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, r);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), i = n;
      }
      var c = function() {
        var d = i;
        i = [], d.forEach(a);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(d) {
          i.push(d), l();
        },
        filter: function(d) {
          return i = i.filter(d), n;
        }
      };
    }
  };
  return o;
}
function Hy(e) {
  e === void 0 && (e = {});
  var t = Wy(null);
  return t.options = or({ async: !0, ssr: !1 }, e), t;
}
var kp = function(e) {
  var t = e.sideCar, n = Sp(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return P.createElement(r, or({}, n));
};
kp.isSideCarExport = !0;
function Uy(e, t) {
  return e.useMedium(t), kp;
}
var _p = Hy(), bc = function() {
}, _s = P.forwardRef(function(e, t) {
  var n = P.useRef(null), r = P.useState({
    onScrollCapture: bc,
    onWheelCapture: bc,
    onTouchMoveCapture: bc
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, d = e.enabled, u = e.shards, v = e.sideCar, m = e.noIsolation, b = e.inert, x = e.allowPinchZoom, g = e.as, k = g === void 0 ? "div" : g, $ = Sp(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), T = v, S = Ly([n, t]), C = or(or({}, $), o);
  return P.createElement(
    P.Fragment,
    null,
    d && P.createElement(T, { sideCar: _p, removeScrollBar: l, shards: u, noIsolation: m, inert: b, setCallbacks: a, allowPinchZoom: !!x, lockRef: n }),
    i ? P.cloneElement(P.Children.only(s), or(or({}, C), { ref: S })) : P.createElement(k, or({}, C, { className: c, ref: S }), s)
  );
});
_s.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_s.classNames = {
  fullWidth: zi,
  zeroRight: Bi
};
var Qd, By = function() {
  if (Qd)
    return Qd;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function zy() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = By();
  return t && e.setAttribute("nonce", t), e;
}
function Vy(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Gy(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var qy = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = zy()) && (Vy(t, n), Gy(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Yy = function() {
  var e = qy();
  return function(t, n) {
    P.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Cp = function() {
  var e = Yy(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Ky = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, yc = function(e) {
  return parseInt(e || "", 10) || 0;
}, Xy = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [yc(n), yc(r), yc(o)];
}, Zy = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Ky;
  var t = Xy(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Qy = Cp(), No = "data-scroll-locked", Jy = function(e, t, n, r) {
  var o = e.left, a = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(My, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(No, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Bi, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(zi, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Bi, " .").concat(Bi, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(zi, " .").concat(zi, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(No, `] {
    `).concat(Dy, ": ").concat(s, `px;
  }
`);
}, Jd = function() {
  var e = parseInt(document.body.getAttribute(No) || "0", 10);
  return isFinite(e) ? e : 0;
}, ex = function() {
  P.useEffect(function() {
    return document.body.setAttribute(No, (Jd() + 1).toString()), function() {
      var e = Jd() - 1;
      e <= 0 ? document.body.removeAttribute(No) : document.body.setAttribute(No, e.toString());
    };
  }, []);
}, tx = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  ex();
  var a = P.useMemo(function() {
    return Zy(o);
  }, [o]);
  return P.createElement(Qy, { styles: Jy(a, !t, o, n ? "" : "!important") });
}, fl = !1;
if (typeof window < "u")
  try {
    var gi = Object.defineProperty({}, "passive", {
      get: function() {
        return fl = !0, !0;
      }
    });
    window.addEventListener("test", gi, gi), window.removeEventListener("test", gi, gi);
  } catch {
    fl = !1;
  }
var So = fl ? { passive: !1 } : !1, nx = function(e) {
  return e.tagName === "TEXTAREA";
}, Pp = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !nx(e) && n[t] === "visible")
  );
}, rx = function(e) {
  return Pp(e, "overflowY");
}, ox = function(e) {
  return Pp(e, "overflowX");
}, ef = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = Ap(e, n);
    if (r) {
      var o = Op(e, n), a = o[1], i = o[2];
      if (a > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, ax = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, ix = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Ap = function(e, t) {
  return e === "v" ? rx(t) : ox(t);
}, Op = function(e, t) {
  return e === "v" ? ax(t) : ix(t);
}, sx = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, cx = function(e, t, n, r, o) {
  var a = sx(e, window.getComputedStyle(t).direction), i = a * r, s = n.target, c = t.contains(s), l = !1, d = i > 0, u = 0, v = 0;
  do {
    var m = Op(e, s), b = m[0], x = m[1], g = m[2], k = x - g - a * b;
    (b || k) && Ap(e, s) && (u += k, v += b), s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (d && (o && u === 0 || !o && i > u) || !d && (o && v === 0 || !o && -i > v)) && (l = !0), l;
}, bi = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, tf = function(e) {
  return [e.deltaX, e.deltaY];
}, nf = function(e) {
  return e && "current" in e ? e.current : e;
}, lx = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, ux = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, dx = 0, ko = [];
function fx(e) {
  var t = P.useRef([]), n = P.useRef([0, 0]), r = P.useRef(), o = P.useState(dx++)[0], a = P.useState(function() {
    return Cp();
  })[0], i = P.useRef(e);
  P.useEffect(function() {
    i.current = e;
  }, [e]), P.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var x = Ry([e.lockRef.current], (e.shards || []).map(nf), !0).filter(Boolean);
      return x.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), x.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = P.useCallback(function(x, g) {
    if ("touches" in x && x.touches.length === 2)
      return !i.current.allowPinchZoom;
    var k = bi(x), $ = n.current, T = "deltaX" in x ? x.deltaX : $[0] - k[0], S = "deltaY" in x ? x.deltaY : $[1] - k[1], C, N = x.target, U = Math.abs(T) > Math.abs(S) ? "h" : "v";
    if ("touches" in x && U === "h" && N.type === "range")
      return !1;
    var L = ef(U, N);
    if (!L)
      return !0;
    if (L ? C = U : (C = U === "v" ? "h" : "v", L = ef(U, N)), !L)
      return !1;
    if (!r.current && "changedTouches" in x && (T || S) && (r.current = C), !C)
      return !0;
    var j = r.current || C;
    return cx(j, g, x, j === "h" ? T : S, !0);
  }, []), c = P.useCallback(function(x) {
    var g = x;
    if (!(!ko.length || ko[ko.length - 1] !== a)) {
      var k = "deltaY" in g ? tf(g) : bi(g), $ = t.current.filter(function(C) {
        return C.name === g.type && C.target === g.target && lx(C.delta, k);
      })[0];
      if ($ && $.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!$) {
        var T = (i.current.shards || []).map(nf).filter(Boolean).filter(function(C) {
          return C.contains(g.target);
        }), S = T.length > 0 ? s(g, T[0]) : !i.current.noIsolation;
        S && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = P.useCallback(function(x, g, k, $) {
    var T = { name: x, delta: g, target: k, should: $ };
    t.current.push(T), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== T;
      });
    }, 1);
  }, []), d = P.useCallback(function(x) {
    n.current = bi(x), r.current = void 0;
  }, []), u = P.useCallback(function(x) {
    l(x.type, tf(x), x.target, s(x, e.lockRef.current));
  }, []), v = P.useCallback(function(x) {
    l(x.type, bi(x), x.target, s(x, e.lockRef.current));
  }, []);
  P.useEffect(function() {
    return ko.push(a), e.setCallbacks({
      onScrollCapture: u,
      onWheelCapture: u,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", c, So), document.addEventListener("touchmove", c, So), document.addEventListener("touchstart", d, So), function() {
      ko = ko.filter(function(x) {
        return x !== a;
      }), document.removeEventListener("wheel", c, So), document.removeEventListener("touchmove", c, So), document.removeEventListener("touchstart", d, So);
    };
  }, []);
  var m = e.removeScrollBar, b = e.inert;
  return P.createElement(
    P.Fragment,
    null,
    b ? P.createElement(a, { styles: ux(o) }) : null,
    m ? P.createElement(tx, { gapMode: "margin" }) : null
  );
}
const mx = Uy(_p, fx);
var Np = P.forwardRef(function(e, t) {
  return P.createElement(_s, or({}, e, { ref: t, sideCar: mx }));
});
Np.classNames = _s.classNames;
const tu = Np;
var px = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, _o = /* @__PURE__ */ new WeakMap(), yi = /* @__PURE__ */ new WeakMap(), xi = {}, xc = 0, Rp = function(e) {
  return e && (e.host || Rp(e.parentNode));
}, hx = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Rp(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, vx = function(e, t, n, r) {
  var o = hx(t, Array.isArray(e) ? e : [e]);
  xi[n] || (xi[n] = /* @__PURE__ */ new WeakMap());
  var a = xi[n], i = [], s = /* @__PURE__ */ new Set(), c = new Set(o), l = function(u) {
    !u || s.has(u) || (s.add(u), l(u.parentNode));
  };
  o.forEach(l);
  var d = function(u) {
    !u || c.has(u) || Array.prototype.forEach.call(u.children, function(v) {
      if (s.has(v))
        d(v);
      else
        try {
          var m = v.getAttribute(r), b = m !== null && m !== "false", x = (_o.get(v) || 0) + 1, g = (a.get(v) || 0) + 1;
          _o.set(v, x), a.set(v, g), i.push(v), x === 1 && b && yi.set(v, !0), g === 1 && v.setAttribute(n, "true"), b || v.setAttribute(r, "true");
        } catch (k) {
          console.error("aria-hidden: cannot operate on ", v, k);
        }
    });
  };
  return d(t), s.clear(), xc++, function() {
    i.forEach(function(u) {
      var v = _o.get(u) - 1, m = a.get(u) - 1;
      _o.set(u, v), a.set(u, m), v || (yi.has(u) || u.removeAttribute(r), yi.delete(u)), m || u.removeAttribute(n);
    }), xc--, xc || (_o = /* @__PURE__ */ new WeakMap(), _o = /* @__PURE__ */ new WeakMap(), yi = /* @__PURE__ */ new WeakMap(), xi = {});
  };
}, nu = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || px(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), vx(r, o, n, "aria-hidden")) : function() {
    return null;
  };
};
const Mp = "Dialog", [Dp, Ip] = Hn(Mp), [gx, Zn] = Dp(Mp), bx = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: o, onOpenChange: a, modal: i = !0 } = e, s = Z(null), c = Z(null), [l = !1, d] = fy({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ I(gx, {
    scope: t,
    triggerRef: s,
    contentRef: c,
    contentId: Ln(),
    titleId: Ln(),
    descriptionId: Ln(),
    open: l,
    onOpenChange: d,
    onOpenToggle: Ie(
      () => d(
        (u) => !u
      ),
      [
        d
      ]
    ),
    modal: i
  }, n);
}, yx = "DialogTrigger", xx = /* @__PURE__ */ M((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = Zn(yx, n), a = ct(t, o.triggerRef);
  return /* @__PURE__ */ I(lt.button, oe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": ru(o.open)
  }, r, {
    ref: a,
    onClick: Le(e.onClick, o.onOpenToggle)
  }));
}), jp = "DialogPortal", [wx, Lp] = Dp(jp, {
  forceMount: void 0
}), Ex = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = Zn(jp, t);
  return /* @__PURE__ */ I(wx, {
    scope: t,
    forceMount: n
  }, Tn.map(
    r,
    (i) => /* @__PURE__ */ I(ks, {
      present: n || a.open
    }, /* @__PURE__ */ I(Ss, {
      asChild: !0,
      container: o
    }, i))
  ));
}, ml = "DialogOverlay", $x = /* @__PURE__ */ M((e, t) => {
  const n = Lp(ml, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Zn(ml, e.__scopeDialog);
  return a.modal ? /* @__PURE__ */ I(ks, {
    present: r || a.open
  }, /* @__PURE__ */ I(Tx, oe({}, o, {
    ref: t
  }))) : null;
}), Tx = /* @__PURE__ */ M((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = Zn(ml, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ I(tu, {
      as: Tr,
      allowPinchZoom: !0,
      shards: [
        o.contentRef
      ]
    }, /* @__PURE__ */ I(lt.div, oe({
      "data-state": ru(o.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), Do = "DialogContent", Sx = /* @__PURE__ */ M((e, t) => {
  const n = Lp(Do, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = Zn(Do, e.__scopeDialog);
  return /* @__PURE__ */ I(ks, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ I(kx, oe({}, o, {
    ref: t
  })) : /* @__PURE__ */ I(_x, oe({}, o, {
    ref: t
  })));
}), kx = /* @__PURE__ */ M((e, t) => {
  const n = Zn(Do, e.__scopeDialog), r = Z(null), o = ct(t, n.contentRef, r);
  return Ee(() => {
    const a = r.current;
    if (a)
      return nu(a);
  }, []), /* @__PURE__ */ I(Fp, oe({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Le(e.onCloseAutoFocus, (a) => {
      var i;
      a.preventDefault(), (i = n.triggerRef.current) === null || i === void 0 || i.focus();
    }),
    onPointerDownOutside: Le(e.onPointerDownOutside, (a) => {
      const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
      (i.button === 2 || s) && a.preventDefault();
    }),
    onFocusOutside: Le(
      e.onFocusOutside,
      (a) => a.preventDefault()
    )
  }));
}), _x = /* @__PURE__ */ M((e, t) => {
  const n = Zn(Do, e.__scopeDialog), r = Z(!1), o = Z(!1);
  return /* @__PURE__ */ I(Fp, oe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (a) => {
      var i, s;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = a.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
    }
  }));
}), Fp = /* @__PURE__ */ M((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = Zn(Do, n), c = Z(null), l = ct(t, c);
  return eu(), /* @__PURE__ */ I(Jt, null, /* @__PURE__ */ I(Jl, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ I(Ba, oe({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": ru(s.open)
  }, i, {
    ref: l,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), Wp = "DialogTitle", Cx = /* @__PURE__ */ M((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = Zn(Wp, n);
  return /* @__PURE__ */ I(lt.h2, oe({
    id: o.titleId
  }, r, {
    ref: t
  }));
}), Px = "DialogDescription", Ax = /* @__PURE__ */ M((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = Zn(Px, n);
  return /* @__PURE__ */ I(lt.p, oe({
    id: o.descriptionId
  }, r, {
    ref: t
  }));
}), Ox = "DialogClose", Nx = /* @__PURE__ */ M((e, t) => {
  const { __scopeDialog: n, ...r } = e, o = Zn(Ox, n);
  return /* @__PURE__ */ I(lt.button, oe({
    type: "button"
  }, r, {
    ref: t,
    onClick: Le(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
});
function ru(e) {
  return e ? "open" : "closed";
}
const Rx = "DialogTitleWarning", [Mx, Bz] = sy(Rx, {
  contentName: Do,
  titleName: Wp,
  docsSlug: "dialog"
}), ou = bx, au = xx, iu = Ex, za = $x, Va = Sx, Ga = Cx, qa = Ax, Uo = Nx, Dx = "AlertDialog", [Ix, zz] = Hn(Dx, [
  Ip
]), Cr = Ip(), jx = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = Cr(t);
  return /* @__PURE__ */ I(ou, oe({}, r, n, {
    modal: !0
  }));
}, Lx = /* @__PURE__ */ M((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Cr(n);
  return /* @__PURE__ */ I(au, oe({}, o, r, {
    ref: t
  }));
}), Fx = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = Cr(t);
  return /* @__PURE__ */ I(iu, oe({}, r, n));
}, Wx = /* @__PURE__ */ M((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Cr(n);
  return /* @__PURE__ */ I(za, oe({}, o, r, {
    ref: t
  }));
}), Hp = "AlertDialogContent", [Hx, Ux] = Ix(Hp), Bx = /* @__PURE__ */ M((e, t) => {
  const { __scopeAlertDialog: n, children: r, ...o } = e, a = Cr(n), i = Z(null), s = ct(t, i), c = Z(null);
  return /* @__PURE__ */ I(Mx, {
    contentName: Hp,
    titleName: zx,
    docsSlug: "alert-dialog"
  }, /* @__PURE__ */ I(Hx, {
    scope: n,
    cancelRef: c
  }, /* @__PURE__ */ I(Va, oe({
    role: "alertdialog"
  }, a, o, {
    ref: s,
    onOpenAutoFocus: Le(o.onOpenAutoFocus, (l) => {
      var d;
      l.preventDefault(), (d = c.current) === null || d === void 0 || d.focus({
        preventScroll: !0
      });
    }),
    onPointerDownOutside: (l) => l.preventDefault(),
    onInteractOutside: (l) => l.preventDefault()
  }), /* @__PURE__ */ I(Ql, null, r), !1)));
}), zx = "AlertDialogTitle", Vx = /* @__PURE__ */ M((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Cr(n);
  return /* @__PURE__ */ I(Ga, oe({}, o, r, {
    ref: t
  }));
}), Gx = /* @__PURE__ */ M((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Cr(n);
  return /* @__PURE__ */ I(qa, oe({}, o, r, {
    ref: t
  }));
}), qx = /* @__PURE__ */ M((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = Cr(n);
  return /* @__PURE__ */ I(Uo, oe({}, o, r, {
    ref: t
  }));
}), Yx = "AlertDialogCancel", Kx = /* @__PURE__ */ M((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, { cancelRef: o } = Ux(Yx, n), a = Cr(n), i = ct(t, o);
  return /* @__PURE__ */ I(Uo, oe({}, a, r, {
    ref: i
  }));
}), Xx = jx, Zx = Lx, Qx = Fx, Up = Wx, Bp = Bx, zp = qx, Vp = Kx, Gp = Vx, qp = Gx, Jx = Wn(
  "inline-block animate-spin rounded-full border-solid border-sky.cloudy/50 border-r-sky.1 align-[-0.125em] motion-reduce:animate-[spin_1.1s_linear_infinite]",
  {
    variants: {
      size: {
        tiny: "h-[1.125rem] w-[1.125rem] border-2",
        small: "h-6 w-6 border-[0.1875rem]",
        normal: "h-[3.375rem] w-[3.375rem] border-[0.375rem]"
      }
    },
    defaultVariants: {
      size: "normal"
    }
  }
), Bo = ({ size: e, className: t, ...n }) => /* @__PURE__ */ w.jsx("div", { ...n, className: z(Jx({ size: e, className: t })), children: /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: "Loading..." }) }), su = Wn(
  "relative inline-flex items-center justify-center gap-x-3 rounded text-sm transition-colors focus-visible:outline-none focus-visible:ring focus-visible:ring-sky.6 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        solid: "bg-sky.1 text-white hover:shadow-lg active:bg-sky.1/80 active:shadow-none",
        outline: "border border-grey.6 bg-white text-sky.1 hover:border-sky.cloudy active:border-sky.1",
        success: "border border-grey.6 bg-spring.1 text-white hover:border-sky.9 active:border-grey.6 active:bg-spring.1/80",
        text: "bg-transparent text-sky.4 underline hover:text-sky.cloudy active:text-sky.cloudy disabled:border-none disabled:bg-transparent",
        danger: "text-berry.1 underline active:text-berry.1/80 disabled:border-none disabled:bg-transparent"
      },
      loading: {
        true: "select-none transition-none disabled:text-transparent"
      },
      size: {
        default: "h-10 px-4 py-3",
        icon: "h-10 w-10 p-2"
      }
    },
    compoundVariants: [
      {
        loading: !1,
        className: "disabled:border disabled:border-sky.cloudy disabled:bg-grey.7 disabled:text-sky.cloudy"
      },
      {
        variant: "solid",
        loading: !1,
        className: "disabled:border-none disabled:shadow-none"
      },
      {
        variant: "text",
        loading: !1,
        className: "disabled:border-none disabled:bg-transparent"
      },
      {
        variant: "danger",
        loading: !1,
        className: "disabled:border-none disabled:bg-transparent"
      }
    ],
    defaultVariants: {
      variant: "solid",
      size: "default"
    }
  }
), la = {
  dark: "border-sky.cloudy/50 border-r-sky.1",
  light: "border-sky.cloudy/50 border-r-white",
  green: "border-spring.2/50 border-r-white",
  red: "border-berry.2/50 border-r-berry.1"
}, ew = Wn("transition-colors", {
  variants: {
    variant: {
      solid: la.light,
      outline: la.dark,
      success: la.green,
      text: la.dark,
      danger: la.red
    }
  },
  defaultVariants: {
    variant: "solid"
  }
}), vo = M(
  ({
    type: e = "button",
    variant: t,
    size: n,
    asChild: r = !1,
    loading: o = !1,
    children: a,
    className: i,
    disabled: s,
    ...c
  }, l) => {
    const d = r ? Tr : "button";
    return /* @__PURE__ */ w.jsxs(
      d,
      {
        ref: l,
        type: e,
        disabled: s || o,
        "aria-disabled": s || o,
        className: z(su({ variant: t, loading: o, size: n, className: i })),
        ...c,
        children: [
          a,
          o && /* @__PURE__ */ w.jsx("div", { className: "absolute flex h-full w-full items-center justify-center", children: /* @__PURE__ */ w.jsx(Bo, { size: "tiny", className: z(ew({ variant: t })) }) })
        ]
      }
    );
  }
);
vo.displayName = "Button";
const Vz = Xx, Gz = Zx, tw = Qx, nw = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Vp,
  {
    ref: n,
    className: z(
      su({ variant: "outline" }),
      "focus:ring focus:ring-sky.6",
      e
    ),
    ...t
  }
));
nw.displayName = Vp.displayName;
const rw = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  zp,
  {
    ref: n,
    className: z(
      su({ variant: "solid" }),
      "focus:ring focus:ring-sky.6",
      e
    ),
    ...t
  }
));
rw.displayName = zp.displayName;
const Yp = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Up,
  {
    className: z(
      "fixed inset-0 z-50 bg-sky.1 opacity-50 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
Yp.displayName = Up.displayName;
const ow = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsxs(tw, { children: [
  /* @__PURE__ */ w.jsx(Yp, {}),
  /* @__PURE__ */ w.jsx(
    Bp,
    {
      ref: n,
      className: z(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-[25rem] translate-x-[-50%] translate-y-[-50%] rounded-md bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] md:w-full",
        e
      ),
      ...t
    }
  )
] }));
ow.displayName = Bp.displayName;
const aw = ({
  className: e,
  ...t
}) => /* @__PURE__ */ w.jsx("div", { className: z("flex flex-col", e), ...t });
aw.displayName = "AlertDialogHeader";
const iw = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "div",
  {
    ref: n,
    className: z("ml-auto mt-8 flex gap-3", e),
    ...t
  }
));
iw.displayName = "AlertDialogFooter";
const sw = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Gp,
  {
    ref: n,
    className: z("mb-6 text-xl/[1.875rem] font-bold text-sky.1", e),
    ...t
  }
));
sw.displayName = Gp.displayName;
const cw = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  qp,
  {
    ref: n,
    className: z("text-label-l", e),
    ...t
  }
));
cw.displayName = qp.displayName;
var yr = /* @__PURE__ */ ((e) => (e.Positive = "Positive", e.Neutral = "Neutral", e.Negative = "Negative", e.Notset = "Notset", e.Balanced = "Balanced", e.Factual = "Factual", e))(yr || {}), Kt = /* @__PURE__ */ ((e) => (e[e.Headline = 1] = "Headline", e[e.SourceName = 2] = "SourceName", e[e.SourceDate = 4] = "SourceDate", e[e.Author = 8] = "Author", e[e.Excerpt = 16] = "Excerpt", e[e.Thumbnail = 32] = "Thumbnail", e[e.MentionsBar = 64] = "MentionsBar", e[e.Metadata = 128] = "Metadata", e))(Kt || {});
const Kp = 254;
var Hr = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.COMPACT = "compact", e))(Hr || {});
const Xp = Et({
  article: {},
  activeArticle: {},
  articleLayout: Hr.DEFAULT,
  componentsConfig: Kp
}), Rn = () => {
  const e = Ye(Xp);
  if (!e)
    throw new Error(
      "useArticleItemContext must be used within an ArticleItemContext provider"
    );
  return e;
}, pl = P.createContext(void 0), lw = {};
pl.Provider;
const uw = () => P.useContext(pl) ? P.useContext(pl) : lw, wc = typeof window > "u" ? global : window, Ec = "@griffel/";
function Zp(e, t) {
  return wc[Symbol.for(Ec + e)] || (wc[Symbol.for(Ec + e)] = t), wc[Symbol.for(Ec + e)];
}
const dw = /* @__PURE__ */ Zp("DEBUG_RESET_CLASSES", {}), Na = /* @__PURE__ */ Zp("DEFINITION_LOOKUP_TABLE", {}), wa = "data-make-styles-bucket", fw = "data-priority", mw = "r", Ea = 7, cr = "___", Qp = "_", Jp = process.env.NODE_ENV === "production" ? cr.length + Ea : cr.length + Ea + Qp.length + Ea, pw = 0, rf = 1;
function $c(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function Tc(e) {
  const t = e.length;
  if (t === Ea)
    return e;
  for (let n = t; n < Ea; n++)
    e += "0";
  return e;
}
function eh(e, t, n = []) {
  return process.env.NODE_ENV === "production" ? cr + Tc($c(e + t)) : cr + Tc($c(e + t)) + Qp + Tc($c(n.join("")));
}
function th(e, t) {
  let n = "", r = "";
  for (const o in e) {
    const a = e[o];
    if (a === 0) {
      r += o + " ";
      continue;
    }
    const i = Array.isArray(a), s = t === "rtl" ? (i ? a[1] : a) + " " : (i ? a[0] : a) + " ";
    n += s, r += s;
  }
  return [n.slice(0, -1), r.slice(0, -1)];
}
function of(e, t) {
  const n = {};
  for (const r in e) {
    const [o, a] = th(e[r], t);
    if (a === "") {
      n[r] = "";
      continue;
    }
    const i = eh(a, t), s = i + (o === "" ? "" : " " + o);
    Na[i] = [e[r], t], n[r] = s;
  }
  return n;
}
const Zi = {};
function hw() {
  let e = null, t = "", n = "";
  const r = new Array(arguments.length);
  let o = "";
  for (let v = 0; v < arguments.length; v++) {
    const m = arguments[v];
    if (typeof m == "string" && m !== "") {
      const b = m.indexOf(cr);
      if (b === -1)
        process.env.NODE_ENV !== "production" && m.split(" ").forEach((x) => {
          x.startsWith(mw) && dw[x] && (o ? console.error(`mergeClasses(): a passed string contains multiple classes produced by makeResetStyles (${m} & ${t}, this will lead to non-deterministic behavior. Learn more:https://griffel.js.org/react/api/make-reset-styles#limitations
Source string: ${m}`) : o = x);
        }), t += m + " ";
      else {
        const x = m.substr(b, Jp);
        b > 0 && (t += m.slice(0, b)), n += x, r[v] = x;
      }
      process.env.NODE_ENV !== "production" && m.indexOf(cr, b + 1) !== -1 && console.error(`mergeClasses(): a passed string contains multiple identifiers of atomic classes (classes that start with "${cr}"), it's possible that passed classes were concatenated in a wrong way. Source string: ${m}`);
    }
  }
  if (n === "")
    return t.slice(0, -1);
  const a = Zi[n];
  if (a !== void 0)
    return t + a;
  const i = [];
  for (let v = 0; v < arguments.length; v++) {
    const m = r[v];
    if (m) {
      const b = Na[m];
      b ? (i.push(b[pw]), process.env.NODE_ENV !== "production" && e !== null && e !== b[rf] && console.error(`mergeClasses(): a passed string contains an identifier (${m}) that has different direction (dir="${b[1] ? "rtl" : "ltr"}") setting than other classes. This is not supported. Source string: ${arguments[v]}`), e = b[rf]) : process.env.NODE_ENV !== "production" && console.error(`mergeClasses(): a passed string contains an identifier (${m}) that does not match any entry in cache. Source string: ${arguments[v]}`);
    }
  }
  const s = Object.assign.apply(
    Object,
    // .assign() mutates the first object, we can't mutate mappings as it will produce invalid results later
    [{}].concat(i)
  ), [c, l] = th(s, e), d = eh(l, e, r), u = d + " " + c;
  return Zi[n] = u, Na[d] = [s, e], t + u;
}
const af = {}, sf = /* @__PURE__ */ new Set(), $a = {
  getChildrenSequences: (e) => {
    const t = Object.keys(Zi).find((n) => Zi[n].startsWith(e));
    return t ? t.split(cr).filter((n) => n.length).map((n) => cr + n) : [];
  },
  addCSSRule: (e) => {
    sf.add(e);
  },
  addSequenceDetails: (e, t) => {
    Object.entries(e).forEach(([n, r]) => {
      af[r.substring(0, Jp)] = {
        slotName: n,
        sourceURL: t
      };
    });
  },
  getCSSRules: () => Array.from(sf),
  getSequenceDetails: (e) => af[e]
};
function cf(e, t) {
  return Array.isArray(e) ? t === "rtl" ? e[1] : e[0] : e || "";
}
function vw(e, t, n, r) {
  const o = e[0], a = e[1];
  return Object.entries(o).map(([i, s]) => {
    const c = cf(s, a);
    let l;
    if (n && t) {
      const d = n.find(({
        className: u
      }) => u === c);
      !d && t[0][i] ? l = cf(t[0][i], t[1]) : d && t[0][i] ? l = (r ? r.filter(({
        debugClassNames: v
      }) => v.filter(({
        className: m
      }) => m === c).length > 0).length > 0 : !1) ? d.className : d.overriddenBy : (!d && !t[0][i] || d && !t[0][i]) && (l = void 0);
    }
    return {
      className: c,
      overriddenBy: l
    };
  });
}
function nh(e, t) {
  const n = Na[e];
  if (n === void 0)
    return;
  const r = t ? Na[t.sequenceHash] : void 0, o = vw(n, r, t == null ? void 0 : t.debugClassNames, t == null ? void 0 : t.children), a = {
    sequenceHash: e,
    direction: n[1],
    children: [],
    debugClassNames: o
  };
  return $a.getChildrenSequences(a.sequenceHash).reverse().forEach((s) => {
    const c = nh(s, a);
    c && a.children.push(c);
  }), a.children.length || (a.rules = {}, a.debugClassNames.forEach(({
    className: s
  }) => {
    const c = $a.getSequenceDetails(e);
    c && (a.slot = c.slotName, a.sourceURL = c.sourceURL);
    const l = $a.getCSSRules().find((d) => d.includes(s));
    a.rules[s] = l;
  })), a;
}
function gw(e) {
  const t = e.defaultView;
  if (!t || t.__GRIFFEL_DEVTOOLS__)
    return;
  const n = {
    getInfo: (r) => {
      const o = Array.from(r.classList).find((a) => a.startsWith(cr));
      if (o !== void 0)
        return nh(o);
    }
  };
  Object.defineProperty(t, "__GRIFFEL_DEVTOOLS__", {
    configurable: !1,
    enumerable: !1,
    get() {
      return n;
    }
  });
}
const Qi = /* @__PURE__ */ (() => {
  var e;
  try {
    return !!(typeof window < "u" && (!((e = window.sessionStorage) === null || e === void 0) && e.getItem("__GRIFFEL_DEVTOOLS__")));
  } catch {
    return !1;
  }
})();
function bw(e) {
  if (!Array.isArray(e))
    return [e];
  if (process.env.NODE_ENV !== "production" && e.length > 2)
    throw new Error("CSS Bucket contains an entry with greater than 2 items, please report this to https://github.com/microsoft/griffel/issues");
  return e;
}
function yw(e, t, n, r) {
  const o = [];
  if (r[wa] = t, r[fw] = String(n), e)
    for (const i in r)
      e.setAttribute(i, r[i]);
  function a(i) {
    return e != null && e.sheet ? e.sheet.insertRule(i, e.sheet.cssRules.length) : o.push(i);
  }
  return {
    elementAttributes: r,
    insertRule: a,
    element: e,
    bucketName: t,
    cssRules() {
      return e != null && e.sheet ? Array.from(e.sheet.cssRules).map((i) => i.cssText) : o;
    }
  };
}
const xw = [
  // reset styles
  "r",
  // catch-all
  "d",
  // link
  "l",
  // visited
  "v",
  // focus-within
  "w",
  // focus
  "f",
  // focus-visible
  "i",
  // hover
  "h",
  // active
  "a",
  // at rules for reset styles
  "s",
  // keyframes
  "k",
  // at-rules
  "t",
  // @media rules
  "m",
  // @container rules
  "c"
], lf = /* @__PURE__ */ xw.reduce((e, t, n) => (e[t] = n, e), {});
function ww(e, t, n) {
  return (e === "m" ? e + t : e) + n;
}
function Ew(e, t, n, r, o = {}) {
  var a, i;
  const s = e === "m", c = (a = o.m) !== null && a !== void 0 ? a : "0", l = (i = o.p) !== null && i !== void 0 ? i : 0, d = ww(e, c, l);
  if (!r.stylesheets[d]) {
    const u = t && t.createElement("style"), v = yw(u, e, l, Object.assign({}, r.styleElementAttributes, s && {
      media: c
    }));
    r.stylesheets[d] = v, t && u && t.head.insertBefore(u, Tw(t, n, e, r, o));
  }
  return r.stylesheets[d];
}
function $w(e, t, n) {
  var r, o;
  const a = t + ((r = n.m) !== null && r !== void 0 ? r : ""), i = e.getAttribute(wa) + ((o = e.media) !== null && o !== void 0 ? o : "");
  return a === i;
}
function Tw(e, t, n, r, o = {}) {
  var a, i;
  const s = lf[n], c = (a = o.m) !== null && a !== void 0 ? a : "", l = (i = o.p) !== null && i !== void 0 ? i : 0;
  let d = (x) => s - lf[x.getAttribute(wa)], u = e.head.querySelectorAll(`[${wa}]`);
  if (n === "m") {
    const x = e.head.querySelectorAll(`[${wa}="${n}"]`);
    x.length && (u = x, d = (g) => r.compareMediaQueries(c, g.media));
  }
  const v = (x) => $w(x, n, o) ? l - Number(x.getAttribute("data-priority")) : d(x), m = u.length;
  let b = m - 1;
  for (; b >= 0; ) {
    const x = u.item(b);
    if (v(x) > 0)
      return x.nextSibling;
    b--;
  }
  return m > 0 ? u.item(0) : t ? t.nextSibling : null;
}
const Sw = /* @__PURE__ */ ["-moz-placeholder", "-moz-focus-inner", "-moz-focusring", "-ms-input-placeholder", "-moz-read-write", "-moz-read-only"].join("|"), kw = /* @__PURE__ */ new RegExp(`:(${Sw})`);
function uf(e, t) {
  try {
    e.insertRule(t);
  } catch (n) {
    process.env.NODE_ENV !== "production" && !kw.test(t) && console.error(`There was a problem inserting the following rule: "${t}"`, n);
  }
}
let _w = 0;
const Cw = (e, t) => e < t ? -1 : e > t ? 1 : 0;
function Pw(e = typeof document > "u" ? void 0 : document, t = {}) {
  const {
    classNameHashSalt: n,
    unstable_filterCSSRule: r,
    insertionPoint: o,
    styleElementAttributes: a,
    compareMediaQueries: i = Cw
  } = t, s = {
    classNameHashSalt: n,
    insertionCache: {},
    stylesheets: {},
    styleElementAttributes: Object.freeze(a),
    compareMediaQueries: i,
    id: `d${_w++}`,
    insertCSSRules(c) {
      for (const l in c) {
        const d = c[l];
        for (let u = 0, v = d.length; u < v; u++) {
          const [m, b] = bw(d[u]), x = Ew(l, e, o || null, s, b);
          s.insertionCache[m] || (s.insertionCache[m] = l, process.env.NODE_ENV !== "production" && Qi && $a.addCSSRule(m), r ? r(m) && uf(x, m) : uf(x, m));
        }
      }
    }
  };
  return e && process.env.NODE_ENV !== "production" && Qi && gw(e), s;
}
const cu = "<unknown>";
function Aw(e) {
  return Mw(e) || jw(e) || Fw(e);
}
const Ow = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)?\)?\s*$/i, Nw = /^\s*at ()((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)\s*$/i, Rw = /\((\S*)\)/;
function Mw(e) {
  const t = Ow.exec(e) || Nw.exec(e);
  if (!t)
    return null;
  let n = t[2];
  const r = n && n.indexOf("native") === 0, o = n && n.indexOf("eval") === 0, a = Rw.exec(n);
  return o && a != null && (n = a[1]), {
    loc: r ? null : t[2],
    name: t[1] || cu
  };
}
const Dw = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)\s*$/i, Iw = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function jw(e) {
  const t = Dw.exec(e);
  if (!t)
    return null;
  let n = t[3];
  const r = n && n.indexOf(" > eval") > -1, o = Iw.exec(n);
  return r && o != null && (n = o[1]), {
    loc: t[3],
    name: t[1] || cu
  };
}
const Lw = /^\s*(?:([^@]*)(?:\((.*?)\))?@)?(\S.*?)\s*$/i;
function Fw(e) {
  const t = Lw.exec(e);
  return t ? {
    loc: t[3],
    name: t[1] || cu
  } : null;
}
function Ww() {
  const e = String(new Error().stack).split(`
`), t = Hw(e);
  if (t === void 0)
    return;
  const n = Aw(t);
  return n == null ? void 0 : n.loc;
}
function Hw(e) {
  for (let t = e.length - 1; t >= 0; --t)
    if (e[t].includes("at getSourceURLfromError"))
      return e[t + 3];
}
const Uw = () => {
  const e = {};
  return function(n, r) {
    e[n.id] === void 0 && (n.insertCSSRules(r), e[n.id] = !0);
  };
};
function Bw(e, t, n = Uw) {
  const r = n();
  let o = null, a = null, i;
  process.env.NODE_ENV !== "production" && Qi && (i = Ww());
  function s(c) {
    const {
      dir: l,
      renderer: d
    } = c, u = l === "ltr";
    u ? o === null && (o = of(e, l)) : a === null && (a = of(e, l)), r(d, t);
    const v = u ? o : a;
    return process.env.NODE_ENV !== "production" && Qi && $a.addSequenceDetails(v, i), v;
  }
  return s;
}
function zw() {
  return typeof window < "u" && !!(window.document && window.document.createElement);
}
const df = (
  // @ts-expect-error Hack to make sure that `useInsertionEffect` will not cause bundling issues in older React versions
  // eslint-disable-next-line no-useless-concat
  P["useInsertionEffect"] ? P["useInsertionEffect"] : void 0
), Vw = () => {
  const e = {};
  return function(n, r) {
    if (df && zw()) {
      df(() => {
        n.insertCSSRules(r);
      }, [n, r]);
      return;
    }
    e[n.id] === void 0 && (n.insertCSSRules(r), e[n.id] = !0);
  };
}, Gw = /* @__PURE__ */ P.createContext(/* @__PURE__ */ Pw());
function qw() {
  return P.useContext(Gw);
}
const Yw = /* @__PURE__ */ P.createContext("ltr");
function Kw() {
  return P.useContext(Yw);
}
function Xw(e, t) {
  const n = Bw(e, t, Vw);
  return function() {
    const o = Kw(), a = qw();
    return n({
      dir: o,
      renderer: a
    });
  };
}
const Zw = Xw({
  root: {
    mc9l5x: "f1w7gpdv",
    Bg96gwp: "fez10in",
    ycbfsm: "fg4l7m0"
  },
  rtl: {
    Bz10aip: "f13rod7r"
  }
}, {
  d: [".f1w7gpdv{display:inline;}", ".fez10in{line-height:0;}", ".f13rod7r{-webkit-transform:scaleX(-1);-moz-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1);}"],
  t: ["@media (forced-colors: active){.fg4l7m0{forced-color-adjust:auto;}}"]
}), Qw = (e, t) => {
  const {
    title: n,
    primaryFill: r = "currentColor",
    ...o
  } = e, a = {
    ...o,
    title: void 0,
    fill: r
  }, i = Zw(), s = uw();
  return a.className = hw(i.root, (t == null ? void 0 : t.flipInRtl) && (s == null ? void 0 : s.textDirection) === "rtl" && i.rtl, a.className), n && (a["aria-label"] = n), !a["aria-label"] && !a["aria-labelledby"] ? a["aria-hidden"] = !0 : a.role = "img", a;
}, zt = (e, t, n, r) => {
  const o = t === "1em" ? "20" : t, a = P.forwardRef((i, s) => {
    const c = {
      ...Qw(i, {
        flipInRtl: r == null ? void 0 : r.flipInRtl
      }),
      ref: s,
      width: t,
      height: t,
      viewBox: `0 0 ${o} ${o}`,
      xmlns: "http://www.w3.org/2000/svg"
    };
    return P.createElement("svg", c, ...n.map((l) => P.createElement("path", {
      d: l,
      fill: c.fill
    })));
  });
  return a.displayName = e, a;
}, Jw = /* @__PURE__ */ zt("Checkmark20Filled", "20", ["M7.03 13.9 3.56 10a.75.75 0 0 0-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 0 0-1.06-1.06l-9.94 9.94Z"]), e2 = /* @__PURE__ */ zt("Checkmark20Regular", "20", ["M3.37 10.17a.5.5 0 0 0-.74.66l4 4.5c.19.22.52.23.72.02l10.5-10.5a.5.5 0 0 0-.7-.7L7.02 14.27l-3.65-4.1Z"]), t2 = /* @__PURE__ */ zt("CheckmarkCircle16Filled", "16", ["M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm2.12 4.16L7.25 9.04l-1.4-1.4a.5.5 0 1 0-.7.71L6.9 10.1c.2.2.5.2.7 0l3.23-3.23a.5.5 0 0 0-.71-.7Z"]), Ya = /* @__PURE__ */ zt("ChevronDown16Regular", "16", ["M3.15 5.65c.2-.2.5-.2.7 0L8 9.79l4.15-4.14a.5.5 0 0 1 .7.7l-4.5 4.5a.5.5 0 0 1-.7 0l-4.5-4.5a.5.5 0 0 1 0-.7Z"]), n2 = /* @__PURE__ */ zt("ChevronLeft20Filled", "20", ["M12.27 15.8a.75.75 0 0 1-1.06-.03l-5-5.25a.75.75 0 0 1 0-1.04l5-5.25a.75.75 0 1 1 1.08 1.04L7.8 10l4.5 4.73c.29.3.28.78-.02 1.06Z"]), r2 = /* @__PURE__ */ zt("ChevronLeft20Regular", "20", ["M12.35 15.85a.5.5 0 0 1-.7 0L6.16 10.4a.55.55 0 0 1 0-.78l5.49-5.46a.5.5 0 1 1 .7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7Z"]), o2 = /* @__PURE__ */ zt("ChevronRight16Regular", "16", ["M5.65 3.15a.5.5 0 0 0 0 .7L9.79 8l-4.14 4.15a.5.5 0 0 0 .7.7l4.5-4.5a.5.5 0 0 0 0-.7l-4.5-4.5a.5.5 0 0 0-.7 0Z"]), a2 = /* @__PURE__ */ zt("ChevronRight20Filled", "20", ["M7.73 4.2a.75.75 0 0 1 1.06.03l5 5.25c.28.3.28.75 0 1.04l-5 5.25a.75.75 0 1 1-1.08-1.04L12.2 10l-4.5-4.73a.75.75 0 0 1 .02-1.06Z"]), i2 = /* @__PURE__ */ zt("ChevronRight20Regular", "20", ["M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 0 1-.7-.7L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7Z"]), s2 = /* @__PURE__ */ zt("Delete16Regular", "16", ["M7 3h2a1 1 0 0 0-2 0ZM6 3a2 2 0 1 1 4 0h4a.5.5 0 0 1 0 1h-.56l-1.2 8.84A2.5 2.5 0 0 1 9.74 15h-3.5a2.5 2.5 0 0 1-2.48-2.16L2.57 4H2a.5.5 0 0 1 0-1h4Zm1 3.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5ZM9.5 6c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5Zm-4.74 6.7c.1.75.74 1.3 1.49 1.3h3.5a1.5 1.5 0 0 0 1.5-1.3L12.42 4H3.57l1.19 8.7Z"]), rh = /* @__PURE__ */ zt("Dismiss12Filled", "12", ["m1.9 2.05.07-.08a.75.75 0 0 1 .98-.07l.08.07L6 4.94l2.97-2.97a.75.75 0 1 1 1.06 1.06L7.06 6l2.97 2.97c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L6 7.06l-2.97 2.97a.75.75 0 1 1-1.06-1.06L4.94 6 1.97 3.03a.75.75 0 0 1-.07-.98l.07-.08-.07.08Z"]), oh = /* @__PURE__ */ zt("Dismiss16Filled", "16", ["m2.4 2.55.07-.08a.75.75 0 0 1 .98-.07l.08.07L8 6.94l4.47-4.47a.75.75 0 1 1 1.06 1.06L9.06 8l4.47 4.47c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L8 9.06l-4.47 4.47a.75.75 0 0 1-1.06-1.06L6.94 8 2.47 3.53a.75.75 0 0 1-.07-.98l.07-.08-.07.08Z"]), ah = /* @__PURE__ */ zt("Dismiss16Regular", "16", ["m2.59 2.72.06-.07a.5.5 0 0 1 .63-.06l.07.06L8 7.29l4.65-4.64a.5.5 0 0 1 .7.7L8.71 8l4.64 4.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L8 8.71l-4.65 4.64a.5.5 0 0 1-.7-.7L7.29 8 2.65 3.35a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"]), c2 = /* @__PURE__ */ zt("Dismiss20Filled", "20", ["m3.9 4.05.07-.08a.75.75 0 0 1 .98-.07l.08.07L10 8.94l4.97-4.97a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.07.98l-.07.08L11.06 10l4.97 4.97c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L10 11.06l-4.97 4.97a.75.75 0 0 1-.98.07l-.08-.07a.75.75 0 0 1-.07-.98l.07-.08L8.94 10 3.97 5.03a.75.75 0 0 1-.07-.98l.07-.08-.07.08Z"]), l2 = /* @__PURE__ */ zt("Dismiss24Filled", "24", ["m4.21 4.39.08-.1a1 1 0 0 1 1.32-.08l.1.08L12 10.6l6.3-6.3a1 1 0 1 1 1.4 1.42L13.42 12l6.3 6.3a1 1 0 0 1 .08 1.31l-.08.1a1 1 0 0 1-1.32.08l-.1-.08L12 13.4l-6.3 6.3a1 1 0 0 1-1.4-1.42L10.58 12l-6.3-6.3a1 1 0 0 1-.08-1.31l.08-.1-.08.1Z"]), u2 = /* @__PURE__ */ zt("DocumentBulletList20Filled", "20", ["M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm-4 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm0 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm0 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2-4c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm3-8V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Z"]), d2 = /* @__PURE__ */ zt("ErrorCircle20Regular", "20", ["M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm0 9.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM10 6a.5.5 0 0 1 .5.41V11a.5.5 0 0 1-1 .09V6.5c0-.28.22-.5.5-.5Z"]), f2 = /* @__PURE__ */ zt("EyeTracking16Regular", "16", ["M4 2a2 2 0 0 0-2 2v1.5a.5.5 0 0 0 1 0V4a1 1 0 0 1 1-1h1.5a.5.5 0 0 0 0-1H4Zm0 12a2 2 0 0 1-2-2v-1.5a.5.5 0 0 1 1 0V12a1 1 0 0 0 1 1h1.5a.5.5 0 0 1 0 1H4ZM14 4a2 2 0 0 0-2-2h-1.5a.5.5 0 0 0 0 1H12a1 1 0 0 1 1 1v1.5a.5.5 0 0 0 1 0V4Zm-2 10a2 2 0 0 0 2-2v-1.5a.5.5 0 0 0-1 0V12a1 1 0 0 1-1 1h-1.5a.5.5 0 0 0 0 1H12ZM5.5 9a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM8 7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-4.69.46a.5.5 0 0 0 .65-.27v-.01L4 7.62c.02-.06.07-.14.13-.24.13-.2.34-.48.64-.76A4.6 4.6 0 0 1 8 5.5a4.6 4.6 0 0 1 3.23 1.12 3.73 3.73 0 0 1 .8 1.06s.25.45.66.28a.5.5 0 0 0 .27-.65c-.1-.22 0 0 0 0V7.3a1.8 1.8 0 0 0-.06-.13c-.04-.08-.1-.2-.19-.33a4.73 4.73 0 0 0-.81-.96A5.6 5.6 0 0 0 8 4.5a5.6 5.6 0 0 0-3.9 1.38A4.73 4.73 0 0 0 3.04 7.3v.01a.5.5 0 0 0 .27.65Z"]), Sc = /* @__PURE__ */ zt("Globe20Filled", "20", ["M7.99 4.18c-.28.66-.5 1.45-.67 2.32h5.36c-.17-.87-.4-1.66-.67-2.32-.3-.73-.65-1.3-1-1.66C10.64 2.15 10.3 2 10 2c-.3 0-.65.15-1 .52-.36.37-.71.93-1.01 1.66Zm-.1-1.9c-.31.43-.59.94-.83 1.52-.32.78-.58 1.7-.76 2.7H2.8c1-2.05 2.85-3.6 5.1-4.22Zm4.22 0c.31.43.59.94.83 1.52.32.78.58 1.7.76 2.7h3.5a8.02 8.02 0 0 0-5.09-4.22Zm5.5 5.22h-3.76a20.52 20.52 0 0 1 0 5h3.75a8 8 0 0 0 0-5Zm-.41 6h-3.5c-.18 1-.44 1.92-.76 2.7-.24.58-.52 1.1-.83 1.52a8.02 8.02 0 0 0 5.09-4.22ZM10 18c.3 0 .65-.15 1-.52.36-.37.71-.93 1.01-1.66.28-.66.5-1.45.67-2.32H7.32c.17.87.4 1.66.67 2.32.3.73.65 1.3 1 1.66.36.37.7.52 1.01.52Zm-2.1-.28a8.02 8.02 0 0 1-5.1-4.22h3.5c.18 1 .44 1.92.76 2.7.24.58.52 1.1.83 1.52ZM2.4 12.5h3.75a20.52 20.52 0 0 1 0-5H2.4a8 8 0 0 0 0 5ZM7 10c0-.87.06-1.71.16-2.5h5.68a19.44 19.44 0 0 1 0 5H7.16C7.06 11.71 7 10.87 7 10Z"]), m2 = /* @__PURE__ */ zt("Mic20Filled", "20", ["M5.5 10a.5.5 0 0 0-1 0 5.5 5.5 0 0 0 5 5.48v2.02a.5.5 0 0 0 1 0v-2.02c2.8-.26 5-2.61 5-5.48a.5.5 0 0 0-1 0 4.5 4.5 0 1 1-9 0Zm7.5 0a3 3 0 0 1-6 0V5a3 3 0 0 1 6 0v5Z"]), p2 = /* @__PURE__ */ zt("News20Filled", "20", ["M5 12v-2h2v2H5Zm10-7.5c0-.83-.67-1.5-1.5-1.5H3.42c-.83 0-1.5.67-1.5 1.5v9a2.5 2.5 0 0 0 2.5 2.5h11.16a2.5 2.5 0 0 0 2.5-2.5v-6c0-.83-.67-1.5-1.5-1.5H16v7.23a.5.5 0 0 1-1 0V4.5Zm-11 2c0-.28.22-.5.5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5ZM9.5 9h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1ZM9 12.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.5 9h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5Z"]), ff = /* @__PURE__ */ zt("Play12Filled", "12", ["M4.5 2a1 1 0 0 0-1.5.86v6.28a1 1 0 0 0 1.5.87l5.49-3.14a1 1 0 0 0 0-1.74L4.49 2Z"]), ih = /* @__PURE__ */ zt("Search20Regular", "20", ["M8.5 3a5.5 5.5 0 0 1 4.23 9.02l4.12 4.13a.5.5 0 0 1-.63.76l-.07-.06-4.13-4.12A5.5 5.5 0 1 1 8.5 3Zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"]), h2 = /* @__PURE__ */ zt("Tv20Filled", "20", ["M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm3.5 10a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z"]);
var sh = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, mf = ce.createContext && ce.createContext(sh), Lr = globalThis && globalThis.__assign || function() {
  return Lr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Lr.apply(this, arguments);
}, v2 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function ch(e) {
  return e && e.map(function(t, n) {
    return ce.createElement(t.tag, Lr({
      key: n
    }, t.attr), ch(t.child));
  });
}
function go(e) {
  return function(t) {
    return ce.createElement(g2, Lr({
      attr: Lr({}, e.attr)
    }, t), ch(e.child));
  };
}
function g2(e) {
  var t = function(n) {
    var r = e.attr, o = e.size, a = e.title, i = v2(e, ["attr", "size", "title"]), s = o || n.size || "1em", c;
    return n.className && (c = n.className), e.className && (c = (c ? c + " " : "") + e.className), ce.createElement("svg", Lr({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, r, i, {
      className: c,
      style: Lr(Lr({
        color: e.color || n.color
      }, n.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), a && ce.createElement("title", null, a), e.children);
  };
  return mf !== void 0 ? ce.createElement(mf.Consumer, null, function(n) {
    return t(n);
  }) : t(sh);
}
function b2(e) {
  return go({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M15.4024 21V14.0344H17.7347L18.0838 11.3265H15.4024V9.59765C15.4024 8.81364 15.62 8.27934 16.7443 8.27934L18.1783 8.27867V5.85676C17.9302 5.82382 17.0791 5.75006 16.0888 5.75006C14.0213 5.75006 12.606 7.01198 12.606 9.32952V11.3265H10.2677V14.0344H12.606V21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H15.4024Z" } }] })(e);
}
function y2(e) {
  return go({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M13.0281 2.00098C14.1535 2.00284 14.7238 2.00879 15.2166 2.02346L15.4107 2.02981C15.6349 2.03778 15.8561 2.04778 16.1228 2.06028C17.1869 2.10944 17.9128 2.27778 18.5503 2.52528C19.2094 2.77944 19.7661 3.12278 20.3219 3.67861C20.8769 4.23444 21.2203 4.79278 21.4753 5.45028C21.7219 6.08694 21.8903 6.81361 21.9403 7.87778C21.9522 8.14444 21.9618 8.36564 21.9697 8.58989L21.976 8.78397C21.9906 9.27672 21.9973 9.8471 21.9994 10.9725L22.0002 11.7182C22.0003 11.8093 22.0003 11.9033 22.0003 12.0003L22.0002 12.2824L21.9996 13.0281C21.9977 14.1535 21.9918 14.7238 21.9771 15.2166L21.9707 15.4107C21.9628 15.6349 21.9528 15.8561 21.9403 16.1228C21.8911 17.1869 21.7219 17.9128 21.4753 18.5503C21.2211 19.2094 20.8769 19.7661 20.3219 20.3219C19.7661 20.8769 19.2069 21.2203 18.5503 21.4753C17.9128 21.7219 17.1869 21.8903 16.1228 21.9403C15.8561 21.9522 15.6349 21.9618 15.4107 21.9697L15.2166 21.976C14.7238 21.9906 14.1535 21.9973 13.0281 21.9994L12.2824 22.0002C12.1913 22.0003 12.0973 22.0003 12.0003 22.0003L11.7182 22.0002L10.9725 21.9996C9.8471 21.9977 9.27672 21.9918 8.78397 21.9771L8.58989 21.9707C8.36564 21.9628 8.14444 21.9528 7.87778 21.9403C6.81361 21.8911 6.08861 21.7219 5.45028 21.4753C4.79194 21.2211 4.23444 20.8769 3.67861 20.3219C3.12278 19.7661 2.78028 19.2069 2.52528 18.5503C2.27778 17.9128 2.11028 17.1869 2.06028 16.1228C2.0484 15.8561 2.03871 15.6349 2.03086 15.4107L2.02457 15.2166C2.00994 14.7238 2.00327 14.1535 2.00111 13.0281L2.00098 10.9725C2.00284 9.8471 2.00879 9.27672 2.02346 8.78397L2.02981 8.58989C2.03778 8.36564 2.04778 8.14444 2.06028 7.87778C2.10944 6.81278 2.27778 6.08778 2.52528 5.45028C2.77944 4.79194 3.12278 4.23444 3.67861 3.67861C4.23444 3.12278 4.79278 2.78028 5.45028 2.52528C6.08778 2.27778 6.81278 2.11028 7.87778 2.06028C8.14444 2.0484 8.36564 2.03871 8.58989 2.03086L8.78397 2.02457C9.27672 2.00994 9.8471 2.00327 10.9725 2.00111L13.0281 2.00098ZM12.0003 7.00028C9.23738 7.00028 7.00028 9.23981 7.00028 12.0003C7.00028 14.7632 9.23981 17.0003 12.0003 17.0003C14.7632 17.0003 17.0003 14.7607 17.0003 12.0003C17.0003 9.23738 14.7607 7.00028 12.0003 7.00028ZM12.0003 9.00028C13.6572 9.00028 15.0003 10.3429 15.0003 12.0003C15.0003 13.6572 13.6576 15.0003 12.0003 15.0003C10.3434 15.0003 9.00028 13.6576 9.00028 12.0003C9.00028 10.3434 10.3429 9.00028 12.0003 9.00028ZM17.2503 5.50028C16.561 5.50028 16.0003 6.06018 16.0003 6.74943C16.0003 7.43867 16.5602 7.99944 17.2503 7.99944C17.9395 7.99944 18.5003 7.43954 18.5003 6.74943C18.5003 6.06018 17.9386 5.49941 17.2503 5.50028Z" } }] })(e);
}
function x2(e) {
  return go({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M18.2048 2.25H21.5128L14.2858 10.51L22.7878 21.75H16.1308L10.9168 14.933L4.95084 21.75H1.64084L9.37084 12.915L1.21484 2.25H8.04084L12.7538 8.481L18.2048 2.25ZM17.0438 19.77H18.8768L7.04484 4.126H5.07784L17.0438 19.77Z" } }] })(e);
}
var lh = { exports: {} };
/*! For license information please see browser.native.js.LICENSE.txt */
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(jt, () => (() => {
    var n = { 9: function(i, s, c) {
      i.exports = function() {
        var l = function() {
          return l = Object.assign || function(f) {
            for (var p, y = 1, h = arguments.length; y < h; y++)
              for (var E in p = arguments[y])
                Object.prototype.hasOwnProperty.call(p, E) && (f[E] = p[E]);
            return f;
          }, l.apply(this, arguments);
        };
        function d(f) {
          var p = typeof Symbol == "function" && Symbol.iterator, y = p && f[p], h = 0;
          if (y)
            return y.call(f);
          if (f && typeof f.length == "number")
            return { next: function() {
              return f && h >= f.length && (f = void 0), { value: f && f[h++], done: !f };
            } };
          throw new TypeError(p ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        function u(f, p) {
          var y = typeof Symbol == "function" && f[Symbol.iterator];
          if (!y)
            return f;
          var h, E, _ = y.call(f), A = [];
          try {
            for (; (p === void 0 || p-- > 0) && !(h = _.next()).done; )
              A.push(h.value);
          } catch (F) {
            E = { error: F };
          } finally {
            try {
              h && !h.done && (y = _.return) && y.call(_);
            } finally {
              if (E)
                throw E.error;
            }
          }
          return A;
        }
        function v(f, p, y) {
          if (y || arguments.length === 2)
            for (var h, E = 0, _ = p.length; E < _; E++)
              !h && E in p || (h || (h = Array.prototype.slice.call(p, 0, E)), h[E] = p[E]);
          return f.concat(h || Array.prototype.slice.call(p));
        }
        typeof SuppressedError == "function" && SuppressedError;
        class m extends Error {
          constructor(p, y, h) {
            super(p), this.token = y, this.type = h || "error";
          }
        }
        const b = (f) => f < 4 ? "short" : f === 4 ? "long" : "narrow", x = (f) => f % 2 == 0 ? "2-digit" : "numeric";
        function g(f, p) {
          switch (f.width) {
            case 1:
              return "numeric";
            case 2:
              return "2-digit";
            case 3:
              return "short";
            case 4:
              return "long";
            case 5:
              return "narrow";
            default:
              return void p(`${f.desc} is not supported with width ${f.width}`);
          }
        }
        function k(f, p) {
          const { char: y, desc: h, width: E } = f;
          return y === "d" ? x(E) : void p(`${h} is not supported`);
        }
        function $(f, p) {
          const { char: y, desc: h, width: E } = f;
          return (y === "c" || y === "e") && E < 3 && p(`Numeric value is not supported for ${h}; falling back to weekday:short`, m.WARNING), b(E);
        }
        function T(f, p) {
          const { char: y, desc: h, width: E } = f;
          switch (y) {
            case "v":
            case "z":
              return E === 4 ? "long" : "short";
            case "V":
              return E === 4 ? "long" : void p(`${h} is not supported with width ${E}`);
            case "X":
              return void p(`${h} is not supported`);
          }
          return "short";
        }
        function S(f, p) {
          switch (f.field) {
            case "era":
              return { era: b(f.width) };
            case "year":
              return function(y, h) {
                switch (y.char) {
                  case "y":
                    return { year: x(y.width) };
                  case "r":
                    return { calendar: "gregory", year: "numeric" };
                  default:
                    return h(`${y.desc} is not supported; falling back to year:numeric`, m.WARNING), { year: "numeric" };
                }
              }(f, p);
            case "month":
              return { month: g(f, p) };
            case "day":
              return { day: k(f, p) };
            case "weekday":
              return { weekday: $(f, p) };
            case "period":
              return;
            case "hour":
              return function(y) {
                const h = x(y.width);
                let E;
                switch (y.char) {
                  case "h":
                    E = "h12";
                    break;
                  case "H":
                    E = "h23";
                    break;
                  case "k":
                    E = "h24";
                    break;
                  case "K":
                    E = "h11";
                }
                return E ? { hour: h, hourCycle: E } : { hour: h };
              }(f);
            case "min":
              return { minute: x(f.width) };
            case "sec":
              return { second: x(f.width) };
            case "tz":
              return { timeZoneName: T(f, p) };
            case "quarter":
            case "week":
            case "sec-frac":
            case "ms":
              p(`${f.desc} is not supported`);
          }
        }
        function C(f) {
          let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (E) => {
            throw E;
          };
          const y = {}, h = [];
          for (const E of f) {
            const { error: _, field: A, str: F } = E;
            if (_) {
              const ee = new m(_.message, E);
              ee.stack = _.stack, p(ee);
            }
            F && p(new m(`Ignoring string part: ${F}`, E, m.WARNING)), A && (h.indexOf(A) === -1 ? h.push(A) : p(new m(`Duplicate ${A} token`, E)));
            const B = S(E, (ee, we) => p(new m(ee, E, we)));
            B && Object.assign(y, B);
          }
          return y;
        }
        const N = { G: { field: "era", desc: "Era" }, y: { field: "year", desc: "Year" }, Y: { field: "year", desc: 'Year of "Week of Year"' }, u: { field: "year", desc: "Extended year" }, U: { field: "year", desc: "Cyclic year name" }, r: { field: "year", desc: "Related Gregorian year" }, Q: { field: "quarter", desc: "Quarter" }, q: { field: "quarter", desc: "Stand-alone quarter" }, M: { field: "month", desc: "Month in year" }, L: { field: "month", desc: "Stand-alone month in year" }, w: { field: "week", desc: "Week of year" }, W: { field: "week", desc: "Week of month" }, d: { field: "day", desc: "Day in month" }, D: { field: "day", desc: "Day of year" }, F: { field: "day", desc: "Day of week in month" }, g: { field: "day", desc: "Modified julian day" }, E: { field: "weekday", desc: "Day of week" }, e: { field: "weekday", desc: "Local day of week" }, c: { field: "weekday", desc: "Stand-alone local day of week" }, a: { field: "period", desc: "AM/PM marker" }, b: { field: "period", desc: "AM/PM/noon/midnight marker" }, B: { field: "period", desc: "Flexible day period" }, h: { field: "hour", desc: "Hour in AM/PM (1~12)" }, H: { field: "hour", desc: "Hour in day (0~23)" }, k: { field: "hour", desc: "Hour in day (1~24)" }, K: { field: "hour", desc: "Hour in AM/PM (0~11)" }, j: { field: "hour", desc: "Hour in preferred cycle" }, J: { field: "hour", desc: "Hour in preferred cycle without marker" }, C: { field: "hour", desc: "Hour in preferred cycle with flexible marker" }, m: { field: "min", desc: "Minute in hour" }, s: { field: "sec", desc: "Second in minute" }, S: { field: "sec-frac", desc: "Fractional second" }, A: { field: "ms", desc: "Milliseconds in day" }, z: { field: "tz", desc: "Time Zone: specific non-location" }, Z: { field: "tz", desc: "Time Zone" }, O: { field: "tz", desc: "Time Zone: localized" }, v: { field: "tz", desc: "Time Zone: generic non-location" }, V: { field: "tz", desc: "Time Zone: ID" }, X: { field: "tz", desc: "Time Zone: ISO8601 with Z" }, x: { field: "tz", desc: "Time Zone: ISO8601" } }, U = (f) => f >= "A" && f <= "Z" || f >= "a" && f <= "z";
        function L(f, p) {
          const y = f[p];
          if (!y)
            return null;
          if (U(y))
            return function(_, A) {
              const F = _[A];
              let B = 1;
              for (; _[++A] === F; )
                ++B;
              const ee = N[F];
              return ee ? { char: F, field: ee.field, desc: ee.desc, width: B } : { char: F, error: new Error(`The letter ${F} is not a valid field identifier`), width: B };
            }(f, p);
          if (y === "'")
            return function(_, A) {
              let F = _[++A], B = 2;
              if (F === "'")
                return { char: "'", str: F, width: B };
              for (; ; ) {
                const ee = _[++A];
                if (++B, ee === void 0)
                  return { char: "'", error: new Error(`Unterminated quoted literal in pattern: ${F || _}`), str: F, width: B };
                if (ee === "'") {
                  if (_[++A] !== "'")
                    return { char: "'", str: F, width: B };
                  ++B;
                }
                F += ee;
              }
            }(f, p);
          let h = y, E = 1;
          for (; ; ) {
            const _ = f[++p];
            if (!_ || U(_) || _ === "'")
              return { char: y, str: h, width: E };
            h += _, E += 1;
          }
        }
        function j(f) {
          const p = [];
          let y = 0;
          for (; ; ) {
            const h = L(f, y);
            if (!h)
              return p;
            p.push(h), y += h.width;
          }
        }
        class q extends Error {
          constructor(p, y) {
            super(y), this.code = p;
          }
        }
        class V extends q {
          constructor(p, y) {
            super("BAD_OPTION", `Unknown ${p} option: ${y}`), this.stem = p, this.option = y;
          }
        }
        class Q extends q {
          constructor(p) {
            super("BAD_STEM", `Unknown stem: ${p}`), this.stem = p;
          }
        }
        class ke extends q {
          constructor(p, y) {
            super("MASKED_VALUE", `Value for ${p} is set multiple times`), this.type = p, this.prev = y;
          }
        }
        class H extends q {
          constructor(p) {
            super("MISSING_OPTION", `Required option missing for ${p}`), this.stem = p;
          }
        }
        class X extends q {
          constructor(p, y) {
            super("BAD_PATTERN", y), this.char = p;
          }
        }
        class he extends q {
          constructor(p, y, h) {
            super("TOO_MANY_OPTIONS", `Token ${p} only supports ${h > 1 ? `${h} options` : "one option"} (got ${y.length})`), this.stem = p, this.options = y;
          }
        }
        class $e extends q {
          constructor(p, y) {
            super("UNSUPPORTED", `The stem ${p} is not supported`), this.stem = p, y && (this.message += ` with value ${y}`, this.source = y);
          }
        }
        function Te(f, p) {
          let { numberingSystem: y } = p;
          return Array.isArray(f) || (f = [f]), y ? f.map((h) => {
            const E = h.indexOf("-u-") === -1 ? "u-nu" : "nu";
            return `${h}-${E}-${y}`;
          }).concat(f) : f;
        }
        function fe(f) {
          let { scale: p, unit: y } = f, h = typeof p == "number" && p >= 0 ? p : 1;
          return y && y.style === "percent" && (h *= 0.01), h;
        }
        function Y(f, p) {
          const { decimal: y, group: h, integerWidth: E, notation: _, precision: A, roundingMode: F, sign: B, unit: ee, unitPer: we, unitWidth: De } = f, je = (Ge, xt) => {
            p && p(new $e(Ge, xt));
          }, be = {};
          if (ee)
            switch (ee.style) {
              case "base-unit":
                be.style = "decimal";
                break;
              case "currency":
                be.style = "currency", be.currency = ee.currency;
                break;
              case "measure-unit":
                be.style = "unit", be.unit = ee.unit.replace(/.*-/, ""), we && (be.unit += "-per-" + we.replace(/.*-/, ""));
                break;
              case "percent":
                be.style = "percent";
                break;
              case "permille":
                je("permille");
            }
          switch (De) {
            case "unit-width-full-name":
              be.currencyDisplay = "name", be.unitDisplay = "long";
              break;
            case "unit-width-hidden":
              je(De);
              break;
            case "unit-width-iso-code":
              be.currencyDisplay = "code";
              break;
            case "unit-width-narrow":
              be.currencyDisplay = "narrowSymbol", be.unitDisplay = "narrow";
              break;
            case "unit-width-short":
              be.currencyDisplay = "symbol", be.unitDisplay = "short";
          }
          switch (h) {
            case "group-off":
              be.useGrouping = !1;
              break;
            case "group-auto":
              be.useGrouping = !0;
              break;
            case "group-min2":
            case "group-on-aligned":
            case "group-thousands":
              je(h), be.useGrouping = !0;
          }
          if (A)
            switch (A.style) {
              case "precision-fraction": {
                const { minFraction: Ge, maxFraction: xt, minSignificant: Ct, maxSignificant: tt, source: ln } = A;
                typeof Ge == "number" && (be.minimumFractionDigits = Ge, typeof Ct == "number" && je("precision-fraction", ln)), typeof xt == "number" && (be.maximumFractionDigits = xt), typeof Ct == "number" && (be.minimumSignificantDigits = Ct), typeof tt == "number" && (be.maximumSignificantDigits = tt);
                break;
              }
              case "precision-integer":
                be.maximumFractionDigits = 0;
                break;
              case "precision-unlimited":
                be.maximumFractionDigits = 20;
                break;
              case "precision-increment":
                break;
              case "precision-currency-standard":
                be.trailingZeroDisplay = A.trailingZero;
                break;
              case "precision-currency-cash":
                je(A.style);
            }
          if (_)
            switch (_.style) {
              case "compact-short":
                be.notation = "compact", be.compactDisplay = "short";
                break;
              case "compact-long":
                be.notation = "compact", be.compactDisplay = "long";
                break;
              case "notation-simple":
                be.notation = "standard";
                break;
              case "scientific":
              case "engineering": {
                const { expDigits: Ge, expSign: xt, source: Ct, style: tt } = _;
                be.notation = tt, (Ge && Ge > 1 || xt && xt !== "sign-auto") && je(tt, Ct);
                break;
              }
            }
          if (E) {
            const { min: Ge, max: xt, source: Ct } = E;
            if (Ge > 0 && (be.minimumIntegerDigits = Ge), Number(xt) > 0) {
              const tt = be.notation === "engineering" || be.notation === "scientific";
              xt === 3 && tt ? be.notation = "engineering" : je("integer-width", Ct);
            }
          }
          switch (B) {
            case "sign-auto":
              be.signDisplay = "auto";
              break;
            case "sign-always":
              be.signDisplay = "always";
              break;
            case "sign-except-zero":
              be.signDisplay = "exceptZero";
              break;
            case "sign-never":
              be.signDisplay = "never";
              break;
            case "sign-accounting":
              be.currencySign = "accounting";
              break;
            case "sign-accounting-always":
              be.currencySign = "accounting", be.signDisplay = "always";
              break;
            case "sign-accounting-except-zero":
              be.currencySign = "accounting", be.signDisplay = "exceptZero";
          }
          return y === "decimal-always" && je(y), F && je(F), be;
        }
        function O(f, p, y) {
          const h = f[p];
          switch (h) {
            case "%":
              return { char: "%", style: "percent", width: 1 };
            case "‰":
              return { char: "%", style: "permille", width: 1 };
            case "¤": {
              let E = 1;
              for (; f[++p] === "¤"; )
                ++E;
              switch (E) {
                case 1:
                  return { char: h, currency: "default", width: E };
                case 2:
                  return { char: h, currency: "iso-code", width: E };
                case 3:
                  return { char: h, currency: "full-name", width: E };
                case 5:
                  return { char: h, currency: "narrow", width: E };
                default:
                  return y(new X("¤", `Invalid number (${E}) of ¤ chars in pattern`)), null;
              }
            }
            case "*": {
              const E = f[p + 1];
              if (E)
                return { char: h, pad: E, width: 2 };
              break;
            }
            case "+":
            case "-":
              return { char: h, width: 1 };
            case "'": {
              let E = f[++p], _ = 2;
              if (E === "'")
                return { char: h, str: E, width: _ };
              for (; ; ) {
                const A = f[++p];
                if (++_, A === void 0)
                  return y(new X("'", `Unterminated quoted literal in pattern: ${E}`)), { char: h, str: E, width: _ };
                if (A === "'") {
                  if (f[++p] !== "'")
                    return { char: h, str: E, width: _ };
                  ++_;
                }
                E += A;
              }
            }
          }
          return null;
        }
        const G = (f) => f >= "0" && f <= "9";
        function W(f, p) {
          const y = f[p];
          if (G(y)) {
            let h = y;
            for (; ; ) {
              const E = f[++p];
              if (!G(E))
                return { char: "0", digits: h, width: h.length };
              h += E;
            }
          }
          switch (y) {
            case "#": {
              let h = 1;
              for (; f[++p] === "#"; )
                ++h;
              return { char: y, width: h };
            }
            case "@": {
              let h = 1;
              for (; f[++p] === "@"; )
                ++h;
              let E = h;
              for (p -= 1; f[++p] === "#"; )
                ++E;
              return { char: y, min: h, width: E };
            }
            case "E": {
              const h = f[p + 1] === "+";
              h && ++p;
              let E = 0;
              for (; f[++p] === "0"; )
                ++E;
              if (E)
                return { char: y, expDigits: E, plus: h, width: (h ? 2 : 1) + E };
              break;
            }
            case ".":
            case ",":
              return { char: y, width: 1 };
          }
          return null;
        }
        function ae(f, p, y) {
          let h;
          (function(ee) {
            ee[ee.Prefix = 0] = "Prefix", ee[ee.Number = 1] = "Number", ee[ee.Suffix = 2] = "Suffix";
          })(h || (h = {}));
          const E = [], _ = [], A = [];
          let F = h.Prefix, B = "";
          for (; p < f.length; ) {
            const ee = f[p];
            if (ee === ";") {
              p += 1;
              break;
            }
            switch (F) {
              case h.Prefix: {
                const we = O(f, p, y);
                if (we)
                  B && (E.push({ char: "'", str: B, width: B.length }), B = ""), E.push(we), p += we.width;
                else {
                  const De = W(f, p);
                  De ? (B && (E.push({ char: "'", str: B, width: B.length }), B = ""), F = h.Number, _.push(De), p += De.width) : (B += ee, p += 1);
                }
                break;
              }
              case h.Number: {
                const we = W(f, p);
                we ? (_.push(we), p += we.width) : F = h.Suffix;
                break;
              }
              case h.Suffix: {
                const we = O(f, p, y);
                we ? (B && (A.push({ char: "'", str: B, width: B.length }), B = ""), A.push(we), p += we.width) : (B += ee, p += 1);
                break;
              }
            }
          }
          return B && A.push({ char: "'", str: B, width: B.length }), { pattern: { prefix: E, number: _, suffix: A }, pos: p };
        }
        function te(f, p, y, h, E) {
          let _ = !1, A = "";
          for (const F of f)
            switch (F.char) {
              case "%":
                p.unit = { style: F.style }, E ? _ = !0 : A = "";
                break;
              case "¤":
                if (!y) {
                  h(new X("¤", "The ¤ pattern requires a currency"));
                  break;
                }
                switch (p.unit = { style: "currency", currency: y }, F.currency) {
                  case "iso-code":
                    p.unitWidth = "unit-width-iso-code";
                    break;
                  case "full-name":
                    p.unitWidth = "unit-width-full-name";
                    break;
                  case "narrow":
                    p.unitWidth = "unit-width-narrow";
                }
                E ? _ = !0 : A = "";
                break;
              case "*":
                break;
              case "+":
                _ || (A += "+");
                break;
              case "'":
                _ || (A += F.str);
            }
          return A;
        }
        function se(f, p) {
          let y = !1, h = "";
          for (const E of f)
            switch (E.char) {
              case "%":
              case "¤":
                p ? y = !0 : h = "";
                break;
              case "-":
                y || (h += "-");
                break;
              case "'":
                y || (h += E.str);
            }
          return h;
        }
        function Se(f, p) {
          let y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (B) => {
            throw B;
          };
          const { tokens: h, negative: E } = function(B, ee) {
            const { pattern: we, pos: De } = ae(B, 0, ee);
            if (De < B.length) {
              const { pattern: je } = ae(B, De, ee);
              return { tokens: we, negative: je };
            }
            return { tokens: we };
          }(f, y), _ = function(B, ee) {
            const we = {};
            let De = !1, je = !1, be = 0, Ge = "", xt = -1, Ct = "", tt = 0;
            for (let Yt = 0; Yt < B.length; ++Yt) {
              const Gt = B[Yt];
              switch (Gt.char) {
                case "#":
                  xt === -1 ? (Ge && ee(new X("#", "Pattern has # after integer digits")), be += Gt.width) : tt += Gt.width;
                  break;
                case "0":
                  xt === -1 ? Ge += Gt.digits : (tt && ee(new X("0", "Pattern has digits after # in fraction")), Ct += Gt.digits);
                  break;
                case "@":
                  we.precision && ee(new ke("precision", we.precision)), we.precision = { style: "precision-fraction", minSignificant: Gt.min, maxSignificant: Gt.width };
                  break;
                case ",":
                  De = !0;
                  break;
                case ".":
                  xt === 1 && ee(new X(".", "Pattern has more than one decimal separator")), xt = Yt;
                  break;
                case "E":
                  je && ee(new ke("exponent", we.notation)), De && ee(new X("E", "Exponential patterns may not contain grouping separators")), we.notation = { style: "scientific" }, Gt.expDigits > 1 && (we.notation.expDigits = Gt.expDigits), Gt.plus && (we.notation.expSign = "sign-always"), je = !0;
              }
            }
            De ? we.group = "group-auto" : be + Ge.length > 3 && (we.group = "group-off");
            const ln = +`${Ge || "0"}.${Ct}`;
            if (ln && (we.precision = { style: "precision-increment", increment: ln }), je)
              if (we.precision && !ln || (we.integerWidth = be ? { min: 1, max: be + Ge.length } : { min: Math.max(1, Ge.length) }), we.precision)
                ln || (we.integerWidth = { min: 1, max: 1 });
              else {
                const Yt = Ge.length + Ct.length;
                xt === -1 ? Yt > 0 && (we.precision = { style: "precision-fraction", maxSignificant: Yt }) : (we.precision = { style: "precision-fraction", maxSignificant: Math.max(1, Yt) + tt }, Yt > 1 && (we.precision.minSignificant = Yt));
              }
            else
              Ge.length > 1 && (we.integerWidth = { min: Ge.length }), we.precision || !Ct.length && !tt || (we.precision = { style: "precision-fraction", minFraction: Ct.length, maxFraction: Ct.length + tt });
            return we;
          }(h.number, y), A = te(h.prefix, _, p, y, !0), F = te(h.suffix, _, p, y, !1);
          if (E) {
            const B = se(E.prefix, !0), ee = se(E.suffix, !1);
            _.affix = { pos: [A, F], neg: [B, ee] }, _.sign = "sign-never";
          } else
            (A || F) && (_.affix = { pos: [A, F] });
          return _;
        }
        function me(f) {
          const [p] = f.split("-", 1);
          return ["acceleration", "angle", "area", "concentr", "consumption", "digital", "duration", "electric", "energy", "force", "frequency", "graphics", "length", "light", "mass", "power", "pressure", "speed", "temperature", "torque", "volume"].indexOf(p) !== -1;
        }
        const ne = { "compact-short": 0, "compact-long": 0, "notation-simple": 0, scientific: 2, engineering: 2, percent: 0, permille: 0, "base-unit": 0, currency: 1, "measure-unit": 1, "per-measure-unit": 1, "unit-width-narrow": 0, "unit-width-short": 0, "unit-width-full-name": 0, "unit-width-iso-code": 0, "unit-width-hidden": 0, "precision-integer": 0, "precision-unlimited": 0, "precision-currency-standard": 1, "precision-currency-cash": 0, "precision-increment": 1, "rounding-mode-ceiling": 0, "rounding-mode-floor": 0, "rounding-mode-down": 0, "rounding-mode-up": 0, "rounding-mode-half-even": 0, "rounding-mode-half-down": 0, "rounding-mode-half-up": 0, "rounding-mode-unnecessary": 0, "integer-width": 1, scale: 1, "group-off": 0, "group-min2": 0, "group-auto": 0, "group-on-aligned": 0, "group-thousands": 0, latin: 0, "numbering-system": 1, "sign-auto": 0, "sign-always": 0, "sign-never": 0, "sign-accounting": 0, "sign-accounting-always": 0, "sign-except-zero": 0, "sign-accounting-except-zero": 0, "decimal-auto": 0, "decimal-always": 0 }, ye = { currency: 1, "integer-width": 1, "measure-unit": 1, "numbering-system": 1, "per-measure-unit": 1, "precision-increment": 1, scale: 1 };
        function ze(f, p, y) {
          if (function(h) {
            return h in ne;
          }(f)) {
            const h = ne[f];
            if (p.length > h) {
              if (h === 0)
                for (const E of p)
                  y(new V(f, E));
              else
                y(new he(f, p, h));
              return !1;
            }
            if (function(E) {
              return E in ye;
            }(f) && p.length < ye[f])
              return y(new H(f)), !1;
          }
          return !0;
        }
        function pe(f, p) {
          const y = p === "fraction" ? /^\.(0*)(\+|#*)$/ : /^(@+)(\+|#*)$/, h = f && f.match(y);
          if (h) {
            const E = h[1].length;
            switch (h[2].charAt(0)) {
              case "":
                return { min: E, max: E };
              case "+":
                return { min: E, max: null };
              case "#":
                return { min: E, max: E + h[2].length };
            }
          }
          return null;
        }
        class mt {
          constructor(p) {
            this.skeleton = {}, this.onError = p;
          }
          badOption(p, y) {
            this.onError(new V(p, y));
          }
          assertEmpty(p) {
            const y = this.skeleton[p];
            y && this.onError(new ke(p, y));
          }
          parseToken(p, y) {
            if (!ze(p, y, this.onError))
              return;
            const h = y[0], E = this.skeleton;
            switch (p) {
              case "compact-short":
              case "compact-long":
              case "notation-simple":
                this.assertEmpty("notation"), E.notation = { style: p };
                break;
              case "scientific":
              case "engineering": {
                let _, A = null;
                for (const B of y)
                  switch (B) {
                    case "sign-auto":
                    case "sign-always":
                    case "sign-never":
                    case "sign-accounting":
                    case "sign-accounting-always":
                    case "sign-except-zero":
                    case "sign-accounting-except-zero":
                      _ = B;
                      break;
                    default:
                      /^\+e+$/.test(B) ? A = B.length - 1 : this.badOption(p, B);
                  }
                this.assertEmpty("notation");
                const F = y.join("/");
                E.notation = A && _ ? { style: p, source: F, expDigits: A, expSign: _ } : A ? { style: p, source: F, expDigits: A } : _ ? { style: p, source: F, expSign: _ } : { style: p, source: F };
                break;
              }
              case "percent":
              case "permille":
              case "base-unit":
                this.assertEmpty("unit"), E.unit = { style: p };
                break;
              case "currency":
                /^[A-Z]{3}$/.test(h) ? (this.assertEmpty("unit"), E.unit = { style: p, currency: h }) : this.badOption(p, h);
                break;
              case "measure-unit":
                me(h) ? (this.assertEmpty("unit"), E.unit = { style: p, unit: h }) : this.badOption(p, h);
                break;
              case "per-measure-unit":
                me(h) ? (this.assertEmpty("unitPer"), E.unitPer = h) : this.badOption(p, h);
                break;
              case "unit-width-narrow":
              case "unit-width-short":
              case "unit-width-full-name":
              case "unit-width-iso-code":
              case "unit-width-hidden":
                this.assertEmpty("unitWidth"), E.unitWidth = p;
                break;
              case "precision-integer":
              case "precision-unlimited":
              case "precision-currency-cash":
                this.assertEmpty("precision"), E.precision = { style: p };
                break;
              case "precision-currency-standard":
                this.assertEmpty("precision"), E.precision = h === "w" ? { style: p, trailingZero: "stripIfInteger" } : { style: p };
                break;
              case "precision-increment": {
                const _ = Number(h);
                _ > 0 ? (this.assertEmpty("precision"), E.precision = { style: p, increment: _ }) : this.badOption(p, h);
                break;
              }
              case "rounding-mode-ceiling":
              case "rounding-mode-floor":
              case "rounding-mode-down":
              case "rounding-mode-up":
              case "rounding-mode-half-even":
              case "rounding-mode-half-odd":
              case "rounding-mode-half-ceiling":
              case "rounding-mode-half-floor":
              case "rounding-mode-half-down":
              case "rounding-mode-half-up":
              case "rounding-mode-unnecessary":
                this.assertEmpty("roundingMode"), E.roundingMode = p;
                break;
              case "integer-width":
                if (/^\+0*$/.test(h))
                  this.assertEmpty("integerWidth"), E.integerWidth = { source: h, min: h.length - 1 };
                else {
                  const _ = h.match(/^#*(0*)$/);
                  _ ? (this.assertEmpty("integerWidth"), E.integerWidth = { source: h, min: _[1].length, max: _[0].length }) : this.badOption(p, h);
                }
                break;
              case "scale": {
                const _ = Number(h);
                _ > 0 ? (this.assertEmpty("scale"), E.scale = _) : this.badOption(p, h);
                break;
              }
              case "group-off":
              case "group-min2":
              case "group-auto":
              case "group-on-aligned":
              case "group-thousands":
                this.assertEmpty("group"), E.group = p;
                break;
              case "latin":
                this.assertEmpty("numberingSystem"), E.numberingSystem = "latn";
                break;
              case "numbering-system":
                ["arab", "arabext", "bali", "beng", "deva", "fullwide", "gujr", "guru", "hanidec", "khmr", "knda", "laoo", "latn", "limb", "mlym", "mong", "mymr", "orya", "tamldec", "telu", "thai", "tibt"].indexOf(h) !== -1 ? (this.assertEmpty("numberingSystem"), E.numberingSystem = h) : this.badOption(p, h);
                break;
              case "sign-auto":
              case "sign-always":
              case "sign-never":
              case "sign-accounting":
              case "sign-accounting-always":
              case "sign-except-zero":
              case "sign-accounting-except-zero":
                this.assertEmpty("sign"), E.sign = p;
                break;
              case "decimal-auto":
              case "decimal-always":
                this.assertEmpty("decimal"), E.decimal = p;
                break;
              default: {
                const _ = function(A, F, B) {
                  const ee = pe(A, "fraction");
                  if (ee) {
                    F.length > 1 && B(new he(A, F, 1));
                    const De = { style: "precision-fraction", source: A, minFraction: ee.min };
                    ee.max != null && (De.maxFraction = ee.max);
                    const je = F[0], be = pe(je, "significant");
                    return be ? (De.source = `${A}/${je}`, De.minSignificant = be.min, be.max != null && (De.maxSignificant = be.max)) : je && B(new V(A, je)), De;
                  }
                  const we = pe(A, "significant");
                  if (we) {
                    for (const je of F)
                      B(new V(A, je));
                    const De = { style: "precision-fraction", source: A, minSignificant: we.min };
                    return we.max != null && (De.maxSignificant = we.max), De;
                  }
                  return null;
                }(p, y, this.onError);
                _ ? (this.assertEmpty("precision"), E.precision = _) : this.onError(new Q(p));
              }
            }
          }
        }
        function Ae(f) {
          let p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (E) => {
            throw E;
          };
          const y = [];
          for (const E of f.split(" "))
            if (E) {
              const _ = E.split("/"), A = _.shift() || "";
              y.push({ stem: A, options: _ });
            }
          const h = new mt(p);
          for (const { stem: E, options: _ } of y)
            h.parseToken(E, _);
          return h.skeleton;
        }
        function K(f, p, y, h) {
          typeof p == "string" && (p = p.indexOf("::") === 0 ? Ae(p.slice(2), h) : Se(p, y, h));
          const E = Te(f, p), _ = Y(p, h), A = function(B) {
            const ee = fe(B), { precision: we } = B;
            return we && we.style === "precision-increment" ? (De) => function(je, be) {
              const Ge = +je + be / 2;
              return Ge - Ge % +be;
            }(De, we.increment) * ee : (De) => De * ee;
          }(p), F = new Intl.NumberFormat(E, _);
          if (p.affix) {
            const [B, ee] = p.affix.pos, [we, De] = p.affix.neg || ["", ""];
            return (je) => {
              const be = F.format(A(je));
              return je < 0 ? `${we}${be}${De}` : `${B}${be}${ee}`;
            };
          }
          return (B) => F.format(A(B));
        }
        function ie(f, p, y, h) {
          typeof p == "string" && (p = p.indexOf("::") === 0 ? Ae(p.slice(2), h) : Se(p, y, h));
          const E = Te(f, p), _ = Y(p, h), A = function(ee) {
            const we = fe(ee), { precision: De } = ee;
            if (De && De.style === "precision-increment") {
              const je = "+n + " + De.increment / 2;
              let be = `x - (x % +${De.increment})`;
              return we !== 1 && (be = `(${be}) * ${we}`), `function(n) { var x = ${je}; return ${be}; }`;
            }
            return we !== 1 ? `function(n) { return n * ${we}; }` : null;
          }(p), F = ["(function() {", `var opt = ${JSON.stringify(_)};`, `var nf = new Intl.NumberFormat(${JSON.stringify(E)}, opt);`];
          let B = "nf.format(value)";
          if (A && (F.push(`var mod = ${A};`), B = "nf.format(mod(value))"), p.affix) {
            const [ee, we] = p.affix.pos.map((De) => JSON.stringify(De));
            if (p.affix.neg) {
              const [De, je] = p.affix.neg.map((be) => JSON.stringify(be));
              B = `value < 0 ? ${De} + ${B} + ${je} : ${ee} + ${B} + ${we}`;
            } else
              B = `${ee} + ${B} + ${we}`;
          }
          return F.push(`return function(value) { return ${B}; }`), F.join(`
  `) + `
})()`;
        }
        var ve = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : c.g !== void 0 ? c.g : typeof self < "u" ? self : {};
        function Me(f) {
          return f && f.__esModule && Object.prototype.hasOwnProperty.call(f, "default") ? f.default : f;
        }
        var Ue = {}, it = {}, et = { exports: {} };
        (function(f) {
          var p, y;
          p = ve, y = function() {
            var h = Object.prototype.hasOwnProperty, E = Object.prototype.toString, _ = typeof new RegExp().sticky == "boolean";
            function A(J) {
              return J && E.call(J) === "[object RegExp]";
            }
            function F(J) {
              return J && typeof J == "object" && !A(J) && !Array.isArray(J);
            }
            function B(J) {
              return "(" + J + ")";
            }
            function ee(J) {
              return J.length ? "(?:" + J.map(function(_e) {
                return "(?:" + _e + ")";
              }).join("|") + ")" : "(?!)";
            }
            function we(J) {
              if (typeof J == "string")
                return "(?:" + J.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&") + ")";
              if (A(J)) {
                if (J.ignoreCase)
                  throw new Error("RegExp /i flag not allowed");
                if (J.global)
                  throw new Error("RegExp /g flag is implied");
                if (J.sticky)
                  throw new Error("RegExp /y flag is implied");
                if (J.multiline)
                  throw new Error("RegExp /m flag is implied");
                return J.source;
              }
              throw new Error("Not a pattern: " + J);
            }
            function De(J, _e) {
              return J.length > _e ? J : Array(_e - J.length + 1).join(" ") + J;
            }
            function je(J, _e) {
              if (F(_e) || (_e = { match: _e }), _e.include)
                throw new Error("Matching rules cannot also include states");
              var We = { defaultType: J, lineBreaks: !!_e.error || !!_e.fallback, pop: !1, next: null, push: null, error: !1, fallback: !1, value: null, type: null, shouldThrow: !1 };
              for (var Ve in _e)
                h.call(_e, Ve) && (We[Ve] = _e[Ve]);
              if (typeof We.type == "string" && J !== We.type)
                throw new Error("Type transform cannot be a string (type '" + We.type + "' for token '" + J + "')");
              var Ke = We.match;
              return We.match = Array.isArray(Ke) ? Ke : Ke ? [Ke] : [], We.match.sort(function(He, pt) {
                return A(He) && A(pt) ? 0 : A(pt) ? -1 : A(He) ? 1 : pt.length - He.length;
              }), We;
            }
            function be(J) {
              return Array.isArray(J) ? function(_e) {
                for (var We = [], Ve = 0; Ve < _e.length; Ve++) {
                  var Ke = _e[Ve];
                  if (Ke.include)
                    for (var He = [].concat(Ke.include), pt = 0; pt < He.length; pt++)
                      We.push({ include: He[pt] });
                  else {
                    if (!Ke.type)
                      throw new Error("Rule has no type: " + JSON.stringify(Ke));
                    We.push(je(Ke.type, Ke));
                  }
                }
                return We;
              }(J) : function(_e) {
                for (var We = Object.getOwnPropertyNames(_e), Ve = [], Ke = 0; Ke < We.length; Ke++) {
                  var He = We[Ke], pt = _e[He], Pt = [].concat(pt);
                  if (He !== "include") {
                    var ht = [];
                    Pt.forEach(function(Zt) {
                      F(Zt) ? (ht.length && Ve.push(je(He, ht)), Ve.push(je(He, Zt)), ht = []) : ht.push(Zt);
                    }), ht.length && Ve.push(je(He, ht));
                  } else
                    for (var vt = 0; vt < Pt.length; vt++)
                      Ve.push({ include: Pt[vt] });
                }
                return Ve;
              }(J);
            }
            var Ge = je("error", { lineBreaks: !0, shouldThrow: !0 });
            function xt(J, _e) {
              for (var We = null, Ve = /* @__PURE__ */ Object.create(null), Ke = !0, He = null, pt = [], Pt = [], ht = 0; ht < J.length; ht++)
                J[ht].fallback && (Ke = !1);
              for (ht = 0; ht < J.length; ht++) {
                var vt = J[ht];
                if (vt.include)
                  throw new Error("Inheritance is not allowed in stateless lexers");
                if (vt.error || vt.fallback) {
                  if (We)
                    throw !vt.fallback == !We.fallback ? new Error("Multiple " + (vt.fallback ? "fallback" : "error") + " rules not allowed (for token '" + vt.defaultType + "')") : new Error("fallback and error are mutually exclusive (for token '" + vt.defaultType + "')");
                  We = vt;
                }
                var Zt = vt.match.slice();
                if (Ke)
                  for (; Zt.length && typeof Zt[0] == "string" && Zt[0].length === 1; )
                    Ve[Zt.shift().charCodeAt(0)] = vt;
                if (vt.pop || vt.push || vt.next) {
                  if (!_e)
                    throw new Error("State-switching options are not allowed in stateless lexers (for token '" + vt.defaultType + "')");
                  if (vt.fallback)
                    throw new Error("State-switching options are not allowed on fallback tokens (for token '" + vt.defaultType + "')");
                }
                if (Zt.length !== 0) {
                  Ke = !1, pt.push(vt);
                  for (var zn = 0; zn < Zt.length; zn++) {
                    var rr = Zt[zn];
                    if (A(rr)) {
                      if (He === null)
                        He = rr.unicode;
                      else if (He !== rr.unicode && vt.fallback === !1)
                        throw new Error("If one rule is /u then all must be");
                    }
                  }
                  var Vn = ee(Zt.map(we)), $n = new RegExp(Vn);
                  if ($n.test(""))
                    throw new Error("RegExp matches empty string: " + $n);
                  if (new RegExp("|" + Vn).exec("").length - 1 > 0)
                    throw new Error("RegExp has capture groups: " + $n + `
Use (?: … ) instead`);
                  if (!vt.lineBreaks && $n.test(`
`))
                    throw new Error("Rule should declare lineBreaks: " + $n);
                  Pt.push(B(Vn));
                }
              }
              var Cn = We && We.fallback, Mr = _ && !Cn ? "ym" : "gm", oa = _ || Cn ? "" : "|";
              return He === !0 && (Mr += "u"), { regexp: new RegExp(ee(Pt) + oa, Mr), groups: pt, fast: Ve, error: We || Ge };
            }
            function Ct(J, _e, We) {
              var Ve = J && (J.push || J.next);
              if (Ve && !We[Ve])
                throw new Error("Missing state '" + Ve + "' (in token '" + J.defaultType + "' of state '" + _e + "')");
              if (J && J.pop && +J.pop != 1)
                throw new Error("pop must be 1 (in token '" + J.defaultType + "' of state '" + _e + "')");
            }
            var tt = function(J, _e) {
              this.startState = _e, this.states = J, this.buffer = "", this.stack = [], this.reset();
            };
            tt.prototype.reset = function(J, _e) {
              return this.buffer = J || "", this.index = 0, this.line = _e ? _e.line : 1, this.col = _e ? _e.col : 1, this.queuedToken = _e ? _e.queuedToken : null, this.queuedText = _e ? _e.queuedText : "", this.queuedThrow = _e ? _e.queuedThrow : null, this.setState(_e ? _e.state : this.startState), this.stack = _e && _e.stack ? _e.stack.slice() : [], this;
            }, tt.prototype.save = function() {
              return { line: this.line, col: this.col, state: this.state, stack: this.stack.slice(), queuedToken: this.queuedToken, queuedText: this.queuedText, queuedThrow: this.queuedThrow };
            }, tt.prototype.setState = function(J) {
              if (J && this.state !== J) {
                this.state = J;
                var _e = this.states[J];
                this.groups = _e.groups, this.error = _e.error, this.re = _e.regexp, this.fast = _e.fast;
              }
            }, tt.prototype.popState = function() {
              this.setState(this.stack.pop());
            }, tt.prototype.pushState = function(J) {
              this.stack.push(this.state), this.setState(J);
            };
            var ln = _ ? function(J, _e) {
              return J.exec(_e);
            } : function(J, _e) {
              var We = J.exec(_e);
              return We[0].length === 0 ? null : We;
            };
            function Yt() {
              return this.value;
            }
            if (tt.prototype._getGroup = function(J) {
              for (var _e = this.groups.length, We = 0; We < _e; We++)
                if (J[We + 1] !== void 0)
                  return this.groups[We];
              throw new Error("Cannot find token type for matched text");
            }, tt.prototype.next = function() {
              var J = this.index;
              if (this.queuedGroup) {
                var _e = this._token(this.queuedGroup, this.queuedText, J);
                return this.queuedGroup = null, this.queuedText = "", _e;
              }
              var We = this.buffer;
              if (J !== We.length) {
                if (pt = this.fast[We.charCodeAt(J)])
                  return this._token(pt, We.charAt(J), J);
                var Ve = this.re;
                Ve.lastIndex = J;
                var Ke = ln(Ve, We), He = this.error;
                if (Ke == null)
                  return this._token(He, We.slice(J, We.length), J);
                var pt = this._getGroup(Ke), Pt = Ke[0];
                return He.fallback && Ke.index !== J ? (this.queuedGroup = pt, this.queuedText = Pt, this._token(He, We.slice(J, Ke.index), J)) : this._token(pt, Pt, J);
              }
            }, tt.prototype._token = function(J, _e, We) {
              var Ve = 0;
              if (J.lineBreaks) {
                var Ke = /\n/g, He = 1;
                if (_e === `
`)
                  Ve = 1;
                else
                  for (; Ke.exec(_e); )
                    Ve++, He = Ke.lastIndex;
              }
              var pt = { type: typeof J.type == "function" && J.type(_e) || J.defaultType, value: typeof J.value == "function" ? J.value(_e) : _e, text: _e, toString: Yt, offset: We, lineBreaks: Ve, line: this.line, col: this.col }, Pt = _e.length;
              if (this.index += Pt, this.line += Ve, Ve !== 0 ? this.col = Pt - He + 1 : this.col += Pt, J.shouldThrow)
                throw new Error(this.formatError(pt, "invalid syntax"));
              return J.pop ? this.popState() : J.push ? this.pushState(J.push) : J.next && this.setState(J.next), pt;
            }, typeof Symbol < "u" && Symbol.iterator) {
              var Gt = function(J) {
                this.lexer = J;
              };
              Gt.prototype.next = function() {
                var J = this.lexer.next();
                return { value: J, done: !J };
              }, Gt.prototype[Symbol.iterator] = function() {
                return this;
              }, tt.prototype[Symbol.iterator] = function() {
                return new Gt(this);
              };
            }
            return tt.prototype.formatError = function(J, _e) {
              if (J == null) {
                var We = this.buffer.slice(this.index);
                J = { text: We, offset: this.index, lineBreaks: We.indexOf(`
`) === -1 ? 0 : 1, line: this.line, col: this.col };
              }
              var Ve = Math.max(J.line - 2, 1), Ke = J.line + 2, He = String(Ke).length, pt = function(zn, rr) {
                for (var Vn = zn.length, $n = 0; ; ) {
                  var Cn = zn.lastIndexOf(`
`, Vn - 1);
                  if (Cn === -1 || (Vn = Cn, ++$n === rr) || Vn === 0)
                    break;
                }
                var Mr = $n < rr ? 0 : Vn + 1;
                return zn.substring(Mr).split(`
`);
              }(this.buffer, this.line - J.line + 2 + 1).slice(0, 5), Pt = [];
              Pt.push(_e + " at line " + J.line + " col " + J.col + ":"), Pt.push("");
              for (var ht = 0; ht < pt.length; ht++) {
                var vt = pt[ht], Zt = Ve + ht;
                Pt.push(De(String(Zt), He) + "  " + vt), Zt === J.line && Pt.push(De("", He + J.col + 1) + "^");
              }
              return Pt.join(`
`);
            }, tt.prototype.clone = function() {
              return new tt(this.states, this.state);
            }, tt.prototype.has = function(J) {
              return !0;
            }, { compile: function(J) {
              var _e = xt(be(J));
              return new tt({ start: _e }, "start");
            }, states: function(J, _e) {
              var We = J.$all ? be(J.$all) : [];
              delete J.$all;
              var Ve = Object.getOwnPropertyNames(J);
              _e || (_e = Ve[0]);
              for (var Ke = /* @__PURE__ */ Object.create(null), He = 0; He < Ve.length; He++)
                Ke[Cn = Ve[He]] = be(J[Cn]).concat(We);
              for (He = 0; He < Ve.length; He++)
                for (var pt = Ke[Cn = Ve[He]], Pt = /* @__PURE__ */ Object.create(null), ht = 0; ht < pt.length; ht++) {
                  var vt = pt[ht];
                  if (vt.include) {
                    var Zt = [ht, 1];
                    if (vt.include !== Cn && !Pt[vt.include]) {
                      Pt[vt.include] = !0;
                      var zn = Ke[vt.include];
                      if (!zn)
                        throw new Error("Cannot include nonexistent state '" + vt.include + "' (in state '" + Cn + "')");
                      for (var rr = 0; rr < zn.length; rr++) {
                        var Vn = zn[rr];
                        pt.indexOf(Vn) === -1 && Zt.push(Vn);
                      }
                    }
                    pt.splice.apply(pt, Zt), ht--;
                  }
                }
              var $n = /* @__PURE__ */ Object.create(null);
              for (He = 0; He < Ve.length; He++) {
                var Cn;
                $n[Cn = Ve[He]] = xt(Ke[Cn], !0);
              }
              for (He = 0; He < Ve.length; He++) {
                var Mr = Ve[He], oa = $n[Mr], Ad = oa.groups;
                for (ht = 0; ht < Ad.length; ht++)
                  Ct(Ad[ht], Mr, $n);
                var Od = Object.getOwnPropertyNames(oa.fast);
                for (ht = 0; ht < Od.length; ht++)
                  Ct(oa.fast[Od[ht]], Mr, $n);
              }
              return new tt($n, _e);
            }, error: Object.freeze({ error: !0 }), fallback: Object.freeze({ fallback: !0 }), keywords: function(J) {
              for (var _e = typeof Map < "u", We = _e ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null), Ve = Object.getOwnPropertyNames(J), Ke = 0; Ke < Ve.length; Ke++) {
                var He = Ve[Ke], pt = J[He];
                (Array.isArray(pt) ? pt : [pt]).forEach(function(Pt) {
                  if (typeof Pt != "string")
                    throw new Error("keyword must be string (in keyword '" + He + "')");
                  _e ? We.set(Pt, He) : We[Pt] = He;
                });
              }
              return function(Pt) {
                return _e ? We.get(Pt) : We[Pt];
              };
            } };
          }, f.exports ? f.exports = y() : p.moo = y();
        })(et);
        var Nt = et.exports;
        (function(f) {
          var p = ve && ve.__importDefault || function(h) {
            return h && h.__esModule ? h : { default: h };
          };
          Object.defineProperty(f, "__esModule", { value: !0 }), f.lexer = f.states = void 0;
          const y = p(Nt);
          f.states = { body: { doubleapos: { match: "''", value: () => "'" }, quoted: { lineBreaks: !0, match: /'[{}#](?:[^]*?[^'])?'(?!')/u, value: (h) => h.slice(1, -1).replace(/''/g, "'") }, argument: { lineBreaks: !0, match: /\{\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u, push: "arg", value: (h) => h.substring(1).trim() }, octothorpe: "#", end: { match: "}", pop: 1 }, content: { lineBreaks: !0, match: /[^][^{}#']*/u } }, arg: { select: { lineBreaks: !0, match: /,\s*(?:plural|select|selectordinal)\s*,\s*/u, next: "select", value: (h) => h.split(",")[1].trim() }, "func-args": { lineBreaks: !0, match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*,/u, next: "body", value: (h) => h.split(",")[1].trim() }, "func-simple": { lineBreaks: !0, match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u, value: (h) => h.substring(1).trim() }, end: { match: "}", pop: 1 } }, select: { offset: { lineBreaks: !0, match: /\s*offset\s*:\s*\d+\s*/u, value: (h) => h.split(":")[1].trim() }, case: { lineBreaks: !0, match: /\s*(?:=\d+|[^\p{Pat_Syn}\p{Pat_WS}]+)\s*\{/u, push: "body", value: (h) => h.substring(0, h.indexOf("{")).trim() }, end: { match: /\s*\}/u, pop: 1 } } }, f.lexer = y.default.states(f.states);
        })(it), Object.defineProperty(Ue, "__esModule", { value: !0 });
        var Vt = Ue.parse = Ue.ParseError = void 0;
        const Rt = it, sn = (f) => ({ offset: f.offset, line: f.line, col: f.col, text: f.text, lineBreaks: f.lineBreaks }), _n = (f) => f === "plural" || f === "select" || f === "selectordinal", Jn = ["number", "date", "time", "spellout", "ordinal", "duration"], Kr = ["zero", "one", "two", "few", "many", "other"];
        class Ft extends Error {
          constructor(p, y) {
            super(Rt.lexer.formatError(p, y));
          }
        }
        Ue.ParseError = Ft;
        class Or {
          constructor(p, y) {
            var h, E, _, A;
            this.lexer = Rt.lexer.reset(p), this.cardinalKeys = (h = y == null ? void 0 : y.cardinal) !== null && h !== void 0 ? h : Kr, this.ordinalKeys = (E = y == null ? void 0 : y.ordinal) !== null && E !== void 0 ? E : Kr, this.strict = (_ = y == null ? void 0 : y.strict) !== null && _ !== void 0 && _, this.strictPluralKeys = (A = y == null ? void 0 : y.strictPluralKeys) === null || A === void 0 || A;
          }
          parse() {
            return this.parseBody(!1, !0);
          }
          checkSelectKey(p, y, h) {
            if (h[0] === "=") {
              if (y === "select")
                throw new Ft(p, `The case ${h} is not valid with select`);
            } else if (y !== "select") {
              const E = y === "plural" ? this.cardinalKeys : this.ordinalKeys;
              if (this.strictPluralKeys && E.length > 0 && !E.includes(h))
                throw new Ft(p, `The ${y} case ${h} is not valid in this locale`);
            }
          }
          parseSelect(p, y, h, E) {
            let { value: _ } = p;
            const A = { type: E, arg: _, cases: [], ctx: h };
            E === "plural" || E === "selectordinal" ? y = !0 : this.strict && (y = !1);
            for (const F of this.lexer)
              switch (F.type) {
                case "offset":
                  if (E === "select")
                    throw new Ft(F, "Unexpected plural offset for select");
                  if (A.cases.length > 0)
                    throw new Ft(F, "Plural offset must be set before cases");
                  A.pluralOffset = Number(F.value), h.text += F.text, h.lineBreaks += F.lineBreaks;
                  break;
                case "case":
                  this.checkSelectKey(F, E, F.value), A.cases.push({ key: F.value, tokens: this.parseBody(y), ctx: sn(F) });
                  break;
                case "end":
                  return A;
                default:
                  throw new Ft(F, `Unexpected lexer token: ${F.type}`);
              }
            throw new Ft(null, "Unexpected message end");
          }
          parseArgToken(p, y) {
            const h = sn(p), E = this.lexer.next();
            if (!E)
              throw new Ft(null, "Unexpected message end");
            if (h.text += E.text, h.lineBreaks += E.lineBreaks, this.strict && (E.type === "func-simple" || E.type === "func-args") && !Jn.includes(E.value)) {
              const _ = `Invalid strict mode function arg type: ${E.value}`;
              throw new Ft(p, _);
            }
            switch (E.type) {
              case "end":
                return { type: "argument", arg: p.value, ctx: h };
              case "func-simple": {
                const _ = this.lexer.next();
                if (!_)
                  throw new Ft(null, "Unexpected message end");
                if (_.type !== "end")
                  throw new Ft(_, `Unexpected lexer token: ${_.type}`);
                if (h.text += _.text, _n(E.value.toLowerCase()))
                  throw new Ft(E, `Invalid type identifier: ${E.value}`);
                return { type: "function", arg: p.value, key: E.value, ctx: h };
              }
              case "func-args": {
                if (_n(E.value.toLowerCase())) {
                  const A = `Invalid type identifier: ${E.value}`;
                  throw new Ft(E, A);
                }
                let _ = this.parseBody(!this.strict && y);
                return this.strict && _.length > 0 && (_ = function(A, F) {
                  let B = "", ee = "";
                  for (const we of F) {
                    const De = we.ctx.text;
                    switch (ee += De, we.type) {
                      case "content":
                        B += we.value;
                        break;
                      case "argument":
                      case "function":
                      case "octothorpe":
                        B += De;
                        break;
                      default:
                        throw new Ft(A, `Unsupported part in strict mode function arg style: ${De}`);
                    }
                  }
                  return [{ type: "content", value: B.trim(), ctx: Object.assign({}, F[0].ctx, { text: ee }) }];
                }(p, _)), { type: "function", arg: p.value, key: E.value, param: _, ctx: h };
              }
              case "select":
                if (_n(E.value))
                  return this.parseSelect(p, y, h, E.value);
                throw new Ft(E, `Unexpected select type ${E.value}`);
              default:
                throw new Ft(E, `Unexpected lexer token: ${E.type}`);
            }
          }
          parseBody(p, y) {
            const h = [];
            let E = null;
            for (const _ of this.lexer)
              if (_.type === "argument")
                E && (E = null), h.push(this.parseArgToken(_, p));
              else if (_.type === "octothorpe" && p)
                E && (E = null), h.push({ type: "octothorpe", ctx: sn(_) });
              else {
                if (_.type === "end" && !y)
                  return h;
                {
                  let A = _.value;
                  if (!p && _.type === "quoted" && A[0] === "#") {
                    if (A.includes("{"))
                      throw new Ft(_, `Unsupported escape pattern: ${A}`);
                    A = _.text;
                  }
                  E ? (E.value += A, E.ctx.text += _.text, E.ctx.lineBreaks += _.lineBreaks) : (E = { type: "content", value: A, ctx: sn(_) }, h.push(E));
                }
              }
            if (y)
              return h;
            throw new Ft(null, "Unexpected message end");
          }
        }
        function Mn(f) {
          return Mn[f] || (Mn[f] = new Intl.NumberFormat(f));
        }
        Vt = Ue.parse = function(f) {
          return new Or(f, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).parse();
        };
        var Nr = Object.freeze({ __proto__: null, _nf: Mn, number: function(f, p, y) {
          return Mn(f).format(p - y);
        }, plural: function(f, p, y, h, E) {
          if ({}.hasOwnProperty.call(h, f))
            return h[f];
          p && (f -= p);
          var _ = y(f, E);
          return _ in h ? h[_] : h.other;
        }, reqArgs: function(f, p) {
          for (var y = 0; y < f.length; ++y)
            if (!p || p[f[y]] === void 0)
              throw new Error("Message requires argument '".concat(f[y], "'"));
        }, select: function(f, p) {
          return {}.hasOwnProperty.call(p, f) ? p[f] : p.other;
        }, strictNumber: function(f, p, y, h) {
          var E = p - y;
          if (isNaN(E))
            throw new Error("`" + h + "` or its offset is not a number");
          return Mn(f).format(E);
        } }), er = {};
        function cn(f, p) {
          var y = String(f) + JSON.stringify(p);
          return er[y] || (er[y] = new Intl.NumberFormat(f, p)), er[y];
        }
        var Dn = Object.freeze({ __proto__: null, date: function(f, p, y) {
          var h = { day: "numeric", month: "short", year: "numeric" };
          switch (y) {
            case "full":
              h.weekday = "long";
            case "long":
              h.month = "long";
              break;
            case "short":
              h.month = "numeric";
          }
          return new Date(f).toLocaleDateString(p, h);
        }, duration: function(f) {
          if (typeof f != "number" && (f = Number(f)), !isFinite(f))
            return String(f);
          var p = "";
          f < 0 ? (p = "-", f = Math.abs(f)) : f = Number(f);
          var y = f % 60, h = [Math.round(y) === y ? y : y.toFixed(3)];
          return f < 60 ? h.unshift(0) : (f = Math.round((f - Number(h[0])) / 60), h.unshift(f % 60), f >= 60 && (f = Math.round((f - Number(h[0])) / 60), h.unshift(f))), p + h.shift() + ":" + h.map(function(E) {
            return Number(E) < 10 ? "0" + String(E) : String(E);
          }).join(":");
        }, numberCurrency: function(f, p, y) {
          return cn(p, { style: "currency", currency: y, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(f);
        }, numberFmt: function(f, p, y, h) {
          var E = y && y.split(":") || [], _ = E[0], A = E[1];
          return cn(p, { integer: { maximumFractionDigits: 0 }, percent: { style: "percent" }, currency: { style: "currency", currency: A && A.trim() || h, minimumFractionDigits: 2, maximumFractionDigits: 2 } }[_] || {}).format(f);
        }, numberInteger: function(f, p) {
          return cn(p, { maximumFractionDigits: 0 }).format(f);
        }, numberPercent: function(f, p) {
          return cn(p, { style: "percent" }).format(f);
        }, time: function(f, p, y) {
          var h = { second: "numeric", minute: "numeric", hour: "numeric" };
          switch (y) {
            case "full":
            case "long":
              h.timeZoneName = "short";
              break;
            case "short":
              delete h.second;
          }
          return new Date(f).toLocaleTimeString(p, h);
        } }), hr = Me({ ES3: { break: !0, continue: !0, delete: !0, else: !0, for: !0, function: !0, if: !0, in: !0, new: !0, return: !0, this: !0, typeof: !0, var: !0, void: !0, while: !0, with: !0, case: !0, catch: !0, default: !0, do: !0, finally: !0, instanceof: !0, switch: !0, throw: !0, try: !0 }, ESnext: { await: !0, debugger: !0, class: !0, enum: !0, extends: !0, super: !0, const: !0, export: !0, import: !0, null: !0, true: !0, false: !0, implements: !0, let: !0, private: !0, public: !0, yield: !0, interface: !0, package: !0, protected: !0, static: !0 } });
        function xn(f, p) {
          p && (f += " " + function(h) {
            let E = 0;
            for (let _ = 0; _ < h.length; ++_)
              E = (E << 5) - E + h.charCodeAt(_), E |= 0;
            return E;
          }(f).toString(36));
          const y = f.trim().replace(/\W+/g, "_");
          return hr.ES3[y] || hr.ESnext[y] || /^\d/.test(y) ? "_" + y : y;
        }
        function Xr(f, p) {
          if (/^[A-Z_$][0-9A-Z_$]*$/i.test(p) && !hr.ES3[p])
            return f ? f + "." + p : p;
          {
            const y = JSON.stringify(p);
            return f ? f + "[" + y + "]" : y;
          }
        }
        var Bn = new RegExp("^" + ["ar", "ckb", "fa", "he", "ks($|[^bfh])", "lrc", "mzn", "pa-Arab", "ps", "ug", "ur", "uz-Arab", "yi"].join("|^")), Zr = "@messageformat/runtime/lib/plurals", tr = function() {
          function f(p) {
            this.arguments = [], this.runtime = {}, this.options = p;
          }
          return f.prototype.compile = function(p, y, h) {
            var E, _, A = this, F = this.options, B = F.localeCodeFromKey, ee = F.requireAllArguments, we = F.strict, De = F.strictPluralKeys;
            if (typeof p == "object") {
              var je = {};
              try {
                for (var be = d(Object.keys(p)), Ge = be.next(); !Ge.done; Ge = be.next()) {
                  var xt = Ge.value, Ct = B ? B(xt) : xt, tt = h && Ct && h[Ct] || y;
                  je[xt] = this.compile(p[xt], tt, h);
                }
              } catch (We) {
                E = { error: We };
              } finally {
                try {
                  Ge && !Ge.done && (_ = be.return) && _.call(be);
                } finally {
                  if (E)
                    throw E.error;
                }
              }
              return je;
            }
            this.plural = y;
            var ln = { cardinal: y.cardinals, ordinal: y.ordinals, strict: we, strictPluralKeys: De };
            this.arguments = [];
            var Yt = Vt(p, ln).map(function(We) {
              return A.token(We, null);
            }), Gt = this.arguments.length > 0, J = this.concatenate(Yt, !0);
            if (ee && Gt) {
              this.setRuntimeFn("reqArgs");
              var _e = JSON.stringify(this.arguments);
              return "(d) => { reqArgs(".concat(_e, ", d); return ").concat(J, "; }");
            }
            return "(".concat(Gt ? "d" : "", ") => ").concat(J);
          }, f.prototype.cases = function(p, y) {
            var h = this, E = !0, _ = p.cases.map(function(we) {
              var De = we.key, je = we.tokens;
              De === "other" && (E = !1);
              var be = je.map(function(Ge) {
                return h.token(Ge, y);
              });
              return "".concat(Xr(null, De.replace(/^=/, "")), ": ").concat(h.concatenate(be, !1));
            });
            if (E) {
              var A = p.type, F = this.plural, B = F.cardinals, ee = F.ordinals;
              if (A === "select" || A === "plural" && B.includes("other") || A === "selectordinal" && ee.includes("other"))
                throw new Error("No 'other' form found in ".concat(JSON.stringify(p)));
            }
            return "{ ".concat(_.join(", "), " }");
          }, f.prototype.concatenate = function(p, y) {
            return this.options.returnType === "values" && (y || p.length > 1) ? "[" + p.join(", ") + "]" : p.join(" + ") || '""';
          }, f.prototype.token = function(p, y) {
            if (p.type === "content")
              return JSON.stringify(p.value);
            var h, E, _, A, F, B, ee = this.plural, we = ee.id, De = ee.lc;
            switch ("arg" in p ? (this.arguments.push(p.arg), h = [Xr("d", p.arg)]) : h = [], p.type) {
              case "argument":
                return this.options.biDiSupport ? (_ = String(h[0]), A = De, F = Bn.test(A), B = JSON.stringify(F ? "‏" : "‎"), "".concat(B, " + ").concat(_, " + ").concat(B)) : String(h[0]);
              case "select":
                E = "select", y && this.options.strict && (y = null), h.push(this.cases(p, y)), this.setRuntimeFn("select");
                break;
              case "selectordinal":
                E = "plural", h.push(p.pluralOffset || 0, we, this.cases(p, p), 1), this.setLocale(we, !0), this.setRuntimeFn("plural");
                break;
              case "plural":
                E = "plural", h.push(p.pluralOffset || 0, we, this.cases(p, p)), this.setLocale(we, !1), this.setRuntimeFn("plural");
                break;
              case "function":
                var je = this.options.customFormatters[p.key], be = je && "module" in je && typeof je.module == "function";
                if (!je) {
                  if (p.key === "date") {
                    E = this.setDateFormatter(p, h, y);
                    break;
                  }
                  if (p.key === "number") {
                    E = this.setNumberFormatter(p, h, y);
                    break;
                  }
                }
                if (h.push(JSON.stringify(this.plural.locale)), p.param) {
                  y && this.options.strict && (y = null);
                  var Ge = this.getFormatterArg(p, y);
                  Ge && h.push(Ge);
                }
                E = be ? xn("".concat(p.key, "__").concat(this.plural.locale)) : p.key, this.setFormatter(E, p.key);
                break;
              case "octothorpe":
                if (!y)
                  return '"#"';
                h = [JSON.stringify(this.plural.locale), Xr("d", y.arg), y.pluralOffset || 0], this.options.strict ? (E = "strictNumber", h.push(JSON.stringify(y.arg)), this.setRuntimeFn("strictNumber")) : (E = "number", this.setRuntimeFn("number"));
            }
            if (!E)
              throw new Error("Parser error for token " + JSON.stringify(p));
            return "".concat(E, "(").concat(h.join(", "), ")");
          }, f.prototype.runtimeIncludes = function(p, y) {
            if (xn(p) !== p)
              throw new SyntaxError("Reserved word used as ".concat(y, " identifier: ").concat(p));
            var h = this.runtime[p];
            if (!h || h.type === y)
              return h;
            throw new TypeError("Cannot override ".concat(h.type, " runtime function as ").concat(y, ": ").concat(p));
          }, f.prototype.setLocale = function(p, y) {
            var h, E, _, A = this.runtimeIncludes(p, "locale"), F = this.plural, B = F.getCardinal, ee = F.getPlural, we = F.isDefault;
            if (!y && we && B) {
              if (A)
                return;
              h = function(De) {
                return B(De);
              }, E = "@messageformat/runtime/lib/cardinals", _ = function() {
                return String(B);
              };
            } else {
              if (A && (!we || A.module === Zr))
                return;
              h = function(De, je) {
                return ee(De, je);
              }, E = we ? Zr : ee.module || null, _ = function() {
                return String(ee);
              };
            }
            this.runtime[p] = Object.assign(h, { id: p, module: E, toString: _, type: "locale" });
          }, f.prototype.setRuntimeFn = function(p) {
            this.runtimeIncludes(p, "runtime") || (this.runtime[p] = Object.assign(Nr[p], { id: p, module: "@messageformat/runtime", type: "runtime" }));
          }, f.prototype.getFormatterArg = function(p, y) {
            var h, E, _, A, F = this, B = p.key, ee = p.param, we = this.options.customFormatters[B] || Dt(B) && Dn[B];
            if (!we || !ee)
              return null;
            var De = "arg" in we && we.arg || "string";
            if (De === "options") {
              var je = "";
              try {
                for (var be = d(ee), Ge = be.next(); !Ge.done; Ge = be.next()) {
                  var xt = Ge.value;
                  if (xt.type !== "content")
                    throw new SyntaxError("Expected literal options for ".concat(B, " formatter"));
                  je += xt.value;
                }
              } catch (He) {
                h = { error: He };
              } finally {
                try {
                  Ge && !Ge.done && (E = be.return) && E.call(be);
                } finally {
                  if (h)
                    throw h.error;
                }
              }
              var Ct = {};
              try {
                for (var tt = d(je.split(",")), ln = tt.next(); !ln.done; ln = tt.next()) {
                  var Yt = ln.value, Gt = Yt.indexOf(":");
                  if (Gt === -1)
                    Ct[Yt.trim()] = null;
                  else {
                    var J = Yt.substring(0, Gt).trim(), _e = Yt.substring(Gt + 1).trim();
                    if (_e === "true")
                      Ct[J] = !0;
                    else if (_e === "false")
                      Ct[J] = !1;
                    else if (_e === "null")
                      Ct[J] = null;
                    else {
                      var We = Number(_e);
                      Ct[J] = Number.isFinite(We) ? We : _e;
                    }
                  }
                }
              } catch (He) {
                _ = { error: He };
              } finally {
                try {
                  ln && !ln.done && (A = tt.return) && A.call(tt);
                } finally {
                  if (_)
                    throw _.error;
                }
              }
              return JSON.stringify(Ct);
            }
            var Ve = ee.map(function(He) {
              return F.token(He, y);
            });
            if (De === "raw")
              return "[".concat(Ve.join(", "), "]");
            var Ke = Ve.join(" + ");
            return Ke ? "(".concat(Ke, ").trim()") : '""';
          }, f.prototype.setFormatter = function(p, y) {
            if (!this.runtimeIncludes(p, "formatter")) {
              var h = this.options.customFormatters[y || p];
              if (h) {
                var E = typeof h == "function" ? { formatter: h } : h;
                this.runtime[p] = Object.assign(E.formatter.bind({}), l(l({}, E.formatter.prototype), { toString: function() {
                  return String(E.formatter);
                } }), { type: "formatter" }, "module" in h && h.module && h.id ? { id: xn(h.id), module: typeof h.module == "function" ? h.module(this.plural.locale) : h.module } : { id: null, module: null });
              } else {
                if (!Dt(p))
                  throw new Error("Formatting function not found: ".concat(p));
                this.runtime[p] = Object.assign(Dn[p], { type: "formatter" }, { id: p, module: "@messageformat/runtime/lib/formatters" });
              }
            }
          }, f.prototype.setDateFormatter = function(p, y, h) {
            var E = this, _ = p.param, A = this.plural.locale, F = _ && _.length === 1 && _[0];
            if (F && F.type === "content" && /^\s*::/.test(F.value)) {
              var B = F.value.trim().substr(2), ee = xn("date_".concat(A, "_").concat(B), !0);
              if (!this.runtimeIncludes(ee, "formatter")) {
                var we = function(je, be, Ge) {
                  typeof be == "string" && (be = j(be));
                  const xt = C(be, Ge), Ct = new Intl.DateTimeFormat(je, xt);
                  return (tt) => Ct.format(tt);
                }(A, B);
                this.runtime[ee] = Object.assign(we, { id: ee, module: null, toString: function() {
                  return function(je, be, Ge) {
                    typeof be == "string" && (be = j(be));
                    const xt = C(be, Ge);
                    return ["(function() {", `var opt = ${JSON.stringify(xt)};`, `var dtf = new Intl.DateTimeFormat(${JSON.stringify(je)}, opt);`, "return function(value) { return dtf.format(value); }"].join(`
  `) + `
})()`;
                  }(A, B);
                }, type: "formatter" });
              }
              return ee;
            }
            if (y.push(JSON.stringify(A)), _ && _.length > 0) {
              h && this.options.strict && (h = null);
              var De = _.map(function(je) {
                return E.token(je, h);
              });
              y.push("(" + (De.join(" + ") || '""') + ").trim()");
            }
            return this.setFormatter("date"), "date";
          }, f.prototype.setNumberFormatter = function(p, y, h) {
            var E = this, _ = p.param, A = this.plural.locale;
            if (!_ || _.length === 0)
              return y.unshift(JSON.stringify(A)), y.push("0"), this.setRuntimeFn("number"), "number";
            if (y.push(JSON.stringify(A)), _.length === 1 && _[0].type === "content") {
              var F = _[0].value.trim();
              switch (F) {
                case "currency":
                  return y.push(JSON.stringify(this.options.currency)), this.setFormatter("numberCurrency"), "numberCurrency";
                case "integer":
                  return this.setFormatter("numberInteger"), "numberInteger";
                case "percent":
                  return this.setFormatter("numberPercent"), "numberPercent";
              }
              var B = F.match(/^currency:([A-Z]+)$/);
              if (B)
                return y.push(JSON.stringify(B[1])), this.setFormatter("numberCurrency"), "numberCurrency";
              var ee = xn("number_".concat(A, "_").concat(F), !0);
              if (!this.runtimeIncludes(ee, "formatter")) {
                var we = this.options.currency, De = K(A, F, we);
                this.runtime[ee] = Object.assign(De, { id: null, module: null, toString: function() {
                  return ie(A, F, we);
                }, type: "formatter" });
              }
              return ee;
            }
            h && this.options.strict && (h = null);
            var je = _.map(function(be) {
              return E.token(be, h);
            });
            return y.push("(" + (je.join(" + ") || '""') + ").trim()"), y.push(JSON.stringify(this.options.currency)), this.setFormatter("numberFmt"), "numberFmt";
          }, f;
        }();
        function Dt(f) {
          return f in Dn;
        }
        const ge = (f) => f == 1 ? "one" : "other", wn = (f) => f == 0 || f == 1 ? "one" : "other", fn = (f) => f >= 0 && f <= 1 ? "one" : "other", Wt = (f) => {
          const p = !String(f).split(".")[1];
          return f == 1 && p ? "one" : "other";
        }, Qe = (f) => "other", mn = (f) => f == 1 ? "one" : f == 2 ? "two" : "other";
        var Jb = Object.freeze({ __proto__: null, af: ge, ak: wn, am: fn, an: ge, ar: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f && p[0].slice(-2);
          return f == 0 ? "zero" : f == 1 ? "one" : f == 2 ? "two" : y >= 3 && y <= 10 ? "few" : y >= 11 && y <= 99 ? "many" : "other";
        }, ars: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f && p[0].slice(-2);
          return f == 0 ? "zero" : f == 1 ? "one" : f == 2 ? "two" : y >= 3 && y <= 10 ? "few" : y >= 11 && y <= 99 ? "many" : "other";
        }, as: fn, asa: ge, ast: Wt, az: ge, bal: ge, be: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f, h = y && p[0].slice(-1), E = y && p[0].slice(-2);
          return h == 1 && E != 11 ? "one" : h >= 2 && h <= 4 && (E < 12 || E > 14) ? "few" : y && h == 0 || h >= 5 && h <= 9 || E >= 11 && E <= 14 ? "many" : "other";
        }, bem: ge, bez: ge, bg: ge, bho: wn, bm: Qe, bn: fn, bo: Qe, br: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f, h = y && p[0].slice(-1), E = y && p[0].slice(-2), _ = y && p[0].slice(-6);
          return h == 1 && E != 11 && E != 71 && E != 91 ? "one" : h == 2 && E != 12 && E != 72 && E != 92 ? "two" : (h == 3 || h == 4 || h == 9) && (E < 10 || E > 19) && (E < 70 || E > 79) && (E < 90 || E > 99) ? "few" : f != 0 && y && _ == 0 ? "many" : "other";
        }, brx: ge, bs: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-1), A = y.slice(-2), F = h.slice(-1), B = h.slice(-2);
          return E && _ == 1 && A != 11 || F == 1 && B != 11 ? "one" : E && _ >= 2 && _ <= 4 && (A < 12 || A > 14) || F >= 2 && F <= 4 && (B < 12 || B > 14) ? "few" : "other";
        }, ca: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-6);
          return f == 1 && h ? "one" : y != 0 && E == 0 && h ? "many" : "other";
        }, ce: ge, ceb: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-1), A = h.slice(-1);
          return E && (y == 1 || y == 2 || y == 3) || E && _ != 4 && _ != 6 && _ != 9 || !E && A != 4 && A != 6 && A != 9 ? "one" : "other";
        }, cgg: ge, chr: ge, ckb: ge, cs: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1];
          return f == 1 && h ? "one" : y >= 2 && y <= 4 && h ? "few" : h ? "other" : "many";
        }, cy: (f) => f == 0 ? "zero" : f == 1 ? "one" : f == 2 ? "two" : f == 3 ? "few" : f == 6 ? "many" : "other", da: (f) => {
          const p = String(f).split("."), y = p[0], h = Number(p[0]) == f;
          return f != 1 && (h || y != 0 && y != 1) ? "other" : "one";
        }, de: Wt, doi: fn, dsb: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-2), A = h.slice(-2);
          return E && _ == 1 || A == 1 ? "one" : E && _ == 2 || A == 2 ? "two" : E && (_ == 3 || _ == 4) || A == 3 || A == 4 ? "few" : "other";
        }, dv: ge, dz: Qe, ee: ge, el: ge, en: Wt, eo: ge, es: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-6);
          return f == 1 ? "one" : y != 0 && E == 0 && h ? "many" : "other";
        }, et: Wt, eu: ge, fa: fn, ff: (f) => f >= 0 && f < 2 ? "one" : "other", fi: Wt, fil: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-1), A = h.slice(-1);
          return E && (y == 1 || y == 2 || y == 3) || E && _ != 4 && _ != 6 && _ != 9 || !E && A != 4 && A != 6 && A != 9 ? "one" : "other";
        }, fo: ge, fr: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-6);
          return f >= 0 && f < 2 ? "one" : y != 0 && E == 0 && h ? "many" : "other";
        }, fur: ge, fy: Wt, ga: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f;
          return f == 1 ? "one" : f == 2 ? "two" : y && f >= 3 && f <= 6 ? "few" : y && f >= 7 && f <= 10 ? "many" : "other";
        }, gd: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f;
          return f == 1 || f == 11 ? "one" : f == 2 || f == 12 ? "two" : y && f >= 3 && f <= 10 || y && f >= 13 && f <= 19 ? "few" : "other";
        }, gl: Wt, gsw: ge, gu: fn, guw: wn, gv: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-1), _ = y.slice(-2);
          return h && E == 1 ? "one" : h && E == 2 ? "two" : !h || _ != 0 && _ != 20 && _ != 40 && _ != 60 && _ != 80 ? h ? "other" : "many" : "few";
        }, ha: ge, haw: ge, he: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1];
          return y == 1 && h || y == 0 && !h ? "one" : y == 2 && h ? "two" : "other";
        }, hi: fn, hnj: Qe, hr: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-1), A = y.slice(-2), F = h.slice(-1), B = h.slice(-2);
          return E && _ == 1 && A != 11 || F == 1 && B != 11 ? "one" : E && _ >= 2 && _ <= 4 && (A < 12 || A > 14) || F >= 2 && F <= 4 && (B < 12 || B > 14) ? "few" : "other";
        }, hsb: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-2), A = h.slice(-2);
          return E && _ == 1 || A == 1 ? "one" : E && _ == 2 || A == 2 ? "two" : E && (_ == 3 || _ == 4) || A == 3 || A == 4 ? "few" : "other";
        }, hu: ge, hy: (f) => f >= 0 && f < 2 ? "one" : "other", ia: Wt, id: Qe, ig: Qe, ii: Qe, io: Wt, is: (f) => {
          const p = String(f).split("."), y = p[0], h = (p[1] || "").replace(/0+$/, ""), E = Number(p[0]) == f, _ = y.slice(-1), A = y.slice(-2);
          return E && _ == 1 && A != 11 || h % 10 == 1 && h % 100 != 11 ? "one" : "other";
        }, it: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-6);
          return f == 1 && h ? "one" : y != 0 && E == 0 && h ? "many" : "other";
        }, iu: mn, ja: Qe, jbo: Qe, jgo: ge, jmc: ge, jv: Qe, jw: Qe, ka: ge, kab: (f) => f >= 0 && f < 2 ? "one" : "other", kaj: ge, kcg: ge, kde: Qe, kea: Qe, kk: ge, kkj: ge, kl: ge, km: Qe, kn: fn, ko: Qe, ks: ge, ksb: ge, ksh: (f) => f == 0 ? "zero" : f == 1 ? "one" : "other", ku: ge, kw: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f, h = y && p[0].slice(-2), E = y && p[0].slice(-3), _ = y && p[0].slice(-5), A = y && p[0].slice(-6);
          return f == 0 ? "zero" : f == 1 ? "one" : h == 2 || h == 22 || h == 42 || h == 62 || h == 82 || y && E == 0 && (_ >= 1e3 && _ <= 2e4 || _ == 4e4 || _ == 6e4 || _ == 8e4) || f != 0 && A == 1e5 ? "two" : h == 3 || h == 23 || h == 43 || h == 63 || h == 83 ? "few" : f == 1 || h != 1 && h != 21 && h != 41 && h != 61 && h != 81 ? "other" : "many";
        }, ky: ge, lag: (f) => {
          const p = String(f).split(".")[0];
          return f == 0 ? "zero" : p != 0 && p != 1 || f == 0 ? "other" : "one";
        }, lb: ge, lg: ge, lij: Wt, lkt: Qe, ln: wn, lo: Qe, lt: (f) => {
          const p = String(f).split("."), y = p[1] || "", h = Number(p[0]) == f, E = h && p[0].slice(-1), _ = h && p[0].slice(-2);
          return E == 1 && (_ < 11 || _ > 19) ? "one" : E >= 2 && E <= 9 && (_ < 11 || _ > 19) ? "few" : y != 0 ? "many" : "other";
        }, lv: (f) => {
          const p = String(f).split("."), y = p[1] || "", h = y.length, E = Number(p[0]) == f, _ = E && p[0].slice(-1), A = E && p[0].slice(-2), F = y.slice(-2), B = y.slice(-1);
          return E && _ == 0 || A >= 11 && A <= 19 || h == 2 && F >= 11 && F <= 19 ? "zero" : _ == 1 && A != 11 || h == 2 && B == 1 && F != 11 || h != 2 && B == 1 ? "one" : "other";
        }, mas: ge, mg: wn, mgo: ge, mk: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-1), A = y.slice(-2), F = h.slice(-1), B = h.slice(-2);
          return E && _ == 1 && A != 11 || F == 1 && B != 11 ? "one" : "other";
        }, ml: ge, mn: ge, mo: (f) => {
          const p = String(f).split("."), y = !p[1], h = Number(p[0]) == f && p[0].slice(-2);
          return f == 1 && y ? "one" : !y || f == 0 || f != 1 && h >= 1 && h <= 19 ? "few" : "other";
        }, mr: ge, ms: Qe, mt: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f && p[0].slice(-2);
          return f == 1 ? "one" : f == 2 ? "two" : f == 0 || y >= 3 && y <= 10 ? "few" : y >= 11 && y <= 19 ? "many" : "other";
        }, my: Qe, nah: ge, naq: mn, nb: ge, nd: ge, ne: ge, nl: Wt, nn: ge, nnh: ge, no: ge, nqo: Qe, nr: ge, nso: wn, ny: ge, nyn: ge, om: ge, or: ge, os: ge, osa: Qe, pa: wn, pap: ge, pcm: fn, pl: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-1), _ = y.slice(-2);
          return f == 1 && h ? "one" : h && E >= 2 && E <= 4 && (_ < 12 || _ > 14) ? "few" : h && y != 1 && (E == 0 || E == 1) || h && E >= 5 && E <= 9 || h && _ >= 12 && _ <= 14 ? "many" : "other";
        }, prg: (f) => {
          const p = String(f).split("."), y = p[1] || "", h = y.length, E = Number(p[0]) == f, _ = E && p[0].slice(-1), A = E && p[0].slice(-2), F = y.slice(-2), B = y.slice(-1);
          return E && _ == 0 || A >= 11 && A <= 19 || h == 2 && F >= 11 && F <= 19 ? "zero" : _ == 1 && A != 11 || h == 2 && B == 1 && F != 11 || h != 2 && B == 1 ? "one" : "other";
        }, ps: ge, pt: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-6);
          return y == 0 || y == 1 ? "one" : y != 0 && E == 0 && h ? "many" : "other";
        }, pt_PT: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-6);
          return f == 1 && h ? "one" : y != 0 && E == 0 && h ? "many" : "other";
        }, rm: ge, ro: (f) => {
          const p = String(f).split("."), y = !p[1], h = Number(p[0]) == f && p[0].slice(-2);
          return f == 1 && y ? "one" : !y || f == 0 || f != 1 && h >= 1 && h <= 19 ? "few" : "other";
        }, rof: ge, ru: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-1), _ = y.slice(-2);
          return h && E == 1 && _ != 11 ? "one" : h && E >= 2 && E <= 4 && (_ < 12 || _ > 14) ? "few" : h && E == 0 || h && E >= 5 && E <= 9 || h && _ >= 11 && _ <= 14 ? "many" : "other";
        }, rwk: ge, sah: Qe, saq: ge, sat: mn, sc: Wt, scn: Wt, sd: ge, sdh: ge, se: mn, seh: ge, ses: Qe, sg: Qe, sh: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-1), A = y.slice(-2), F = h.slice(-1), B = h.slice(-2);
          return E && _ == 1 && A != 11 || F == 1 && B != 11 ? "one" : E && _ >= 2 && _ <= 4 && (A < 12 || A > 14) || F >= 2 && F <= 4 && (B < 12 || B > 14) ? "few" : "other";
        }, shi: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f;
          return f >= 0 && f <= 1 ? "one" : y && f >= 2 && f <= 10 ? "few" : "other";
        }, si: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "";
          return f == 0 || f == 1 || y == 0 && h == 1 ? "one" : "other";
        }, sk: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1];
          return f == 1 && h ? "one" : y >= 2 && y <= 4 && h ? "few" : h ? "other" : "many";
        }, sl: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-2);
          return h && E == 1 ? "one" : h && E == 2 ? "two" : h && (E == 3 || E == 4) || !h ? "few" : "other";
        }, sma: mn, smi: mn, smj: mn, smn: mn, sms: mn, sn: ge, so: ge, sq: ge, sr: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-1), A = y.slice(-2), F = h.slice(-1), B = h.slice(-2);
          return E && _ == 1 && A != 11 || F == 1 && B != 11 ? "one" : E && _ >= 2 && _ <= 4 && (A < 12 || A > 14) || F >= 2 && F <= 4 && (B < 12 || B > 14) ? "few" : "other";
        }, ss: ge, ssy: ge, st: ge, su: Qe, sv: Wt, sw: Wt, syr: ge, ta: ge, te: ge, teo: ge, th: Qe, ti: wn, tig: ge, tk: ge, tl: (f) => {
          const p = String(f).split("."), y = p[0], h = p[1] || "", E = !p[1], _ = y.slice(-1), A = h.slice(-1);
          return E && (y == 1 || y == 2 || y == 3) || E && _ != 4 && _ != 6 && _ != 9 || !E && A != 4 && A != 6 && A != 9 ? "one" : "other";
        }, tn: ge, to: Qe, tpi: Qe, tr: ge, ts: ge, tzm: (f) => {
          const p = String(f).split("."), y = Number(p[0]) == f;
          return f == 0 || f == 1 || y && f >= 11 && f <= 99 ? "one" : "other";
        }, ug: ge, uk: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-1), _ = y.slice(-2);
          return h && E == 1 && _ != 11 ? "one" : h && E >= 2 && E <= 4 && (_ < 12 || _ > 14) ? "few" : h && E == 0 || h && E >= 5 && E <= 9 || h && _ >= 11 && _ <= 14 ? "many" : "other";
        }, und: Qe, ur: Wt, uz: ge, ve: ge, vec: (f) => {
          const p = String(f).split("."), y = p[0], h = !p[1], E = y.slice(-6);
          return f == 1 && h ? "one" : y != 0 && E == 0 && h ? "many" : "other";
        }, vi: Qe, vo: ge, vun: ge, wa: wn, wae: ge, wo: Qe, xh: ge, xog: ge, yi: Wt, yo: Qe, yue: Qe, zh: Qe, zu: fn });
        const vr = "zero", Oe = "one", Ut = "two", Ze = "few", Je = "many", re = "other", le = { cardinal: [Oe, re], ordinal: [re] }, Jr = { cardinal: [Oe, re], ordinal: [Oe, re] }, bt = { cardinal: [re], ordinal: [re] }, nr = { cardinal: [Oe, Ut, re], ordinal: [re] };
        var Pd = Object.freeze({ __proto__: null, af: le, ak: le, am: le, an: le, ar: { cardinal: [vr, Oe, Ut, Ze, Je, re], ordinal: [re] }, ars: { cardinal: [vr, Oe, Ut, Ze, Je, re], ordinal: [re] }, as: { cardinal: [Oe, re], ordinal: [Oe, Ut, Ze, Je, re] }, asa: le, ast: le, az: { cardinal: [Oe, re], ordinal: [Oe, Ze, Je, re] }, bal: Jr, be: { cardinal: [Oe, Ze, Je, re], ordinal: [Ze, re] }, bem: le, bez: le, bg: le, bho: le, bm: bt, bn: { cardinal: [Oe, re], ordinal: [Oe, Ut, Ze, Je, re] }, bo: bt, br: { cardinal: [Oe, Ut, Ze, Je, re], ordinal: [re] }, brx: le, bs: { cardinal: [Oe, Ze, re], ordinal: [re] }, ca: { cardinal: [Oe, Je, re], ordinal: [Oe, Ut, Ze, re] }, ce: le, ceb: le, cgg: le, chr: le, ckb: le, cs: { cardinal: [Oe, Ze, Je, re], ordinal: [re] }, cy: { cardinal: [vr, Oe, Ut, Ze, Je, re], ordinal: [vr, Oe, Ut, Ze, Je, re] }, da: le, de: le, doi: le, dsb: { cardinal: [Oe, Ut, Ze, re], ordinal: [re] }, dv: le, dz: bt, ee: le, el: le, en: { cardinal: [Oe, re], ordinal: [Oe, Ut, Ze, re] }, eo: le, es: { cardinal: [Oe, Je, re], ordinal: [re] }, et: le, eu: le, fa: le, ff: le, fi: le, fil: Jr, fo: le, fr: { cardinal: [Oe, Je, re], ordinal: [Oe, re] }, fur: le, fy: le, ga: { cardinal: [Oe, Ut, Ze, Je, re], ordinal: [Oe, re] }, gd: { cardinal: [Oe, Ut, Ze, re], ordinal: [Oe, Ut, Ze, re] }, gl: le, gsw: le, gu: { cardinal: [Oe, re], ordinal: [Oe, Ut, Ze, Je, re] }, guw: le, gv: { cardinal: [Oe, Ut, Ze, Je, re], ordinal: [re] }, ha: le, haw: le, he: nr, hi: { cardinal: [Oe, re], ordinal: [Oe, Ut, Ze, Je, re] }, hnj: bt, hr: { cardinal: [Oe, Ze, re], ordinal: [re] }, hsb: { cardinal: [Oe, Ut, Ze, re], ordinal: [re] }, hu: Jr, hy: Jr, ia: le, id: bt, ig: bt, ii: bt, io: le, is: le, it: { cardinal: [Oe, Je, re], ordinal: [Je, re] }, iu: nr, ja: bt, jbo: bt, jgo: le, jmc: le, jv: bt, jw: bt, ka: { cardinal: [Oe, re], ordinal: [Oe, Je, re] }, kab: le, kaj: le, kcg: le, kde: bt, kea: bt, kk: { cardinal: [Oe, re], ordinal: [Je, re] }, kkj: le, kl: le, km: bt, kn: le, ko: bt, ks: le, ksb: le, ksh: { cardinal: [vr, Oe, re], ordinal: [re] }, ku: le, kw: { cardinal: [vr, Oe, Ut, Ze, Je, re], ordinal: [Oe, Je, re] }, ky: le, lag: { cardinal: [vr, Oe, re], ordinal: [re] }, lb: le, lg: le, lij: { cardinal: [Oe, re], ordinal: [Je, re] }, lkt: bt, ln: le, lo: { cardinal: [re], ordinal: [Oe, re] }, lt: { cardinal: [Oe, Ze, Je, re], ordinal: [re] }, lv: { cardinal: [vr, Oe, re], ordinal: [re] }, mas: le, mg: le, mgo: le, mk: { cardinal: [Oe, re], ordinal: [Oe, Ut, Je, re] }, ml: le, mn: le, mo: { cardinal: [Oe, Ze, re], ordinal: [Oe, re] }, mr: { cardinal: [Oe, re], ordinal: [Oe, Ut, Ze, re] }, ms: { cardinal: [re], ordinal: [Oe, re] }, mt: { cardinal: [Oe, Ut, Ze, Je, re], ordinal: [re] }, my: bt, nah: le, naq: nr, nb: le, nd: le, ne: Jr, nl: le, nn: le, nnh: le, no: le, nqo: bt, nr: le, nso: le, ny: le, nyn: le, om: le, or: { cardinal: [Oe, re], ordinal: [Oe, Ut, Ze, Je, re] }, os: le, osa: bt, pa: le, pap: le, pcm: le, pl: { cardinal: [Oe, Ze, Je, re], ordinal: [re] }, prg: { cardinal: [vr, Oe, re], ordinal: [re] }, ps: le, pt: { cardinal: [Oe, Je, re], ordinal: [re] }, pt_PT: { cardinal: [Oe, Je, re], ordinal: [re] }, rm: le, ro: { cardinal: [Oe, Ze, re], ordinal: [Oe, re] }, rof: le, ru: { cardinal: [Oe, Ze, Je, re], ordinal: [re] }, rwk: le, sah: bt, saq: le, sat: nr, sc: { cardinal: [Oe, re], ordinal: [Je, re] }, scn: { cardinal: [Oe, re], ordinal: [Je, re] }, sd: le, sdh: le, se: nr, seh: le, ses: bt, sg: bt, sh: { cardinal: [Oe, Ze, re], ordinal: [re] }, shi: { cardinal: [Oe, Ze, re], ordinal: [re] }, si: le, sk: { cardinal: [Oe, Ze, Je, re], ordinal: [re] }, sl: { cardinal: [Oe, Ut, Ze, re], ordinal: [re] }, sma: nr, smi: nr, smj: nr, smn: nr, sms: nr, sn: le, so: le, sq: { cardinal: [Oe, re], ordinal: [Oe, Je, re] }, sr: { cardinal: [Oe, Ze, re], ordinal: [re] }, ss: le, ssy: le, st: le, su: bt, sv: Jr, sw: le, syr: le, ta: le, te: le, teo: le, th: bt, ti: le, tig: le, tk: { cardinal: [Oe, re], ordinal: [Ze, re] }, tl: Jr, tn: le, to: bt, tpi: bt, tr: le, ts: le, tzm: le, ug: le, uk: { cardinal: [Oe, Ze, Je, re], ordinal: [Ze, re] }, und: bt, ur: le, uz: le, ve: le, vec: { cardinal: [Oe, Je, re], ordinal: [Je, re] }, vi: { cardinal: [re], ordinal: [Oe, re] }, vo: le, vun: le, wa: le, wae: le, wo: bt, xh: le, xog: le, yi: le, yo: bt, yue: bt, zh: bt, zu: le });
        const Ne = (f, p) => p ? "other" : f == 1 ? "one" : "other", gr = (f, p) => p ? "other" : f == 0 || f == 1 ? "one" : "other", To = (f, p) => p ? "other" : f >= 0 && f <= 1 ? "one" : "other", In = (f, p) => {
          const y = !String(f).split(".")[1];
          return p ? "other" : f == 1 && y ? "one" : "other";
        }, yt = (f, p) => "other", br = (f, p) => p ? "other" : f == 1 ? "one" : f == 2 ? "two" : "other";
        var mi = Object.freeze({ __proto__: null, af: Ne, ak: gr, am: To, an: Ne, ar: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f && y[0].slice(-2);
          return p ? "other" : f == 0 ? "zero" : f == 1 ? "one" : f == 2 ? "two" : h >= 3 && h <= 10 ? "few" : h >= 11 && h <= 99 ? "many" : "other";
        }, ars: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f && y[0].slice(-2);
          return p ? "other" : f == 0 ? "zero" : f == 1 ? "one" : f == 2 ? "two" : h >= 3 && h <= 10 ? "few" : h >= 11 && h <= 99 ? "many" : "other";
        }, as: (f, p) => p ? f == 1 || f == 5 || f == 7 || f == 8 || f == 9 || f == 10 ? "one" : f == 2 || f == 3 ? "two" : f == 4 ? "few" : f == 6 ? "many" : "other" : f >= 0 && f <= 1 ? "one" : "other", asa: Ne, ast: In, az: (f, p) => {
          const y = String(f).split(".")[0], h = y.slice(-1), E = y.slice(-2), _ = y.slice(-3);
          return p ? h == 1 || h == 2 || h == 5 || h == 7 || h == 8 || E == 20 || E == 50 || E == 70 || E == 80 ? "one" : h == 3 || h == 4 || _ == 100 || _ == 200 || _ == 300 || _ == 400 || _ == 500 || _ == 600 || _ == 700 || _ == 800 || _ == 900 ? "few" : y == 0 || h == 6 || E == 40 || E == 60 || E == 90 ? "many" : "other" : f == 1 ? "one" : "other";
        }, bal: (f, p) => f == 1 ? "one" : "other", be: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f, E = h && y[0].slice(-1), _ = h && y[0].slice(-2);
          return p ? E != 2 && E != 3 || _ == 12 || _ == 13 ? "other" : "few" : E == 1 && _ != 11 ? "one" : E >= 2 && E <= 4 && (_ < 12 || _ > 14) ? "few" : h && E == 0 || E >= 5 && E <= 9 || _ >= 11 && _ <= 14 ? "many" : "other";
        }, bem: Ne, bez: Ne, bg: Ne, bho: gr, bm: yt, bn: (f, p) => p ? f == 1 || f == 5 || f == 7 || f == 8 || f == 9 || f == 10 ? "one" : f == 2 || f == 3 ? "two" : f == 4 ? "few" : f == 6 ? "many" : "other" : f >= 0 && f <= 1 ? "one" : "other", bo: yt, br: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f, E = h && y[0].slice(-1), _ = h && y[0].slice(-2), A = h && y[0].slice(-6);
          return p ? "other" : E == 1 && _ != 11 && _ != 71 && _ != 91 ? "one" : E == 2 && _ != 12 && _ != 72 && _ != 92 ? "two" : (E == 3 || E == 4 || E == 9) && (_ < 10 || _ > 19) && (_ < 70 || _ > 79) && (_ < 90 || _ > 99) ? "few" : f != 0 && h && A == 0 ? "many" : "other";
        }, brx: Ne, bs: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-1), F = h.slice(-2), B = E.slice(-1), ee = E.slice(-2);
          return p ? "other" : _ && A == 1 && F != 11 || B == 1 && ee != 11 ? "one" : _ && A >= 2 && A <= 4 && (F < 12 || F > 14) || B >= 2 && B <= 4 && (ee < 12 || ee > 14) ? "few" : "other";
        }, ca: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-6);
          return p ? f == 1 || f == 3 ? "one" : f == 2 ? "two" : f == 4 ? "few" : "other" : f == 1 && E ? "one" : h != 0 && _ == 0 && E ? "many" : "other";
        }, ce: Ne, ceb: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-1), F = E.slice(-1);
          return p ? "other" : _ && (h == 1 || h == 2 || h == 3) || _ && A != 4 && A != 6 && A != 9 || !_ && F != 4 && F != 6 && F != 9 ? "one" : "other";
        }, cgg: Ne, chr: Ne, ckb: Ne, cs: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1];
          return p ? "other" : f == 1 && E ? "one" : h >= 2 && h <= 4 && E ? "few" : E ? "other" : "many";
        }, cy: (f, p) => p ? f == 0 || f == 7 || f == 8 || f == 9 ? "zero" : f == 1 ? "one" : f == 2 ? "two" : f == 3 || f == 4 ? "few" : f == 5 || f == 6 ? "many" : "other" : f == 0 ? "zero" : f == 1 ? "one" : f == 2 ? "two" : f == 3 ? "few" : f == 6 ? "many" : "other", da: (f, p) => {
          const y = String(f).split("."), h = y[0], E = Number(y[0]) == f;
          return p || f != 1 && (E || h != 0 && h != 1) ? "other" : "one";
        }, de: In, doi: To, dsb: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-2), F = E.slice(-2);
          return p ? "other" : _ && A == 1 || F == 1 ? "one" : _ && A == 2 || F == 2 ? "two" : _ && (A == 3 || A == 4) || F == 3 || F == 4 ? "few" : "other";
        }, dv: Ne, dz: yt, ee: Ne, el: Ne, en: (f, p) => {
          const y = String(f).split("."), h = !y[1], E = Number(y[0]) == f, _ = E && y[0].slice(-1), A = E && y[0].slice(-2);
          return p ? _ == 1 && A != 11 ? "one" : _ == 2 && A != 12 ? "two" : _ == 3 && A != 13 ? "few" : "other" : f == 1 && h ? "one" : "other";
        }, eo: Ne, es: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-6);
          return p ? "other" : f == 1 ? "one" : h != 0 && _ == 0 && E ? "many" : "other";
        }, et: In, eu: Ne, fa: To, ff: (f, p) => p ? "other" : f >= 0 && f < 2 ? "one" : "other", fi: In, fil: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-1), F = E.slice(-1);
          return p ? f == 1 ? "one" : "other" : _ && (h == 1 || h == 2 || h == 3) || _ && A != 4 && A != 6 && A != 9 || !_ && F != 4 && F != 6 && F != 9 ? "one" : "other";
        }, fo: Ne, fr: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-6);
          return p ? f == 1 ? "one" : "other" : f >= 0 && f < 2 ? "one" : h != 0 && _ == 0 && E ? "many" : "other";
        }, fur: Ne, fy: In, ga: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f;
          return p ? f == 1 ? "one" : "other" : f == 1 ? "one" : f == 2 ? "two" : h && f >= 3 && f <= 6 ? "few" : h && f >= 7 && f <= 10 ? "many" : "other";
        }, gd: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f;
          return p ? f == 1 || f == 11 ? "one" : f == 2 || f == 12 ? "two" : f == 3 || f == 13 ? "few" : "other" : f == 1 || f == 11 ? "one" : f == 2 || f == 12 ? "two" : h && f >= 3 && f <= 10 || h && f >= 13 && f <= 19 ? "few" : "other";
        }, gl: In, gsw: Ne, gu: (f, p) => p ? f == 1 ? "one" : f == 2 || f == 3 ? "two" : f == 4 ? "few" : f == 6 ? "many" : "other" : f >= 0 && f <= 1 ? "one" : "other", guw: gr, gv: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-1), A = h.slice(-2);
          return p ? "other" : E && _ == 1 ? "one" : E && _ == 2 ? "two" : !E || A != 0 && A != 20 && A != 40 && A != 60 && A != 80 ? E ? "other" : "many" : "few";
        }, ha: Ne, haw: Ne, he: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1];
          return p ? "other" : h == 1 && E || h == 0 && !E ? "one" : h == 2 && E ? "two" : "other";
        }, hi: (f, p) => p ? f == 1 ? "one" : f == 2 || f == 3 ? "two" : f == 4 ? "few" : f == 6 ? "many" : "other" : f >= 0 && f <= 1 ? "one" : "other", hnj: yt, hr: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-1), F = h.slice(-2), B = E.slice(-1), ee = E.slice(-2);
          return p ? "other" : _ && A == 1 && F != 11 || B == 1 && ee != 11 ? "one" : _ && A >= 2 && A <= 4 && (F < 12 || F > 14) || B >= 2 && B <= 4 && (ee < 12 || ee > 14) ? "few" : "other";
        }, hsb: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-2), F = E.slice(-2);
          return p ? "other" : _ && A == 1 || F == 1 ? "one" : _ && A == 2 || F == 2 ? "two" : _ && (A == 3 || A == 4) || F == 3 || F == 4 ? "few" : "other";
        }, hu: (f, p) => p ? f == 1 || f == 5 ? "one" : "other" : f == 1 ? "one" : "other", hy: (f, p) => p ? f == 1 ? "one" : "other" : f >= 0 && f < 2 ? "one" : "other", ia: In, id: yt, ig: yt, ii: yt, io: In, is: (f, p) => {
          const y = String(f).split("."), h = y[0], E = (y[1] || "").replace(/0+$/, ""), _ = Number(y[0]) == f, A = h.slice(-1), F = h.slice(-2);
          return p ? "other" : _ && A == 1 && F != 11 || E % 10 == 1 && E % 100 != 11 ? "one" : "other";
        }, it: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-6);
          return p ? f == 11 || f == 8 || f == 80 || f == 800 ? "many" : "other" : f == 1 && E ? "one" : h != 0 && _ == 0 && E ? "many" : "other";
        }, iu: br, ja: yt, jbo: yt, jgo: Ne, jmc: Ne, jv: yt, jw: yt, ka: (f, p) => {
          const y = String(f).split(".")[0], h = y.slice(-2);
          return p ? y == 1 ? "one" : y == 0 || h >= 2 && h <= 20 || h == 40 || h == 60 || h == 80 ? "many" : "other" : f == 1 ? "one" : "other";
        }, kab: (f, p) => p ? "other" : f >= 0 && f < 2 ? "one" : "other", kaj: Ne, kcg: Ne, kde: yt, kea: yt, kk: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f, E = h && y[0].slice(-1);
          return p ? E == 6 || E == 9 || h && E == 0 && f != 0 ? "many" : "other" : f == 1 ? "one" : "other";
        }, kkj: Ne, kl: Ne, km: yt, kn: To, ko: yt, ks: Ne, ksb: Ne, ksh: (f, p) => p ? "other" : f == 0 ? "zero" : f == 1 ? "one" : "other", ku: Ne, kw: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f, E = h && y[0].slice(-2), _ = h && y[0].slice(-3), A = h && y[0].slice(-5), F = h && y[0].slice(-6);
          return p ? h && f >= 1 && f <= 4 || E >= 1 && E <= 4 || E >= 21 && E <= 24 || E >= 41 && E <= 44 || E >= 61 && E <= 64 || E >= 81 && E <= 84 ? "one" : f == 5 || E == 5 ? "many" : "other" : f == 0 ? "zero" : f == 1 ? "one" : E == 2 || E == 22 || E == 42 || E == 62 || E == 82 || h && _ == 0 && (A >= 1e3 && A <= 2e4 || A == 4e4 || A == 6e4 || A == 8e4) || f != 0 && F == 1e5 ? "two" : E == 3 || E == 23 || E == 43 || E == 63 || E == 83 ? "few" : f == 1 || E != 1 && E != 21 && E != 41 && E != 61 && E != 81 ? "other" : "many";
        }, ky: Ne, lag: (f, p) => {
          const y = String(f).split(".")[0];
          return p ? "other" : f == 0 ? "zero" : y != 0 && y != 1 || f == 0 ? "other" : "one";
        }, lb: Ne, lg: Ne, lij: (f, p) => {
          const y = String(f).split("."), h = !y[1], E = Number(y[0]) == f;
          return p ? f == 11 || f == 8 || E && f >= 80 && f <= 89 || E && f >= 800 && f <= 899 ? "many" : "other" : f == 1 && h ? "one" : "other";
        }, lkt: yt, ln: gr, lo: (f, p) => p && f == 1 ? "one" : "other", lt: (f, p) => {
          const y = String(f).split("."), h = y[1] || "", E = Number(y[0]) == f, _ = E && y[0].slice(-1), A = E && y[0].slice(-2);
          return p ? "other" : _ == 1 && (A < 11 || A > 19) ? "one" : _ >= 2 && _ <= 9 && (A < 11 || A > 19) ? "few" : h != 0 ? "many" : "other";
        }, lv: (f, p) => {
          const y = String(f).split("."), h = y[1] || "", E = h.length, _ = Number(y[0]) == f, A = _ && y[0].slice(-1), F = _ && y[0].slice(-2), B = h.slice(-2), ee = h.slice(-1);
          return p ? "other" : _ && A == 0 || F >= 11 && F <= 19 || E == 2 && B >= 11 && B <= 19 ? "zero" : A == 1 && F != 11 || E == 2 && ee == 1 && B != 11 || E != 2 && ee == 1 ? "one" : "other";
        }, mas: Ne, mg: gr, mgo: Ne, mk: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-1), F = h.slice(-2), B = E.slice(-1), ee = E.slice(-2);
          return p ? A == 1 && F != 11 ? "one" : A == 2 && F != 12 ? "two" : A != 7 && A != 8 || F == 17 || F == 18 ? "other" : "many" : _ && A == 1 && F != 11 || B == 1 && ee != 11 ? "one" : "other";
        }, ml: Ne, mn: Ne, mo: (f, p) => {
          const y = String(f).split("."), h = !y[1], E = Number(y[0]) == f && y[0].slice(-2);
          return p ? f == 1 ? "one" : "other" : f == 1 && h ? "one" : !h || f == 0 || f != 1 && E >= 1 && E <= 19 ? "few" : "other";
        }, mr: (f, p) => p ? f == 1 ? "one" : f == 2 || f == 3 ? "two" : f == 4 ? "few" : "other" : f == 1 ? "one" : "other", ms: (f, p) => p && f == 1 ? "one" : "other", mt: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f && y[0].slice(-2);
          return p ? "other" : f == 1 ? "one" : f == 2 ? "two" : f == 0 || h >= 3 && h <= 10 ? "few" : h >= 11 && h <= 19 ? "many" : "other";
        }, my: yt, nah: Ne, naq: br, nb: Ne, nd: Ne, ne: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f;
          return p ? h && f >= 1 && f <= 4 ? "one" : "other" : f == 1 ? "one" : "other";
        }, nl: In, nn: Ne, nnh: Ne, no: Ne, nqo: yt, nr: Ne, nso: gr, ny: Ne, nyn: Ne, om: Ne, or: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f;
          return p ? f == 1 || f == 5 || h && f >= 7 && f <= 9 ? "one" : f == 2 || f == 3 ? "two" : f == 4 ? "few" : f == 6 ? "many" : "other" : f == 1 ? "one" : "other";
        }, os: Ne, osa: yt, pa: gr, pap: Ne, pcm: To, pl: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-1), A = h.slice(-2);
          return p ? "other" : f == 1 && E ? "one" : E && _ >= 2 && _ <= 4 && (A < 12 || A > 14) ? "few" : E && h != 1 && (_ == 0 || _ == 1) || E && _ >= 5 && _ <= 9 || E && A >= 12 && A <= 14 ? "many" : "other";
        }, prg: (f, p) => {
          const y = String(f).split("."), h = y[1] || "", E = h.length, _ = Number(y[0]) == f, A = _ && y[0].slice(-1), F = _ && y[0].slice(-2), B = h.slice(-2), ee = h.slice(-1);
          return p ? "other" : _ && A == 0 || F >= 11 && F <= 19 || E == 2 && B >= 11 && B <= 19 ? "zero" : A == 1 && F != 11 || E == 2 && ee == 1 && B != 11 || E != 2 && ee == 1 ? "one" : "other";
        }, ps: Ne, pt: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-6);
          return p ? "other" : h == 0 || h == 1 ? "one" : h != 0 && _ == 0 && E ? "many" : "other";
        }, pt_PT: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-6);
          return p ? "other" : f == 1 && E ? "one" : h != 0 && _ == 0 && E ? "many" : "other";
        }, rm: Ne, ro: (f, p) => {
          const y = String(f).split("."), h = !y[1], E = Number(y[0]) == f && y[0].slice(-2);
          return p ? f == 1 ? "one" : "other" : f == 1 && h ? "one" : !h || f == 0 || f != 1 && E >= 1 && E <= 19 ? "few" : "other";
        }, rof: Ne, ru: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-1), A = h.slice(-2);
          return p ? "other" : E && _ == 1 && A != 11 ? "one" : E && _ >= 2 && _ <= 4 && (A < 12 || A > 14) ? "few" : E && _ == 0 || E && _ >= 5 && _ <= 9 || E && A >= 11 && A <= 14 ? "many" : "other";
        }, rwk: Ne, sah: yt, saq: Ne, sat: br, sc: (f, p) => {
          const y = !String(f).split(".")[1];
          return p ? f == 11 || f == 8 || f == 80 || f == 800 ? "many" : "other" : f == 1 && y ? "one" : "other";
        }, scn: (f, p) => {
          const y = !String(f).split(".")[1];
          return p ? f == 11 || f == 8 || f == 80 || f == 800 ? "many" : "other" : f == 1 && y ? "one" : "other";
        }, sd: Ne, sdh: Ne, se: br, seh: Ne, ses: yt, sg: yt, sh: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-1), F = h.slice(-2), B = E.slice(-1), ee = E.slice(-2);
          return p ? "other" : _ && A == 1 && F != 11 || B == 1 && ee != 11 ? "one" : _ && A >= 2 && A <= 4 && (F < 12 || F > 14) || B >= 2 && B <= 4 && (ee < 12 || ee > 14) ? "few" : "other";
        }, shi: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f;
          return p ? "other" : f >= 0 && f <= 1 ? "one" : h && f >= 2 && f <= 10 ? "few" : "other";
        }, si: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "";
          return p ? "other" : f == 0 || f == 1 || h == 0 && E == 1 ? "one" : "other";
        }, sk: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1];
          return p ? "other" : f == 1 && E ? "one" : h >= 2 && h <= 4 && E ? "few" : E ? "other" : "many";
        }, sl: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-2);
          return p ? "other" : E && _ == 1 ? "one" : E && _ == 2 ? "two" : E && (_ == 3 || _ == 4) || !E ? "few" : "other";
        }, sma: br, smi: br, smj: br, smn: br, sms: br, sn: Ne, so: Ne, sq: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f, E = h && y[0].slice(-1), _ = h && y[0].slice(-2);
          return p ? f == 1 ? "one" : E == 4 && _ != 14 ? "many" : "other" : f == 1 ? "one" : "other";
        }, sr: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-1), F = h.slice(-2), B = E.slice(-1), ee = E.slice(-2);
          return p ? "other" : _ && A == 1 && F != 11 || B == 1 && ee != 11 ? "one" : _ && A >= 2 && A <= 4 && (F < 12 || F > 14) || B >= 2 && B <= 4 && (ee < 12 || ee > 14) ? "few" : "other";
        }, ss: Ne, ssy: Ne, st: Ne, su: yt, sv: (f, p) => {
          const y = String(f).split("."), h = !y[1], E = Number(y[0]) == f, _ = E && y[0].slice(-1), A = E && y[0].slice(-2);
          return p ? _ != 1 && _ != 2 || A == 11 || A == 12 ? "other" : "one" : f == 1 && h ? "one" : "other";
        }, sw: In, syr: Ne, ta: Ne, te: Ne, teo: Ne, th: yt, ti: gr, tig: Ne, tk: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f && y[0].slice(-1);
          return p ? h == 6 || h == 9 || f == 10 ? "few" : "other" : f == 1 ? "one" : "other";
        }, tl: (f, p) => {
          const y = String(f).split("."), h = y[0], E = y[1] || "", _ = !y[1], A = h.slice(-1), F = E.slice(-1);
          return p ? f == 1 ? "one" : "other" : _ && (h == 1 || h == 2 || h == 3) || _ && A != 4 && A != 6 && A != 9 || !_ && F != 4 && F != 6 && F != 9 ? "one" : "other";
        }, tn: Ne, to: yt, tpi: yt, tr: Ne, ts: Ne, tzm: (f, p) => {
          const y = String(f).split("."), h = Number(y[0]) == f;
          return p ? "other" : f == 0 || f == 1 || h && f >= 11 && f <= 99 ? "one" : "other";
        }, ug: Ne, uk: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = Number(y[0]) == f, A = _ && y[0].slice(-1), F = _ && y[0].slice(-2), B = h.slice(-1), ee = h.slice(-2);
          return p ? A == 3 && F != 13 ? "few" : "other" : E && B == 1 && ee != 11 ? "one" : E && B >= 2 && B <= 4 && (ee < 12 || ee > 14) ? "few" : E && B == 0 || E && B >= 5 && B <= 9 || E && ee >= 11 && ee <= 14 ? "many" : "other";
        }, und: yt, ur: In, uz: Ne, ve: Ne, vec: (f, p) => {
          const y = String(f).split("."), h = y[0], E = !y[1], _ = h.slice(-6);
          return p ? f == 11 || f == 8 || f == 80 || f == 800 ? "many" : "other" : f == 1 && E ? "one" : h != 0 && _ == 0 && E ? "many" : "other";
        }, vi: (f, p) => p && f == 1 ? "one" : "other", vo: Ne, vun: Ne, wa: gr, wae: Ne, wo: yt, xh: Ne, xog: Ne, yi: In, yo: yt, yue: yt, zh: yt, zu: To });
        function mc(f) {
          if (typeof f != "string" || f.length < 2)
            throw new RangeError("Invalid language tag: ".concat(f));
          if (f.startsWith("pt-PT"))
            return "pt-PT";
          var p = f.match(/.+?(?=[-_])/);
          return p ? p[0] : f;
        }
        function pi(f) {
          if (typeof f == "function") {
            var p = mc(f.name);
            return { isDefault: !1, id: xn(p), lc: p, locale: f.name, getPlural: f, cardinals: f.cardinals || [], ordinals: f.ordinals || [] };
          }
          var y = mc(f), h = xn(y);
          return function(E) {
            return E in mi;
          }(h) ? { isDefault: !0, id: h, lc: y, locale: f, getCardinal: Jb[h], getPlural: mi[h], cardinals: Pd[h].cardinal, ordinals: Pd[h].ordinal } : null;
        }
        function e1(f) {
          return xn(mc(f)) in mi;
        }
        return function() {
          function f(p, y) {
            if (this.plurals = [], this.options = Object.assign({ biDiSupport: !1, currency: "USD", customFormatters: {}, localeCodeFromKey: null, requireAllArguments: !1, returnType: "string", strict: y && y.strictNumberSign || !1, strictPluralKeys: !0 }, y), p === "*" ? this.plurals = (E = f.defaultLocale, (_ = Object.keys(mi).filter(function(A) {
              return A !== E;
            })).unshift(E), _.map(pi)) : Array.isArray(p) ? this.plurals = p.map(pi).filter(Boolean) : p && (h = pi(p)) && (this.plurals = [h]), this.plurals.length === 0) {
              var h = pi(f.defaultLocale);
              this.plurals = [h];
            }
            var E, _;
          }
          return f.escape = function(p, y) {
            var h = y ? /[#{}]/g : /[{}]/g;
            return String(p).replace(h, "'$&'");
          }, f.supportedLocalesOf = function(p) {
            return (Array.isArray(p) ? p : [p]).filter(e1);
          }, f.prototype.resolvedOptions = function() {
            return l(l({}, this.options), { locale: this.plurals[0].locale, plurals: this.plurals });
          }, f.prototype.compile = function(p) {
            var y, h, E = new tr(this.options), _ = "return " + E.compile(p, this.plurals[0]), A = [], F = [];
            try {
              for (var B = d(Object.entries(E.runtime)), ee = B.next(); !ee.done; ee = B.next()) {
                var we = u(ee.value, 2), De = we[0], je = we[1];
                A.push(De), F.push(je);
              }
            } catch (be) {
              y = { error: be };
            } finally {
              try {
                ee && !ee.done && (h = B.return) && h.call(B);
              } finally {
                if (y)
                  throw y.error;
              }
            }
            return new (Function.bind.apply(Function, v(v([void 0], u(A), !1), [_], !1)))().apply(void 0, v([], u(F), !1));
          }, f.defaultLocale = "en", f;
        }();
      }();
    }, 151: (i) => {
      var s = { utf8: { stringToBytes: function(c) {
        return s.bin.stringToBytes(unescape(encodeURIComponent(c)));
      }, bytesToString: function(c) {
        return decodeURIComponent(escape(s.bin.bytesToString(c)));
      } }, bin: { stringToBytes: function(c) {
        for (var l = [], d = 0; d < c.length; d++)
          l.push(255 & c.charCodeAt(d));
        return l;
      }, bytesToString: function(c) {
        for (var l = [], d = 0; d < c.length; d++)
          l.push(String.fromCharCode(c[d]));
        return l.join("");
      } } };
      i.exports = s;
    }, 945: (i, s, c) => {
      var l = typeof globalThis < "u" && globalThis || typeof self < "u" && self || c.g !== void 0 && c.g, d = function() {
        function v() {
          this.fetch = !1, this.DOMException = l.DOMException;
        }
        return v.prototype = l, new v();
      }();
      (function(v) {
        (function(m) {
          var b = v !== void 0 && v || typeof self < "u" && self || b !== void 0 && b, x = "URLSearchParams" in b, g = "Symbol" in b && "iterator" in Symbol, k = "FileReader" in b && "Blob" in b && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(), $ = "FormData" in b, T = "ArrayBuffer" in b;
          if (T)
            var S = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"], C = ArrayBuffer.isView || function(O) {
              return O && S.indexOf(Object.prototype.toString.call(O)) > -1;
            };
          function N(O) {
            if (typeof O != "string" && (O = String(O)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(O) || O === "")
              throw new TypeError('Invalid character in header field name: "' + O + '"');
            return O.toLowerCase();
          }
          function U(O) {
            return typeof O != "string" && (O = String(O)), O;
          }
          function L(O) {
            var G = { next: function() {
              var W = O.shift();
              return { done: W === void 0, value: W };
            } };
            return g && (G[Symbol.iterator] = function() {
              return G;
            }), G;
          }
          function j(O) {
            this.map = {}, O instanceof j ? O.forEach(function(G, W) {
              this.append(W, G);
            }, this) : Array.isArray(O) ? O.forEach(function(G) {
              this.append(G[0], G[1]);
            }, this) : O && Object.getOwnPropertyNames(O).forEach(function(G) {
              this.append(G, O[G]);
            }, this);
          }
          function q(O) {
            if (O.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            O.bodyUsed = !0;
          }
          function V(O) {
            return new Promise(function(G, W) {
              O.onload = function() {
                G(O.result);
              }, O.onerror = function() {
                W(O.error);
              };
            });
          }
          function Q(O) {
            var G = new FileReader(), W = V(G);
            return G.readAsArrayBuffer(O), W;
          }
          function ke(O) {
            if (O.slice)
              return O.slice(0);
            var G = new Uint8Array(O.byteLength);
            return G.set(new Uint8Array(O)), G.buffer;
          }
          function H() {
            return this.bodyUsed = !1, this._initBody = function(O) {
              var G;
              this.bodyUsed = this.bodyUsed, this._bodyInit = O, O ? typeof O == "string" ? this._bodyText = O : k && Blob.prototype.isPrototypeOf(O) ? this._bodyBlob = O : $ && FormData.prototype.isPrototypeOf(O) ? this._bodyFormData = O : x && URLSearchParams.prototype.isPrototypeOf(O) ? this._bodyText = O.toString() : T && k && (G = O) && DataView.prototype.isPrototypeOf(G) ? (this._bodyArrayBuffer = ke(O.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : T && (ArrayBuffer.prototype.isPrototypeOf(O) || C(O)) ? this._bodyArrayBuffer = ke(O) : this._bodyText = O = Object.prototype.toString.call(O) : this._bodyText = "", this.headers.get("content-type") || (typeof O == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : x && URLSearchParams.prototype.isPrototypeOf(O) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
            }, k && (this.blob = function() {
              var O = q(this);
              if (O)
                return O;
              if (this._bodyBlob)
                return Promise.resolve(this._bodyBlob);
              if (this._bodyArrayBuffer)
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              if (this._bodyFormData)
                throw new Error("could not read FormData body as blob");
              return Promise.resolve(new Blob([this._bodyText]));
            }, this.arrayBuffer = function() {
              return this._bodyArrayBuffer ? q(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer)) : this.blob().then(Q);
            }), this.text = function() {
              var O, G, W, ae = q(this);
              if (ae)
                return ae;
              if (this._bodyBlob)
                return O = this._bodyBlob, W = V(G = new FileReader()), G.readAsText(O), W;
              if (this._bodyArrayBuffer)
                return Promise.resolve(function(te) {
                  for (var se = new Uint8Array(te), Se = new Array(se.length), me = 0; me < se.length; me++)
                    Se[me] = String.fromCharCode(se[me]);
                  return Se.join("");
                }(this._bodyArrayBuffer));
              if (this._bodyFormData)
                throw new Error("could not read FormData body as text");
              return Promise.resolve(this._bodyText);
            }, $ && (this.formData = function() {
              return this.text().then($e);
            }), this.json = function() {
              return this.text().then(JSON.parse);
            }, this;
          }
          j.prototype.append = function(O, G) {
            O = N(O), G = U(G);
            var W = this.map[O];
            this.map[O] = W ? W + ", " + G : G;
          }, j.prototype.delete = function(O) {
            delete this.map[N(O)];
          }, j.prototype.get = function(O) {
            return O = N(O), this.has(O) ? this.map[O] : null;
          }, j.prototype.has = function(O) {
            return this.map.hasOwnProperty(N(O));
          }, j.prototype.set = function(O, G) {
            this.map[N(O)] = U(G);
          }, j.prototype.forEach = function(O, G) {
            for (var W in this.map)
              this.map.hasOwnProperty(W) && O.call(G, this.map[W], W, this);
          }, j.prototype.keys = function() {
            var O = [];
            return this.forEach(function(G, W) {
              O.push(W);
            }), L(O);
          }, j.prototype.values = function() {
            var O = [];
            return this.forEach(function(G) {
              O.push(G);
            }), L(O);
          }, j.prototype.entries = function() {
            var O = [];
            return this.forEach(function(G, W) {
              O.push([W, G]);
            }), L(O);
          }, g && (j.prototype[Symbol.iterator] = j.prototype.entries);
          var X = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
          function he(O, G) {
            if (!(this instanceof he))
              throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            var W, ae, te = (G = G || {}).body;
            if (O instanceof he) {
              if (O.bodyUsed)
                throw new TypeError("Already read");
              this.url = O.url, this.credentials = O.credentials, G.headers || (this.headers = new j(O.headers)), this.method = O.method, this.mode = O.mode, this.signal = O.signal, te || O._bodyInit == null || (te = O._bodyInit, O.bodyUsed = !0);
            } else
              this.url = String(O);
            if (this.credentials = G.credentials || this.credentials || "same-origin", !G.headers && this.headers || (this.headers = new j(G.headers)), this.method = (ae = (W = G.method || this.method || "GET").toUpperCase(), X.indexOf(ae) > -1 ? ae : W), this.mode = G.mode || this.mode || null, this.signal = G.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && te)
              throw new TypeError("Body not allowed for GET or HEAD requests");
            if (this._initBody(te), !(this.method !== "GET" && this.method !== "HEAD" || G.cache !== "no-store" && G.cache !== "no-cache")) {
              var se = /([?&])_=[^&]*/;
              se.test(this.url) ? this.url = this.url.replace(se, "$1_=" + (/* @__PURE__ */ new Date()).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
          function $e(O) {
            var G = new FormData();
            return O.trim().split("&").forEach(function(W) {
              if (W) {
                var ae = W.split("="), te = ae.shift().replace(/\+/g, " "), se = ae.join("=").replace(/\+/g, " ");
                G.append(decodeURIComponent(te), decodeURIComponent(se));
              }
            }), G;
          }
          function Te(O, G) {
            if (!(this instanceof Te))
              throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            G || (G = {}), this.type = "default", this.status = G.status === void 0 ? 200 : G.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = G.statusText === void 0 ? "" : "" + G.statusText, this.headers = new j(G.headers), this.url = G.url || "", this._initBody(O);
          }
          he.prototype.clone = function() {
            return new he(this, { body: this._bodyInit });
          }, H.call(he.prototype), H.call(Te.prototype), Te.prototype.clone = function() {
            return new Te(this._bodyInit, { status: this.status, statusText: this.statusText, headers: new j(this.headers), url: this.url });
          }, Te.error = function() {
            var O = new Te(null, { status: 0, statusText: "" });
            return O.type = "error", O;
          };
          var fe = [301, 302, 303, 307, 308];
          Te.redirect = function(O, G) {
            if (fe.indexOf(G) === -1)
              throw new RangeError("Invalid status code");
            return new Te(null, { status: G, headers: { location: O } });
          }, m.DOMException = b.DOMException;
          try {
            new m.DOMException();
          } catch {
            m.DOMException = function(G, W) {
              this.message = G, this.name = W;
              var ae = Error(G);
              this.stack = ae.stack;
            }, m.DOMException.prototype = Object.create(Error.prototype), m.DOMException.prototype.constructor = m.DOMException;
          }
          function Y(O, G) {
            return new Promise(function(W, ae) {
              var te = new he(O, G);
              if (te.signal && te.signal.aborted)
                return ae(new m.DOMException("Aborted", "AbortError"));
              var se = new XMLHttpRequest();
              function Se() {
                se.abort();
              }
              se.onload = function() {
                var me, ne, ye = { status: se.status, statusText: se.statusText, headers: (me = se.getAllResponseHeaders() || "", ne = new j(), me.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(pe) {
                  return pe.indexOf(`
`) === 0 ? pe.substr(1, pe.length) : pe;
                }).forEach(function(pe) {
                  var mt = pe.split(":"), Ae = mt.shift().trim();
                  if (Ae) {
                    var K = mt.join(":").trim();
                    ne.append(Ae, K);
                  }
                }), ne) };
                ye.url = "responseURL" in se ? se.responseURL : ye.headers.get("X-Request-URL");
                var ze = "response" in se ? se.response : se.responseText;
                setTimeout(function() {
                  W(new Te(ze, ye));
                }, 0);
              }, se.onerror = function() {
                setTimeout(function() {
                  ae(new TypeError("Network request failed"));
                }, 0);
              }, se.ontimeout = function() {
                setTimeout(function() {
                  ae(new TypeError("Network request failed"));
                }, 0);
              }, se.onabort = function() {
                setTimeout(function() {
                  ae(new m.DOMException("Aborted", "AbortError"));
                }, 0);
              }, se.open(te.method, function(me) {
                try {
                  return me === "" && b.location.href ? b.location.href : me;
                } catch {
                  return me;
                }
              }(te.url), !0), te.credentials === "include" ? se.withCredentials = !0 : te.credentials === "omit" && (se.withCredentials = !1), "responseType" in se && (k ? se.responseType = "blob" : T && te.headers.get("Content-Type") && te.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (se.responseType = "arraybuffer")), !G || typeof G.headers != "object" || G.headers instanceof j ? te.headers.forEach(function(me, ne) {
                se.setRequestHeader(ne, me);
              }) : Object.getOwnPropertyNames(G.headers).forEach(function(me) {
                se.setRequestHeader(me, U(G.headers[me]));
              }), te.signal && (te.signal.addEventListener("abort", Se), se.onreadystatechange = function() {
                se.readyState === 4 && te.signal.removeEventListener("abort", Se);
              }), se.send(te._bodyInit === void 0 ? null : te._bodyInit);
            });
          }
          Y.polyfill = !0, b.fetch || (b.fetch = Y, b.Headers = j, b.Request = he, b.Response = Te), m.Headers = j, m.Request = he, m.Response = Te, m.fetch = Y;
        })({});
      })(d), d.fetch.ponyfill = !0, delete d.fetch.polyfill;
      var u = l.fetch ? l : d;
      (s = u.fetch).default = u.fetch, s.fetch = u.fetch, s.Headers = u.Headers, s.Request = u.Request, s.Response = u.Response, i.exports = s;
    }, 939: (i) => {
      var s, c;
      s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = { rotl: function(l, d) {
        return l << d | l >>> 32 - d;
      }, rotr: function(l, d) {
        return l << 32 - d | l >>> d;
      }, endian: function(l) {
        if (l.constructor == Number)
          return 16711935 & c.rotl(l, 8) | 4278255360 & c.rotl(l, 24);
        for (var d = 0; d < l.length; d++)
          l[d] = c.endian(l[d]);
        return l;
      }, randomBytes: function(l) {
        for (var d = []; l > 0; l--)
          d.push(Math.floor(256 * Math.random()));
        return d;
      }, bytesToWords: function(l) {
        for (var d = [], u = 0, v = 0; u < l.length; u++, v += 8)
          d[v >>> 5] |= l[u] << 24 - v % 32;
        return d;
      }, wordsToBytes: function(l) {
        for (var d = [], u = 0; u < 32 * l.length; u += 8)
          d.push(l[u >>> 5] >>> 24 - u % 32 & 255);
        return d;
      }, bytesToHex: function(l) {
        for (var d = [], u = 0; u < l.length; u++)
          d.push((l[u] >>> 4).toString(16)), d.push((15 & l[u]).toString(16));
        return d.join("");
      }, hexToBytes: function(l) {
        for (var d = [], u = 0; u < l.length; u += 2)
          d.push(parseInt(l.substr(u, 2), 16));
        return d;
      }, bytesToBase64: function(l) {
        for (var d = [], u = 0; u < l.length; u += 3)
          for (var v = l[u] << 16 | l[u + 1] << 8 | l[u + 2], m = 0; m < 4; m++)
            8 * u + 6 * m <= 8 * l.length ? d.push(s.charAt(v >>> 6 * (3 - m) & 63)) : d.push("=");
        return d.join("");
      }, base64ToBytes: function(l) {
        l = l.replace(/[^A-Z0-9+\/]/gi, "");
        for (var d = [], u = 0, v = 0; u < l.length; v = ++u % 4)
          v != 0 && d.push((s.indexOf(l.charAt(u - 1)) & Math.pow(2, -2 * v + 8) - 1) << 2 * v | s.indexOf(l.charAt(u)) >>> 6 - 2 * v);
        return d;
      } }, i.exports = c;
    }, 206: (i) => {
      function s(c) {
        return !!c.constructor && typeof c.constructor.isBuffer == "function" && c.constructor.isBuffer(c);
      }
      i.exports = function(c) {
        return c != null && (s(c) || function(l) {
          return typeof l.readFloatLE == "function" && typeof l.slice == "function" && s(l.slice(0, 0));
        }(c) || !!c._isBuffer);
      };
    }, 503: (i, s, c) => {
      var l, d, u, v, m;
      l = c(939), d = c(151).utf8, u = c(206), v = c(151).bin, (m = function(b, x) {
        b.constructor == String ? b = x && x.encoding === "binary" ? v.stringToBytes(b) : d.stringToBytes(b) : u(b) ? b = Array.prototype.slice.call(b, 0) : Array.isArray(b) || b.constructor === Uint8Array || (b = b.toString());
        for (var g = l.bytesToWords(b), k = 8 * b.length, $ = 1732584193, T = -271733879, S = -1732584194, C = 271733878, N = 0; N < g.length; N++)
          g[N] = 16711935 & (g[N] << 8 | g[N] >>> 24) | 4278255360 & (g[N] << 24 | g[N] >>> 8);
        g[k >>> 5] |= 128 << k % 32, g[14 + (k + 64 >>> 9 << 4)] = k;
        var U = m._ff, L = m._gg, j = m._hh, q = m._ii;
        for (N = 0; N < g.length; N += 16) {
          var V = $, Q = T, ke = S, H = C;
          $ = U($, T, S, C, g[N + 0], 7, -680876936), C = U(C, $, T, S, g[N + 1], 12, -389564586), S = U(S, C, $, T, g[N + 2], 17, 606105819), T = U(T, S, C, $, g[N + 3], 22, -1044525330), $ = U($, T, S, C, g[N + 4], 7, -176418897), C = U(C, $, T, S, g[N + 5], 12, 1200080426), S = U(S, C, $, T, g[N + 6], 17, -1473231341), T = U(T, S, C, $, g[N + 7], 22, -45705983), $ = U($, T, S, C, g[N + 8], 7, 1770035416), C = U(C, $, T, S, g[N + 9], 12, -1958414417), S = U(S, C, $, T, g[N + 10], 17, -42063), T = U(T, S, C, $, g[N + 11], 22, -1990404162), $ = U($, T, S, C, g[N + 12], 7, 1804603682), C = U(C, $, T, S, g[N + 13], 12, -40341101), S = U(S, C, $, T, g[N + 14], 17, -1502002290), $ = L($, T = U(T, S, C, $, g[N + 15], 22, 1236535329), S, C, g[N + 1], 5, -165796510), C = L(C, $, T, S, g[N + 6], 9, -1069501632), S = L(S, C, $, T, g[N + 11], 14, 643717713), T = L(T, S, C, $, g[N + 0], 20, -373897302), $ = L($, T, S, C, g[N + 5], 5, -701558691), C = L(C, $, T, S, g[N + 10], 9, 38016083), S = L(S, C, $, T, g[N + 15], 14, -660478335), T = L(T, S, C, $, g[N + 4], 20, -405537848), $ = L($, T, S, C, g[N + 9], 5, 568446438), C = L(C, $, T, S, g[N + 14], 9, -1019803690), S = L(S, C, $, T, g[N + 3], 14, -187363961), T = L(T, S, C, $, g[N + 8], 20, 1163531501), $ = L($, T, S, C, g[N + 13], 5, -1444681467), C = L(C, $, T, S, g[N + 2], 9, -51403784), S = L(S, C, $, T, g[N + 7], 14, 1735328473), $ = j($, T = L(T, S, C, $, g[N + 12], 20, -1926607734), S, C, g[N + 5], 4, -378558), C = j(C, $, T, S, g[N + 8], 11, -2022574463), S = j(S, C, $, T, g[N + 11], 16, 1839030562), T = j(T, S, C, $, g[N + 14], 23, -35309556), $ = j($, T, S, C, g[N + 1], 4, -1530992060), C = j(C, $, T, S, g[N + 4], 11, 1272893353), S = j(S, C, $, T, g[N + 7], 16, -155497632), T = j(T, S, C, $, g[N + 10], 23, -1094730640), $ = j($, T, S, C, g[N + 13], 4, 681279174), C = j(C, $, T, S, g[N + 0], 11, -358537222), S = j(S, C, $, T, g[N + 3], 16, -722521979), T = j(T, S, C, $, g[N + 6], 23, 76029189), $ = j($, T, S, C, g[N + 9], 4, -640364487), C = j(C, $, T, S, g[N + 12], 11, -421815835), S = j(S, C, $, T, g[N + 15], 16, 530742520), $ = q($, T = j(T, S, C, $, g[N + 2], 23, -995338651), S, C, g[N + 0], 6, -198630844), C = q(C, $, T, S, g[N + 7], 10, 1126891415), S = q(S, C, $, T, g[N + 14], 15, -1416354905), T = q(T, S, C, $, g[N + 5], 21, -57434055), $ = q($, T, S, C, g[N + 12], 6, 1700485571), C = q(C, $, T, S, g[N + 3], 10, -1894986606), S = q(S, C, $, T, g[N + 10], 15, -1051523), T = q(T, S, C, $, g[N + 1], 21, -2054922799), $ = q($, T, S, C, g[N + 8], 6, 1873313359), C = q(C, $, T, S, g[N + 15], 10, -30611744), S = q(S, C, $, T, g[N + 6], 15, -1560198380), T = q(T, S, C, $, g[N + 13], 21, 1309151649), $ = q($, T, S, C, g[N + 4], 6, -145523070), C = q(C, $, T, S, g[N + 11], 10, -1120210379), S = q(S, C, $, T, g[N + 2], 15, 718787259), T = q(T, S, C, $, g[N + 9], 21, -343485551), $ = $ + V >>> 0, T = T + Q >>> 0, S = S + ke >>> 0, C = C + H >>> 0;
        }
        return l.endian([$, T, S, C]);
      })._ff = function(b, x, g, k, $, T, S) {
        var C = b + (x & g | ~x & k) + ($ >>> 0) + S;
        return (C << T | C >>> 32 - T) + x;
      }, m._gg = function(b, x, g, k, $, T, S) {
        var C = b + (x & k | g & ~k) + ($ >>> 0) + S;
        return (C << T | C >>> 32 - T) + x;
      }, m._hh = function(b, x, g, k, $, T, S) {
        var C = b + (x ^ g ^ k) + ($ >>> 0) + S;
        return (C << T | C >>> 32 - T) + x;
      }, m._ii = function(b, x, g, k, $, T, S) {
        var C = b + (g ^ (x | ~k)) + ($ >>> 0) + S;
        return (C << T | C >>> 32 - T) + x;
      }, m._blocksize = 16, m._digestsize = 16, i.exports = function(b, x) {
        if (b == null)
          throw new Error("Illegal argument " + b);
        var g = l.wordsToBytes(m(b, x));
        return x && x.asBytes ? g : x && x.asString ? v.bytesToString(g) : l.bytesToHex(g);
      };
    } }, r = {};
    function o(i) {
      var s = r[i];
      if (s !== void 0)
        return s.exports;
      var c = r[i] = { exports: {} };
      return n[i].call(c.exports, c, c.exports, o), c.exports;
    }
    o.n = (i) => {
      var s = i && i.__esModule ? () => i.default : () => i;
      return o.d(s, { a: s }), s;
    }, o.d = (i, s) => {
      for (var c in s)
        o.o(s, c) && !o.o(i, c) && Object.defineProperty(i, c, { enumerable: !0, get: s[c] });
    }, o.g = function() {
      if (typeof globalThis == "object")
        return globalThis;
      try {
        return this || new Function("return this")();
      } catch {
        if (typeof window == "object")
          return window;
      }
    }(), o.o = (i, s) => Object.prototype.hasOwnProperty.call(i, s), o.r = (i) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    };
    var a = {};
    return (() => {
      o.r(a), o.d(a, { FETCHING_LOCALES: () => V, FETCHING_TRANSLATIONS: () => U, LOCALES_FETCHED: () => Q, LOCALES_FETCH_FAILED: () => ke, LOCALE_CHANGED: () => q, MessageFormatRenderer: () => ye, PseudoTranslationPolicy: () => se, SourceErrorPolicy: () => me, SourceStringPolicy: () => Se, TRANSLATIONS_FETCHED: () => L, TRANSLATIONS_FETCH_FAILED: () => j, ThrowErrorPolicy: () => ne, createNativeInstance: () => ze, escape: () => T, explodePlurals: () => O, generateHashedKey: () => $, generateKey: () => k, implodePlurals: () => G, isPluralized: () => W, isString: () => S, normalizeLocale: () => C, offEvent: () => he, onEvent: () => X, sendEvent: () => $e, sleep: () => N, t: () => mt, tx: () => pe });
      var i = o(945), s = o.n(i);
      class c {
        constructor() {
          this.translationsByLocale = {};
        }
        update(K, ie) {
          const ve = this.translationsByLocale[K] || {};
          this.translationsByLocale[K] = { ...ve, ...ie };
        }
        getTranslations(K) {
          return this.translationsByLocale[K] || {};
        }
        hasTranslations(K) {
          return !!this.translationsByLocale[K];
        }
        isStale(K) {
          return !this.hasTranslations(K);
        }
        get(K, ie) {
          return this.getTranslations(ie)[K] || "";
        }
      }
      class l {
        handle(K, ie, ve, Me) {
          return ie;
        }
      }
      class d {
        handle(K, ie, ve) {
          return K;
        }
      }
      var u = o(9), v = o.n(u);
      const m = {};
      class b {
        render(K, ie, ve) {
          const Me = (ie || "").split("_")[0];
          if (!m[Me])
            try {
              m[Me] = new (v())(Me, { strictPluralKeys: !1 });
            } catch {
              m[Me] = new (v())("*", { strictPluralKeys: !1 });
            }
          return m[Me].compile(K)(ve);
        }
      }
      var x = o(503), g = o.n(x);
      function k(Ae) {
        let K = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return K._key ? K._key : K._context ? `${Ae}::${K._context}` : `${Ae}`;
      }
      function $(Ae) {
        let K = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (K._key)
          return K._key;
        let ie = "";
        return K._context && (ie = K._context, ie = ie.replace(/,/g, ":")), g()(`5:${Ae}:${ie}`);
      }
      function T(Ae) {
        return Ae.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
      }
      function S(Ae) {
        return Object.prototype.toString.call(Ae) === "[object String]";
      }
      function C(Ae) {
        const K = Ae.split("-");
        let ie;
        return ie = K.length === 1 ? Ae : [K[0], K[1].toUpperCase()].join("_"), ie;
      }
      function N(Ae) {
        return new Promise((K) => {
          setTimeout(() => {
            K();
          }, Ae);
        });
      }
      const U = "FETCHING_TRANSLATIONS", L = "TRANSLATIONS_FETCHED", j = "TRANSLATIONS_FETCH_FAILED", q = "LOCALE_CHANGED", V = "FETCHING_LOCALES", Q = "LOCALES_FETCHED", ke = "LOCALES_FETCH_FAILED", H = {};
      function X(Ae, K) {
        H[Ae] = H[Ae] || [], H[Ae].push(K);
      }
      function he(Ae, K) {
        const ie = H[Ae] || [], ve = ie.indexOf(K);
        ve !== -1 && ie.splice(ve, 1);
      }
      function $e(Ae, K, ie) {
        (H[Ae] || []).forEach((ve) => {
          ve(K, ie);
        });
      }
      const Te = ["zero", "one", "two", "few", "many", "other"];
      function fe(Ae) {
        const K = Ae.indexOf("{");
        if (K === -1)
          return [null, null];
        let ie = Ae.substring(0, K).trim();
        if (ie[0] === "=") {
          if (ie = ie.substring(1), Number.isNaN(parseInt(ie, 10)) || parseInt(ie, 10) !== parseFloat(ie))
            return [null, null];
          if (ie = parseInt(ie, 10), ie = Te[ie], ie === void 0)
            return [null, null];
        } else if (Te.indexOf(ie) === -1)
          return [null, null];
        return [ie, Ae.substring(K)];
      }
      function Y(Ae) {
        let [K, ie] = [0, !1], ve = 0;
        for (; ve < Ae.length; ) {
          const Me = Ae[ve];
          if (Me === "'") {
            const Ue = Ae[ve + 1];
            Ue === "'" ? ve += 1 : ie ? ie = !1 : Ue !== "{" && Ue !== "}" || (ie = !0);
          } else if (Me === "{")
            ie || (K += 1);
          else if (Me === "}" && (ie || (K -= 1), K === 0))
            return [Ae.substring(1, ve), Ae.substring(ve + 1).trim()];
          ve += 1;
        }
        return [null, null];
      }
      function O(Ae) {
        const K = [null, { other: Ae }];
        let [ie, ve] = function(et) {
          if (!(et.length > 1 && et[0] === "{" && et[et.length - 1] === "}"))
            return [null, null];
          const Nt = et.indexOf(",");
          if (Nt === -1)
            return [null, null];
          const Vt = et.indexOf(",", Nt + 1);
          if (Vt === -1)
            return [null, null];
          const Rt = et.substring(1, Nt).trim(), sn = et.substring(Nt + 1, Vt).trim();
          return /^[\w_]+$/.test(Rt) && sn === "plural" ? [Rt, et.substring(Vt + 1, et.length - 1).trim()] : [null, null];
        }(Ae);
        if (ie == null)
          return K;
        const Me = {};
        let Ue, it;
        if ([Ue, ve] = fe(ve), Ue == null || ([it, ve] = Y(ve.trim()), it == null))
          return K;
        for (Me[Ue] = it; ve.trim(); ) {
          if ([Ue, ve] = fe(ve.trim()), Ue == null || ([it, ve] = Y(ve.trim()), it == null))
            return K;
          Me[Ue] = it;
        }
        return (Object.keys(Me).length !== 1 || "other" in Me) && "one" in Me && "other" in Me ? [ie, Me] : K;
      }
      function G(Ae) {
        const K = [`{${arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "???"}, plural,`];
        for (const ie of Te)
          if (ie in Ae) {
            const ve = Ae[ie];
            K.push(` ${ie} {${ve}}`);
          }
        return K.push("}"), K.join("");
      }
      function W(Ae) {
        const K = O(Ae)[1];
        return Object.keys(K).length > 1;
      }
      class ae {
        constructor() {
          this.cdsHost = "https://cds.svc.transifex.net", this.token = "", this.secret = "", this.filterTags = "", this.filterStatus = "", this.fetchTimeout = 0, this.fetchInterval = 250, this.cache = new c(), this.missingPolicy = new d(), this.errorPolicy = new l(), this.stringRenderer = new b(), this.currentLocale = "", this.locales = [], this.languages = [], this.childInstances = [];
        }
        init(K) {
          const ie = this;
          ["cdsHost", "token", "secret", "cache", "filterTags", "filterStatus", "fetchTimeout", "fetchInterval", "missingPolicy", "errorPolicy", "stringRenderer", "currentLocale"].forEach((ve) => {
            K[ve] !== void 0 && (ie[ve] = K[ve]);
          }), this.fetchedTags = {};
        }
        translate(K, ie) {
          return this.translateLocale(this.currentLocale, K, ie);
        }
        translateLocale(K, ie, ve) {
          try {
            let Me = this.cache.get(k(ie, ve), K);
            Me || (Me = this.cache.get($(ie, ve), K)), Me && Me.startsWith("{???") && W(ie) && (Me = `{${ie.substring(1, ie.indexOf(",")).trim()}${Me.substring(4)}`);
            let Ue = !1;
            if (Me || (Ue = !0, Me = ie), ve && ve._escapeVars) {
              const it = {};
              Object.keys(ve).forEach((et) => {
                const Nt = ve[et];
                it[et] = S(Nt) ? T(Nt) : Nt;
              }), Me = this.stringRenderer.render(Me, K, it);
            } else
              Me = this.stringRenderer.render(Me, K, ve);
            return Ue && K && (Me = this.missingPolicy.handle(Me, K, ve)), S(Me) || (Me = `${Me}`), Me;
          } catch (Me) {
            return this.errorPolicy.handle(Me, `${ie}`, K, ve);
          }
        }
        async fetchTranslations(K) {
          let ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          const ve = ie.filterTags || this.filterTags;
          if (!ie.refresh && !this.cache.isStale(K) && (!ve && this.cache.hasTranslations(K) || ve && (this.fetchedTags[K] || []).indexOf(ve) !== -1))
            return;
          ve && (K in this.fetchedTags || (this.fetchedTags[K] = []), this.fetchedTags[K].indexOf(ve) === -1 && this.fetchedTags[K].push(ve));
          const Me = (Ue) => ($e(j, { localeCode: K, filterTags: ve }, this), Ue);
          try {
            let Ue;
            $e(U, { localeCode: K, filterTags: ve }, this);
            let it = 202;
            const et = Date.now();
            for (; it === 202; ) {
              let Vt = `${this.cdsHost}/content/${K}`;
              const Rt = [];
              if (ve && Rt.push(`filter[tags]=${ve}`), this.filterStatus && Rt.push(`filter[status]=${this.filterStatus}`), Rt.length && (Vt = `${Vt}?${Rt.join("&")}`), Ue = await s()(Vt, { method: "GET", headers: { Authorization: `Bearer ${this.token}`, "Accept-version": "v2", "X-NATIVE-SDK": "txjs/browser/7.1.2" }, signal: this.fetchTimeout > 0 ? AbortSignal.timeout(this.fetchTimeout) : void 0 }), !Ue.ok)
                throw await this._fetchError(Ue);
              if (it = Ue.status, this.fetchTimeout > 0 && Date.now() - et >= this.fetchTimeout)
                throw Me(new Error("Fetch translations timeout"));
              it === 202 && this.fetchInterval > 0 && await N(this.fetchInterval);
            }
            const Nt = await Ue.json();
            if (!Nt || !Nt.data)
              throw Me(new Error("Could not fetch translations"));
            {
              const Vt = {};
              Object.keys(Nt.data).forEach((Rt) => {
                Nt.data[Rt].string && (Vt[Rt] = Nt.data[Rt].string);
              }), this.cache.update(K, Vt), $e(L, { localeCode: K, filterTags: ve }, this);
            }
          } catch (Ue) {
            throw Me(Ue);
          }
        }
        async invalidateCDS() {
          let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          if (!this.token)
            throw new Error("token is not defined");
          if (!this.secret)
            throw new Error("secret is not defined");
          const ie = K.purge ? "purge" : "invalidate", ve = await s()(`${this.cdsHost}/${ie}`, { method: "POST", headers: { Authorization: `Bearer ${this.token}:${this.secret}`, "Accept-version": "v2", "Content-Type": "application/json;charset=utf-8", "X-NATIVE-SDK": "txjs/browser/7.1.2" } });
          if (!ve.ok)
            throw await this._fetchError(ve);
          return await ve.json();
        }
        async pushSource(K) {
          let ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (!this.token)
            throw new Error("token is not defined");
          if (!this.secret)
            throw new Error("secret is not defined");
          const ve = { Authorization: `Bearer ${this.token}:${this.secret}`, "Accept-version": "v2", "Content-Type": "application/json;charset=utf-8", "X-NATIVE-SDK": "txjs/browser/7.1.2" }, Me = await s()(`${this.cdsHost}/content`, { method: "POST", headers: ve, body: JSON.stringify({ data: K, meta: { purge: !!ie.purge, override_tags: !!ie.overrideTags, override_occurrences: !!ie.overrideOccurrences } }) });
          if (!Me.ok)
            throw await this._fetchError(Me);
          const Ue = await Me.json(), it = `${this.cdsHost}${Ue.data.links.job}`;
          if (ie.noWait)
            return { jobUrl: it };
          let et = { status: "" };
          do {
            await N(1500);
            const Nt = await s()(it, { method: "GET", headers: ve });
            if (!Nt.ok)
              throw await this._fetchError(Nt);
            const Vt = await Nt.json(), { data: Rt } = Vt;
            et = { ...Rt.details || {}, errors: Rt.errors || [], status: Rt.status };
          } while (et.status === "pending" || et.status === "processing");
          return { jobUrl: it, ...et };
        }
        async getLocales() {
          if (!(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).refresh && this.locales.length > 0)
            return [...this.locales];
          if (!this.token)
            return [];
          const K = (ie) => ($e(ke, null, this), ie);
          try {
            let ie;
            $e(V, null, this);
            let ve = 202;
            const Me = Date.now();
            for (; ve === 202; ) {
              if (ie = await s()(`${this.cdsHost}/languages`, { method: "GET", headers: { Authorization: `Bearer ${this.token}`, "Accept-version": "v2", "X-NATIVE-SDK": "txjs/browser/7.1.2" }, signal: this.fetchTimeout > 0 ? AbortSignal.timeout(this.fetchTimeout) : void 0 }), !ie.ok)
                throw await this._fetchError(ie);
              if (ve = ie.status, this.fetchTimeout > 0 && Date.now() - Me >= this.fetchTimeout)
                throw K(new Error("Get locales timeout"));
              ve === 202 && this.fetchInterval > 0 && await N(this.fetchInterval);
            }
            const Ue = await ie.json();
            if (!Ue || !Ue.data)
              throw K(new Error("Could not fetch languages"));
            this.languages = Ue.data, this.locales = this.languages.map((it) => it.code), $e(Q, null, this);
          } catch (ie) {
            throw K(ie);
          }
          return [...this.locales];
        }
        getCurrentLocale() {
          return this.currentLocale;
        }
        isCurrent(K) {
          return K === this.currentLocale;
        }
        async setCurrentLocale(K) {
          if (this.isCurrent(K))
            await this._syncInstances(this.childInstances);
          else {
            if (!K)
              return this.currentLocale = "", await this._syncInstances(this.childInstances), void $e(q, this.currentLocale, this);
            await this.fetchTranslations(K), this.currentLocale = K, await this._syncInstances(this.childInstances), $e(q, K, this);
          }
        }
        async getLanguages() {
          let K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return await this.getLocales(K), [...this.languages];
        }
        async controllerOf(K) {
          if (K === this)
            throw new Error("Cannot add self as instance");
          if (K.childInstances.indexOf(this) !== -1)
            throw new Error("Cycle reference error, instance is controller of this");
          return this.childInstances.push(K), await this._syncInstances([K]), K;
        }
        async _syncInstances(K) {
          const ie = this.getCurrentLocale();
          if (ie) {
            for (let ve = 0; ve < K.length; ve++)
              if (K[ve].getCurrentLocale() !== ie)
                try {
                  await K[ve].fetchTranslations(ie);
                } catch {
                }
          }
          K.forEach((ve) => {
            ve.getCurrentLocale() !== ie && (ve.currentLocale = ie, $e(q, ie, ve));
          });
        }
        async _fetchError(K) {
          try {
            const ie = await K.text();
            return new Error(`HTTP ${K.status}: ${ie}`);
          } catch {
            return new Error(`HTTP error ${K.status}`);
          }
        }
      }
      const te = { a: "ȧ", A: "Ȧ", b: "ƀ", B: "Ɓ", c: "ƈ", C: "Ƈ", d: "ḓ", D: "Ḓ", e: "ḗ", E: "Ḗ", f: "ƒ", F: "Ƒ", g: "ɠ", G: "Ɠ", h: "ħ", H: "Ħ", i: "ī", I: "Ī", j: "ĵ", J: "Ĵ", k: "ķ", K: "Ķ", l: "ŀ", L: "Ŀ", m: "ḿ", M: "Ḿ", n: "ƞ", N: "Ƞ", o: "ǿ", O: "Ǿ", p: "ƥ", P: "Ƥ", q: "ɋ", Q: "Ɋ", r: "ř", R: "Ř", s: "ş", S: "Ş", t: "ŧ", T: "Ŧ", v: "ṽ", V: "Ṽ", u: "ŭ", U: "Ŭ", w: "ẇ", W: "Ẇ", x: "ẋ", X: "Ẋ", y: "ẏ", Y: "Ẏ", z: "ẑ", Z: "Ẑ" }, se = class {
        handle(Ae, K, ie) {
          return Ae.split(/__txnative__/).map((ve) => {
            let Me = "";
            for (let Ue = 0; Ue < ve.length; Ue += 1) {
              const it = ve.charAt(Ue);
              if (te[it]) {
                const et = it.toLowerCase();
                Me += et === "a" || et === "e" || et === "o" || et === "u" ? te[it] + te[it] : te[it];
              } else
                Me += it;
            }
            return Me;
          }).join("__txnative__");
        }
      }, Se = d, me = l, ne = class {
        handle(Ae, K, ie, ve) {
          throw Ae || new Error(`Error translating "${K}"`);
        }
      }, ye = b, ze = function(Ae) {
        const K = new ae();
        return K.t = K.translate.bind(K), Ae && K.init(Ae), K;
      }, pe = new ae(), mt = pe.translate.bind(pe);
    })(), a;
  })());
})(lh);
var Pn = lh.exports;
const pf = {
  1860266: {
    icon: "facebook",
    name: "Facebook"
  },
  1091698: {
    icon: "instagram",
    name: "Instagram"
  },
  1077116: {
    icon: "twitter",
    name: "Twitter"
  }
}, w2 = (e) => {
  if (!e || e === "<p></p>")
    return {
      paragraphsToShow: [],
      paragraphsToExpand: [],
      allParagraphs: []
    };
  const n = (e == null ? void 0 : e.replaceAll("</p>", "</p>##")).split("##");
  let r = 0, o = 0;
  return n == null || n.forEach((a) => {
    o += a.length, o < 700 && (r += 1);
  }), {
    paragraphsToShow: n.slice(0, r),
    paragraphsToExpand: n.slice(r),
    allParagraphs: n
  };
}, lu = (e) => {
  if (!e)
    return /* @__PURE__ */ w.jsx(Sc, {});
  const { sourceType: t, socialMediaType: n, size: r = 16 } = e;
  switch (t) {
    case "SOCIAL":
      return n === "twitter" ? /* @__PURE__ */ w.jsx(x2, { size: r }) : n === "instagram" ? /* @__PURE__ */ w.jsx(y2, { size: r }) : /* @__PURE__ */ w.jsx(b2, { size: r });
    case "RADIO":
    case "WEB_RADIO":
      return /* @__PURE__ */ w.jsx(m2, {});
    case "TV":
    case "WEB_TV":
      return /* @__PURE__ */ w.jsx(h2, {});
    case "PRINT":
      return /* @__PURE__ */ w.jsx(p2, {});
    case "WEB":
      return /* @__PURE__ */ w.jsx(Sc, {});
    case "SUMMARY":
      return /* @__PURE__ */ w.jsx(u2, {});
    default:
      return /* @__PURE__ */ w.jsx(Sc, {});
  }
}, Ka = (e) => {
  var t;
  return e ? ((t = e.mediatype) == null ? void 0 : t.text) === "SOCIAL" : !1;
}, E2 = (e) => {
  var t;
  return e ? !!((t = e.identical_documents) != null && t.cnt) : !1;
}, uu = (e) => {
  var t;
  return Array.isArray((t = e.identical_documents) == null ? void 0 : t.document) ? e.identical_documents.document : [];
}, qz = (e, t) => {
  var n;
  return ((n = e.identical_documents) == null ? void 0 : n.document.findIndex(
    (r) => Qt(r) === t
  )) || 0;
}, $2 = ({
  mainArticle: e,
  similarArticle: t
}) => {
  var a;
  const { id_site: n, id_article: r } = t;
  return ((a = (e.almost_identical || []).find(
    (i) => i.id_article === r && i.id_site === n
  )) == null ? void 0 : a.sim) || 0;
}, uh = ({
  mainArticle: e,
  similarArticles: t
}) => t.map((n) => {
  const r = $2({ mainArticle: e, similarArticle: n });
  return { ...n, similarity: r };
}), T2 = [577, 578], du = ({
  topics: e = [],
  mediatype: t
}) => t ? !!e.find(({ id: r }) => T2.includes(r)) && t === "WEB" ? "RADIO" : t : null, Qt = (e) => `${e.id_site}_${e.id_article}`, S2 = ({
  summary: e,
  type: t,
  retweeted_user: n
}) => {
  const r = (e == null ? void 0 : e.lastIndexOf(" ")) ?? -1;
  switch (!0) {
    case t === "link":
      return e.substring(0, r);
    case t === "retweet":
      let o = e;
      const a = e == null ? void 0 : e.includes("RT"), i = e.split(":");
      return i.shift(), a && (o = i.join(" ")), Pn.t("Retweeted @{retweeted_user}: {newSummary}", {
        retweeted_user: n,
        newSummary: o
      });
    case t === "reply":
      return Pn.t("Replying to {summary}", { summary: e });
    default:
      return e;
  }
}, Xa = (e) => e in pf ? pf[e] : null, Yz = (e) => {
  const t = [];
  return e.forEach((n) => {
    var o;
    const r = (o = n == null ? void 0 : n.identical_documents) == null ? void 0 : o.document;
    r != null && r.length ? r.forEach((a) => {
      t.push(a);
    }) : n && t.push(n);
  }), t;
}, vn = (e, t) => !!(t & e), k2 = M(
  ({
    children: e,
    className: t,
    article: n,
    activeArticleSourceId: r,
    onSetArticleSource: o,
    onDeleteArticleSource: a,
    articleLayout: i = Hr.DEFAULT,
    componentsConfig: s = Kp,
    ...c
  }, l) => {
    const d = qe(
      () => uu(n).find(
        (v) => Qt(v) === r
      ) || n,
      [r, n]
    ), u = qe(
      () => ({
        article: n,
        activeArticle: d,
        onSetArticleSource: o,
        onDeleteArticleSource: a,
        articleLayout: i,
        componentsConfig: s
      }),
      [
        d,
        n,
        a,
        o,
        i,
        s
      ]
    );
    return /* @__PURE__ */ w.jsx(
      "article",
      {
        ref: l,
        className: z(
          "group/article m-0 flex cursor-pointer gap-x-[1.125rem] overflow-x-hidden border-b border-b-grey.6 py-5 pl-[0.625rem] pr-4 text-sky.1",
          {
            "py-2 gap-x-2.5": i === Hr.COMPACT,
            "py-1": !vn(
              Kt.Thumbnail,
              s
            ),
            "pb-4": !vn(
              Kt.Thumbnail,
              s
            ) && !!vn(
              Kt.Metadata,
              s
            )
          },
          t
        ),
        ...c,
        children: /* @__PURE__ */ w.jsx(Xp.Provider, { value: u, children: e })
      }
    );
  }
);
k2.displayName = "ArticleItem";
var hl = { exports: {} }, wi = { exports: {} }, Tt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hf;
function _2() {
  if (hf)
    return Tt;
  hf = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function T(C) {
    if (typeof C == "object" && C !== null) {
      var N = C.$$typeof;
      switch (N) {
        case t:
          switch (C = C.type, C) {
            case c:
            case l:
            case r:
            case a:
            case o:
            case u:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case d:
                case b:
                case m:
                case i:
                  return C;
                default:
                  return N;
              }
          }
        case n:
          return N;
      }
    }
  }
  function S(C) {
    return T(C) === l;
  }
  return Tt.AsyncMode = c, Tt.ConcurrentMode = l, Tt.ContextConsumer = s, Tt.ContextProvider = i, Tt.Element = t, Tt.ForwardRef = d, Tt.Fragment = r, Tt.Lazy = b, Tt.Memo = m, Tt.Portal = n, Tt.Profiler = a, Tt.StrictMode = o, Tt.Suspense = u, Tt.isAsyncMode = function(C) {
    return S(C) || T(C) === c;
  }, Tt.isConcurrentMode = S, Tt.isContextConsumer = function(C) {
    return T(C) === s;
  }, Tt.isContextProvider = function(C) {
    return T(C) === i;
  }, Tt.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Tt.isForwardRef = function(C) {
    return T(C) === d;
  }, Tt.isFragment = function(C) {
    return T(C) === r;
  }, Tt.isLazy = function(C) {
    return T(C) === b;
  }, Tt.isMemo = function(C) {
    return T(C) === m;
  }, Tt.isPortal = function(C) {
    return T(C) === n;
  }, Tt.isProfiler = function(C) {
    return T(C) === a;
  }, Tt.isStrictMode = function(C) {
    return T(C) === o;
  }, Tt.isSuspense = function(C) {
    return T(C) === u;
  }, Tt.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === r || C === l || C === a || C === o || C === u || C === v || typeof C == "object" && C !== null && (C.$$typeof === b || C.$$typeof === m || C.$$typeof === i || C.$$typeof === s || C.$$typeof === d || C.$$typeof === g || C.$$typeof === k || C.$$typeof === $ || C.$$typeof === x);
  }, Tt.typeOf = T, Tt;
}
var St = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vf;
function C2() {
  return vf || (vf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function T(pe) {
      return typeof pe == "string" || typeof pe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      pe === r || pe === l || pe === a || pe === o || pe === u || pe === v || typeof pe == "object" && pe !== null && (pe.$$typeof === b || pe.$$typeof === m || pe.$$typeof === i || pe.$$typeof === s || pe.$$typeof === d || pe.$$typeof === g || pe.$$typeof === k || pe.$$typeof === $ || pe.$$typeof === x);
    }
    function S(pe) {
      if (typeof pe == "object" && pe !== null) {
        var mt = pe.$$typeof;
        switch (mt) {
          case t:
            var Ae = pe.type;
            switch (Ae) {
              case c:
              case l:
              case r:
              case a:
              case o:
              case u:
                return Ae;
              default:
                var K = Ae && Ae.$$typeof;
                switch (K) {
                  case s:
                  case d:
                  case b:
                  case m:
                  case i:
                    return K;
                  default:
                    return mt;
                }
            }
          case n:
            return mt;
        }
      }
    }
    var C = c, N = l, U = s, L = i, j = t, q = d, V = r, Q = b, ke = m, H = n, X = a, he = o, $e = u, Te = !1;
    function fe(pe) {
      return Te || (Te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Y(pe) || S(pe) === c;
    }
    function Y(pe) {
      return S(pe) === l;
    }
    function O(pe) {
      return S(pe) === s;
    }
    function G(pe) {
      return S(pe) === i;
    }
    function W(pe) {
      return typeof pe == "object" && pe !== null && pe.$$typeof === t;
    }
    function ae(pe) {
      return S(pe) === d;
    }
    function te(pe) {
      return S(pe) === r;
    }
    function se(pe) {
      return S(pe) === b;
    }
    function Se(pe) {
      return S(pe) === m;
    }
    function me(pe) {
      return S(pe) === n;
    }
    function ne(pe) {
      return S(pe) === a;
    }
    function ye(pe) {
      return S(pe) === o;
    }
    function ze(pe) {
      return S(pe) === u;
    }
    St.AsyncMode = C, St.ConcurrentMode = N, St.ContextConsumer = U, St.ContextProvider = L, St.Element = j, St.ForwardRef = q, St.Fragment = V, St.Lazy = Q, St.Memo = ke, St.Portal = H, St.Profiler = X, St.StrictMode = he, St.Suspense = $e, St.isAsyncMode = fe, St.isConcurrentMode = Y, St.isContextConsumer = O, St.isContextProvider = G, St.isElement = W, St.isForwardRef = ae, St.isFragment = te, St.isLazy = se, St.isMemo = Se, St.isPortal = me, St.isProfiler = ne, St.isStrictMode = ye, St.isSuspense = ze, St.isValidElementType = T, St.typeOf = S;
  }()), St;
}
var gf;
function dh() {
  return gf || (gf = 1, process.env.NODE_ENV === "production" ? wi.exports = _2() : wi.exports = C2()), wi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var kc, bf;
function P2() {
  if (bf)
    return kc;
  bf = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(i).map(function(d) {
        return i[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return kc = o() ? Object.assign : function(a, i) {
    for (var s, c = r(a), l, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var u in s)
        t.call(s, u) && (c[u] = s[u]);
      if (e) {
        l = e(s);
        for (var v = 0; v < l.length; v++)
          n.call(s, l[v]) && (c[l[v]] = s[l[v]]);
      }
    }
    return c;
  }, kc;
}
var _c, yf;
function fu() {
  if (yf)
    return _c;
  yf = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _c = e, _c;
}
var Cc, xf;
function fh() {
  return xf || (xf = 1, Cc = Function.call.bind(Object.prototype.hasOwnProperty)), Cc;
}
var Pc, wf;
function A2() {
  if (wf)
    return Pc;
  wf = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = fu(), n = {}, r = fh();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (r(a, d)) {
          var u;
          try {
            if (typeof a[d] != "function") {
              var v = Error(
                (c || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw v.name = "Invariant Violation", v;
            }
            u = a[d](i, d, c, s, null, t);
          } catch (b) {
            u = b;
          }
          if (u && !(u instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in n)) {
            n[u.message] = !0;
            var m = l ? l() : "";
            e(
              "Failed " + s + " type: " + u.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Pc = o, Pc;
}
var Ac, Ef;
function O2() {
  if (Ef)
    return Ac;
  Ef = 1;
  var e = dh(), t = P2(), n = fu(), r = fh(), o = A2(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Ac = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function u(Y) {
      var O = Y && (l && Y[l] || Y[d]);
      if (typeof O == "function")
        return O;
    }
    var v = "<<anonymous>>", m = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: $(),
      arrayOf: T,
      element: S(),
      elementType: C(),
      instanceOf: N,
      node: q(),
      objectOf: L,
      oneOf: U,
      oneOfType: j,
      shape: Q,
      exact: ke
    };
    function b(Y, O) {
      return Y === O ? Y !== 0 || 1 / Y === 1 / O : Y !== Y && O !== O;
    }
    function x(Y, O) {
      this.message = Y, this.data = O && typeof O == "object" ? O : {}, this.stack = "";
    }
    x.prototype = Error.prototype;
    function g(Y) {
      if (process.env.NODE_ENV !== "production")
        var O = {}, G = 0;
      function W(te, se, Se, me, ne, ye, ze) {
        if (me = me || v, ye = ye || Se, ze !== n) {
          if (c) {
            var pe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw pe.name = "Invariant Violation", pe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var mt = me + ":" + Se;
            !O[mt] && // Avoid spamming the console because they are often not actionable except for lib authors
            G < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ye + "` prop on `" + me + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), O[mt] = !0, G++);
          }
        }
        return se[Se] == null ? te ? se[Se] === null ? new x("The " + ne + " `" + ye + "` is marked as required " + ("in `" + me + "`, but its value is `null`.")) : new x("The " + ne + " `" + ye + "` is marked as required in " + ("`" + me + "`, but its value is `undefined`.")) : null : Y(se, Se, me, ne, ye);
      }
      var ae = W.bind(null, !1);
      return ae.isRequired = W.bind(null, !0), ae;
    }
    function k(Y) {
      function O(G, W, ae, te, se, Se) {
        var me = G[W], ne = he(me);
        if (ne !== Y) {
          var ye = $e(me);
          return new x(
            "Invalid " + te + " `" + se + "` of type " + ("`" + ye + "` supplied to `" + ae + "`, expected ") + ("`" + Y + "`."),
            { expectedType: Y }
          );
        }
        return null;
      }
      return g(O);
    }
    function $() {
      return g(i);
    }
    function T(Y) {
      function O(G, W, ae, te, se) {
        if (typeof Y != "function")
          return new x("Property `" + se + "` of component `" + ae + "` has invalid PropType notation inside arrayOf.");
        var Se = G[W];
        if (!Array.isArray(Se)) {
          var me = he(Se);
          return new x("Invalid " + te + " `" + se + "` of type " + ("`" + me + "` supplied to `" + ae + "`, expected an array."));
        }
        for (var ne = 0; ne < Se.length; ne++) {
          var ye = Y(Se, ne, ae, te, se + "[" + ne + "]", n);
          if (ye instanceof Error)
            return ye;
        }
        return null;
      }
      return g(O);
    }
    function S() {
      function Y(O, G, W, ae, te) {
        var se = O[G];
        if (!s(se)) {
          var Se = he(se);
          return new x("Invalid " + ae + " `" + te + "` of type " + ("`" + Se + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(Y);
    }
    function C() {
      function Y(O, G, W, ae, te) {
        var se = O[G];
        if (!e.isValidElementType(se)) {
          var Se = he(se);
          return new x("Invalid " + ae + " `" + te + "` of type " + ("`" + Se + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(Y);
    }
    function N(Y) {
      function O(G, W, ae, te, se) {
        if (!(G[W] instanceof Y)) {
          var Se = Y.name || v, me = fe(G[W]);
          return new x("Invalid " + te + " `" + se + "` of type " + ("`" + me + "` supplied to `" + ae + "`, expected ") + ("instance of `" + Se + "`."));
        }
        return null;
      }
      return g(O);
    }
    function U(Y) {
      if (!Array.isArray(Y))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function O(G, W, ae, te, se) {
        for (var Se = G[W], me = 0; me < Y.length; me++)
          if (b(Se, Y[me]))
            return null;
        var ne = JSON.stringify(Y, function(ze, pe) {
          var mt = $e(pe);
          return mt === "symbol" ? String(pe) : pe;
        });
        return new x("Invalid " + te + " `" + se + "` of value `" + String(Se) + "` " + ("supplied to `" + ae + "`, expected one of " + ne + "."));
      }
      return g(O);
    }
    function L(Y) {
      function O(G, W, ae, te, se) {
        if (typeof Y != "function")
          return new x("Property `" + se + "` of component `" + ae + "` has invalid PropType notation inside objectOf.");
        var Se = G[W], me = he(Se);
        if (me !== "object")
          return new x("Invalid " + te + " `" + se + "` of type " + ("`" + me + "` supplied to `" + ae + "`, expected an object."));
        for (var ne in Se)
          if (r(Se, ne)) {
            var ye = Y(Se, ne, ae, te, se + "." + ne, n);
            if (ye instanceof Error)
              return ye;
          }
        return null;
      }
      return g(O);
    }
    function j(Y) {
      if (!Array.isArray(Y))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var O = 0; O < Y.length; O++) {
        var G = Y[O];
        if (typeof G != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Te(G) + " at index " + O + "."
          ), i;
      }
      function W(ae, te, se, Se, me) {
        for (var ne = [], ye = 0; ye < Y.length; ye++) {
          var ze = Y[ye], pe = ze(ae, te, se, Se, me, n);
          if (pe == null)
            return null;
          pe.data && r(pe.data, "expectedType") && ne.push(pe.data.expectedType);
        }
        var mt = ne.length > 0 ? ", expected one of type [" + ne.join(", ") + "]" : "";
        return new x("Invalid " + Se + " `" + me + "` supplied to " + ("`" + se + "`" + mt + "."));
      }
      return g(W);
    }
    function q() {
      function Y(O, G, W, ae, te) {
        return H(O[G]) ? null : new x("Invalid " + ae + " `" + te + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return g(Y);
    }
    function V(Y, O, G, W, ae) {
      return new x(
        (Y || "React class") + ": " + O + " type `" + G + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ae + "`."
      );
    }
    function Q(Y) {
      function O(G, W, ae, te, se) {
        var Se = G[W], me = he(Se);
        if (me !== "object")
          return new x("Invalid " + te + " `" + se + "` of type `" + me + "` " + ("supplied to `" + ae + "`, expected `object`."));
        for (var ne in Y) {
          var ye = Y[ne];
          if (typeof ye != "function")
            return V(ae, te, se, ne, $e(ye));
          var ze = ye(Se, ne, ae, te, se + "." + ne, n);
          if (ze)
            return ze;
        }
        return null;
      }
      return g(O);
    }
    function ke(Y) {
      function O(G, W, ae, te, se) {
        var Se = G[W], me = he(Se);
        if (me !== "object")
          return new x("Invalid " + te + " `" + se + "` of type `" + me + "` " + ("supplied to `" + ae + "`, expected `object`."));
        var ne = t({}, G[W], Y);
        for (var ye in ne) {
          var ze = Y[ye];
          if (r(Y, ye) && typeof ze != "function")
            return V(ae, te, se, ye, $e(ze));
          if (!ze)
            return new x(
              "Invalid " + te + " `" + se + "` key `" + ye + "` supplied to `" + ae + "`.\nBad object: " + JSON.stringify(G[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Y), null, "  ")
            );
          var pe = ze(Se, ye, ae, te, se + "." + ye, n);
          if (pe)
            return pe;
        }
        return null;
      }
      return g(O);
    }
    function H(Y) {
      switch (typeof Y) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Y;
        case "object":
          if (Array.isArray(Y))
            return Y.every(H);
          if (Y === null || s(Y))
            return !0;
          var O = u(Y);
          if (O) {
            var G = O.call(Y), W;
            if (O !== Y.entries) {
              for (; !(W = G.next()).done; )
                if (!H(W.value))
                  return !1;
            } else
              for (; !(W = G.next()).done; ) {
                var ae = W.value;
                if (ae && !H(ae[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function X(Y, O) {
      return Y === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
    }
    function he(Y) {
      var O = typeof Y;
      return Array.isArray(Y) ? "array" : Y instanceof RegExp ? "object" : X(O, Y) ? "symbol" : O;
    }
    function $e(Y) {
      if (typeof Y > "u" || Y === null)
        return "" + Y;
      var O = he(Y);
      if (O === "object") {
        if (Y instanceof Date)
          return "date";
        if (Y instanceof RegExp)
          return "regexp";
      }
      return O;
    }
    function Te(Y) {
      var O = $e(Y);
      switch (O) {
        case "array":
        case "object":
          return "an " + O;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;
        default:
          return O;
      }
    }
    function fe(Y) {
      return !Y.constructor || !Y.constructor.name ? v : Y.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, Ac;
}
var Oc, $f;
function N2() {
  if ($f)
    return Oc;
  $f = 1;
  var e = fu();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Oc = function() {
    function r(i, s, c, l, d, u) {
      if (u !== e) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Oc;
}
if (process.env.NODE_ENV !== "production") {
  var R2 = dh(), M2 = !0;
  hl.exports = O2()(R2.isElement, M2);
} else
  hl.exports = N2()();
var D2 = hl.exports;
const Ji = /* @__PURE__ */ $s(D2), mh = /* @__PURE__ */ Et({
  instance: null
});
function I2(e, t, n) {
  let r = Pn.t;
  n && (n.instance && n.instance.t ? r = n.instance.t : n.t && (r = n.t));
  const o = {}, a = [];
  t && Object.entries(t).forEach(([m, b]) => {
    /* @__PURE__ */ ce.isValidElement(b) ? (o[m] = `__txnative__${a.length}__txnative__`, a.push(b)) : o[m] = b;
  });
  const i = r(e, o), s = [];
  let c = 0, l = 0;
  const d = RegExp("__txnative__(\\d+)__txnative__", "g");
  let u = d.exec(i);
  for (; u !== null; ) {
    const m = i.slice(c, u.index);
    m && (s.push(/* @__PURE__ */ ce.createElement(Jt, {
      key: l
    }, m)), l += 1), s.push(/* @__PURE__ */ ce.cloneElement(a[parseInt(u[1], 10)], {
      key: l
    })), l += 1, c = u.index + u[0].length, u = d.exec(i);
  }
  const v = i.slice(c);
  return v && s.push(/* @__PURE__ */ ce.createElement(Jt, {
    key: l
  }, v)), s.length === 0 ? "" : s.length === 1 ? s[0].props.children : /* @__PURE__ */ ce.createElement(Jt, null, s);
}
function ph(e) {
  const t = Ye(mh), n = e || t.instance || Pn.tx, [r, o] = Ce(0);
  return Ee(() => {
    function a(i, s) {
      n === s && o((c) => c + 1);
    }
    return Pn.onEvent(Pn.LOCALE_CHANGED, a), Pn.onEvent(Pn.TRANSLATIONS_FETCHED, a), () => {
      Pn.offEvent(Pn.LOCALE_CHANGED, a), Pn.offEvent(Pn.TRANSLATIONS_FETCHED, a);
    };
  }, [o, n]), Ie((a, i) => I2(a, i, n), [n, r]);
}
Ji.string;
function Fr({
  _str: e,
  ...t
}) {
  return ph()(e, t);
}
Fr.propTypes = {
  _str: Ji.string.isRequired
};
Ji.string.isRequired, Ji.bool;
function Cs({
  instance: e,
  children: t
}) {
  return /* @__PURE__ */ ce.createElement(mh.Provider, {
    value: {
      instance: e
    }
  }, t);
}
const j2 = "1/7421b2b6ea259547b4fba8171bd912dbfc9bb931", Za = Pn.createNativeInstance();
Za.init({ token: j2 });
const L2 = M(
  ({ className: e, ...t }, n) => {
    var i, s, c;
    const r = ph(), { activeArticle: o, componentsConfig: a } = Rn();
    if (!vn(
      Kt.Author,
      a
    ))
      return null;
    if (Ka(o)) {
      const l = o.social_meta, d = ((i = l == null ? void 0 : l.author) == null ? void 0 : i.username) || o.author;
      return d ? /* @__PURE__ */ w.jsxs(
        "div",
        {
          ref: n,
          className: z("flex items-center space-x-1 text-label-s", e),
          ...t,
          children: [
            /* @__PURE__ */ w.jsxs("span", { children: [
              d,
              !!((s = l == null ? void 0 : l.author) != null && s.display_name) && /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
                /* @__PURE__ */ w.jsx("span", { className: "px-1", children: "|" }),
                /* @__PURE__ */ w.jsx("span", { className: "truncate text-sky.cloudy", children: l.author.display_name })
              ] })
            ] }),
            !!((c = l == null ? void 0 : l.author) != null && c.verified) && /* @__PURE__ */ w.jsx(Cs, { instance: Za, children: /* @__PURE__ */ w.jsx(
              t2,
              {
                title: r("Verified"),
                className: "text-[#1DA1F2]"
              }
            ) })
          ]
        }
      ) : null;
    }
    return /* @__PURE__ */ w.jsx(
      "div",
      {
        ref: n,
        className: z("font-slab text-label-s", e),
        ...t,
        children: o.author
      }
    );
  }
);
L2.displayName = "ArticleItem.Author";
const F2 = M(
  ({ children: e, className: t, ...n }, r) => {
    const { articleLayout: o } = Rn();
    return /* @__PURE__ */ w.jsx(
      "div",
      {
        className: z(
          "flex grow flex-col gap-y-2 overflow-x-hidden",
          { "gap-1": o === Hr.COMPACT },
          t
        ),
        ref: r,
        ...n,
        children: e
      }
    );
  }
);
F2.displayName = "ArticleItem.Content";
const W2 = M(({ children: e, className: t, ...n }, r) => {
  const { componentsConfig: o } = Rn();
  return vn(
    Kt.SourceDate,
    o
  ) || vn(
    Kt.SourceName,
    o
  ) ? /* @__PURE__ */ w.jsx(
    "div",
    {
      className: z(
        "flex items-center justify-between overflow-x-hidden",
        t
      ),
      ref: r,
      ...n,
      children: e
    }
  ) : null;
});
W2.displayName = "ArticleItem.ContentHead";
/*! @license DOMPurify 3.1.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.6/LICENSE */
const {
  entries: hh,
  setPrototypeOf: Tf,
  isFrozen: H2,
  getPrototypeOf: U2,
  getOwnPropertyDescriptor: B2
} = Object;
let {
  freeze: gn,
  seal: Fn,
  create: vh
} = Object, {
  apply: vl,
  construct: gl
} = typeof Reflect < "u" && Reflect;
gn || (gn = function(t) {
  return t;
});
Fn || (Fn = function(t) {
  return t;
});
vl || (vl = function(t, n, r) {
  return t.apply(n, r);
});
gl || (gl = function(t, n) {
  return new t(...n);
});
const Ei = Nn(Array.prototype.forEach), Sf = Nn(Array.prototype.pop), ua = Nn(Array.prototype.push), Vi = Nn(String.prototype.toLowerCase), Nc = Nn(String.prototype.toString), kf = Nn(String.prototype.match), da = Nn(String.prototype.replace), z2 = Nn(String.prototype.indexOf), V2 = Nn(String.prototype.trim), qn = Nn(Object.prototype.hasOwnProperty), hn = Nn(RegExp.prototype.test), fa = G2(TypeError);
function Nn(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return vl(e, t, r);
  };
}
function G2(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return gl(e, n);
  };
}
function ot(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Vi;
  Tf && Tf(e, null);
  let r = t.length;
  for (; r--; ) {
    let o = t[r];
    if (typeof o == "string") {
      const a = n(o);
      a !== o && (H2(t) || (t[r] = a), o = a);
    }
    e[o] = !0;
  }
  return e;
}
function q2(e) {
  for (let t = 0; t < e.length; t++)
    qn(e, t) || (e[t] = null);
  return e;
}
function eo(e) {
  const t = vh(null);
  for (const [n, r] of hh(e))
    qn(e, n) && (Array.isArray(r) ? t[n] = q2(r) : r && typeof r == "object" && r.constructor === Object ? t[n] = eo(r) : t[n] = r);
  return t;
}
function ma(e, t) {
  for (; e !== null; ) {
    const r = B2(e, t);
    if (r) {
      if (r.get)
        return Nn(r.get);
      if (typeof r.value == "function")
        return Nn(r.value);
    }
    e = U2(e);
  }
  function n() {
    return null;
  }
  return n;
}
const _f = gn(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Rc = gn(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Mc = gn(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Y2 = gn(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Dc = gn(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), K2 = gn(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Cf = gn(["#text"]), Pf = gn(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ic = gn(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Af = gn(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), $i = gn(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), X2 = Fn(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Z2 = Fn(/<%[\w\W]*|[\w\W]*%>/gm), Q2 = Fn(/\${[\w\W]*}/gm), J2 = Fn(/^data-[\-\w.\u00B7-\uFFFF]/), eE = Fn(/^aria-[\-\w]+$/), gh = Fn(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), tE = Fn(/^(?:\w+script|data):/i), nE = Fn(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), bh = Fn(/^html$/i), rE = Fn(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Of = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: X2,
  ERB_EXPR: Z2,
  TMPLIT_EXPR: Q2,
  DATA_ATTR: J2,
  ARIA_ATTR: eE,
  IS_ALLOWED_URI: gh,
  IS_SCRIPT_OR_DATA: tE,
  ATTR_WHITESPACE: nE,
  DOCTYPE_NAME: bh,
  CUSTOM_ELEMENT: rE
});
const pa = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, oE = function() {
  return typeof window > "u" ? null : window;
}, aE = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let r = null;
  const o = "data-tt-policy-suffix";
  n && n.hasAttribute(o) && (r = n.getAttribute(o));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(a, {
      createHTML(i) {
        return i;
      },
      createScriptURL(i) {
        return i;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
};
function yh() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : oE();
  const t = (xe) => yh(xe);
  if (t.version = "3.1.6", t.removed = [], !e || !e.document || e.document.nodeType !== pa.document)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const r = n, o = r.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: i,
    Node: s,
    Element: c,
    NodeFilter: l,
    NamedNodeMap: d = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: u,
    DOMParser: v,
    trustedTypes: m
  } = e, b = c.prototype, x = ma(b, "cloneNode"), g = ma(b, "remove"), k = ma(b, "nextSibling"), $ = ma(b, "childNodes"), T = ma(b, "parentNode");
  if (typeof i == "function") {
    const xe = n.createElement("template");
    xe.content && xe.content.ownerDocument && (n = xe.content.ownerDocument);
  }
  let S, C = "";
  const {
    implementation: N,
    createNodeIterator: U,
    createDocumentFragment: L,
    getElementsByTagName: j
  } = n, {
    importNode: q
  } = r;
  let V = {};
  t.isSupported = typeof hh == "function" && typeof T == "function" && N && N.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Q,
    ERB_EXPR: ke,
    TMPLIT_EXPR: H,
    DATA_ATTR: X,
    ARIA_ATTR: he,
    IS_SCRIPT_OR_DATA: $e,
    ATTR_WHITESPACE: Te,
    CUSTOM_ELEMENT: fe
  } = Of;
  let {
    IS_ALLOWED_URI: Y
  } = Of, O = null;
  const G = ot({}, [..._f, ...Rc, ...Mc, ...Dc, ...Cf]);
  let W = null;
  const ae = ot({}, [...Pf, ...Ic, ...Af, ...$i]);
  let te = Object.seal(vh(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), se = null, Se = null, me = !0, ne = !0, ye = !1, ze = !0, pe = !1, mt = !0, Ae = !1, K = !1, ie = !1, ve = !1, Me = !1, Ue = !1, it = !0, et = !1;
  const Nt = "user-content-";
  let Vt = !0, Rt = !1, sn = {}, _n = null;
  const Jn = ot({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Kr = null;
  const Ft = ot({}, ["audio", "video", "img", "source", "image", "track"]);
  let Or = null;
  const Mn = ot({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Nr = "http://www.w3.org/1998/Math/MathML", er = "http://www.w3.org/2000/svg", cn = "http://www.w3.org/1999/xhtml";
  let Dn = cn, hr = !1, xn = null;
  const Xr = ot({}, [Nr, er, cn], Nc);
  let Bn = null;
  const Zr = ["application/xhtml+xml", "text/html"], tr = "text/html";
  let Dt = null, ge = null;
  const wn = n.createElement("form"), fn = function(D) {
    return D instanceof RegExp || D instanceof Function;
  }, Wt = function() {
    let D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(ge && ge === D)) {
      if ((!D || typeof D != "object") && (D = {}), D = eo(D), Bn = // eslint-disable-next-line unicorn/prefer-includes
      Zr.indexOf(D.PARSER_MEDIA_TYPE) === -1 ? tr : D.PARSER_MEDIA_TYPE, Dt = Bn === "application/xhtml+xml" ? Nc : Vi, O = qn(D, "ALLOWED_TAGS") ? ot({}, D.ALLOWED_TAGS, Dt) : G, W = qn(D, "ALLOWED_ATTR") ? ot({}, D.ALLOWED_ATTR, Dt) : ae, xn = qn(D, "ALLOWED_NAMESPACES") ? ot({}, D.ALLOWED_NAMESPACES, Nc) : Xr, Or = qn(D, "ADD_URI_SAFE_ATTR") ? ot(
        eo(Mn),
        // eslint-disable-line indent
        D.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        Dt
        // eslint-disable-line indent
      ) : Mn, Kr = qn(D, "ADD_DATA_URI_TAGS") ? ot(
        eo(Ft),
        // eslint-disable-line indent
        D.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        Dt
        // eslint-disable-line indent
      ) : Ft, _n = qn(D, "FORBID_CONTENTS") ? ot({}, D.FORBID_CONTENTS, Dt) : Jn, se = qn(D, "FORBID_TAGS") ? ot({}, D.FORBID_TAGS, Dt) : {}, Se = qn(D, "FORBID_ATTR") ? ot({}, D.FORBID_ATTR, Dt) : {}, sn = qn(D, "USE_PROFILES") ? D.USE_PROFILES : !1, me = D.ALLOW_ARIA_ATTR !== !1, ne = D.ALLOW_DATA_ATTR !== !1, ye = D.ALLOW_UNKNOWN_PROTOCOLS || !1, ze = D.ALLOW_SELF_CLOSE_IN_ATTR !== !1, pe = D.SAFE_FOR_TEMPLATES || !1, mt = D.SAFE_FOR_XML !== !1, Ae = D.WHOLE_DOCUMENT || !1, ve = D.RETURN_DOM || !1, Me = D.RETURN_DOM_FRAGMENT || !1, Ue = D.RETURN_TRUSTED_TYPE || !1, ie = D.FORCE_BODY || !1, it = D.SANITIZE_DOM !== !1, et = D.SANITIZE_NAMED_PROPS || !1, Vt = D.KEEP_CONTENT !== !1, Rt = D.IN_PLACE || !1, Y = D.ALLOWED_URI_REGEXP || gh, Dn = D.NAMESPACE || cn, te = D.CUSTOM_ELEMENT_HANDLING || {}, D.CUSTOM_ELEMENT_HANDLING && fn(D.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (te.tagNameCheck = D.CUSTOM_ELEMENT_HANDLING.tagNameCheck), D.CUSTOM_ELEMENT_HANDLING && fn(D.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (te.attributeNameCheck = D.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), D.CUSTOM_ELEMENT_HANDLING && typeof D.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (te.allowCustomizedBuiltInElements = D.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), pe && (ne = !1), Me && (ve = !0), sn && (O = ot({}, Cf), W = [], sn.html === !0 && (ot(O, _f), ot(W, Pf)), sn.svg === !0 && (ot(O, Rc), ot(W, Ic), ot(W, $i)), sn.svgFilters === !0 && (ot(O, Mc), ot(W, Ic), ot(W, $i)), sn.mathMl === !0 && (ot(O, Dc), ot(W, Af), ot(W, $i))), D.ADD_TAGS && (O === G && (O = eo(O)), ot(O, D.ADD_TAGS, Dt)), D.ADD_ATTR && (W === ae && (W = eo(W)), ot(W, D.ADD_ATTR, Dt)), D.ADD_URI_SAFE_ATTR && ot(Or, D.ADD_URI_SAFE_ATTR, Dt), D.FORBID_CONTENTS && (_n === Jn && (_n = eo(_n)), ot(_n, D.FORBID_CONTENTS, Dt)), Vt && (O["#text"] = !0), Ae && ot(O, ["html", "head", "body"]), O.table && (ot(O, ["tbody"]), delete se.tbody), D.TRUSTED_TYPES_POLICY) {
        if (typeof D.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw fa('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof D.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw fa('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        S = D.TRUSTED_TYPES_POLICY, C = S.createHTML("");
      } else
        S === void 0 && (S = aE(m, o)), S !== null && typeof C == "string" && (C = S.createHTML(""));
      gn && gn(D), ge = D;
    }
  }, Qe = ot({}, ["mi", "mo", "mn", "ms", "mtext"]), mn = ot({}, ["foreignobject", "annotation-xml"]), Zo = ot({}, ["title", "style", "font", "a", "script"]), Qo = ot({}, [...Rc, ...Mc, ...Y2]), Jo = ot({}, [...Dc, ...K2]), ea = function(D) {
    let de = T(D);
    (!de || !de.tagName) && (de = {
      namespaceURI: Dn,
      tagName: "template"
    });
    const Pe = Vi(D.tagName), Xe = Vi(de.tagName);
    return xn[D.namespaceURI] ? D.namespaceURI === er ? de.namespaceURI === cn ? Pe === "svg" : de.namespaceURI === Nr ? Pe === "svg" && (Xe === "annotation-xml" || Qe[Xe]) : !!Qo[Pe] : D.namespaceURI === Nr ? de.namespaceURI === cn ? Pe === "math" : de.namespaceURI === er ? Pe === "math" && mn[Xe] : !!Jo[Pe] : D.namespaceURI === cn ? de.namespaceURI === er && !mn[Xe] || de.namespaceURI === Nr && !Qe[Xe] ? !1 : !Jo[Pe] && (Zo[Pe] || !Qo[Pe]) : !!(Bn === "application/xhtml+xml" && xn[D.namespaceURI]) : !1;
  }, En = function(D) {
    ua(t.removed, {
      element: D
    });
    try {
      T(D).removeChild(D);
    } catch {
      g(D);
    }
  }, Qr = function(D, de) {
    try {
      ua(t.removed, {
        attribute: de.getAttributeNode(D),
        from: de
      });
    } catch {
      ua(t.removed, {
        attribute: null,
        from: de
      });
    }
    if (de.removeAttribute(D), D === "is" && !W[D])
      if (ve || Me)
        try {
          En(de);
        } catch {
        }
      else
        try {
          de.setAttribute(D, "");
        } catch {
        }
  }, ta = function(D) {
    let de = null, Pe = null;
    if (ie)
      D = "<remove></remove>" + D;
    else {
      const Mt = kf(D, /^[\r\n\t ]+/);
      Pe = Mt && Mt[0];
    }
    Bn === "application/xhtml+xml" && Dn === cn && (D = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + D + "</body></html>");
    const Xe = S ? S.createHTML(D) : D;
    if (Dn === cn)
      try {
        de = new v().parseFromString(Xe, Bn);
      } catch {
      }
    if (!de || !de.documentElement) {
      de = N.createDocument(Dn, "template", null);
      try {
        de.documentElement.innerHTML = hr ? C : Xe;
      } catch {
      }
    }
    const Ht = de.body || de.documentElement;
    return D && Pe && Ht.insertBefore(n.createTextNode(Pe), Ht.childNodes[0] || null), Dn === cn ? j.call(de, Ae ? "html" : "body")[0] : Ae ? de.documentElement : Ht;
  }, na = function(D) {
    return U.call(
      D.ownerDocument || D,
      D,
      // eslint-disable-next-line no-bitwise
      l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION,
      null
    );
  }, ra = function(D) {
    return D instanceof u && (typeof D.nodeName != "string" || typeof D.textContent != "string" || typeof D.removeChild != "function" || !(D.attributes instanceof d) || typeof D.removeAttribute != "function" || typeof D.setAttribute != "function" || typeof D.namespaceURI != "string" || typeof D.insertBefore != "function" || typeof D.hasChildNodes != "function");
  }, R = function(D) {
    return typeof s == "function" && D instanceof s;
  }, ue = function(D, de, Pe) {
    V[D] && Ei(V[D], (Xe) => {
      Xe.call(t, de, Pe, ge);
    });
  }, Re = function(D) {
    let de = null;
    if (ue("beforeSanitizeElements", D, null), ra(D))
      return En(D), !0;
    const Pe = Dt(D.nodeName);
    if (ue("uponSanitizeElement", D, {
      tagName: Pe,
      allowedTags: O
    }), D.hasChildNodes() && !R(D.firstElementChild) && hn(/<[/\w]/g, D.innerHTML) && hn(/<[/\w]/g, D.textContent) || D.nodeType === pa.progressingInstruction || mt && D.nodeType === pa.comment && hn(/<[/\w]/g, D.data))
      return En(D), !0;
    if (!O[Pe] || se[Pe]) {
      if (!se[Pe] && ut(Pe) && (te.tagNameCheck instanceof RegExp && hn(te.tagNameCheck, Pe) || te.tagNameCheck instanceof Function && te.tagNameCheck(Pe)))
        return !1;
      if (Vt && !_n[Pe]) {
        const Xe = T(D) || D.parentNode, Ht = $(D) || D.childNodes;
        if (Ht && Xe) {
          const Mt = Ht.length;
          for (let $t = Mt - 1; $t >= 0; --$t) {
            const pn = x(Ht[$t], !0);
            pn.__removalCount = (D.__removalCount || 0) + 1, Xe.insertBefore(pn, k(D));
          }
        }
      }
      return En(D), !0;
    }
    return D instanceof c && !ea(D) || (Pe === "noscript" || Pe === "noembed" || Pe === "noframes") && hn(/<\/no(script|embed|frames)/i, D.innerHTML) ? (En(D), !0) : (pe && D.nodeType === pa.text && (de = D.textContent, Ei([Q, ke, H], (Xe) => {
      de = da(de, Xe, " ");
    }), D.textContent !== de && (ua(t.removed, {
      element: D.cloneNode()
    }), D.textContent = de)), ue("afterSanitizeElements", D, null), !1);
  }, Be = function(D, de, Pe) {
    if (it && (de === "id" || de === "name") && (Pe in n || Pe in wn))
      return !1;
    if (!(ne && !Se[de] && hn(X, de))) {
      if (!(me && hn(he, de))) {
        if (!W[de] || Se[de]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(ut(D) && (te.tagNameCheck instanceof RegExp && hn(te.tagNameCheck, D) || te.tagNameCheck instanceof Function && te.tagNameCheck(D)) && (te.attributeNameCheck instanceof RegExp && hn(te.attributeNameCheck, de) || te.attributeNameCheck instanceof Function && te.attributeNameCheck(de)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            de === "is" && te.allowCustomizedBuiltInElements && (te.tagNameCheck instanceof RegExp && hn(te.tagNameCheck, Pe) || te.tagNameCheck instanceof Function && te.tagNameCheck(Pe)))
          )
            return !1;
        } else if (!Or[de]) {
          if (!hn(Y, da(Pe, Te, ""))) {
            if (!((de === "src" || de === "xlink:href" || de === "href") && D !== "script" && z2(Pe, "data:") === 0 && Kr[D])) {
              if (!(ye && !hn($e, da(Pe, Te, "")))) {
                if (Pe)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, ut = function(D) {
    return D !== "annotation-xml" && kf(D, fe);
  }, gt = function(D) {
    ue("beforeSanitizeAttributes", D, null);
    const {
      attributes: de
    } = D;
    if (!de)
      return;
    const Pe = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: W
    };
    let Xe = de.length;
    for (; Xe--; ) {
      const Ht = de[Xe], {
        name: Mt,
        namespaceURI: $t,
        value: pn
      } = Ht, Rr = Dt(Mt);
      let Xt = Mt === "value" ? pn : V2(pn);
      if (Pe.attrName = Rr, Pe.attrValue = Xt, Pe.keepAttr = !0, Pe.forceKeepAttr = void 0, ue("uponSanitizeAttribute", D, Pe), Xt = Pe.attrValue, mt && hn(/((--!?|])>)|<\/(style|title)/i, Xt)) {
        Qr(Mt, D);
        continue;
      }
      if (Pe.forceKeepAttr || (Qr(Mt, D), !Pe.keepAttr))
        continue;
      if (!ze && hn(/\/>/i, Xt)) {
        Qr(Mt, D);
        continue;
      }
      pe && Ei([Q, ke, H], (fc) => {
        Xt = da(Xt, fc, " ");
      });
      const dc = Dt(D.nodeName);
      if (Be(dc, Rr, Xt)) {
        if (et && (Rr === "id" || Rr === "name") && (Qr(Mt, D), Xt = Nt + Xt), S && typeof m == "object" && typeof m.getAttributeType == "function" && !$t)
          switch (m.getAttributeType(dc, Rr)) {
            case "TrustedHTML": {
              Xt = S.createHTML(Xt);
              break;
            }
            case "TrustedScriptURL": {
              Xt = S.createScriptURL(Xt);
              break;
            }
          }
        try {
          $t ? D.setAttributeNS($t, Mt, Xt) : D.setAttribute(Mt, Xt), ra(D) ? En(D) : Sf(t.removed);
        } catch {
        }
      }
    }
    ue("afterSanitizeAttributes", D, null);
  }, rt = function xe(D) {
    let de = null;
    const Pe = na(D);
    for (ue("beforeSanitizeShadowDOM", D, null); de = Pe.nextNode(); )
      ue("uponSanitizeShadowNode", de, null), !Re(de) && (de.content instanceof a && xe(de.content), gt(de));
    ue("afterSanitizeShadowDOM", D, null);
  };
  return t.sanitize = function(xe) {
    let D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, de = null, Pe = null, Xe = null, Ht = null;
    if (hr = !xe, hr && (xe = "<!-->"), typeof xe != "string" && !R(xe))
      if (typeof xe.toString == "function") {
        if (xe = xe.toString(), typeof xe != "string")
          throw fa("dirty is not a string, aborting");
      } else
        throw fa("toString is not a function");
    if (!t.isSupported)
      return xe;
    if (K || Wt(D), t.removed = [], typeof xe == "string" && (Rt = !1), Rt) {
      if (xe.nodeName) {
        const pn = Dt(xe.nodeName);
        if (!O[pn] || se[pn])
          throw fa("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (xe instanceof s)
      de = ta("<!---->"), Pe = de.ownerDocument.importNode(xe, !0), Pe.nodeType === pa.element && Pe.nodeName === "BODY" || Pe.nodeName === "HTML" ? de = Pe : de.appendChild(Pe);
    else {
      if (!ve && !pe && !Ae && // eslint-disable-next-line unicorn/prefer-includes
      xe.indexOf("<") === -1)
        return S && Ue ? S.createHTML(xe) : xe;
      if (de = ta(xe), !de)
        return ve ? null : Ue ? C : "";
    }
    de && ie && En(de.firstChild);
    const Mt = na(Rt ? xe : de);
    for (; Xe = Mt.nextNode(); )
      Re(Xe) || (Xe.content instanceof a && rt(Xe.content), gt(Xe));
    if (Rt)
      return xe;
    if (ve) {
      if (Me)
        for (Ht = L.call(de.ownerDocument); de.firstChild; )
          Ht.appendChild(de.firstChild);
      else
        Ht = de;
      return (W.shadowroot || W.shadowrootmode) && (Ht = q.call(r, Ht, !0)), Ht;
    }
    let $t = Ae ? de.outerHTML : de.innerHTML;
    return Ae && O["!doctype"] && de.ownerDocument && de.ownerDocument.doctype && de.ownerDocument.doctype.name && hn(bh, de.ownerDocument.doctype.name) && ($t = "<!DOCTYPE " + de.ownerDocument.doctype.name + `>
` + $t), pe && Ei([Q, ke, H], (pn) => {
      $t = da($t, pn, " ");
    }), S && Ue ? S.createHTML($t) : $t;
  }, t.setConfig = function() {
    let xe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Wt(xe), K = !0;
  }, t.clearConfig = function() {
    ge = null, K = !1;
  }, t.isValidAttribute = function(xe, D, de) {
    ge || Wt({});
    const Pe = Dt(xe), Xe = Dt(D);
    return Be(Pe, Xe, de);
  }, t.addHook = function(xe, D) {
    typeof D == "function" && (V[xe] = V[xe] || [], ua(V[xe], D));
  }, t.removeHook = function(xe) {
    if (V[xe])
      return Sf(V[xe]);
  }, t.removeHooks = function(xe) {
    V[xe] && (V[xe] = []);
  }, t.removeAllHooks = function() {
    V = {};
  }, t;
}
var iE = yh(), Ta = {}, mu = {}, pu = {};
Object.defineProperty(pu, "__esModule", { value: !0 });
pu.default = uE;
var Nf = "html", Rf = "head", Ti = "body", sE = /<([a-zA-Z]+[0-9]?)/, Mf = /<head[^]*>/i, Df = /<body[^]*>/i, es = function(e, t) {
  throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
}, bl = function(e, t) {
  throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
}, If = typeof window == "object" && window.DOMParser;
if (typeof If == "function") {
  var cE = new If(), lE = "text/html";
  bl = function(e, t) {
    return t && (e = "<".concat(t, ">").concat(e, "</").concat(t, ">")), cE.parseFromString(e, lE);
  }, es = bl;
}
if (typeof document == "object" && document.implementation) {
  var Si = document.implementation.createHTMLDocument();
  es = function(e, t) {
    if (t) {
      var n = Si.documentElement.querySelector(t);
      return n && (n.innerHTML = e), Si;
    }
    return Si.documentElement.innerHTML = e, Si;
  };
}
var ki = typeof document == "object" && document.createElement("template"), yl;
ki && ki.content && (yl = function(e) {
  return ki.innerHTML = e, ki.content.childNodes;
});
function uE(e) {
  var t, n, r = e.match(sE), o = r && r[1] ? r[1].toLowerCase() : "";
  switch (o) {
    case Nf: {
      var a = bl(e);
      if (!Mf.test(e)) {
        var i = a.querySelector(Rf);
        (t = i == null ? void 0 : i.parentNode) === null || t === void 0 || t.removeChild(i);
      }
      if (!Df.test(e)) {
        var i = a.querySelector(Ti);
        (n = i == null ? void 0 : i.parentNode) === null || n === void 0 || n.removeChild(i);
      }
      return a.querySelectorAll(Nf);
    }
    case Rf:
    case Ti: {
      var s = es(e).querySelectorAll(o);
      return Df.test(e) && Mf.test(e) ? s[0].parentNode.childNodes : s;
    }
    default: {
      if (yl)
        return yl(e);
      var i = es(e, Ti).querySelector(Ti);
      return i.childNodes;
    }
  }
}
var Ps = {}, hu = {}, vu = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var t;
  (function(r) {
    r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
  })(t = e.ElementType || (e.ElementType = {}));
  function n(r) {
    return r.type === t.Tag || r.type === t.Script || r.type === t.Style;
  }
  e.isTag = n, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})(vu);
var at = {}, Gr = jt && jt.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (r[a] = o[a]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Sa = jt && jt.__assign || function() {
  return Sa = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Sa.apply(this, arguments);
};
Object.defineProperty(at, "__esModule", { value: !0 });
at.cloneNode = at.hasChildren = at.isDocument = at.isDirective = at.isComment = at.isText = at.isCDATA = at.isTag = at.Element = at.Document = at.CDATA = at.NodeWithChildren = at.ProcessingInstruction = at.Comment = at.Text = at.DataNode = at.Node = void 0;
var Sn = vu, gu = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), bu(this, t);
    }, e;
  }()
);
at.Node = gu;
var As = (
  /** @class */
  function(e) {
    Gr(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.data = n, r;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(gu)
);
at.DataNode = As;
var xh = (
  /** @class */
  function(e) {
    Gr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Sn.ElementType.Text, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(As)
);
at.Text = xh;
var wh = (
  /** @class */
  function(e) {
    Gr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Sn.ElementType.Comment, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(As)
);
at.Comment = wh;
var Eh = (
  /** @class */
  function(e) {
    Gr(t, e);
    function t(n, r) {
      var o = e.call(this, r) || this;
      return o.name = n, o.type = Sn.ElementType.Directive, o;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(As)
);
at.ProcessingInstruction = Eh;
var Os = (
  /** @class */
  function(e) {
    Gr(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.children = n, r;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(gu)
);
at.NodeWithChildren = Os;
var $h = (
  /** @class */
  function(e) {
    Gr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Sn.ElementType.CDATA, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Os)
);
at.CDATA = $h;
var Th = (
  /** @class */
  function(e) {
    Gr(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = Sn.ElementType.Root, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Os)
);
at.Document = Th;
var Sh = (
  /** @class */
  function(e) {
    Gr(t, e);
    function t(n, r, o, a) {
      o === void 0 && (o = []), a === void 0 && (a = n === "script" ? Sn.ElementType.Script : n === "style" ? Sn.ElementType.Style : Sn.ElementType.Tag);
      var i = e.call(this, o) || this;
      return i.name = n, i.attribs = r, i.type = a, i;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(r) {
          var o, a;
          return {
            name: r,
            value: n.attribs[r],
            namespace: (o = n["x-attribsNamespace"]) === null || o === void 0 ? void 0 : o[r],
            prefix: (a = n["x-attribsPrefix"]) === null || a === void 0 ? void 0 : a[r]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Os)
);
at.Element = Sh;
function kh(e) {
  return (0, Sn.isTag)(e);
}
at.isTag = kh;
function _h(e) {
  return e.type === Sn.ElementType.CDATA;
}
at.isCDATA = _h;
function Ch(e) {
  return e.type === Sn.ElementType.Text;
}
at.isText = Ch;
function Ph(e) {
  return e.type === Sn.ElementType.Comment;
}
at.isComment = Ph;
function Ah(e) {
  return e.type === Sn.ElementType.Directive;
}
at.isDirective = Ah;
function Oh(e) {
  return e.type === Sn.ElementType.Root;
}
at.isDocument = Oh;
function dE(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
at.hasChildren = dE;
function bu(e, t) {
  t === void 0 && (t = !1);
  var n;
  if (Ch(e))
    n = new xh(e.data);
  else if (Ph(e))
    n = new wh(e.data);
  else if (kh(e)) {
    var r = t ? jc(e.children) : [], o = new Sh(e.name, Sa({}, e.attribs), r);
    r.forEach(function(c) {
      return c.parent = o;
    }), e.namespace != null && (o.namespace = e.namespace), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = Sa({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = Sa({}, e["x-attribsPrefix"])), n = o;
  } else if (_h(e)) {
    var r = t ? jc(e.children) : [], a = new $h(r);
    r.forEach(function(l) {
      return l.parent = a;
    }), n = a;
  } else if (Oh(e)) {
    var r = t ? jc(e.children) : [], i = new Th(r);
    r.forEach(function(l) {
      return l.parent = i;
    }), e["x-mode"] && (i["x-mode"] = e["x-mode"]), n = i;
  } else if (Ah(e)) {
    var s = new Eh(e.name, e.data);
    e["x-name"] != null && (s["x-name"] = e["x-name"], s["x-publicId"] = e["x-publicId"], s["x-systemId"] = e["x-systemId"]), n = s;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return n.startIndex = e.startIndex, n.endIndex = e.endIndex, e.sourceCodeLocation != null && (n.sourceCodeLocation = e.sourceCodeLocation), n;
}
at.cloneNode = bu;
function jc(e) {
  for (var t = e.map(function(r) {
    return bu(r, !0);
  }), n = 1; n < t.length; n++)
    t[n].prev = t[n - 1], t[n - 1].next = t[n];
  return t;
}
(function(e) {
  var t = jt && jt.__createBinding || (Object.create ? function(s, c, l, d) {
    d === void 0 && (d = l);
    var u = Object.getOwnPropertyDescriptor(c, l);
    (!u || ("get" in u ? !c.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
      return c[l];
    } }), Object.defineProperty(s, d, u);
  } : function(s, c, l, d) {
    d === void 0 && (d = l), s[d] = c[l];
  }), n = jt && jt.__exportStar || function(s, c) {
    for (var l in s)
      l !== "default" && !Object.prototype.hasOwnProperty.call(c, l) && t(c, s, l);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var r = vu, o = at;
  n(at, e);
  var a = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, i = (
    /** @class */
    function() {
      function s(c, l, d) {
        this.dom = [], this.root = new o.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof l == "function" && (d = l, l = a), typeof c == "object" && (l = c, c = void 0), this.callback = c ?? null, this.options = l ?? a, this.elementCB = d ?? null;
      }
      return s.prototype.onparserinit = function(c) {
        this.parser = c;
      }, s.prototype.onreset = function() {
        this.dom = [], this.root = new o.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, s.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, s.prototype.onerror = function(c) {
        this.handleCallback(c);
      }, s.prototype.onclosetag = function() {
        this.lastNode = null;
        var c = this.tagStack.pop();
        this.options.withEndIndices && (c.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(c);
      }, s.prototype.onopentag = function(c, l) {
        var d = this.options.xmlMode ? r.ElementType.Tag : void 0, u = new o.Element(c, l, void 0, d);
        this.addNode(u), this.tagStack.push(u);
      }, s.prototype.ontext = function(c) {
        var l = this.lastNode;
        if (l && l.type === r.ElementType.Text)
          l.data += c, this.options.withEndIndices && (l.endIndex = this.parser.endIndex);
        else {
          var d = new o.Text(c);
          this.addNode(d), this.lastNode = d;
        }
      }, s.prototype.oncomment = function(c) {
        if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
          this.lastNode.data += c;
          return;
        }
        var l = new o.Comment(c);
        this.addNode(l), this.lastNode = l;
      }, s.prototype.oncommentend = function() {
        this.lastNode = null;
      }, s.prototype.oncdatastart = function() {
        var c = new o.Text(""), l = new o.CDATA([c]);
        this.addNode(l), c.parent = l, this.lastNode = c;
      }, s.prototype.oncdataend = function() {
        this.lastNode = null;
      }, s.prototype.onprocessinginstruction = function(c, l) {
        var d = new o.ProcessingInstruction(c, l);
        this.addNode(d);
      }, s.prototype.handleCallback = function(c) {
        if (typeof this.callback == "function")
          this.callback(c, this.dom);
        else if (c)
          throw c;
      }, s.prototype.addNode = function(c) {
        var l = this.tagStack[this.tagStack.length - 1], d = l.children[l.children.length - 1];
        this.options.withStartIndices && (c.startIndex = this.parser.startIndex), this.options.withEndIndices && (c.endIndex = this.parser.endIndex), l.children.push(c), d && (c.prev = d, d.next = c), c.parent = l, this.lastNode = null;
      }, s;
    }()
  );
  e.DomHandler = i, e.default = i;
})(hu);
var Nh = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CASE_SENSITIVE_TAG_NAMES_MAP = e.CASE_SENSITIVE_TAG_NAMES = void 0, e.CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
  ], e.CASE_SENSITIVE_TAG_NAMES_MAP = e.CASE_SENSITIVE_TAG_NAMES.reduce(function(t, n) {
    return t[n.toLowerCase()] = n, t;
  }, {});
})(Nh);
Object.defineProperty(Ps, "__esModule", { value: !0 });
Ps.formatAttributes = Rh;
Ps.formatDOM = Mh;
var _i = hu, fE = Nh;
function mE(e) {
  return fE.CASE_SENSITIVE_TAG_NAMES_MAP[e];
}
function Rh(e) {
  for (var t = {}, n = 0, r = e.length; n < r; n++) {
    var o = e[n];
    t[o.name] = o.value;
  }
  return t;
}
function pE(e) {
  e = e.toLowerCase();
  var t = mE(e);
  return t || e;
}
function Mh(e, t, n) {
  t === void 0 && (t = null);
  for (var r = [], o, a = 0, i = e.length; a < i; a++) {
    var s = e[a];
    switch (s.nodeType) {
      case 1: {
        var c = pE(s.nodeName);
        o = new _i.Element(c, Rh(s.attributes)), o.children = Mh(
          // template children are on content
          c === "template" ? s.content.childNodes : s.childNodes,
          o
        );
        break;
      }
      case 3:
        o = new _i.Text(s.nodeValue);
        break;
      case 8:
        o = new _i.Comment(s.nodeValue);
        break;
      default:
        continue;
    }
    var l = r[a - 1] || null;
    l && (l.next = o), o.parent = t, o.prev = l, o.next = null, r.push(o);
  }
  return n && (o = new _i.ProcessingInstruction(n.substring(0, n.indexOf(" ")).toLowerCase(), n), o.next = r[0] || null, o.parent = t, r.unshift(o), r[1] && (r[1].prev = r[0])), r;
}
var hE = jt && jt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(mu, "__esModule", { value: !0 });
mu.default = yE;
var vE = hE(pu), gE = Ps, bE = /<(![a-zA-Z\s]+)>/;
function yE(e) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  var t = e.match(bE), n = t ? t[1] : void 0;
  return (0, gE.formatDOM)((0, vE.default)(e), null, n);
}
var Ns = {}, Qn = {}, Rs = {}, xE = 0;
Rs.SAME = xE;
var wE = 1;
Rs.CAMELCASE = wE;
Rs.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  "accept-charset": "acceptCharset",
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: "className",
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: "htmlFor",
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  "http-equiv": "httpEquiv",
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  "accent-height": "accentHeight",
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  "alignment-baseline": "alignmentBaseline",
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  "arabic-form": "arabicForm",
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  "baseline-shift": "baselineShift",
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  "cap-height": "capHeight",
  clip: 0,
  clipPath: 1,
  "clip-path": "clipPath",
  clipPathUnits: 1,
  clipRule: 1,
  "clip-rule": "clipRule",
  color: 0,
  colorInterpolation: 1,
  "color-interpolation": "colorInterpolation",
  colorInterpolationFilters: 1,
  "color-interpolation-filters": "colorInterpolationFilters",
  colorProfile: 1,
  "color-profile": "colorProfile",
  colorRendering: 1,
  "color-rendering": "colorRendering",
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  "dominant-baseline": "dominantBaseline",
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  "enable-background": "enableBackground",
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  "fill-opacity": "fillOpacity",
  fillRule: 1,
  "fill-rule": "fillRule",
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  "flood-opacity": "floodOpacity",
  floodColor: 1,
  "flood-color": "floodColor",
  focusable: 0,
  fontFamily: 1,
  "font-family": "fontFamily",
  fontSize: 1,
  "font-size": "fontSize",
  fontSizeAdjust: 1,
  "font-size-adjust": "fontSizeAdjust",
  fontStretch: 1,
  "font-stretch": "fontStretch",
  fontStyle: 1,
  "font-style": "fontStyle",
  fontVariant: 1,
  "font-variant": "fontVariant",
  fontWeight: 1,
  "font-weight": "fontWeight",
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  "glyph-name": "glyphName",
  glyphOrientationHorizontal: 1,
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphOrientationVertical: 1,
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  "horiz-adv-x": "horizAdvX",
  horizOriginX: 1,
  "horiz-origin-x": "horizOriginX",
  ideographic: 0,
  imageRendering: 1,
  "image-rendering": "imageRendering",
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  "letter-spacing": "letterSpacing",
  lightingColor: 1,
  "lighting-color": "lightingColor",
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  "marker-end": "markerEnd",
  markerHeight: 1,
  markerMid: 1,
  "marker-mid": "markerMid",
  markerStart: 1,
  "marker-start": "markerStart",
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  "overline-position": "overlinePosition",
  overlineThickness: 1,
  "overline-thickness": "overlineThickness",
  paintOrder: 1,
  "paint-order": "paintOrder",
  panose1: 0,
  "panose-1": "panose1",
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  "pointer-events": "pointerEvents",
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  "rendering-intent": "renderingIntent",
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  "shape-rendering": "shapeRendering",
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  "stop-color": "stopColor",
  stopOpacity: 1,
  "stop-opacity": "stopOpacity",
  strikethroughPosition: 1,
  "strikethrough-position": "strikethroughPosition",
  strikethroughThickness: 1,
  "strikethrough-thickness": "strikethroughThickness",
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  "stroke-dasharray": "strokeDasharray",
  strokeDashoffset: 1,
  "stroke-dashoffset": "strokeDashoffset",
  strokeLinecap: 1,
  "stroke-linecap": "strokeLinecap",
  strokeLinejoin: 1,
  "stroke-linejoin": "strokeLinejoin",
  strokeMiterlimit: 1,
  "stroke-miterlimit": "strokeMiterlimit",
  strokeWidth: 1,
  "stroke-width": "strokeWidth",
  strokeOpacity: 1,
  "stroke-opacity": "strokeOpacity",
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  "text-anchor": "textAnchor",
  textDecoration: 1,
  "text-decoration": "textDecoration",
  textLength: 1,
  textRendering: 1,
  "text-rendering": "textRendering",
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  "underline-position": "underlinePosition",
  underlineThickness: 1,
  "underline-thickness": "underlineThickness",
  unicode: 0,
  unicodeBidi: 1,
  "unicode-bidi": "unicodeBidi",
  unicodeRange: 1,
  "unicode-range": "unicodeRange",
  unitsPerEm: 1,
  "units-per-em": "unitsPerEm",
  unselectable: 0,
  vAlphabetic: 1,
  "v-alphabetic": "vAlphabetic",
  values: 0,
  vectorEffect: 1,
  "vector-effect": "vectorEffect",
  version: 0,
  vertAdvY: 1,
  "vert-adv-y": "vertAdvY",
  vertOriginX: 1,
  "vert-origin-x": "vertOriginX",
  vertOriginY: 1,
  "vert-origin-y": "vertOriginY",
  vHanging: 1,
  "v-hanging": "vHanging",
  vIdeographic: 1,
  "v-ideographic": "vIdeographic",
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  "v-mathematical": "vMathematical",
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  "word-spacing": "wordSpacing",
  writingMode: 1,
  "writing-mode": "writingMode",
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  "x-height": "xHeight",
  xlinkActuate: 1,
  "xlink:actuate": "xlinkActuate",
  xlinkArcrole: 1,
  "xlink:arcrole": "xlinkArcrole",
  xlinkHref: 1,
  "xlink:href": "xlinkHref",
  xlinkRole: 1,
  "xlink:role": "xlinkRole",
  xlinkShow: 1,
  "xlink:show": "xlinkShow",
  xlinkTitle: 1,
  "xlink:title": "xlinkTitle",
  xlinkType: 1,
  "xlink:type": "xlinkType",
  xmlBase: 1,
  "xml:base": "xmlBase",
  xmlLang: 1,
  "xml:lang": "xmlLang",
  xmlns: 0,
  "xml:space": "xmlSpace",
  xmlnsXlink: 1,
  "xmlns:xlink": "xmlnsXlink",
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};
const Dh = 0, qr = 1, Ms = 2, Ds = 3, yu = 4, Ih = 5, jh = 6;
function EE(e) {
  return rn.hasOwnProperty(e) ? rn[e] : null;
}
function bn(e, t, n, r, o, a, i) {
  this.acceptsBooleans = t === Ms || t === Ds || t === yu, this.attributeName = r, this.attributeNamespace = o, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = a, this.removeEmptyString = i;
}
const rn = {}, $E = [
  "children",
  "dangerouslySetInnerHTML",
  // TODO: This prevents the assignment of defaultValue to regular
  // elements (not just inputs). Now that ReactDOMInput assigns to the
  // defaultValue property -- do we need this?
  "defaultValue",
  "defaultChecked",
  "innerHTML",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "style"
];
$E.forEach((e) => {
  rn[e] = new bn(
    e,
    Dh,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  ["acceptCharset", "accept-charset"],
  ["className", "class"],
  ["htmlFor", "for"],
  ["httpEquiv", "http-equiv"]
].forEach(([e, t]) => {
  rn[e] = new bn(
    e,
    qr,
    !1,
    // mustUseProperty
    t,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["contentEditable", "draggable", "spellCheck", "value"].forEach((e) => {
  rn[e] = new bn(
    e,
    Ms,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "autoReverse",
  "externalResourcesRequired",
  "focusable",
  "preserveAlpha"
].forEach((e) => {
  rn[e] = new bn(
    e,
    Ms,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "allowFullScreen",
  "async",
  // Note: there is a special case that prevents it from being written to the DOM
  // on the client side because the browsers are inconsistent. Instead we call focus().
  "autoFocus",
  "autoPlay",
  "controls",
  "default",
  "defer",
  "disabled",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "formNoValidate",
  "hidden",
  "loop",
  "noModule",
  "noValidate",
  "open",
  "playsInline",
  "readOnly",
  "required",
  "reversed",
  "scoped",
  "seamless",
  // Microdata
  "itemScope"
].forEach((e) => {
  rn[e] = new bn(
    e,
    Ds,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "checked",
  // Note: `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`. We have special logic for handling this.
  "multiple",
  "muted",
  "selected"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  rn[e] = new bn(
    e,
    Ds,
    !0,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "capture",
  "download"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  rn[e] = new bn(
    e,
    yu,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "cols",
  "rows",
  "size",
  "span"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  rn[e] = new bn(
    e,
    jh,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["rowSpan", "start"].forEach((e) => {
  rn[e] = new bn(
    e,
    Ih,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
const xu = /[\-\:]([a-z])/g, wu = (e) => e[1].toUpperCase();
[
  "accent-height",
  "alignment-baseline",
  "arabic-form",
  "baseline-shift",
  "cap-height",
  "clip-path",
  "clip-rule",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "dominant-baseline",
  "enable-background",
  "fill-opacity",
  "fill-rule",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "glyph-name",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "horiz-adv-x",
  "horiz-origin-x",
  "image-rendering",
  "letter-spacing",
  "lighting-color",
  "marker-end",
  "marker-mid",
  "marker-start",
  "overline-position",
  "overline-thickness",
  "paint-order",
  "panose-1",
  "pointer-events",
  "rendering-intent",
  "shape-rendering",
  "stop-color",
  "stop-opacity",
  "strikethrough-position",
  "strikethrough-thickness",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "text-decoration",
  "text-rendering",
  "underline-position",
  "underline-thickness",
  "unicode-bidi",
  "unicode-range",
  "units-per-em",
  "v-alphabetic",
  "v-hanging",
  "v-ideographic",
  "v-mathematical",
  "vector-effect",
  "vert-adv-y",
  "vert-origin-x",
  "vert-origin-y",
  "word-spacing",
  "writing-mode",
  "xmlns:xlink",
  "x-height"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(xu, wu);
  rn[t] = new bn(
    t,
    qr,
    !1,
    // mustUseProperty
    e,
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "xlink:actuate",
  "xlink:arcrole",
  "xlink:role",
  "xlink:show",
  "xlink:title",
  "xlink:type"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(xu, wu);
  rn[t] = new bn(
    t,
    qr,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/1999/xlink",
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "xml:base",
  "xml:lang",
  "xml:space"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(xu, wu);
  rn[t] = new bn(
    t,
    qr,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/XML/1998/namespace",
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["tabIndex", "crossOrigin"].forEach((e) => {
  rn[e] = new bn(
    e,
    qr,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
const TE = "xlinkHref";
rn[TE] = new bn(
  "xlinkHref",
  qr,
  !1,
  // mustUseProperty
  "xlink:href",
  "http://www.w3.org/1999/xlink",
  !0,
  // sanitizeURL
  !1
  // removeEmptyString
);
["src", "href", "action", "formAction"].forEach((e) => {
  rn[e] = new bn(
    e,
    qr,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !0,
    // sanitizeURL
    !0
    // removeEmptyString
  );
});
const {
  CAMELCASE: SE,
  SAME: kE,
  possibleStandardNames: jf
} = Rs, _E = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", CE = _E + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", PE = RegExp.prototype.test.bind(
  // eslint-disable-next-line no-misleading-character-class
  new RegExp("^(data|aria)-[" + CE + "]*$")
), AE = Object.keys(
  jf
).reduce((e, t) => {
  const n = jf[t];
  return n === kE ? e[t] = t : n === SE ? e[t.toLowerCase()] = t : e[t] = n, e;
}, {});
Qn.BOOLEAN = Ds;
Qn.BOOLEANISH_STRING = Ms;
Qn.NUMERIC = Ih;
Qn.OVERLOADED_BOOLEAN = yu;
Qn.POSITIVE_NUMERIC = jh;
Qn.RESERVED = Dh;
Qn.STRING = qr;
Qn.getPropertyInfo = EE;
Qn.isCustomAttribute = PE;
Qn.possibleStandardNames = AE;
var Eu = {}, $u = {}, Lf = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, OE = /\n/g, NE = /^\s*/, RE = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, ME = /^:\s*/, DE = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, IE = /^[;\s]*/, jE = /^\s+|\s+$/g, LE = `
`, Ff = "/", Wf = "*", ro = "", FE = "comment", WE = "declaration", HE = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function o(b) {
    var x = b.match(OE);
    x && (n += x.length);
    var g = b.lastIndexOf(LE);
    r = ~g ? b.length - g : r + b.length;
  }
  function a() {
    var b = { line: n, column: r };
    return function(x) {
      return x.position = new i(b), l(), x;
    };
  }
  function i(b) {
    this.start = b, this.end = { line: n, column: r }, this.source = t.source;
  }
  i.prototype.content = e;
  function s(b) {
    var x = new Error(
      t.source + ":" + n + ":" + r + ": " + b
    );
    if (x.reason = b, x.filename = t.source, x.line = n, x.column = r, x.source = e, !t.silent)
      throw x;
  }
  function c(b) {
    var x = b.exec(e);
    if (x) {
      var g = x[0];
      return o(g), e = e.slice(g.length), x;
    }
  }
  function l() {
    c(NE);
  }
  function d(b) {
    var x;
    for (b = b || []; x = u(); )
      x !== !1 && b.push(x);
    return b;
  }
  function u() {
    var b = a();
    if (!(Ff != e.charAt(0) || Wf != e.charAt(1))) {
      for (var x = 2; ro != e.charAt(x) && (Wf != e.charAt(x) || Ff != e.charAt(x + 1)); )
        ++x;
      if (x += 2, ro === e.charAt(x - 1))
        return s("End of comment missing");
      var g = e.slice(2, x - 2);
      return r += 2, o(g), e = e.slice(x), r += 2, b({
        type: FE,
        comment: g
      });
    }
  }
  function v() {
    var b = a(), x = c(RE);
    if (x) {
      if (u(), !c(ME))
        return s("property missing ':'");
      var g = c(DE), k = b({
        type: WE,
        property: Hf(x[0].replace(Lf, ro)),
        value: g ? Hf(g[0].replace(Lf, ro)) : ro
      });
      return c(IE), k;
    }
  }
  function m() {
    var b = [];
    d(b);
    for (var x; x = v(); )
      x !== !1 && (b.push(x), d(b));
    return b;
  }
  return l(), m();
};
function Hf(e) {
  return e ? e.replace(jE, ro) : ro;
}
var UE = jt && jt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty($u, "__esModule", { value: !0 });
var BE = UE(HE);
function zE(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, BE.default)(e), o = typeof t == "function";
  return r.forEach(function(a) {
    if (a.type === "declaration") {
      var i = a.property, s = a.value;
      o ? t(i, s, a) : s && (n = n || {}, n[i] = s);
    }
  }), n;
}
$u.default = zE;
var Is = {};
Object.defineProperty(Is, "__esModule", { value: !0 });
Is.camelCase = void 0;
var VE = /^--[a-zA-Z0-9-]+$/, GE = /-([a-z])/g, qE = /^[^-]+$/, YE = /^-(webkit|moz|ms|o|khtml)-/, KE = /^-(ms)-/, XE = function(e) {
  return !e || qE.test(e) || VE.test(e);
}, ZE = function(e, t) {
  return t.toUpperCase();
}, Uf = function(e, t) {
  return "".concat(t, "-");
}, QE = function(e, t) {
  return t === void 0 && (t = {}), XE(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(KE, Uf) : e = e.replace(YE, Uf), e.replace(GE, ZE));
};
Is.camelCase = QE;
var JE = jt && jt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, e$ = JE($u), t$ = Is;
function xl(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, e$.default)(e, function(r, o) {
    r && o && (n[(0, t$.camelCase)(r, t)] = o);
  }), n;
}
xl.default = xl;
var n$ = xl;
(function(e) {
  var t = jt && jt.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.returnFirstArg = e.canTextBeChildOfNode = e.ELEMENTS_WITH_NO_TEXT_CHILDREN = e.PRESERVE_CUSTOM_ATTRIBUTES = void 0, e.isCustomComponent = a, e.setStyleProp = s;
  var n = ce, r = t(n$), o = /* @__PURE__ */ new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
  ]);
  function a(d, u) {
    return d.includes("-") ? !o.has(d) : !!(u && typeof u.is == "string");
  }
  var i = {
    reactCompat: !0
  };
  function s(d, u) {
    if (typeof d == "string") {
      if (!d.trim()) {
        u.style = {};
        return;
      }
      try {
        u.style = (0, r.default)(d, i);
      } catch {
        u.style = {};
      }
    }
  }
  e.PRESERVE_CUSTOM_ATTRIBUTES = Number(n.version.split(".")[0]) >= 16, e.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
  ]);
  var c = function(d) {
    return !e.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(d.name);
  };
  e.canTextBeChildOfNode = c;
  var l = function(d) {
    return d;
  };
  e.returnFirstArg = l;
})(Eu);
Object.defineProperty(Ns, "__esModule", { value: !0 });
Ns.default = i$;
var ba = Qn, Bf = Eu, r$ = ["checked", "value"], o$ = ["input", "select", "textarea"], a$ = {
  reset: !0,
  submit: !0
};
function i$(e, t) {
  e === void 0 && (e = {});
  var n = {}, r = !!(e.type && a$[e.type]);
  for (var o in e) {
    var a = e[o];
    if ((0, ba.isCustomAttribute)(o)) {
      n[o] = a;
      continue;
    }
    var i = o.toLowerCase(), s = zf(i);
    if (s) {
      var c = (0, ba.getPropertyInfo)(s);
      switch (r$.includes(s) && o$.includes(t) && !r && (s = zf("default" + i)), n[s] = a, c && c.type) {
        case ba.BOOLEAN:
          n[s] = !0;
          break;
        case ba.OVERLOADED_BOOLEAN:
          a === "" && (n[s] = !0);
          break;
      }
      continue;
    }
    Bf.PRESERVE_CUSTOM_ATTRIBUTES && (n[o] = a);
  }
  return (0, Bf.setStyleProp)(e.style, n), n;
}
function zf(e) {
  return ba.possibleStandardNames[e];
}
var Tu = {}, s$ = jt && jt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Tu, "__esModule", { value: !0 });
Tu.default = Lh;
var Lc = ce, c$ = s$(Ns), ka = Eu, l$ = {
  cloneElement: Lc.cloneElement,
  createElement: Lc.createElement,
  isValidElement: Lc.isValidElement
};
function Lh(e, t) {
  t === void 0 && (t = {});
  for (var n = [], r = typeof t.replace == "function", o = t.transform || ka.returnFirstArg, a = t.library || l$, i = a.cloneElement, s = a.createElement, c = a.isValidElement, l = e.length, d = 0; d < l; d++) {
    var u = e[d];
    if (r) {
      var v = t.replace(u, d);
      if (c(v)) {
        l > 1 && (v = i(v, {
          key: v.key || d
        })), n.push(o(v, u, d));
        continue;
      }
    }
    if (u.type === "text") {
      var m = !u.data.trim().length;
      if (m && u.parent && !(0, ka.canTextBeChildOfNode)(u.parent) || t.trim && m)
        continue;
      n.push(o(u.data, u, d));
      continue;
    }
    var b = u, x = {};
    u$(b) ? ((0, ka.setStyleProp)(b.attribs.style, b.attribs), x = b.attribs) : b.attribs && (x = (0, c$.default)(b.attribs, b.name));
    var g = void 0;
    switch (u.type) {
      case "script":
      case "style":
        u.children[0] && (x.dangerouslySetInnerHTML = {
          __html: u.children[0].data
        });
        break;
      case "tag":
        u.name === "textarea" && u.children[0] ? x.defaultValue = u.children[0].data : u.children && u.children.length && (g = Lh(u.children, t));
        break;
      default:
        continue;
    }
    l > 1 && (x.key = d), n.push(o(s(u.name, x, g), u, d));
  }
  return n.length === 1 ? n[0] : n;
}
function u$(e) {
  return ka.PRESERVE_CUSTOM_ATTRIBUTES && e.type === "tag" && (0, ka.isCustomComponent)(e.name, e.attribs);
}
(function(e) {
  var t = jt && jt.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.htmlToDOM = e.domToReact = e.attributesToProps = e.Text = e.ProcessingInstruction = e.Element = e.Comment = void 0, e.default = s;
  var n = t(mu);
  e.htmlToDOM = n.default;
  var r = t(Ns);
  e.attributesToProps = r.default;
  var o = t(Tu);
  e.domToReact = o.default;
  var a = hu;
  Object.defineProperty(e, "Comment", { enumerable: !0, get: function() {
    return a.Comment;
  } }), Object.defineProperty(e, "Element", { enumerable: !0, get: function() {
    return a.Element;
  } }), Object.defineProperty(e, "ProcessingInstruction", { enumerable: !0, get: function() {
    return a.ProcessingInstruction;
  } }), Object.defineProperty(e, "Text", { enumerable: !0, get: function() {
    return a.Text;
  } });
  var i = { lowerCaseAttributeNames: !1 };
  function s(c, l) {
    if (typeof c != "string")
      throw new TypeError("First argument must be a string");
    return c ? (0, o.default)((0, n.default)(c, (l == null ? void 0 : l.htmlparser2) || i), l) : [];
  }
})(Ta);
const Vf = /* @__PURE__ */ $s(Ta), d$ = Vf.default || Vf;
var Fh = {};
Object.defineProperty(Fh, "__esModule", { value: !0 });
var f$ = [
  "area",
  "base",
  "br",
  "col",
  "command",
  "embed",
  "hr",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], Wh = [
  "address",
  "article",
  "aside",
  "blockquote",
  "canvas",
  "dd",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "hr",
  "li",
  "main",
  "nav",
  "noscript",
  "ol",
  "output",
  "p",
  "pre",
  "section",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "video"
], Ci = ["audio", "math", "svg", "video"], Ro = 10, m$ = 33, p$ = 34, h$ = 38, v$ = 39, ha = 47, wl = 59, Gi = 60, g$ = 61, Fc = 62, b$ = /[<&\n\ud800-\udbff]/, y$ = /[<&\ud800-\udbff]/, x$ = /\s+/g;
function w$(e, t, n) {
  return n === void 0 && (n = {}), e ? (e = e.toString(), n.html ? $$(e, t, n) : T$(e, t, n)) : "";
}
var E$ = Fh.default = w$;
function $$(e, t, n) {
  for (var r = n.imageWeight, o = r === void 0 ? 2 : r, a = n.indicator, i = a === void 0 ? "…" : a, s = n.maxLines, c = s === void 0 ? 1 / 0 : s, l = n.stripTags, d = l === void 0 ? !1 : l, u = i.length, v = 1, m = typeof d == "boolean" ? function() {
    return d;
  } : function(ie) {
    return d.includes(ie);
  }, b = [], x = function(ie) {
    for (var ve; ve = b.pop(), ve !== void 0; )
      m(ve) || (ie += "</" + ve + ">");
    return ie;
  }, g = 0, k = -1, $ = e.length; g < $; g++) {
    var T = g ? e.slice(g) : e, S = k$(b), C = k > -1 || S ? y$ : b$, N = T.search(C), U = N > -1 ? N : T.length;
    if (k === -1) {
      if (S) {
        var L = _$(U === T.length ? T : T.slice(0, N));
        if (m(b[b.length - 1])) {
          var j = g > 0 && !oo(e.charCodeAt(g - 1)), q = !oo(e.charCodeAt(g + U));
          L.length > 0 ? L = (j ? " " : "") + L + (q ? " " : "") : j && q && (L = " "), e = e.slice(0, g) + L + e.slice(g + U), U = L.length;
        }
        if (u += L.length, u > t)
          break;
      } else if (u += U, u > t) {
        g = Math.max(g + U - u + t, 0);
        break;
      }
    }
    if (g += U, N === -1)
      break;
    var V = e.charCodeAt(g);
    if (V === Gi) {
      var Q = e.charCodeAt(g + 1), ke = Q === m$;
      if (ke && e.substr(g + 2, 2) === "--") {
        var H = e.indexOf("-->", g + 4) + 3;
        g = H - 1;
      } else if (ke && e.substr(g + 2, 7) === "[CDATA[") {
        var X = e.indexOf("]]>", g + 9) + 3;
        g = X - 1;
      } else {
        var he = Q === ha;
        if (u === t && !he) {
          u++;
          break;
        }
        for (var $e = 0, Te = g, fe = !1; ; ) {
          if (Te++, Te >= $)
            throw new Error("Invalid HTML: " + e);
          var Y = e.charCodeAt(Te);
          if (fe)
            $e ? Y === $e && (fe = !1) : oo(Y) ? fe = !1 : Y === Fc && (fe = !1, Te--);
          else if (Y === g$) {
            for (; oo(e.charCodeAt(Te + 1)); )
              Te++;
            fe = !0;
            var O = e.charCodeAt(Te + 1);
            O === p$ || O === v$ ? ($e = O, Te++) : $e = 0;
          } else if (Y === Fc) {
            var G = g + (he ? 2 : 1), W = Math.min(S$(e, G), Te), ae = e.slice(G, W).toLowerCase();
            ae.charCodeAt(ae.length - 1) === ha && (ae = ae.slice(0, ae.length - 1));
            var te = m(ae);
            if (he) {
              var se = b.pop();
              if (se !== ae)
                throw new Error("Invalid HTML: " + e);
              if (Ci.includes(ae) && !Ci.some(function(ie) {
                return b.includes(ie);
              })) {
                if (te)
                  g = k, k = -1;
                else if (k = -1, u += o, u > t)
                  break;
              }
              var Se = Wh.includes(ae);
              if (Se && k === -1 && !te && (v++, v > c)) {
                b.push(ae);
                break;
              }
            } else if (f$.includes(ae) || e.charCodeAt(Te - 1) === ha) {
              if (!te) {
                if (ae === "br") {
                  if (v++, v > c)
                    break;
                } else if (ae === "img" && (u += o, u > t))
                  break;
              }
            } else
              Ci.some(function(ie) {
                return b.includes(ie);
              }) || Ci.includes(ae) && (k = g), b.push(ae);
            te && k === -1 ? (e = e.slice(0, g) + e.slice(Te + 1), g--) : g = Te;
            break;
          }
        }
        if (u > t || v > c)
          break;
      }
    } else if (V === h$) {
      for (var Te = g + 1, me = !0; ; ) {
        var ne = e.charCodeAt(Te);
        if (Hh(ne))
          Te++;
        else {
          if (ne === wl)
            break;
          me = !1;
          break;
        }
      }
      if (k === -1 && (u++, u > t))
        break;
      me && (g = Te);
    } else if (V === Ro) {
      if (u++, u > t || (v++, v > c))
        break;
    } else {
      if (k === -1 && (u++, u > t))
        break;
      if ((V & 64512) === 55296) {
        var Q = e.charCodeAt(g + 1);
        (Q & 64512) === 56320 && g++;
      }
    }
  }
  if (u > t) {
    var ye = C$(e, g);
    if (i) {
      for (var ze = g + ye.length; e.charCodeAt(ze) === Gi && e.charCodeAt(ze + 1) === ha; ) {
        var pe = e.indexOf(">", ze + 2) + 1;
        if (pe)
          ze = pe;
        else
          break;
      }
      ze && (ze === e.length || Gf(e, ze)) && (g += ye.length, ye = e.charAt(g));
    }
    for (; ye === "<" && e.charCodeAt(g + 1) === ha; ) {
      var ae = b.pop();
      if (!ae)
        break;
      var mt = e.indexOf(">", g + 2);
      if (mt === -1 || e.slice(g + 2, mt).trim() !== ae)
        throw new Error("Invalid HTML: " + e);
      m(ae) ? e = e.slice(0, g) + e.slice(mt + 1) : g = mt + 1, ye = e.charAt(g);
    }
    if (g < e.length) {
      if (!n.breakWords)
        for (var Ae = g - i.length; Ae >= 0; Ae--) {
          var V = e.charCodeAt(Ae);
          if (V === Fc || V === wl)
            break;
          if (V === Ro || V === Gi) {
            g = Ae;
            break;
          } else if (oo(V)) {
            g = Ae + (i ? 1 : 0);
            break;
          }
        }
      var K = e.slice(0, g);
      return Gf(e, g) || (K += i), x(K);
    }
  } else if (v > c)
    return x(e.slice(0, g));
  return e;
}
function T$(e, t, n) {
  for (var r = n.indicator, o = r === void 0 ? "…" : r, a = n.maxLines, i = a === void 0 ? 1 / 0 : a, s = o.length, c = 1, l = 0, d = e.length; l < d && (s++, !(s > t)); l++) {
    var u = e.charCodeAt(l);
    if (u === Ro) {
      if (c++, c > i)
        break;
    } else if ((u & 64512) === 55296) {
      var v = e.charCodeAt(l + 1);
      (v & 64512) === 56320 && l++;
    }
  }
  if (s > t) {
    var m = Uh(e, l);
    if (o) {
      var b = l + m.length;
      if (b === e.length)
        return e;
      if (e.charCodeAt(b) === Ro)
        return e.slice(0, l + m.length);
    }
    if (!n.breakWords)
      for (var x = l - o.length; x >= 0; x--) {
        var u = e.charCodeAt(x);
        if (u === Ro) {
          l = x, m = `
`;
          break;
        } else if (oo(u)) {
          l = x + (o ? 1 : 0);
          break;
        }
      }
    return e.slice(0, l) + (m === `
` ? "" : o);
  } else if (c > i)
    return e.slice(0, l);
  return e;
}
function S$(e, t) {
  for (var n = e.length, r = t; r < n; r++)
    if (oo(e.charCodeAt(r)))
      return r;
  return n;
}
function Hh(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function Gf(e, t) {
  var n = e.charCodeAt(t);
  if (n === Ro)
    return !0;
  if (n === Gi) {
    var r = "(" + Wh.join("|") + "|br)", o = new RegExp("^<" + r + `[	
\f\r ]*/?>`, "i");
    return o.test(e.slice(t));
  } else
    return !1;
}
function oo(e) {
  return e === 9 || e === 10 || e === 12 || e === 13 || e === 32;
}
function k$(e) {
  for (var t = e.length - 1; t >= 0; t--) {
    var n = e[t];
    if (n === "li" || n === "td")
      return !1;
    if (n === "ol" || n === "table" || n === "ul")
      return !0;
  }
  return !1;
}
function _$(e) {
  return e.trim().replace(x$, " ");
}
function Uh(e, t) {
  var n = e.charCodeAt(t);
  if ((n & 64512) === 55296) {
    var r = e.charCodeAt(t + 1);
    if ((r & 64512) === 56320)
      return String.fromCharCode(n, r);
  }
  return String.fromCharCode(n);
}
function C$(e, t) {
  var n = Uh(e, t);
  if (n === "&")
    for (; ; ) {
      t++;
      var r = e.charCodeAt(t);
      if (Hh(r))
        n += String.fromCharCode(r);
      else if (r === wl) {
        n += String.fromCharCode(r);
        break;
      } else
        break;
    }
  return n;
}
const P$ = "content-match", qf = ({
  hasLightFont: e = !1,
  className: t,
  children: n
}) => /* @__PURE__ */ w.jsx(
  "span",
  {
    className: z(
      "rounded-sm px-0.5",
      e ? "bg-sky.3 " : "bg-sky.6",
      P$,
      t
    ),
    children: n
  }
), A$ = ["top", "right", "bottom", "left"], sr = Math.min, An = Math.max, ts = Math.round, Pi = Math.floor, Ur = (e) => ({
  x: e,
  y: e
}), O$ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, N$ = {
  start: "end",
  end: "start"
};
function El(e, t, n) {
  return An(e, sr(t, n));
}
function lr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Sr(e) {
  return e.split("-")[0];
}
function zo(e) {
  return e.split("-")[1];
}
function Su(e) {
  return e === "x" ? "y" : "x";
}
function ku(e) {
  return e === "y" ? "height" : "width";
}
function Br(e) {
  return ["top", "bottom"].includes(Sr(e)) ? "y" : "x";
}
function _u(e) {
  return Su(Br(e));
}
function R$(e, t, n) {
  n === void 0 && (n = !1);
  const r = zo(e), o = _u(e), a = ku(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = ns(i)), [i, ns(i)];
}
function M$(e) {
  const t = ns(e);
  return [$l(e), t, $l(t)];
}
function $l(e) {
  return e.replace(/start|end/g, (t) => N$[t]);
}
function D$(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function I$(e, t, n, r) {
  const o = zo(e);
  let a = D$(Sr(e), n === "start", r);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map($l)))), a;
}
function ns(e) {
  return e.replace(/left|right|bottom|top/g, (t) => O$[t]);
}
function j$(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Bh(e) {
  return typeof e != "number" ? j$(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function rs(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Yf(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = Br(t), i = _u(t), s = ku(i), c = Sr(t), l = a === "y", d = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, v = r[s] / 2 - o[s] / 2;
  let m;
  switch (c) {
    case "top":
      m = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (zo(t)) {
    case "start":
      m[i] -= v * (n && l ? -1 : 1);
      break;
    case "end":
      m[i] += v * (n && l ? -1 : 1);
      break;
  }
  return m;
}
const L$ = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let l = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: u
  } = Yf(l, r, c), v = r, m = {}, b = 0;
  for (let x = 0; x < s.length; x++) {
    const {
      name: g,
      fn: k
    } = s[x], {
      x: $,
      y: T,
      data: S,
      reset: C
    } = await k({
      x: d,
      y: u,
      initialPlacement: r,
      placement: v,
      strategy: o,
      middlewareData: m,
      rects: l,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = $ ?? d, u = T ?? u, m = {
      ...m,
      [g]: {
        ...m[g],
        ...S
      }
    }, C && b <= 50 && (b++, typeof C == "object" && (C.placement && (v = C.placement), C.rects && (l = C.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : C.rects), {
      x: d,
      y: u
    } = Yf(l, v, c)), x = -1);
  }
  return {
    x: d,
    y: u,
    placement: v,
    strategy: o,
    middlewareData: m
  };
};
async function Io(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: v = !1,
    padding: m = 0
  } = lr(t, e), b = Bh(m), g = s[v ? u === "floating" ? "reference" : "floating" : u], k = rs(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(g))) == null || n ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: c
  })), $ = u === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, T = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), S = await (a.isElement == null ? void 0 : a.isElement(T)) ? await (a.getScale == null ? void 0 : a.getScale(T)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = rs(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: $,
    offsetParent: T,
    strategy: c
  }) : $);
  return {
    top: (k.top - C.top + b.top) / S.y,
    bottom: (C.bottom - k.bottom + b.bottom) / S.y,
    left: (k.left - C.left + b.left) / S.x,
    right: (C.right - k.right + b.right) / S.x
  };
}
const F$ = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: d = 0
    } = lr(e, t) || {};
    if (l == null)
      return {};
    const u = Bh(d), v = {
      x: n,
      y: r
    }, m = _u(o), b = ku(m), x = await i.getDimensions(l), g = m === "y", k = g ? "top" : "left", $ = g ? "bottom" : "right", T = g ? "clientHeight" : "clientWidth", S = a.reference[b] + a.reference[m] - v[m] - a.floating[b], C = v[m] - a.reference[m], N = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let U = N ? N[T] : 0;
    (!U || !await (i.isElement == null ? void 0 : i.isElement(N))) && (U = s.floating[T] || a.floating[b]);
    const L = S / 2 - C / 2, j = U / 2 - x[b] / 2 - 1, q = sr(u[k], j), V = sr(u[$], j), Q = q, ke = U - x[b] - V, H = U / 2 - x[b] / 2 + L, X = El(Q, H, ke), he = !c.arrow && zo(o) != null && H !== X && a.reference[b] / 2 - (H < Q ? q : V) - x[b] / 2 < 0, $e = he ? H < Q ? H - Q : H - ke : 0;
    return {
      [m]: v[m] + $e,
      data: {
        [m]: X,
        centerOffset: H - X - $e,
        ...he && {
          alignmentOffset: $e
        }
      },
      reset: he
    };
  }
}), W$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: v,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: x = !0,
        ...g
      } = lr(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const k = Sr(o), $ = Br(s), T = Sr(s) === s, S = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), C = v || (T || !x ? [ns(s)] : M$(s)), N = b !== "none";
      !v && N && C.push(...I$(s, x, b, S));
      const U = [s, ...C], L = await Io(t, g), j = [];
      let q = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && j.push(L[k]), u) {
        const H = R$(o, i, S);
        j.push(L[H[0]], L[H[1]]);
      }
      if (q = [...q, {
        placement: o,
        overflows: j
      }], !j.every((H) => H <= 0)) {
        var V, Q;
        const H = (((V = a.flip) == null ? void 0 : V.index) || 0) + 1, X = U[H];
        if (X)
          return {
            data: {
              index: H,
              overflows: q
            },
            reset: {
              placement: X
            }
          };
        let he = (Q = q.filter(($e) => $e.overflows[0] <= 0).sort(($e, Te) => $e.overflows[1] - Te.overflows[1])[0]) == null ? void 0 : Q.placement;
        if (!he)
          switch (m) {
            case "bestFit": {
              var ke;
              const $e = (ke = q.filter((Te) => {
                if (N) {
                  const fe = Br(Te.placement);
                  return fe === $ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  fe === "y";
                }
                return !0;
              }).map((Te) => [Te.placement, Te.overflows.filter((fe) => fe > 0).reduce((fe, Y) => fe + Y, 0)]).sort((Te, fe) => Te[1] - fe[1])[0]) == null ? void 0 : ke[0];
              $e && (he = $e);
              break;
            }
            case "initialPlacement":
              he = s;
              break;
          }
        if (o !== he)
          return {
            reset: {
              placement: he
            }
          };
      }
      return {};
    }
  };
};
function Kf(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Xf(e) {
  return A$.some((t) => e[t] >= 0);
}
const H$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = lr(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await Io(t, {
            ...o,
            elementContext: "reference"
          }), i = Kf(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Xf(i)
            }
          };
        }
        case "escaped": {
          const a = await Io(t, {
            ...o,
            altBoundary: !0
          }), i = Kf(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Xf(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function U$(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = Sr(n), s = zo(n), c = Br(n) === "y", l = ["left", "top"].includes(i) ? -1 : 1, d = a && c ? -1 : 1, u = lr(t, e);
  let {
    mainAxis: v,
    crossAxis: m,
    alignmentAxis: b
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof b == "number" && (m = s === "end" ? b * -1 : b), c ? {
    x: m * d,
    y: v * l
  } : {
    x: v * l,
    y: m * d
  };
}
const B$ = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, c = await U$(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, z$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: k,
              y: $
            } = g;
            return {
              x: k,
              y: $
            };
          }
        },
        ...c
      } = lr(e, t), l = {
        x: n,
        y: r
      }, d = await Io(t, c), u = Br(Sr(o)), v = Su(u);
      let m = l[v], b = l[u];
      if (a) {
        const g = v === "y" ? "top" : "left", k = v === "y" ? "bottom" : "right", $ = m + d[g], T = m - d[k];
        m = El($, m, T);
      }
      if (i) {
        const g = u === "y" ? "top" : "left", k = u === "y" ? "bottom" : "right", $ = b + d[g], T = b - d[k];
        b = El($, b, T);
      }
      const x = s.fn({
        ...t,
        [v]: m,
        [u]: b
      });
      return {
        ...x,
        data: {
          x: x.x - n,
          y: x.y - r
        }
      };
    }
  };
}, V$ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = lr(e, t), d = {
        x: n,
        y: r
      }, u = Br(o), v = Su(u);
      let m = d[v], b = d[u];
      const x = lr(s, t), g = typeof x == "number" ? {
        mainAxis: x,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...x
      };
      if (c) {
        const T = v === "y" ? "height" : "width", S = a.reference[v] - a.floating[T] + g.mainAxis, C = a.reference[v] + a.reference[T] - g.mainAxis;
        m < S ? m = S : m > C && (m = C);
      }
      if (l) {
        var k, $;
        const T = v === "y" ? "width" : "height", S = ["top", "left"].includes(Sr(o)), C = a.reference[u] - a.floating[T] + (S && ((k = i.offset) == null ? void 0 : k[u]) || 0) + (S ? 0 : g.crossAxis), N = a.reference[u] + a.reference[T] + (S ? 0 : (($ = i.offset) == null ? void 0 : $[u]) || 0) - (S ? g.crossAxis : 0);
        b < C ? b = C : b > N && (b = N);
      }
      return {
        [v]: m,
        [u]: b
      };
    }
  };
}, G$ = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: a
      } = t, {
        apply: i = () => {
        },
        ...s
      } = lr(e, t), c = await Io(t, s), l = Sr(n), d = zo(n), u = Br(n) === "y", {
        width: v,
        height: m
      } = r.floating;
      let b, x;
      l === "top" || l === "bottom" ? (b = l, x = d === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (x = l, b = d === "end" ? "top" : "bottom");
      const g = m - c.top - c.bottom, k = v - c.left - c.right, $ = sr(m - c[b], g), T = sr(v - c[x], k), S = !t.middlewareData.shift;
      let C = $, N = T;
      if (u ? N = d || S ? sr(T, k) : k : C = d || S ? sr($, g) : g, S && !d) {
        const L = An(c.left, 0), j = An(c.right, 0), q = An(c.top, 0), V = An(c.bottom, 0);
        u ? N = v - 2 * (L !== 0 || j !== 0 ? L + j : An(c.left, c.right)) : C = m - 2 * (q !== 0 || V !== 0 ? q + V : An(c.top, c.bottom));
      }
      await i({
        ...t,
        availableWidth: N,
        availableHeight: C
      });
      const U = await o.getDimensions(a.floating);
      return v !== U.width || m !== U.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Vo(e) {
  return zh(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function On(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Pr(e) {
  var t;
  return (t = (zh(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function zh(e) {
  return e instanceof Node || e instanceof On(e).Node;
}
function dn(e) {
  return e instanceof Element || e instanceof On(e).Element;
}
function ur(e) {
  return e instanceof HTMLElement || e instanceof On(e).HTMLElement;
}
function Zf(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof On(e).ShadowRoot;
}
function Qa(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Kn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function q$(e) {
  return ["table", "td", "th"].includes(Vo(e));
}
function js(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Cu(e) {
  const t = Pu(), n = dn(e) ? Kn(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Y$(e) {
  let t = zr(e);
  for (; ur(t) && !jo(t); ) {
    if (Cu(t))
      return t;
    if (js(t))
      return null;
    t = zr(t);
  }
  return null;
}
function Pu() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function jo(e) {
  return ["html", "body", "#document"].includes(Vo(e));
}
function Kn(e) {
  return On(e).getComputedStyle(e);
}
function Ls(e) {
  return dn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function zr(e) {
  if (Vo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Zf(e) && e.host || // Fallback.
    Pr(e)
  );
  return Zf(t) ? t.host : t;
}
function Vh(e) {
  const t = zr(e);
  return jo(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ur(t) && Qa(t) ? t : Vh(t);
}
function Ra(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Vh(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = On(o);
  return a ? t.concat(i, i.visualViewport || [], Qa(o) ? o : [], i.frameElement && n ? Ra(i.frameElement) : []) : t.concat(o, Ra(o, [], n));
}
function Gh(e) {
  const t = Kn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = ur(e), a = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, s = ts(n) !== a || ts(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function Au(e) {
  return dn(e) ? e : e.contextElement;
}
function Mo(e) {
  const t = Au(e);
  if (!ur(t))
    return Ur(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = Gh(t);
  let i = (a ? ts(n.width) : n.width) / r, s = (a ? ts(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const K$ = /* @__PURE__ */ Ur(0);
function qh(e) {
  const t = On(e);
  return !Pu() || !t.visualViewport ? K$ : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function X$(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== On(e) ? !1 : t;
}
function lo(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Au(e);
  let i = Ur(1);
  t && (r ? dn(r) && (i = Mo(r)) : i = Mo(e));
  const s = X$(a, n, r) ? qh(a) : Ur(0);
  let c = (o.left + s.x) / i.x, l = (o.top + s.y) / i.y, d = o.width / i.x, u = o.height / i.y;
  if (a) {
    const v = On(a), m = r && dn(r) ? On(r) : r;
    let b = v, x = b.frameElement;
    for (; x && r && m !== b; ) {
      const g = Mo(x), k = x.getBoundingClientRect(), $ = Kn(x), T = k.left + (x.clientLeft + parseFloat($.paddingLeft)) * g.x, S = k.top + (x.clientTop + parseFloat($.paddingTop)) * g.y;
      c *= g.x, l *= g.y, d *= g.x, u *= g.y, c += T, l += S, b = On(x), x = b.frameElement;
    }
  }
  return rs({
    width: d,
    height: u,
    x: c,
    y: l
  });
}
function Z$(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", i = Pr(r), s = t ? js(t.floating) : !1;
  if (r === i || s && a)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Ur(1);
  const d = Ur(0), u = ur(r);
  if ((u || !u && !a) && ((Vo(r) !== "body" || Qa(i)) && (c = Ls(r)), ur(r))) {
    const v = lo(r);
    l = Mo(r), d.x = v.x + r.clientLeft, d.y = v.y + r.clientTop;
  }
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + d.x,
    y: n.y * l.y - c.scrollTop * l.y + d.y
  };
}
function Q$(e) {
  return Array.from(e.getClientRects());
}
function Yh(e) {
  return lo(Pr(e)).left + Ls(e).scrollLeft;
}
function J$(e) {
  const t = Pr(e), n = Ls(e), r = e.ownerDocument.body, o = An(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = An(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + Yh(e);
  const s = -n.scrollTop;
  return Kn(r).direction === "rtl" && (i += An(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function eT(e, t) {
  const n = On(e), r = Pr(e), o = n.visualViewport;
  let a = r.clientWidth, i = r.clientHeight, s = 0, c = 0;
  if (o) {
    a = o.width, i = o.height;
    const l = Pu();
    (!l || l && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: c
  };
}
function tT(e, t) {
  const n = lo(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = ur(e) ? Mo(e) : Ur(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, c = o * a.x, l = r * a.y;
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function Qf(e, t, n) {
  let r;
  if (t === "viewport")
    r = eT(e, n);
  else if (t === "document")
    r = J$(Pr(e));
  else if (dn(t))
    r = tT(t, n);
  else {
    const o = qh(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return rs(r);
}
function Kh(e, t) {
  const n = zr(e);
  return n === t || !dn(n) || jo(n) ? !1 : Kn(n).position === "fixed" || Kh(n, t);
}
function nT(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ra(e, [], !1).filter((s) => dn(s) && Vo(s) !== "body"), o = null;
  const a = Kn(e).position === "fixed";
  let i = a ? zr(e) : e;
  for (; dn(i) && !jo(i); ) {
    const s = Kn(i), c = Cu(i);
    !c && s.position === "fixed" && (o = null), (a ? !c && !o : !c && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Qa(i) && !c && Kh(e, i)) ? r = r.filter((d) => d !== i) : o = s, i = zr(i);
  }
  return t.set(e, r), r;
}
function rT(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? js(t) ? [] : nT(t, this._c) : [].concat(n), r], s = i[0], c = i.reduce((l, d) => {
    const u = Qf(t, d, o);
    return l.top = An(u.top, l.top), l.right = sr(u.right, l.right), l.bottom = sr(u.bottom, l.bottom), l.left = An(u.left, l.left), l;
  }, Qf(t, s, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function oT(e) {
  const {
    width: t,
    height: n
  } = Gh(e);
  return {
    width: t,
    height: n
  };
}
function aT(e, t, n) {
  const r = ur(t), o = Pr(t), a = n === "fixed", i = lo(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Ur(0);
  if (r || !r && !a)
    if ((Vo(t) !== "body" || Qa(o)) && (s = Ls(t)), r) {
      const u = lo(t, !0, a, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else
      o && (c.x = Yh(o));
  const l = i.left + s.scrollLeft - c.x, d = i.top + s.scrollTop - c.y;
  return {
    x: l,
    y: d,
    width: i.width,
    height: i.height
  };
}
function Wc(e) {
  return Kn(e).position === "static";
}
function Jf(e, t) {
  return !ur(e) || Kn(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Xh(e, t) {
  const n = On(e);
  if (js(e))
    return n;
  if (!ur(e)) {
    let o = zr(e);
    for (; o && !jo(o); ) {
      if (dn(o) && !Wc(o))
        return o;
      o = zr(o);
    }
    return n;
  }
  let r = Jf(e, t);
  for (; r && q$(r) && Wc(r); )
    r = Jf(r, t);
  return r && jo(r) && Wc(r) && !Cu(r) ? n : r || Y$(e) || n;
}
const iT = async function(e) {
  const t = this.getOffsetParent || Xh, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: aT(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function sT(e) {
  return Kn(e).direction === "rtl";
}
const cT = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Z$,
  getDocumentElement: Pr,
  getClippingRect: rT,
  getOffsetParent: Xh,
  getElementRects: iT,
  getClientRects: Q$,
  getDimensions: oT,
  getScale: Mo,
  isElement: dn,
  isRTL: sT
};
function lT(e, t) {
  let n = null, r;
  const o = Pr(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const {
      left: l,
      top: d,
      width: u,
      height: v
    } = e.getBoundingClientRect();
    if (s || t(), !u || !v)
      return;
    const m = Pi(d), b = Pi(o.clientWidth - (l + u)), x = Pi(o.clientHeight - (d + v)), g = Pi(l), $ = {
      rootMargin: -m + "px " + -b + "px " + -x + "px " + -g + "px",
      threshold: An(0, sr(1, c)) || 1
    };
    let T = !0;
    function S(C) {
      const N = C[0].intersectionRatio;
      if (N !== c) {
        if (!T)
          return i();
        N ? i(!1, N) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      T = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...$,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, $);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function Zh(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Au(e), d = o || a ? [...l ? Ra(l) : [], ...Ra(t)] : [];
  d.forEach((k) => {
    o && k.addEventListener("scroll", n, {
      passive: !0
    }), a && k.addEventListener("resize", n);
  });
  const u = l && s ? lT(l, n) : null;
  let v = -1, m = null;
  i && (m = new ResizeObserver((k) => {
    let [$] = k;
    $ && $.target === l && m && (m.unobserve(t), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      var T;
      (T = m) == null || T.observe(t);
    })), n();
  }), l && !c && m.observe(l), m.observe(t));
  let b, x = c ? lo(e) : null;
  c && g();
  function g() {
    const k = lo(e);
    x && (k.x !== x.x || k.y !== x.y || k.width !== x.width || k.height !== x.height) && n(), x = k, b = requestAnimationFrame(g);
  }
  return n(), () => {
    var k;
    d.forEach(($) => {
      o && $.removeEventListener("scroll", n), a && $.removeEventListener("resize", n);
    }), u == null || u(), (k = m) == null || k.disconnect(), m = null, c && cancelAnimationFrame(b);
  };
}
const Hc = Io, uT = B$, dT = z$, fT = W$, mT = G$, pT = H$, em = F$, hT = V$, vT = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: cT,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return L$(e, t, {
    ...o,
    platform: a
  });
};
var qi = typeof document < "u" ? Ua : Ee;
function os(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!os(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !os(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Qh(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function tm(e, t) {
  const n = Qh(e);
  return Math.round(t * n) / n;
}
function nm(e) {
  const t = P.useRef(e);
  return qi(() => {
    t.current = e;
  }), t;
}
function Jh(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [d, u] = P.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [v, m] = P.useState(r);
  os(v, r) || m(r);
  const [b, x] = P.useState(null), [g, k] = P.useState(null), $ = P.useCallback(($e) => {
    $e !== N.current && (N.current = $e, x($e));
  }, []), T = P.useCallback(($e) => {
    $e !== U.current && (U.current = $e, k($e));
  }, []), S = a || b, C = i || g, N = P.useRef(null), U = P.useRef(null), L = P.useRef(d), j = c != null, q = nm(c), V = nm(o), Q = P.useCallback(() => {
    if (!N.current || !U.current)
      return;
    const $e = {
      placement: t,
      strategy: n,
      middleware: v
    };
    V.current && ($e.platform = V.current), vT(N.current, U.current, $e).then((Te) => {
      const fe = {
        ...Te,
        isPositioned: !0
      };
      ke.current && !os(L.current, fe) && (L.current = fe, Wr.flushSync(() => {
        u(fe);
      }));
    });
  }, [v, t, n, V]);
  qi(() => {
    l === !1 && L.current.isPositioned && (L.current.isPositioned = !1, u(($e) => ({
      ...$e,
      isPositioned: !1
    })));
  }, [l]);
  const ke = P.useRef(!1);
  qi(() => (ke.current = !0, () => {
    ke.current = !1;
  }), []), qi(() => {
    if (S && (N.current = S), C && (U.current = C), S && C) {
      if (q.current)
        return q.current(S, C, Q);
      Q();
    }
  }, [S, C, Q, q, j]);
  const H = P.useMemo(() => ({
    reference: N,
    floating: U,
    setReference: $,
    setFloating: T
  }), [$, T]), X = P.useMemo(() => ({
    reference: S,
    floating: C
  }), [S, C]), he = P.useMemo(() => {
    const $e = {
      position: n,
      left: 0,
      top: 0
    };
    if (!X.floating)
      return $e;
    const Te = tm(X.floating, d.x), fe = tm(X.floating, d.y);
    return s ? {
      ...$e,
      transform: "translate(" + Te + "px, " + fe + "px)",
      ...Qh(X.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: Te,
      top: fe
    };
  }, [n, s, X.floating, d.x, d.y]);
  return P.useMemo(() => ({
    ...d,
    update: Q,
    refs: H,
    elements: X,
    floatingStyles: he
  }), [d, Q, H, X, he]);
}
const gT = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? em({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? em({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Ou = (e, t) => ({
  ...uT(e),
  options: [e, t]
}), ev = (e, t) => ({
  ...dT(e),
  options: [e, t]
}), bT = (e, t) => ({
  ...hT(e),
  options: [e, t]
}), tv = (e, t) => ({
  ...fT(e),
  options: [e, t]
}), nv = (e, t) => ({
  ...mT(e),
  options: [e, t]
}), yT = (e, t) => ({
  ...pT(e),
  options: [e, t]
}), xT = (e, t) => ({
  ...gT(e),
  options: [e, t]
}), wT = /* @__PURE__ */ M((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ I(lt.svg, oe({}, a, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ I("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), ET = wT;
function $T(e) {
  const [t, n] = Ce(void 0);
  return qt(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({
          width: i,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const rv = "Popper", [ov, Go] = Hn(rv), [TT, av] = ov(rv), ST = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = Ce(null);
  return /* @__PURE__ */ I(TT, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, kT = "PopperAnchor", _T = /* @__PURE__ */ M((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, a = av(kT, n), i = Z(null), s = ct(t, i);
  return Ee(() => {
    a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
  }), r ? null : /* @__PURE__ */ I(lt.div, oe({}, o, {
    ref: s
  }));
}), iv = "PopperContent", [CT, PT] = ov(iv), AT = /* @__PURE__ */ M((e, t) => {
  var n, r, o, a, i, s, c, l;
  const { __scopePopper: d, side: u = "bottom", sideOffset: v = 0, align: m = "center", alignOffset: b = 0, arrowPadding: x = 0, avoidCollisions: g = !0, collisionBoundary: k = [], collisionPadding: $ = 0, sticky: T = "partial", hideWhenDetached: S = !1, updatePositionStrategy: C = "optimized", onPlaced: N, ...U } = e, L = av(iv, d), [j, q] = Ce(null), V = ct(
    t,
    (K) => q(K)
  ), [Q, ke] = Ce(null), H = $T(Q), X = (n = H == null ? void 0 : H.width) !== null && n !== void 0 ? n : 0, he = (r = H == null ? void 0 : H.height) !== null && r !== void 0 ? r : 0, $e = u + (m !== "center" ? "-" + m : ""), Te = typeof $ == "number" ? $ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...$
  }, fe = Array.isArray(k) ? k : [
    k
  ], Y = fe.length > 0, O = {
    padding: Te,
    boundary: fe.filter(MT),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: Y
  }, { refs: G, floatingStyles: W, placement: ae, isPositioned: te, middlewareData: se } = Jh({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: $e,
    whileElementsMounted: (...K) => Zh(...K, {
      animationFrame: C === "always"
    }),
    elements: {
      reference: L.anchor
    },
    middleware: [
      Ou({
        mainAxis: v + he,
        alignmentAxis: b
      }),
      g && ev({
        mainAxis: !0,
        crossAxis: !1,
        limiter: T === "partial" ? bT() : void 0,
        ...O
      }),
      g && tv({
        ...O
      }),
      nv({
        ...O,
        apply: ({ elements: K, rects: ie, availableWidth: ve, availableHeight: Me }) => {
          const { width: Ue, height: it } = ie.reference, et = K.floating.style;
          et.setProperty("--radix-popper-available-width", `${ve}px`), et.setProperty("--radix-popper-available-height", `${Me}px`), et.setProperty("--radix-popper-anchor-width", `${Ue}px`), et.setProperty("--radix-popper-anchor-height", `${it}px`);
        }
      }),
      Q && xT({
        element: Q,
        padding: x
      }),
      DT({
        arrowWidth: X,
        arrowHeight: he
      }),
      S && yT({
        strategy: "referenceHidden",
        ...O
      })
    ]
  }), [Se, me] = sv(ae), ne = wt(N);
  qt(() => {
    te && (ne == null || ne());
  }, [
    te,
    ne
  ]);
  const ye = (o = se.arrow) === null || o === void 0 ? void 0 : o.x, ze = (a = se.arrow) === null || a === void 0 ? void 0 : a.y, pe = ((i = se.arrow) === null || i === void 0 ? void 0 : i.centerOffset) !== 0, [mt, Ae] = Ce();
  return qt(() => {
    j && Ae(window.getComputedStyle(j).zIndex);
  }, [
    j
  ]), /* @__PURE__ */ I("div", {
    ref: G.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...W,
      transform: te ? W.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: mt,
      "--radix-popper-transform-origin": [
        (s = se.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (c = se.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ I(CT, {
    scope: d,
    placedSide: Se,
    onArrowChange: ke,
    arrowX: ye,
    arrowY: ze,
    shouldHideArrow: pe
  }, /* @__PURE__ */ I(lt.div, oe({
    "data-side": Se,
    "data-align": me
  }, U, {
    ref: V,
    style: {
      ...U.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: te ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = se.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
}), OT = "PopperArrow", NT = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, RT = /* @__PURE__ */ M(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = PT(OT, r), i = NT[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ I("span", {
      ref: a.onArrowChange,
      style: {
        position: "absolute",
        left: a.arrowX,
        top: a.arrowY,
        [i]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[a.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[a.placedSide],
        visibility: a.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ I(ET, oe({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function MT(e) {
  return e !== null;
}
const DT = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, a, i;
    const { placement: s, rects: c, middlewareData: l } = t, u = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, v = u ? 0 : e.arrowWidth, m = u ? 0 : e.arrowHeight, [b, x] = sv(s), g = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[x], k = ((r = (o = l.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + v / 2, $ = ((a = (i = l.arrow) === null || i === void 0 ? void 0 : i.y) !== null && a !== void 0 ? a : 0) + m / 2;
    let T = "", S = "";
    return b === "bottom" ? (T = u ? g : `${k}px`, S = `${-m}px`) : b === "top" ? (T = u ? g : `${k}px`, S = `${c.floating.height + m}px`) : b === "right" ? (T = `${-m}px`, S = u ? g : `${$}px`) : b === "left" && (T = `${c.floating.width + m}px`, S = u ? g : `${$}px`), {
      data: {
        x: T,
        y: S
      }
    };
  }
});
function sv(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Fs = ST, Ws = _T, Nu = AT, cv = RT;
function IT(e, t) {
  return mr((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Ru = (e) => {
  const { present: t, children: n } = e, r = jT(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Tn.only(n), a = ct(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ fr(o, {
    ref: a
  }) : null;
};
Ru.displayName = "Presence";
function jT(e) {
  const [t, n] = Ce(), r = Z({}), o = Z(e), a = Z("none"), i = e ? "mounted" : "unmounted", [s, c] = IT(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const l = Ai(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), qt(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, m = Ai(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && v !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), qt(() => {
    if (t) {
      const l = (u) => {
        const m = Ai(r.current).includes(u.animationName);
        u.target === t && m && Vr(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (a.current = Ai(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Ie((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Ai(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function LT({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = FT({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = wt(n), c = Ie((l) => {
    if (a) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    c
  ];
}
function FT({ defaultProp: e, onChange: t }) {
  const n = Ce(e), [r] = n, o = Z(r), a = wt(t);
  return Ee(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
const WT = /* @__PURE__ */ M((e, t) => /* @__PURE__ */ I(lt.span, oe({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), HT = WT, [Hs, Kz] = Hn("Tooltip", [
  Go
]), Us = Go(), UT = "TooltipProvider", BT = 700, Tl = "tooltip.open", [zT, Mu] = Hs(UT), VT = (e) => {
  const { __scopeTooltip: t, delayDuration: n = BT, skipDelayDuration: r = 300, disableHoverableContent: o = !1, children: a } = e, [i, s] = Ce(!0), c = Z(!1), l = Z(0);
  return Ee(() => {
    const d = l.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ I(zT, {
    scope: t,
    isOpenDelayed: i,
    delayDuration: n,
    onOpen: Ie(() => {
      window.clearTimeout(l.current), s(!1);
    }, []),
    onClose: Ie(() => {
      window.clearTimeout(l.current), l.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: Ie((d) => {
      c.current = d;
    }, []),
    disableHoverableContent: o
  }, a);
}, Du = "Tooltip", [GT, Ja] = Hs(Du), qT = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: o = !1, onOpenChange: a, disableHoverableContent: i, delayDuration: s } = e, c = Mu(Du, e.__scopeTooltip), l = Us(t), [d, u] = Ce(null), v = Ln(), m = Z(0), b = i ?? c.disableHoverableContent, x = s ?? c.delayDuration, g = Z(!1), [k = !1, $] = LT({
    prop: r,
    defaultProp: o,
    onChange: (U) => {
      U ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Tl))) : c.onClose(), a == null || a(U);
    }
  }), T = qe(() => k ? g.current ? "delayed-open" : "instant-open" : "closed", [
    k
  ]), S = Ie(() => {
    window.clearTimeout(m.current), g.current = !1, $(!0);
  }, [
    $
  ]), C = Ie(() => {
    window.clearTimeout(m.current), $(!1);
  }, [
    $
  ]), N = Ie(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      g.current = !0, $(!0);
    }, x);
  }, [
    x,
    $
  ]);
  return Ee(() => () => window.clearTimeout(m.current), []), /* @__PURE__ */ I(Fs, l, /* @__PURE__ */ I(GT, {
    scope: t,
    contentId: v,
    open: k,
    stateAttribute: T,
    trigger: d,
    onTriggerChange: u,
    onTriggerEnter: Ie(() => {
      c.isOpenDelayed ? N() : S();
    }, [
      c.isOpenDelayed,
      N,
      S
    ]),
    onTriggerLeave: Ie(() => {
      b ? C() : window.clearTimeout(m.current);
    }, [
      C,
      b
    ]),
    onOpen: S,
    onClose: C,
    disableHoverableContent: b
  }, n));
}, rm = "TooltipTrigger", YT = /* @__PURE__ */ M((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = Ja(rm, n), a = Mu(rm, n), i = Us(n), s = Z(null), c = ct(t, s, o.onTriggerChange), l = Z(!1), d = Z(!1), u = Ie(
    () => l.current = !1,
    []
  );
  return Ee(() => () => document.removeEventListener("pointerup", u), [
    u
  ]), /* @__PURE__ */ I(Ws, oe({
    asChild: !0
  }, i), /* @__PURE__ */ I(lt.button, oe({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": o.open ? o.contentId : void 0,
    "data-state": o.stateAttribute
  }, r, {
    ref: c,
    onPointerMove: Le(e.onPointerMove, (v) => {
      v.pointerType !== "touch" && !d.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
    }),
    onPointerLeave: Le(e.onPointerLeave, () => {
      o.onTriggerLeave(), d.current = !1;
    }),
    onPointerDown: Le(e.onPointerDown, () => {
      l.current = !0, document.addEventListener("pointerup", u, {
        once: !0
      });
    }),
    onFocus: Le(e.onFocus, () => {
      l.current || o.onOpen();
    }),
    onBlur: Le(e.onBlur, o.onClose),
    onClick: Le(e.onClick, o.onClose)
  })));
}), lv = "TooltipPortal", [KT, XT] = Hs(lv, {
  forceMount: void 0
}), ZT = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, a = Ja(lv, t);
  return /* @__PURE__ */ I(KT, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ I(Ru, {
    present: n || a.open
  }, /* @__PURE__ */ I(Ss, {
    asChild: !0,
    container: o
  }, r)));
}, Ma = "TooltipContent", QT = /* @__PURE__ */ M((e, t) => {
  const n = XT(Ma, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...a } = e, i = Ja(Ma, e.__scopeTooltip);
  return /* @__PURE__ */ I(Ru, {
    present: r || i.open
  }, i.disableHoverableContent ? /* @__PURE__ */ I(uv, oe({
    side: o
  }, a, {
    ref: t
  })) : /* @__PURE__ */ I(JT, oe({
    side: o
  }, a, {
    ref: t
  })));
}), JT = /* @__PURE__ */ M((e, t) => {
  const n = Ja(Ma, e.__scopeTooltip), r = Mu(Ma, e.__scopeTooltip), o = Z(null), a = ct(t, o), [i, s] = Ce(null), { trigger: c, onClose: l } = n, d = o.current, { onPointerInTransitChange: u } = r, v = Ie(() => {
    s(null), u(!1);
  }, [
    u
  ]), m = Ie((b, x) => {
    const g = b.currentTarget, k = {
      x: b.clientX,
      y: b.clientY
    }, $ = oS(k, g.getBoundingClientRect()), T = aS(k, $), S = iS(x.getBoundingClientRect()), C = cS([
      ...T,
      ...S
    ]);
    s(C), u(!0);
  }, [
    u
  ]);
  return Ee(() => () => v(), [
    v
  ]), Ee(() => {
    if (c && d) {
      const b = (g) => m(g, d), x = (g) => m(g, c);
      return c.addEventListener("pointerleave", b), d.addEventListener("pointerleave", x), () => {
        c.removeEventListener("pointerleave", b), d.removeEventListener("pointerleave", x);
      };
    }
  }, [
    c,
    d,
    m,
    v
  ]), Ee(() => {
    if (i) {
      const b = (x) => {
        const g = x.target, k = {
          x: x.clientX,
          y: x.clientY
        }, $ = (c == null ? void 0 : c.contains(g)) || (d == null ? void 0 : d.contains(g)), T = !sS(k, i);
        $ ? v() : T && (v(), l());
      };
      return document.addEventListener("pointermove", b), () => document.removeEventListener("pointermove", b);
    }
  }, [
    c,
    d,
    i,
    l,
    v
  ]), /* @__PURE__ */ I(uv, oe({}, e, {
    ref: a
  }));
}), [eS, tS] = Hs(Du, {
  isInside: !1
}), uv = /* @__PURE__ */ M((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": o, onEscapeKeyDown: a, onPointerDownOutside: i, ...s } = e, c = Ja(Ma, n), l = Us(n), { onClose: d } = c;
  return Ee(() => (document.addEventListener(Tl, d), () => document.removeEventListener(Tl, d)), [
    d
  ]), Ee(() => {
    if (c.trigger) {
      const u = (v) => {
        const m = v.target;
        m != null && m.contains(c.trigger) && d();
      };
      return window.addEventListener("scroll", u, {
        capture: !0
      }), () => window.removeEventListener("scroll", u, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    d
  ]), /* @__PURE__ */ I(Ba, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: a,
    onPointerDownOutside: i,
    onFocusOutside: (u) => u.preventDefault(),
    onDismiss: d
  }, /* @__PURE__ */ I(Nu, oe({
    "data-state": c.stateAttribute
  }, l, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ I(Ql, null, r), /* @__PURE__ */ I(eS, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ I(HT, {
    id: c.contentId,
    role: "tooltip"
  }, o || r))));
}), nS = "TooltipArrow", rS = /* @__PURE__ */ M((e, t) => {
  const { __scopeTooltip: n, ...r } = e, o = Us(n);
  return tS(nS, n).isInside ? null : /* @__PURE__ */ I(cv, oe({}, o, r, {
    ref: t
  }));
});
function oS(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function aS(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function iS(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    {
      x: o,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: o,
      y: r
    }
  ];
}
function sS(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, c = t[a].y, l = t[i].x, d = t[i].y;
    c > r != d > r && n < (l - s) * (r - c) / (d - c) + s && (o = !o);
  }
  return o;
}
function cS(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), lS(t);
}
function lS(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const uS = VT, dS = qT, fS = YT, mS = ZT, dv = QT, pS = rS, Xz = uS, Bs = dS;
Bs.defaultProps = {
  delayDuration: 200
};
const Iu = fS, ju = mS, zs = M(
  ({
    align: e = "center",
    side: t = "bottom",
    sideOffset: n = 0,
    children: r,
    className: o,
    ...a
  }, i) => /* @__PURE__ */ w.jsxs(
    dv,
    {
      ref: i,
      align: e,
      side: t,
      sideOffset: n,
      className: z(
        "z-50 max-w-[14rem] rounded bg-sky.1 p-3 text-label-m font-bold text-white duration-200",
        "data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0",
        "data-[state=instant-open]:animate-in data-[state=instant-open]:fade-in-0",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
        t === "bottom" || t === "top" ? "min-w-[7.75rem] text-center" : "text-left",
        o
      ),
      ...a,
      children: [
        r,
        /* @__PURE__ */ w.jsx(pS, { className: "fill-sky.1", width: 16, height: 8 })
      ]
    }
  )
);
zs.displayName = dv.displayName;
const om = ({
  children: e,
  className: t
}) => /* @__PURE__ */ w.jsx(
  "span",
  {
    className: z(
      'relative inline-flex overflow-hidden before:pointer-events-none before:absolute before:left-0 before:top-0 before:h-full before:w-full before:translate-y-[95%] before:bg-black/20 before:transition-transform before:duration-200 before:content-[""]',
      t
    ),
    children: e
  }
), am = ({
  children: e,
  popupContent: t,
  tooltipClassName: n
}) => t ? /* @__PURE__ */ w.jsxs(Bs, { children: [
  /* @__PURE__ */ w.jsx(Iu, { children: /* @__PURE__ */ w.jsx(om, { className: "cursor-help hover:before:translate-y-0", children: e }) }),
  /* @__PURE__ */ w.jsx(ju, { children: /* @__PURE__ */ w.jsx(
    zs,
    {
      className: z("max-w-[25rem]", n),
      side: "top",
      children: t
    }
  ) })
] }) : /* @__PURE__ */ w.jsx(om, { children: e }), hS = ({
  children: e,
  className: t,
  tooltipClassName: n,
  ...r
}) => /* @__PURE__ */ w.jsxs(
  "span",
  {
    className: z(
      "w-fit space-x-1 rounded-sm bg-grey.6 px-0.5 text-sky.1",
      t
    ),
    ...r,
    children: [
      /* @__PURE__ */ w.jsxs(Bs, { children: [
        /* @__PURE__ */ w.jsx(Iu, { asChild: !0, children: /* @__PURE__ */ w.jsx(f2, { className: "-mt-0.5 cursor-help align-middle" }) }),
        /* @__PURE__ */ w.jsx(ju, { children: /* @__PURE__ */ w.jsx(
          zs,
          {
            side: "top",
            className: z("max-w-[25rem]", n),
            children: /* @__PURE__ */ w.jsx(Fr, { _str: "The text highlighted after the eye icon is the text displayed on the screen." })
          }
        ) })
      ] }),
      /* @__PURE__ */ w.jsx("span", { children: e })
    ]
  }
), bo = Et({
  imageProxyUrl: "",
  locale: "en-GB",
  dateVariant: "absolute",
  editedArticles: []
}), vS = "https://www.facebook.com/", gS = "https://www.facebook.com/hashtag/", bS = "https://www.instagram.com/", yS = "https://www.instagram.com/explore/tags/", xS = "https://twitter.com/", wS = "https://twitter.com/hashtag/", fv = {
  Facebook: {
    handle: vS,
    hashtag: gS
  },
  Instagram: {
    handle: bS,
    hashtag: yS
  },
  Twitter: {
    handle: xS,
    hashtag: wS
  }
}, ES = /(http(s)?:\/\/[\w.~:/?#\[\]@!$&%'()*+,;=-]*)/gu, $S = {
  // eslint-disable-next-line no-useless-escape
  Facebook: /#(?!\d+[\s!#$%&\*]+)[_\p{Alphabetic}\d]+/gu,
  Instagram: (
    // eslint-disable-next-line no-useless-escape
    /(@(?![\w\d]+@)[\w\d](?:\.?[\w\d]+(?:[\w\d.]?[\w\d]))*)|(#(?![\s!#$%&\*]+)[_\p{Alphabetic}\d]+)/gu
  ),
  // eslint-disable-next-line no-useless-escape
  Twitter: /(@(?!\w+@)\w*)|(#(?!\d+[\s!#$%&\*]+)[_\p{Alphabetic}\d]+)/gu
}, TS = /([#@][^>\s]*<match[^>]*>[^<]*<\/match>\S*)|(<match[^>]*>[#@][^<]*<\/match>\S*)/gu, SS = /(?<textBefore>^[^><]*)(?<matchStart><match[^>]*>)(?<text>[^><]*)(?<matchEnd><\/match>)(?<textAfter>[^><]*$)/gu, kS = /[\s!"$%&'()*+,-./:;<=>?[\]^`\{|\}~]/gu, _S = (e, t) => {
  const n = fv[t], r = $S[t], o = t === "Facebook", a = new RegExp(
    TS.source + "|" + r.source + "|" + ES.source,
    "gu"
  );
  return e.replace(a, (s) => {
    if (s != null && s.includes("https://") || s != null && s.includes("http://"))
      return `<a href="${s}" target="_blank">${s}</a>`;
    if (s != null && s.includes("<match")) {
      const c = Array.from(s.matchAll(SS));
      if (c[0]) {
        const l = c[0].groups, d = (
          // @ts-expect-error: Muted so we could enable TS strict mode
          l.textBefore + l.text + l.textAfter
        ), u = l.text.split(kS), v = !l.textBefore.length, m = !l.textAfter.length;
        return d.replace(r, (x) => {
          let g;
          if (v) {
            if (!m && x === u[u.length - 1]) {
              let $ = x.lastIndexOf(l.textAfter);
              $ >= 0 && ($ += l.textAfter.length, g = `${l == null ? void 0 : l.matchStart}${x.substring(
                0,
                $
              )}${// @ts-expect-error: Muted so we could enable TS strict mode
              l.matchEnd}${x.substring($, x.length)}`);
            }
          } else {
            let $ = x.indexOf(l.textBefore);
            $ >= 0 && ($ += l.textBefore.length, g = `${x.substring(
              0,
              $
            )}${// @ts-expect-error: Muted so we could enable TS strict mode
            l.matchStart}${x.substring(
              $,
              x.length
            )}${l == null ? void 0 : l.matchEnd}`);
          }
          return g || (g = `${l.matchStart}${x}${l.matchEnd}`), `<a href="${(!o && (x != null && x.includes("@")) ? n.handle : n.hashtag) + x.slice(1)}" target="_blank">${g}</a>`;
        });
      } else
        return s;
    } else
      return `<a href="${(!o && (s != null && s.includes("@")) ? n.handle : n.hashtag) + s.slice(1)}" target="_blank">${s}</a>`;
  });
}, Lo = ({
  isExtract: e,
  text: t,
  truncate: n,
  showMatches: r = !0,
  showEntities: o = !0,
  socialSource: a,
  hasLightFont: i = !1
}) => {
  const { wikidescriptions: s, wikinames: c } = Ye(bo);
  let l = (t || "").replace(/(&lt;p)|(&lt;)|(p&gt;)/gi, "").trim();
  if (e) {
    const b = Array.from(
      l.matchAll(
        /(?<start>^[^>]*>)(?<middle>.*)(?<end><\/[^>]*>$)/gi
      )
    );
    b.length && (l = `${b[0].groups.start}(...) ${b[0].groups.middle} (...)${b[0].groups.end}`);
  }
  const d = n ? E$(l, n, { html: !a }) : a && fv[a] ? _S(l, a) : l;
  let u = iE.sanitize(d, {
    ALLOWED_TAGS: [
      "p",
      "ul",
      "li",
      "strong",
      "match",
      "ol",
      "a",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "em",
      "ocr"
    ],
    ADD_TAGS: ["h"],
    ALLOWED_ATTR: ["href", "target"],
    ADD_ATTR: ["color", "ent"]
  });
  u = u.replace(/&amp;nbsp;/g, "&nbsp;");
  const v = (b, x) => b && x ? `${b}, ${x}` : b || x || null, m = qe(
    () => ({
      replace: (b) => {
        const { name: x, type: g, children: k, attribs: $, data: T } = b;
        if (g === "text")
          return /* @__PURE__ */ w.jsx("span", { children: T });
        if (x === "p")
          return /* @__PURE__ */ w.jsx("p", { className: "mb-3 last:mb-0", children: /* @__PURE__ */ w.jsx("span", { children: Ta.domToReact(k, m) }) });
        if (x === "a")
          return /* @__PURE__ */ w.jsx("a", { ...$, className: "text-sky.4 hover:text-sky.4", children: /* @__PURE__ */ w.jsx("span", { children: Ta.domToReact(k, m) }) });
        if (x === "ocr" && g === "tag")
          return /* @__PURE__ */ w.jsx(hS, { children: Ta.domToReact(k, m) });
        if (x === "match" && g === "tag") {
          const [S] = k, { ent: C, color: N } = $;
          if (!S)
            return null;
          const U = S;
          if (C && o) {
            const L = C.split(",").map(Number), j = L[0], q = s && s[j] || "", V = c && c[j] || "", Q = v(V, q), ke = L.filter(
              (X, he) => he > 0 && c && c[X] && !q.includes(c[X]) && !V.includes(c[X])
            ).map((X) => c && c[X]), H = Q ? /* @__PURE__ */ w.jsxs("div", { className: "flex flex-col items-start text-left", children: [
              /* @__PURE__ */ w.jsx("strong", { children: Q }),
              ke.length > 0 && /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
                /* @__PURE__ */ w.jsx("hr", { className: "my-2 w-full border-sky.cloudy" }),
                /* @__PURE__ */ w.jsx("ul", { className: "flex list-inside list-disc flex-col items-start", children: ke.map((X, he) => /* @__PURE__ */ w.jsx("li", { className: "ml-2", children: X }, he)) })
              ] })
            ] }) : null;
            return !N || N === "0" ? /* @__PURE__ */ w.jsx(am, { popupContent: H, children: U.data }) : /* @__PURE__ */ w.jsx(qf, { hasLightFont: i, children: /* @__PURE__ */ w.jsx(am, { popupContent: H, children: U.data }) });
          }
          return r ? /* @__PURE__ */ w.jsx(qf, { hasLightFont: i, children: U.data }) : /* @__PURE__ */ w.jsx("span", { children: U.data });
        }
      }
    }),
    [i, o, r, s, c]
  );
  return /* @__PURE__ */ w.jsx(w.Fragment, { children: d$(u, m) });
}, CS = 150, PS = 300, AS = M(
  ({ className: e, customExcerpt: t, ...n }, r) => {
    var v, m;
    const { activeArticle: o, componentsConfig: a } = Rn();
    if (!vn(
      Kt.Excerpt,
      a
    ))
      return null;
    const { summary: i, social_meta: s } = o, l = ((v = o.manual_summary) == null ? void 0 : v.text) ? PS : CS, d = S2({
      summary: (i == null ? void 0 : i.text) || "",
      type: (s == null ? void 0 : s.content_type) || "unknown",
      retweeted_user: (m = s == null ? void 0 : s.attachments) == null ? void 0 : m.retweeted_user
    }), u = Xa(o.first_source.id);
    return /* @__PURE__ */ w.jsx(
      "div",
      {
        ref: r,
        className: z("font-slab text-label-s", e),
        ...n,
        children: /* @__PURE__ */ w.jsx(
          Lo,
          {
            socialSource: u == null ? void 0 : u.name,
            truncate: l,
            text: t || d
          }
        )
      }
    );
  }
);
AS.displayName = "ArticleItem.Excerpt";
const mv = M(({ sourceType: e, socialMediaType: t, className: n, ...r }, o) => {
  if (!e)
    return null;
  const a = lu({ size: 28, sourceType: e, socialMediaType: t });
  return /* @__PURE__ */ w.jsx(
    "div",
    {
      className: z(
        "bg-transparent [&_svg]:h-8 [&_svg]:w-8 [&_svg]:text-sky.cloudy",
        n
      ),
      ...r,
      ref: o,
      children: a
    }
  );
});
mv.displayName = "ArticleSourceAvatarIcon";
const OS = ({
  icon: e,
  imageProxyUrl: t
}) => `${t}/?path=${e}`, Zz = ({
  imageProxyUrl: e,
  url: t,
  width: n
}) => `${e}/?alter_code=true&opoint_max=true&url=${btoa(
  unescape(encodeURIComponent(t))
)}&opoint_x=${n}`, NS = ({
  imageProxyUrl: e,
  url: t,
  height: n,
  width: r
}) => {
  let o = `${e}/?alter_code=true&opoint_crop=true&url=${t}`;
  return r && r > 0 && (o += `&opoint_x=${r}`), n && n > 0 && (o += `&opoint_y=${n}`), o;
}, RS = ({
  imageProxyUrl: e,
  imageUrl: t
}) => `${e}/?alter_code=true&url=${btoa(
  unescape(encodeURIComponent(t))
)}`, MS = (e) => {
  switch (e) {
    case 1:
      return "bg-sky.4";
    case 2:
      return "bg-sea.4";
    case 3:
      return "bg-sand.3";
    case 4:
      return "bg-forest.3";
    default:
      return "bg-sea.1";
  }
}, pv = M(
  ({
    article: e,
    renderImage: t,
    smallIcon: n,
    profileImageUrl: r = "",
    showLogo: o,
    className: a,
    ...i
  }, s) => {
    var Q;
    const { imageProxyUrl: c } = Ye(bo), { mediatype: l, first_source: d, icon: u } = e, v = Ka(e), m = Xa(d.id), b = !!(e.articleimages && e.articleimages.articleimage && e.articleimages.count), x = qe(() => {
      var ke, H;
      return !o && b ? NS({
        url: ((H = (ke = e.articleimages) == null ? void 0 : ke.articleimage[0]) == null ? void 0 : H.url) || "",
        imageProxyUrl: c,
        width: 100,
        height: 100
      }) : u !== void 0 ? OS({
        icon: u,
        imageProxyUrl: c
      }) : null;
    }, [
      u,
      b,
      c,
      o,
      (Q = e.articleimages) == null ? void 0 : Q.articleimage
    ]), g = t ? x : "", [k, $] = Ce(!!g), [T, S] = Ce(!1), C = d.sitename.trim().replace(/\s\s+/g, " "), N = ["Instagram"].includes(d.sitename), U = RS({
      imageProxyUrl: c,
      imageUrl: r
    }), L = () => {
      S(!0), $(!1);
    }, j = {
      title: C ? C.split(" ").slice(0, 2).map((ke) => {
        var H;
        return (H = ke[0]) == null ? void 0 : H.toUpperCase();
      }).join("") : "",
      backgroundClassname: MS(C.length % 5)
    }, q = m == null ? void 0 : m.icon;
    if (v)
      return /* @__PURE__ */ w.jsx(
        "div",
        {
          className: z(
            "flex h-full w-full items-center justify-center overflow-hidden rounded-full fill-sky.cloudy text-3xl",
            {
              "text-sm text-white": n,
              "bg-grey.7": !t || !r || T
            },
            a
          ),
          title: d.sitename,
          ref: s,
          ...i,
          children: t && r && !T ? /* @__PURE__ */ w.jsx(
            "img",
            {
              src: N ? U : r,
              onError: L,
              width: "80",
              height: "80",
              loading: "lazy",
              alt: "Article",
              crossOrigin: "anonymous",
              className: "mb-0 rounded-full bg-grey.7"
            }
          ) : /* @__PURE__ */ w.jsx(
            mv,
            {
              sourceType: l == null ? void 0 : l.text,
              socialMediaType: q
            }
          )
        }
      );
    const V = !g || !k || !t;
    return /* @__PURE__ */ w.jsx(
      "div",
      {
        className: z("rounded bg-grey.7", {
          [j.backgroundClassname]: V,
          "h-full flex justify-center items-center": V,
          "text-sm text-white": n,
          className: a
        }),
        title: d.sitename,
        ref: s,
        ...i,
        children: k ? /* @__PURE__ */ w.jsx(
          "img",
          {
            src: g || "",
            onError: L,
            width: "80",
            height: "80",
            loading: "lazy",
            alt: "Article"
          }
        ) : /* @__PURE__ */ w.jsx("div", { className: "text-2xl font-medium text-white", children: j.title })
      }
    );
  }
);
pv.displayName = "ArticleSourceAvatar";
const DS = M(
  ({ icon: e, className: t, ...n }, r) => {
    const { activeArticle: o, componentsConfig: a } = Rn();
    if (!vn(
      Kt.Thumbnail,
      a
    ))
      return null;
    const { social_meta: i } = o, s = i == null ? void 0 : i.author, c = Ka(o);
    return /* @__PURE__ */ w.jsxs(
      "div",
      {
        ref: r,
        className: z(
          "h-20 w-20 shrink-0 [&_img]:h-20 [&_img]:w-20 [&_img]:rounded",
          t
        ),
        ...n,
        children: [
          /* @__PURE__ */ w.jsx(
            pv,
            {
              article: o,
              profileImageUrl: c ? s == null ? void 0 : s.profile_image : void 0,
              renderImage: !0
            }
          ),
          c && e && /* @__PURE__ */ w.jsx("div", { className: "relative bottom-7 left-[3.25rem] flex h-6 w-6 items-center justify-center rounded-full border border-sky.1 bg-white fill-sky.1 [&>span]:text-lg", children: /* @__PURE__ */ w.jsx(e, {}) })
        ]
      }
    );
  }
);
DS.displayName = "ArticleItem.Image";
const IS = M(
  ({ className: e, customTitle: t, ...n }, r) => {
    const { activeArticle: o, articleLayout: a } = Rn(), { editedArticles: i } = Ye(bo), s = Ka(o), {
      id_site: c,
      id_article: l,
      header: d,
      short_header: u,
      summary: v,
      translated_header: m
    } = o, b = i.includes(`${c}_${l}`), x = qe(() => m ? {
      translated: m.text,
      original: d == null ? void 0 : d.text
    } : null, [d == null ? void 0 : d.text, m]), g = qe(() => s ? v == null ? void 0 : v.text : x ? b ? d == null ? void 0 : d.text : x.translated : b ? d == null ? void 0 : d.text : (u == null ? void 0 : u.text) || (d == null ? void 0 : d.text), [
      d == null ? void 0 : d.text,
      b,
      s,
      u == null ? void 0 : u.text,
      v == null ? void 0 : v.text,
      x
    ]);
    return /* @__PURE__ */ w.jsx(
      "h3",
      {
        ref: r,
        className: z(
          "font-slab",
          s ? "text-label-s" : "text-body",
          {
            "text-label-l font-medium": a === Hr.COMPACT
          },
          e
        ),
        ...n,
        children: /* @__PURE__ */ w.jsx(Lo, { text: t || g })
      }
    );
  }
);
IS.displayName = "ArticleItem.Title";
const jS = M(({ customSubtitle: e, className: t, ...n }, r) => {
  const { activeArticle: o } = Rn(), { editedArticles: a } = Ye(bo), i = Ka(o), { id_site: s, id_article: c, header: l, translated_header: d } = o, u = a.includes(`${s}_${c}`), v = qe(() => d ? {
    translated: d.text,
    original: l == null ? void 0 : l.text
  } : null, [l == null ? void 0 : l.text, d]), m = qe(() => v && !i ? u ? l == null ? void 0 : l.text : v.original : null, [l == null ? void 0 : l.text, u, i, v]);
  return !i && (m || e) ? /* @__PURE__ */ w.jsx(
    "p",
    {
      ref: r,
      className: z("font-slab text-label-l text-sky.cloudy", t),
      ...n,
      children: /* @__PURE__ */ w.jsx(
        Lo,
        {
          text: e || m
        }
      )
    }
  ) : /* @__PURE__ */ w.jsx(w.Fragment, {});
});
jS.displayName = "ArticleItem.Subtitle";
const LS = ({
  point: e
}) => {
  var t;
  return /* @__PURE__ */ w.jsxs(Bs, { disableHoverableContent: !0, children: [
    /* @__PURE__ */ w.jsx(Iu, { asChild: !0, children: /* @__PURE__ */ w.jsx(
      "li",
      {
        className: "absolute top-1/2 block h-2 w-2 -translate-y-1/2 rounded-full bg-grey.5",
        style: { left: e.middle }
      }
    ) }),
    /* @__PURE__ */ w.jsx(ju, { children: /* @__PURE__ */ w.jsx(zs, { side: "top", children: /* @__PURE__ */ w.jsx(Lo, { text: (t = e == null ? void 0 : e.quote) == null ? void 0 : t.text, hasLightFont: !0 }) }) })
  ] });
}, im = 3, Qz = () => {
  var a;
  const { activeArticle: e, articleLayout: t, componentsConfig: n } = Rn();
  if (!vn(
    Kt.MentionsBar,
    n
  ))
    return null;
  const { colorbar: r } = e;
  return !(r != null && r.item) || !r.item.filter(
    ({ quote: i, color: s }) => !(!i || !i.text || s <= im)
  ).length ? null : /* @__PURE__ */ w.jsx("div", { className: "pb-2", children: /* @__PURE__ */ w.jsx(
    "ul",
    {
      className: z("relative mt-4 h-[0.0625rem] w-full bg-grey.6", {
        "mt-3": t === Hr.COMPACT
      }),
      children: (a = r.item) == null ? void 0 : a.map((i, s) => !i.quote || !i.quote.text || i.color <= im ? null : /* @__PURE__ */ w.jsx(LS, { point: i }, s))
    }
  ) });
}, FS = M(({ maxVisibleEntries: e = 5, ...t }, n) => {
  const { article: r, onSetArticleSource: o, activeArticle: a } = Rn(), { locale: i, dateVariant: s } = Ye(bo), c = qe(() => uh({
    mainArticle: r,
    similarArticles: uu(r)
  }).sort((T, S) => T.similarity === 0 && S.similarity !== 0 ? -1 : S.similarity === 0 && T.similarity !== 0 ? 1 : S.similarity - T.similarity), [r]), l = c.slice(0, e), [d, u] = Ce(a), [v, m] = Ce(l);
  if (v.length === 0)
    return null;
  const b = v.length === c.length, x = () => {
    m(b ? l : c);
  }, g = (k) => {
    o == null || o(Qt(k)), u(k);
  };
  return /* @__PURE__ */ w.jsx(Cs, { instance: Za, children: /* @__PURE__ */ w.jsxs("div", { ref: n, ...t, children: [
    /* @__PURE__ */ w.jsx("div", { className: "flex flex-col gap-y-1 border-y border-y-grey.6 py-2", children: v.map((k, $) => {
      const {
        first_source: T,
        topics: S,
        mediatype: C,
        similarity: N,
        unix_timestamp: U
      } = k, L = du({
        topics: S || [],
        mediatype: C == null ? void 0 : C.text
      }), j = Xa(T.id), q = (j == null ? void 0 : j.name) || T.name, V = Qt(d) === Qt(k);
      return $ === 0 ? /* @__PURE__ */ w.jsxs(
        "button",
        {
          type: "button",
          className: "flex justify-between gap-x-1 text-sm font-medium text-sky.1",
          onClick: () => g(k),
          children: [
            /* @__PURE__ */ w.jsxs("div", { className: "flex gap-x-1.5", children: [
              /* @__PURE__ */ w.jsx(
                "div",
                {
                  className: z(
                    "invisible flex items-center justify-center",
                    {
                      "visible ": V
                    }
                  ),
                  children: /* @__PURE__ */ w.jsx(ff, {})
                }
              ),
              /* @__PURE__ */ w.jsx("div", { children: us({
                dateVariant: s,
                localeName: i,
                unixTimestamp: U
              }) }),
              /* @__PURE__ */ w.jsx("span", { children: "|" }),
              /* @__PURE__ */ w.jsx("div", { className: "truncate", children: q })
            ] }),
            /* @__PURE__ */ w.jsxs("div", { children: [
              /* @__PURE__ */ w.jsx(
                Vs,
                {
                  mediaType: L,
                  socialMediaType: j == null ? void 0 : j.icon
                }
              ),
              /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: L })
            ] })
          ]
        },
        Qt(k)
      ) : /* @__PURE__ */ w.jsxs(
        "button",
        {
          type: "button",
          className: "flex justify-between gap-x-1 text-sm font-normal text-grey.1",
          onClick: () => g(k),
          children: [
            /* @__PURE__ */ w.jsxs("div", { className: "flex gap-x-1.5", children: [
              /* @__PURE__ */ w.jsx(
                "span",
                {
                  className: z(
                    "invisible flex items-center justify-center text-sky.1",
                    {
                      "visible ": V
                    }
                  ),
                  children: /* @__PURE__ */ w.jsx(ff, {})
                }
              ),
              /* @__PURE__ */ w.jsx("span", { className: "text-grey.1", children: us({
                dateVariant: s,
                localeName: i,
                unixTimestamp: U
              }) }),
              /* @__PURE__ */ w.jsx("span", { children: "|" }),
              /* @__PURE__ */ w.jsx("span", { className: "truncate", children: q })
            ] }),
            /* @__PURE__ */ w.jsxs("span", { children: [
              N === 0 ? 100 : N,
              "%"
            ] })
          ]
        },
        Qt(k)
      );
    }) }),
    c.length > e && /* @__PURE__ */ w.jsxs("div", { className: "ml-[18px] mr-0.5 mt-1.5 flex items-center justify-between text-sm", children: [
      /* @__PURE__ */ w.jsxs("div", { className: "font-normal text-grey.3", children: [
        c.length,
        " ",
        /* @__PURE__ */ w.jsx(Fr, { _str: "sources" })
      ] }),
      /* @__PURE__ */ w.jsx(
        vo,
        {
          type: "button",
          variant: "text",
          className: "h-4 p-0",
          onClick: x,
          children: b ? /* @__PURE__ */ w.jsx(Fr, { _str: "Show less" }) : /* @__PURE__ */ w.jsx(Fr, { _str: "Show all" })
        }
      )
    ] })
  ] }) });
});
FS.displayName = "ArticleItemSimilarArticlesListing";
const WS = ({
  similarity: e
}) => /* @__PURE__ */ w.jsx(Cs, { instance: Za, children: /* @__PURE__ */ w.jsx("span", { children: e ? /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
  e,
  "% ",
  /* @__PURE__ */ w.jsx(Fr, { _str: "similar" })
] }) : /* @__PURE__ */ w.jsx(Fr, { _str: "Identical" }) }) });
function as(e) {
  "@babel/helpers - typeof";
  return as = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, as(e);
}
function Xn(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Ot(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Lt(e) {
  Ot(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || as(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function HS(e, t) {
  Ot(2, arguments);
  var n = Lt(e), r = Xn(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function US(e, t) {
  Ot(2, arguments);
  var n = Lt(e).getTime(), r = Xn(t);
  return new Date(n + r);
}
var BS = {};
function qo() {
  return BS;
}
function uo(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function is(e) {
  Ot(1, arguments);
  var t = Lt(e);
  return t.setHours(0, 0, 0, 0), t;
}
var zS = 864e5;
function hv(e, t) {
  Ot(2, arguments);
  var n = is(e), r = is(t), o = n.getTime() - uo(n), a = r.getTime() - uo(r);
  return Math.round((o - a) / zS);
}
function VS(e, t) {
  Ot(2, arguments);
  var n = Lt(e), r = Lt(t), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
function vv(e, t) {
  Ot(2, arguments);
  var n = is(e), r = is(t);
  return n.getTime() === r.getTime();
}
function GS(e) {
  return Ot(1, arguments), e instanceof Date || as(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function qS(e) {
  if (Ot(1, arguments), !GS(e) && typeof e != "number")
    return !1;
  var t = Lt(e);
  return !isNaN(Number(t));
}
function sm(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function YS(e, t) {
  Ot(2, arguments);
  var n = Lt(e), r = Lt(t), o = sm(n, r), a = Math.abs(hv(n, r));
  n.setDate(n.getDate() - o * a);
  var i = +(sm(n, r) === -o), s = o * (a - i);
  return s === 0 ? 0 : s;
}
function Sl(e, t) {
  Ot(2, arguments);
  var n = Xn(t);
  return US(e, -n);
}
var KS = 864e5;
function XS(e) {
  Ot(1, arguments);
  var t = Lt(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), o = n - r;
  return Math.floor(o / KS) + 1;
}
function ss(e) {
  Ot(1, arguments);
  var t = 1, n = Lt(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function gv(e) {
  Ot(1, arguments);
  var t = Lt(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = ss(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = ss(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function ZS(e) {
  Ot(1, arguments);
  var t = gv(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = ss(n);
  return r;
}
var QS = 6048e5;
function JS(e) {
  Ot(1, arguments);
  var t = Lt(e), n = ss(t).getTime() - ZS(t).getTime();
  return Math.round(n / QS) + 1;
}
function cs(e, t) {
  var n, r, o, a, i, s, c, l;
  Ot(1, arguments);
  var d = qo(), u = Xn((n = (r = (o = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && o !== void 0 ? o : d.weekStartsOn) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(u >= 0 && u <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var v = Lt(e), m = v.getUTCDay(), b = (m < u ? 7 : 0) + m - u;
  return v.setUTCDate(v.getUTCDate() - b), v.setUTCHours(0, 0, 0, 0), v;
}
function bv(e, t) {
  var n, r, o, a, i, s, c, l;
  Ot(1, arguments);
  var d = Lt(e), u = d.getUTCFullYear(), v = qo(), m = Xn((n = (r = (o = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : v.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = v.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(u + 1, 0, m), b.setUTCHours(0, 0, 0, 0);
  var x = cs(b, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(u, 0, m), g.setUTCHours(0, 0, 0, 0);
  var k = cs(g, t);
  return d.getTime() >= x.getTime() ? u + 1 : d.getTime() >= k.getTime() ? u : u - 1;
}
function ek(e, t) {
  var n, r, o, a, i, s, c, l;
  Ot(1, arguments);
  var d = qo(), u = Xn((n = (r = (o = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && o !== void 0 ? o : d.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), v = bv(e, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(v, 0, u), m.setUTCHours(0, 0, 0, 0);
  var b = cs(m, t);
  return b;
}
var tk = 6048e5;
function nk(e, t) {
  Ot(1, arguments);
  var n = Lt(e), r = cs(n, t).getTime() - ek(n, t).getTime();
  return Math.round(r / tk) + 1;
}
function At(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var rk = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return At(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : At(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return At(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return At(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return At(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return At(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return At(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, o = t.getUTCMilliseconds(), a = Math.floor(o * Math.pow(10, r - 3));
    return At(a, n.length);
  }
};
const Ir = rk;
var Co = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ok = {
  // Era
  G: function(t, n, r) {
    var o = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var o = t.getUTCFullYear(), a = o > 0 ? o : 1 - o;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Ir.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, o) {
    var a = bv(t, o), i = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var s = i % 100;
      return At(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : At(i, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = gv(t);
    return At(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return At(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return At(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return At(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Ir.M(t, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return At(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, o) {
    var a = nk(t, o);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : At(a, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var o = JS(t);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : At(o, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Ir.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var o = XS(t);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : At(o, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var o = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, o) {
    var a = t.getUTCDay(), i = (a - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return At(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, o) {
    var a = t.getUTCDay(), i = (a - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return At(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var o = t.getUTCDay(), a = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(a);
      case "ii":
        return At(a, n.length);
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var o = t.getUTCHours(), a = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var o = t.getUTCHours(), a;
    switch (o === 12 ? a = Co.noon : o === 0 ? a = Co.midnight : a = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var o = t.getUTCHours(), a;
    switch (o >= 17 ? a = Co.evening : o >= 12 ? a = Co.afternoon : o >= 4 ? a = Co.morning : a = Co.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var o = t.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return Ir.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Ir.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var o = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : At(o, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var o = t.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : At(o, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Ir.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Ir.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Ir.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return lm(i);
      case "XXXX":
      case "XX":
        return to(i);
      case "XXXXX":
      case "XXX":
      default:
        return to(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "x":
        return lm(i);
      case "xxxx":
      case "xx":
        return to(i);
      case "xxxxx":
      case "xxx":
      default:
        return to(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + cm(i, ":");
      case "OOOO":
      default:
        return "GMT" + to(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + cm(i, ":");
      case "zzzz":
      default:
        return "GMT" + to(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, o) {
    var a = o._originalDate || t, i = Math.floor(a.getTime() / 1e3);
    return At(i, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTime();
    return At(i, n.length);
  }
};
function cm(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(o);
  var i = t || "";
  return n + String(o) + i + At(a, 2);
}
function lm(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + At(Math.abs(e) / 60, 2);
  }
  return to(e, t);
}
function to(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), a = At(Math.floor(o / 60), 2), i = At(o % 60, 2);
  return r + a + n + i;
}
const ak = ok;
var um = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, yv = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, ik = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], o = r[1], a = r[2];
  if (!a)
    return um(t, n);
  var i;
  switch (o) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", um(o, n)).replace("{{time}}", yv(a, n));
}, sk = {
  p: yv,
  P: ik
};
const ck = sk;
var lk = ["D", "DD"], uk = ["YY", "YYYY"];
function dk(e) {
  return lk.indexOf(e) !== -1;
}
function fk(e) {
  return uk.indexOf(e) !== -1;
}
function dm(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var mk = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, pk = function(t, n, r) {
  var o, a = mk[t];
  return typeof a == "string" ? o = a : n === 1 ? o = a.one : o = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const xv = pk;
function Bt(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var hk = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, vk = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, gk = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, bk = {
  date: Bt({
    formats: hk,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: vk,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: gk,
    defaultWidth: "full"
  })
};
const yk = bk;
var xk = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, wk = function(t, n, r, o) {
  return xk[t];
};
const wv = wk;
function dt(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[i] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[l];
  };
}
var Ek = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, $k = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Tk = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Sk = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, kk = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, _k = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ck = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Pk = {
  ordinalNumber: Ck,
  era: dt({
    values: Ek,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: $k,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: dt({
    values: Tk,
    defaultWidth: "wide"
  }),
  day: dt({
    values: Sk,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: kk,
    defaultWidth: "wide",
    formattingValues: _k,
    defaultFormattingWidth: "wide"
  })
};
const Ev = Pk;
function ft(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    var i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Ok(s, function(u) {
      return u.test(i);
    }) : Ak(s, function(u) {
      return u.test(i);
    }), l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
    var d = t.slice(i.length);
    return {
      value: l,
      rest: d
    };
  };
}
function Ak(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function Ok(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function yo(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var o = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    var i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var s = t.slice(o.length);
    return {
      value: i,
      rest: s
    };
  };
}
var Nk = /^(\d+)(th|st|nd|rd)?/i, Rk = /\d+/i, Mk = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Dk = {
  any: [/^b/i, /^(a|c)/i]
}, Ik = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, jk = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Lk = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Fk = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Wk = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Hk = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Uk = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Bk = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, zk = {
  ordinalNumber: yo({
    matchPattern: Nk,
    parsePattern: Rk,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ft({
    matchPatterns: Mk,
    defaultMatchWidth: "wide",
    parsePatterns: Dk,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: Ik,
    defaultMatchWidth: "wide",
    parsePatterns: jk,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ft({
    matchPatterns: Lk,
    defaultMatchWidth: "wide",
    parsePatterns: Fk,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: Wk,
    defaultMatchWidth: "wide",
    parsePatterns: Hk,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: Uk,
    defaultMatchWidth: "any",
    parsePatterns: Bk,
    defaultParseWidth: "any"
  })
};
const $v = zk;
var Vk = {
  code: "en-US",
  formatDistance: xv,
  formatLong: yk,
  formatRelative: wv,
  localize: Ev,
  match: $v,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Lu = Vk;
var Gk = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, qk = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Yk = /^'([^]*?)'?$/, Kk = /''/g, Xk = /[a-zA-Z]/;
function ya(e, t, n) {
  var r, o, a, i, s, c, l, d, u, v, m, b, x, g, k, $, T, S;
  Ot(2, arguments);
  var C = String(t), N = qo(), U = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : N.locale) !== null && r !== void 0 ? r : Lu, L = Xn((a = (i = (s = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (l = n.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && s !== void 0 ? s : N.firstWeekContainsDate) !== null && i !== void 0 ? i : (u = N.locale) === null || u === void 0 || (v = u.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(L >= 1 && L <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var j = Xn((m = (b = (x = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (k = n.locale) === null || k === void 0 || ($ = k.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && x !== void 0 ? x : N.weekStartsOn) !== null && b !== void 0 ? b : (T = N.locale) === null || T === void 0 || (S = T.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(j >= 0 && j <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!U.localize)
    throw new RangeError("locale must contain localize property");
  if (!U.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var q = Lt(e);
  if (!qS(q))
    throw new RangeError("Invalid time value");
  var V = uo(q), Q = Sl(q, V), ke = {
    firstWeekContainsDate: L,
    weekStartsOn: j,
    locale: U,
    _originalDate: q
  }, H = C.match(qk).map(function(X) {
    var he = X[0];
    if (he === "p" || he === "P") {
      var $e = ck[he];
      return $e(X, U.formatLong);
    }
    return X;
  }).join("").match(Gk).map(function(X) {
    if (X === "''")
      return "'";
    var he = X[0];
    if (he === "'")
      return Zk(X);
    var $e = ak[he];
    if ($e)
      return !(n != null && n.useAdditionalWeekYearTokens) && fk(X) && dm(X, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && dk(X) && dm(X, t, String(e)), $e(Q, X, U.localize, ke);
    if (he.match(Xk))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + he + "`");
    return X;
  }).join("");
  return H;
}
function Zk(e) {
  var t = e.match(Yk);
  return t ? t[1].replace(Kk, "'") : e;
}
function Tv(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function Qk(e) {
  return Tv({}, e);
}
var fm = 1e3 * 60, ls = 60 * 24, mm = ls * 30, pm = ls * 365;
function Jk(e, t, n) {
  var r, o, a;
  Ot(2, arguments);
  var i = qo(), s = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : i.locale) !== null && r !== void 0 ? r : Lu;
  if (!s.formatDistance)
    throw new RangeError("locale must contain localize.formatDistance property");
  var c = VS(e, t);
  if (isNaN(c))
    throw new RangeError("Invalid time value");
  var l = Tv(Qk(n), {
    addSuffix: !!(n != null && n.addSuffix),
    comparison: c
  }), d, u;
  c > 0 ? (d = Lt(t), u = Lt(e)) : (d = Lt(e), u = Lt(t));
  var v = String((a = n == null ? void 0 : n.roundingMethod) !== null && a !== void 0 ? a : "round"), m;
  if (v === "floor")
    m = Math.floor;
  else if (v === "ceil")
    m = Math.ceil;
  else if (v === "round")
    m = Math.round;
  else
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  var b = u.getTime() - d.getTime(), x = b / fm, g = uo(u) - uo(d), k = (b - g) / fm, $ = n == null ? void 0 : n.unit, T;
  if ($ ? T = String($) : x < 1 ? T = "second" : x < 60 ? T = "minute" : x < ls ? T = "hour" : k < mm ? T = "day" : k < pm ? T = "month" : T = "year", T === "second") {
    var S = m(b / 1e3);
    return s.formatDistance("xSeconds", S, l);
  } else if (T === "minute") {
    var C = m(x);
    return s.formatDistance("xMinutes", C, l);
  } else if (T === "hour") {
    var N = m(x / 60);
    return s.formatDistance("xHours", N, l);
  } else if (T === "day") {
    var U = m(k / ls);
    return s.formatDistance("xDays", U, l);
  } else if (T === "month") {
    var L = m(k / mm);
    return L === 12 && $ !== "month" ? s.formatDistance("xYears", 1, l) : s.formatDistance("xMonths", L, l);
  } else if (T === "year") {
    var j = m(k / pm);
    return s.formatDistance("xYears", j, l);
  }
  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}
function e5(e, t, n) {
  var r, o, a, i, s, c, l, d, u, v;
  Ot(2, arguments);
  var m = Lt(e), b = Lt(t), x = qo(), g = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : x.locale) !== null && r !== void 0 ? r : Lu, k = Xn((a = (i = (s = (c = n == null ? void 0 : n.weekStartsOn) !== null && c !== void 0 ? c : n == null || (l = n.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && s !== void 0 ? s : x.weekStartsOn) !== null && i !== void 0 ? i : (u = x.locale) === null || u === void 0 || (v = u.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!g.localize)
    throw new RangeError("locale must contain localize property");
  if (!g.formatLong)
    throw new RangeError("locale must contain formatLong property");
  if (!g.formatRelative)
    throw new RangeError("locale must contain formatRelative property");
  var $ = hv(m, b);
  if (isNaN($))
    throw new RangeError("Invalid time value");
  var T;
  $ < -6 ? T = "other" : $ < -1 ? T = "lastWeek" : $ < 0 ? T = "yesterday" : $ < 1 ? T = "today" : $ < 2 ? T = "tomorrow" : $ < 7 ? T = "nextWeek" : T = "other";
  var S = Sl(m, uo(m)), C = Sl(b, uo(b)), N = g.formatRelative(T, S, C, {
    locale: g,
    weekStartsOn: k
  });
  return ya(m, N, {
    locale: g,
    weekStartsOn: k
  });
}
function hm(e) {
  Ot(1, arguments);
  var t = Xn(e);
  return Lt(t * 1e3);
}
function t5(e, t) {
  Ot(2, arguments);
  var n = Lt(e), r = Lt(t);
  return n.getFullYear() === r.getFullYear();
}
function n5(e) {
  return Ot(1, arguments), vv(e, Date.now());
}
function r5(e, t) {
  Ot(2, arguments);
  var n = Xn(t);
  return HS(e, -n);
}
function o5(e) {
  return Ot(1, arguments), vv(e, r5(Date.now(), 1));
}
var a5 = function(t = window) {
  return !!(t.loki && t.loki.isRunning);
};
const i5 = /* @__PURE__ */ $s(a5);
var s5 = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, c5 = function(t, n, r) {
  var o, a = s5[t];
  return typeof a == "string" ? o = a : n === 1 ? o = a.one : o = a.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + o : o + " siden" : o;
};
const l5 = c5;
var u5 = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, d5 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, f5 = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, m5 = {
  date: Bt({
    formats: u5,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: d5,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: f5,
    defaultWidth: "full"
  })
};
const p5 = m5;
var h5 = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, v5 = function(t, n, r, o) {
  return h5[t];
};
const g5 = v5;
var b5 = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, y5 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, x5 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, w5 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, E5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, $5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, T5 = function(t, n) {
  var r = Number(t);
  return r + ".";
}, S5 = {
  ordinalNumber: T5,
  era: dt({
    values: b5,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: y5,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: dt({
    values: x5,
    defaultWidth: "wide"
  }),
  day: dt({
    values: w5,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: E5,
    defaultWidth: "wide",
    formattingValues: $5,
    defaultFormattingWidth: "wide"
  })
};
const k5 = S5;
var _5 = /^(\d+)(\.)?/i, C5 = /\d+/i, P5 = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, A5 = {
  any: [/^f/i, /^(v|e)/i]
}, O5 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, N5 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, R5 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, M5 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, D5 = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, I5 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, j5 = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, L5 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, F5 = {
  ordinalNumber: yo({
    matchPattern: _5,
    parsePattern: C5,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ft({
    matchPatterns: P5,
    defaultMatchWidth: "wide",
    parsePatterns: A5,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: O5,
    defaultMatchWidth: "wide",
    parsePatterns: N5,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ft({
    matchPatterns: R5,
    defaultMatchWidth: "wide",
    parsePatterns: M5,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: D5,
    defaultMatchWidth: "wide",
    parsePatterns: I5,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: j5,
    defaultMatchWidth: "any",
    parsePatterns: L5,
    defaultParseWidth: "any"
  })
};
const W5 = F5;
var H5 = {
  code: "da",
  formatDistance: l5,
  formatLong: p5,
  formatRelative: g5,
  localize: k5,
  match: W5,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const U5 = H5;
var B5 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, z5 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, V5 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, G5 = {
  date: Bt({
    formats: B5,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: z5,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: V5,
    defaultWidth: "full"
  })
};
const q5 = G5;
var Y5 = {
  code: "en-GB",
  formatDistance: xv,
  formatLong: q5,
  formatRelative: wv,
  localize: Ev,
  match: $v,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const K5 = Y5;
var vm = {
  lessThanXSeconds: {
    standalone: {
      one: "vähem kui üks sekund",
      other: "vähem kui {{count}} sekundit"
    },
    withPreposition: {
      one: "vähem kui ühe sekundi",
      other: "vähem kui {{count}} sekundi"
    }
  },
  xSeconds: {
    standalone: {
      one: "üks sekund",
      other: "{{count}} sekundit"
    },
    withPreposition: {
      one: "ühe sekundi",
      other: "{{count}} sekundi"
    }
  },
  halfAMinute: {
    standalone: "pool minutit",
    withPreposition: "poole minuti"
  },
  lessThanXMinutes: {
    standalone: {
      one: "vähem kui üks minut",
      other: "vähem kui {{count}} minutit"
    },
    withPreposition: {
      one: "vähem kui ühe minuti",
      other: "vähem kui {{count}} minuti"
    }
  },
  xMinutes: {
    standalone: {
      one: "üks minut",
      other: "{{count}} minutit"
    },
    withPreposition: {
      one: "ühe minuti",
      other: "{{count}} minuti"
    }
  },
  aboutXHours: {
    standalone: {
      one: "umbes üks tund",
      other: "umbes {{count}} tundi"
    },
    withPreposition: {
      one: "umbes ühe tunni",
      other: "umbes {{count}} tunni"
    }
  },
  xHours: {
    standalone: {
      one: "üks tund",
      other: "{{count}} tundi"
    },
    withPreposition: {
      one: "ühe tunni",
      other: "{{count}} tunni"
    }
  },
  xDays: {
    standalone: {
      one: "üks päev",
      other: "{{count}} päeva"
    },
    withPreposition: {
      one: "ühe päeva",
      other: "{{count}} päeva"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "umbes üks nädal",
      other: "umbes {{count}} nädalat"
    },
    withPreposition: {
      one: "umbes ühe nädala",
      other: "umbes {{count}} nädala"
    }
  },
  xWeeks: {
    standalone: {
      one: "üks nädal",
      other: "{{count}} nädalat"
    },
    withPreposition: {
      one: "ühe nädala",
      other: "{{count}} nädala"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "umbes üks kuu",
      other: "umbes {{count}} kuud"
    },
    withPreposition: {
      one: "umbes ühe kuu",
      other: "umbes {{count}} kuu"
    }
  },
  xMonths: {
    standalone: {
      one: "üks kuu",
      other: "{{count}} kuud"
    },
    withPreposition: {
      one: "ühe kuu",
      other: "{{count}} kuu"
    }
  },
  aboutXYears: {
    standalone: {
      one: "umbes üks aasta",
      other: "umbes {{count}} aastat"
    },
    withPreposition: {
      one: "umbes ühe aasta",
      other: "umbes {{count}} aasta"
    }
  },
  xYears: {
    standalone: {
      one: "üks aasta",
      other: "{{count}} aastat"
    },
    withPreposition: {
      one: "ühe aasta",
      other: "{{count}} aasta"
    }
  },
  overXYears: {
    standalone: {
      one: "rohkem kui üks aasta",
      other: "rohkem kui {{count}} aastat"
    },
    withPreposition: {
      one: "rohkem kui ühe aasta",
      other: "rohkem kui {{count}} aasta"
    }
  },
  almostXYears: {
    standalone: {
      one: "peaaegu üks aasta",
      other: "peaaegu {{count}} aastat"
    },
    withPreposition: {
      one: "peaaegu ühe aasta",
      other: "peaaegu {{count}} aasta"
    }
  }
}, X5 = function(t, n, r) {
  var o = r != null && r.addSuffix ? vm[t].withPreposition : vm[t].standalone, a;
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? a + " pärast" : a + " eest" : a;
};
const Z5 = X5;
var Q5 = {
  full: "EEEE, d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, J5 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, e_ = {
  full: "{{date}} 'kell' {{time}}",
  long: "{{date}} 'kell' {{time}}",
  medium: "{{date}}. {{time}}",
  short: "{{date}}. {{time}}"
}, t_ = {
  date: Bt({
    formats: Q5,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: J5,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: e_,
    defaultWidth: "full"
  })
};
const n_ = t_;
var r_ = {
  lastWeek: "'eelmine' eeee 'kell' p",
  yesterday: "'eile kell' p",
  today: "'täna kell' p",
  tomorrow: "'homme kell' p",
  nextWeek: "'järgmine' eeee 'kell' p",
  other: "P"
}, o_ = function(t, n, r, o) {
  return r_[t];
};
const a_ = o_;
var i_ = {
  narrow: ["e.m.a", "m.a.j"],
  abbreviated: ["e.m.a", "m.a.j"],
  wide: ["enne meie ajaarvamist", "meie ajaarvamise järgi"]
}, s_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, gm = {
  narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jaan", "veebr", "märts", "apr", "mai", "juuni", "juuli", "aug", "sept", "okt", "nov", "dets"],
  wide: ["jaanuar", "veebruar", "märts", "aprill", "mai", "juuni", "juuli", "august", "september", "oktoober", "november", "detsember"]
}, bm = {
  narrow: ["P", "E", "T", "K", "N", "R", "L"],
  short: ["P", "E", "T", "K", "N", "R", "L"],
  abbreviated: ["pühap.", "esmasp.", "teisip.", "kolmap.", "neljap.", "reede.", "laup."],
  wide: ["pühapäev", "esmaspäev", "teisipäev", "kolmapäev", "neljapäev", "reede", "laupäev"]
}, c_ = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  }
}, l_ = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  }
}, u_ = function(t, n) {
  var r = Number(t);
  return r + ".";
}, d_ = {
  ordinalNumber: u_,
  era: dt({
    values: i_,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: s_,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: dt({
    values: gm,
    defaultWidth: "wide",
    formattingValues: gm,
    defaultFormattingWidth: "wide"
  }),
  day: dt({
    values: bm,
    defaultWidth: "wide",
    formattingValues: bm,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: dt({
    values: c_,
    defaultWidth: "wide",
    formattingValues: l_,
    defaultFormattingWidth: "wide"
  })
};
const f_ = d_;
var m_ = /^\d+\./i, p_ = /\d+/i, h_ = {
  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
}, v_ = {
  any: [/^e/i, /^(m|p)/i]
}, g_ = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, b_ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, y_ = {
  narrow: /^[jvmasond]/i,
  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
}, x_ = {
  narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^juun/i, /^juul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, w_ = {
  narrow: /^[petknrl]/i,
  short: /^[petknrl]/i,
  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
}, E_ = {
  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
}, $_ = {
  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
}, T_ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^keskö/i,
    noon: /^keskp/i,
    morning: /hommik/i,
    afternoon: /pärastlõuna/i,
    evening: /õhtu/i,
    night: /öö/i
  }
}, S_ = {
  ordinalNumber: yo({
    matchPattern: m_,
    parsePattern: p_,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ft({
    matchPatterns: h_,
    defaultMatchWidth: "wide",
    parsePatterns: v_,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: g_,
    defaultMatchWidth: "wide",
    parsePatterns: b_,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ft({
    matchPatterns: y_,
    defaultMatchWidth: "wide",
    parsePatterns: x_,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: w_,
    defaultMatchWidth: "wide",
    parsePatterns: E_,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: $_,
    defaultMatchWidth: "any",
    parsePatterns: T_,
    defaultParseWidth: "any"
  })
};
const k_ = S_;
var __ = {
  code: "et",
  formatDistance: Z5,
  formatLong: n_,
  formatRelative: a_,
  localize: f_,
  match: k_,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const C_ = __;
function ym(e) {
  return e.replace(/sekuntia?/, "sekunnin");
}
function xm(e) {
  return e.replace(/minuuttia?/, "minuutin");
}
function wm(e) {
  return e.replace(/tuntia?/, "tunnin");
}
function P_(e) {
  return e.replace(/päivää?/, "päivän");
}
function Em(e) {
  return e.replace(/(viikko|viikkoa)/, "viikon");
}
function $m(e) {
  return e.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function Oi(e) {
  return e.replace(/(vuosi|vuotta)/, "vuoden");
}
var A_ = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: ym
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: ym
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(t) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: xm
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: xm
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: wm
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: wm
  },
  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: P_
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: Em
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: Em
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: $m
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: $m
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: Oi
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: Oi
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: Oi
  },
  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: Oi
  }
}, O_ = function(t, n, r) {
  var o = A_[t], a = n === 1 ? o.one : o.other.replace("{{count}}", String(n));
  return r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? o.futureTense(a) + " kuluttua" : a + " sitten" : a;
};
const N_ = O_;
var R_ = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, M_ = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, D_ = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, I_ = {
  date: Bt({
    formats: R_,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: M_,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: D_,
    defaultWidth: "full"
  })
};
const j_ = I_;
var L_ = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, F_ = function(t, n, r, o) {
  return L_[t];
};
const W_ = F_;
var H_ = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "jälkeen ajanlaskun alun"]
}, U_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, kl = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kesä", "heinä", "elo", "syys", "loka", "marras", "joulu"],
  wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
}, B_ = {
  narrow: kl.narrow,
  abbreviated: kl.abbreviated,
  wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kesäkuuta", "heinäkuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
}, Yi = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
}, z_ = {
  narrow: Yi.narrow,
  short: Yi.short,
  abbreviated: Yi.abbreviated,
  wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
}, V_ = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyöllä",
    noon: "keskipäivällä",
    morning: "aamupäivällä",
    afternoon: "iltapäivällä",
    evening: "illalla",
    night: "yöllä"
  }
}, G_ = function(t, n) {
  var r = Number(t);
  return r + ".";
}, q_ = {
  ordinalNumber: G_,
  era: dt({
    values: H_,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: U_,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: dt({
    values: kl,
    defaultWidth: "wide",
    formattingValues: B_,
    defaultFormattingWidth: "wide"
  }),
  day: dt({
    values: Yi,
    defaultWidth: "wide",
    formattingValues: z_,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: dt({
    values: V_,
    defaultWidth: "wide"
  })
};
const Y_ = q_;
var K_ = /^(\d+)(\.)/i, X_ = /\d+/i, Z_ = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, Q_ = {
  any: [/^e/i, /^j/i]
}, J_ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, eC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tC = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, nC = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
}, rC = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, oC = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, aC = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, iC = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, sC = {
  ordinalNumber: yo({
    matchPattern: K_,
    parsePattern: X_,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ft({
    matchPatterns: Z_,
    defaultMatchWidth: "wide",
    parsePatterns: Q_,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: J_,
    defaultMatchWidth: "wide",
    parsePatterns: eC,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ft({
    matchPatterns: tC,
    defaultMatchWidth: "wide",
    parsePatterns: nC,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: rC,
    defaultMatchWidth: "wide",
    parsePatterns: oC,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: aC,
    defaultMatchWidth: "any",
    parsePatterns: iC,
    defaultParseWidth: "any"
  })
};
const cC = sC;
var lC = {
  code: "fi",
  formatDistance: N_,
  formatLong: j_,
  formatRelative: W_,
  localize: Y_,
  match: cC,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const uC = lC;
var dC = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, fC = function(t, n, r) {
  var o, a = dC[t];
  return typeof a == "string" ? o = a : n === 1 ? o = a.one : o = a.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + o : o + " siden" : o;
};
const mC = fC;
var pC = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, hC = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, vC = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, gC = {
  date: Bt({
    formats: pC,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: hC,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: vC,
    defaultWidth: "full"
  })
};
const bC = gC;
var yC = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, xC = function(t, n, r, o) {
  return yC[t];
};
const wC = xC;
var EC = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, $C = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, TC = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, SC = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, kC = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, _C = function(t, n) {
  var r = Number(t);
  return r + ".";
}, CC = {
  ordinalNumber: _C,
  era: dt({
    values: EC,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: $C,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: dt({
    values: TC,
    defaultWidth: "wide"
  }),
  day: dt({
    values: SC,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: kC,
    defaultWidth: "wide"
  })
};
const PC = CC;
var AC = /^(\d+)\.?/i, OC = /\d+/i, NC = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, RC = {
  any: [/^f/i, /^e/i]
}, MC = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, DC = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, IC = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, jC = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, LC = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, FC = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, WC = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, HC = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, UC = {
  ordinalNumber: yo({
    matchPattern: AC,
    parsePattern: OC,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ft({
    matchPatterns: NC,
    defaultMatchWidth: "wide",
    parsePatterns: RC,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: MC,
    defaultMatchWidth: "wide",
    parsePatterns: DC,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ft({
    matchPatterns: IC,
    defaultMatchWidth: "wide",
    parsePatterns: jC,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: LC,
    defaultMatchWidth: "wide",
    parsePatterns: FC,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: WC,
    defaultMatchWidth: "any",
    parsePatterns: HC,
    defaultParseWidth: "any"
  })
};
const BC = UC;
var zC = {
  code: "nb",
  formatDistance: mC,
  formatLong: bC,
  formatRelative: wC,
  localize: PC,
  match: BC,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const VC = zC;
var GC = {
  lessThanXSeconds: {
    one: "mindre enn eitt sekund",
    other: "mindre enn {{count}} sekund"
  },
  xSeconds: {
    one: "eitt sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "eit halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn eitt minutt",
    other: "mindre enn {{count}} minutt"
  },
  xMinutes: {
    one: "eitt minutt",
    other: "{{count}} minutt"
  },
  aboutXHours: {
    one: "omtrent ein time",
    other: "omtrent {{count}} timar"
  },
  xHours: {
    one: "ein time",
    other: "{{count}} timar"
  },
  xDays: {
    one: "ein dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "omtrent ei veke",
    other: "omtrent {{count}} veker"
  },
  xWeeks: {
    one: "ei veke",
    other: "{{count}} veker"
  },
  aboutXMonths: {
    one: "omtrent ein månad",
    other: "omtrent {{count}} månader"
  },
  xMonths: {
    one: "ein månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "omtrent eitt år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "eitt år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over eitt år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten eitt år",
    other: "nesten {{count}} år"
  }
}, qC = ["null", "ein", "to", "tre", "fire", "fem", "seks", "sju", "åtte", "ni", "ti", "elleve", "tolv"], YC = function(t, n, r) {
  var o, a = GC[t];
  return typeof a == "string" ? o = a : n === 1 ? o = a.one : r && r.onlyNumeric ? o = a.other.replace("{{count}}", String(n)) : o = a.other.replace("{{count}}", n < 13 ? qC[n] : String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + o : o + " sidan" : o;
};
const KC = YC;
var XC = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, ZC = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, QC = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, JC = {
  date: Bt({
    formats: XC,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: ZC,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: QC,
    defaultWidth: "full"
  })
};
const e3 = JC;
var t3 = {
  lastWeek: "'førre' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, n3 = function(t, n, r, o) {
  return t3[t];
};
const r3 = n3;
var o3 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, a3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, i3 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
}, s3 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["su", "må", "ty", "on", "to", "fr", "lau"],
  abbreviated: ["sun", "mån", "tys", "ons", "tor", "fre", "laur"],
  wide: ["sundag", "måndag", "tysdag", "onsdag", "torsdag", "fredag", "laurdag"]
}, c3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natta"
  }
}, l3 = function(t, n) {
  var r = Number(t);
  return r + ".";
}, u3 = {
  ordinalNumber: l3,
  era: dt({
    values: o3,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: a3,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: dt({
    values: i3,
    defaultWidth: "wide"
  }),
  day: dt({
    values: s3,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: c3,
    defaultWidth: "wide"
  })
};
const d3 = u3;
var f3 = /^(\d+)\.?/i, m3 = /\d+/i, p3 = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, h3 = {
  any: [/^f/i, /^e/i]
}, v3 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, g3 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, b3 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, y3 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, x3 = {
  narrow: /^[smtofl]/i,
  short: /^(su|må|ty|on|to|fr|la)/i,
  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
}, w3 = {
  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, E3 = {
  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
}, $3 = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, T3 = {
  ordinalNumber: yo({
    matchPattern: f3,
    parsePattern: m3,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ft({
    matchPatterns: p3,
    defaultMatchWidth: "wide",
    parsePatterns: h3,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: v3,
    defaultMatchWidth: "wide",
    parsePatterns: g3,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ft({
    matchPatterns: b3,
    defaultMatchWidth: "wide",
    parsePatterns: y3,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: x3,
    defaultMatchWidth: "wide",
    parsePatterns: w3,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: E3,
    defaultMatchWidth: "any",
    parsePatterns: $3,
    defaultParseWidth: "any"
  })
};
const S3 = T3;
var k3 = {
  code: "nn",
  formatDistance: KC,
  formatLong: e3,
  formatRelative: r3,
  localize: d3,
  match: S3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const _3 = k3;
var C3 = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, P3 = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], A3 = function(t, n, r) {
  var o, a = C3[t];
  return typeof a == "string" ? o = a : n === 1 ? o = a.one : r && r.onlyNumeric ? o = a.other.replace("{{count}}", String(n)) : o = a.other.replace("{{count}}", n < 13 ? P3[n] : String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + o : o + " sedan" : o;
};
const O3 = A3;
var N3 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, R3 = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, M3 = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, D3 = {
  date: Bt({
    formats: N3,
    defaultWidth: "full"
  }),
  time: Bt({
    formats: R3,
    defaultWidth: "full"
  }),
  dateTime: Bt({
    formats: M3,
    defaultWidth: "full"
  })
};
const I3 = D3;
var j3 = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, L3 = function(t, n, r, o) {
  return j3[t];
};
const F3 = L3;
var W3 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, H3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, U3 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, B3 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, z3 = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, V3 = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, G3 = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, q3 = {
  ordinalNumber: G3,
  era: dt({
    values: W3,
    defaultWidth: "wide"
  }),
  quarter: dt({
    values: H3,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: dt({
    values: U3,
    defaultWidth: "wide"
  }),
  day: dt({
    values: B3,
    defaultWidth: "wide"
  }),
  dayPeriod: dt({
    values: z3,
    defaultWidth: "wide",
    formattingValues: V3,
    defaultFormattingWidth: "wide"
  })
};
const Y3 = q3;
var K3 = /^(\d+)(:a|:e)?/i, X3 = /\d+/i, Z3 = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, Q3 = {
  any: [/^f/i, /^[ev]/i]
}, J3 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, eP = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tP = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, nP = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, rP = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, oP = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, aP = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, iP = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, sP = {
  ordinalNumber: yo({
    matchPattern: K3,
    parsePattern: X3,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ft({
    matchPatterns: Z3,
    defaultMatchWidth: "wide",
    parsePatterns: Q3,
    defaultParseWidth: "any"
  }),
  quarter: ft({
    matchPatterns: J3,
    defaultMatchWidth: "wide",
    parsePatterns: eP,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ft({
    matchPatterns: tP,
    defaultMatchWidth: "wide",
    parsePatterns: nP,
    defaultParseWidth: "any"
  }),
  day: ft({
    matchPatterns: rP,
    defaultMatchWidth: "wide",
    parsePatterns: oP,
    defaultParseWidth: "any"
  }),
  dayPeriod: ft({
    matchPatterns: aP,
    defaultMatchWidth: "any",
    parsePatterns: iP,
    defaultParseWidth: "any"
  })
};
const cP = sP;
var lP = {
  code: "sv",
  formatDistance: O3,
  formatLong: I3,
  formatRelative: F3,
  localize: Y3,
  match: cP,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const uP = lP, dP = {
  "da-DK": U5,
  "en-GB": K5,
  "et-EE": C_,
  "fi-FI": uC,
  "nb-NO": VC,
  "nn-NO": _3,
  "sv-SE": uP
}, Tm = 1690891200, us = ({
  dateVariant: e = "absolute",
  localeName: t,
  unixTimestamp: n
}) => {
  const r = dP[t], o = i5() && n !== Tm ? hm(Tm) : /* @__PURE__ */ new Date(), a = hm(n), i = () => t5(o, a) ? ya(a, "PPp", { locale: r }).replace(/(\s?\d{4},?)/, "") : ya(a, "PPp", { locale: r }), s = () => n5(a) ? Jk(a, o, { locale: r }) : o5(a) ? e5(a, o, { locale: r }).replace(
    /(\s?\b\w+\.?)(?=\s+\d{1,2}:\d{2})/i,
    " "
  ) : ya(a, "cccc HH:mm", { locale: r });
  return e === "plain" ? ya(a, "P", { locale: r }).replace(/\/|-/g, ".") : e === "relative" && YS(o, a) < 7 ? s() : i();
}, Fu = M(({ unixTimestamp: e, className: t, ...n }, r) => {
  const { dateVariant: o, locale: a } = Ye(bo);
  return /* @__PURE__ */ w.jsx("div", { ref: r, className: z("shrink-0", t), ...n, children: us({
    dateVariant: o,
    localeName: a,
    unixTimestamp: e
  }) });
});
Fu.displayName = "ArticleItem.SourceDate";
const Vs = M(({ mediaType: e, socialMediaType: t, className: n, ...r }, o) => e ? /* @__PURE__ */ w.jsx("span", { className: z("flex", n), ref: o, ...r, children: lu({ sourceType: e, socialMediaType: t }) }) : null);
Vs.displayName = "ArticleItem.Source.Icon";
const Wu = M(({ sourceName: e, className: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "span",
  {
    ref: r,
    title: e,
    className: z("truncate", t),
    ...n,
    children: e
  }
));
Wu.displayName = "ArticleItem.Source.Text";
const Sv = M(
  ({ mediaType: e, sourceName: t, hideIcon: n, socialMediaType: r, className: o, ...a }, i) => /* @__PURE__ */ w.jsxs(
    "div",
    {
      className: z("flex items-center gap-x-1 truncate", o),
      ref: i,
      ...a,
      children: [
        !n && /* @__PURE__ */ w.jsx(
          Vs,
          {
            mediaType: e,
            socialMediaType: r
          }
        ),
        /* @__PURE__ */ w.jsx(Wu, { sourceName: t })
      ]
    }
  )
);
Sv.displayName = "ArticleItem.Source";
function fP(e, t) {
  return mr((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const Hu = (e) => {
  const { present: t, children: n } = e, r = mP(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Tn.only(n), a = ct(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ fr(o, {
    ref: a
  }) : null;
};
Hu.displayName = "Presence";
function mP(e) {
  const [t, n] = Ce(), r = Z({}), o = Z(e), a = Z("none"), i = e ? "mounted" : "unmounted", [s, c] = fP(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const l = Ni(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), qt(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, m = Ni(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && v !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), qt(() => {
    if (t) {
      const l = (u) => {
        const m = Ni(r.current).includes(u.animationName);
        u.target === t && m && Vr(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (a.current = Ni(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Ie((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Ni(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function pP({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = hP({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = wt(n), c = Ie((l) => {
    if (a) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    c
  ];
}
function hP({ defaultProp: e, onChange: t }) {
  const n = Ce(e), [r] = n, o = Z(r), a = wt(t);
  return Ee(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
const kv = "Popover", [_v, Jz] = Hn(kv, [
  Go
]), ei = Go(), [vP, xo] = _v(kv), gP = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: o, onOpenChange: a, modal: i = !1 } = e, s = ei(t), c = Z(null), [l, d] = Ce(!1), [u = !1, v] = pP({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ I(Fs, s, /* @__PURE__ */ I(vP, {
    scope: t,
    contentId: Ln(),
    triggerRef: c,
    open: u,
    onOpenChange: v,
    onOpenToggle: Ie(
      () => v(
        (m) => !m
      ),
      [
        v
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: Ie(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: Ie(
      () => d(!1),
      []
    ),
    modal: i
  }, n));
}, bP = "PopoverAnchor", yP = /* @__PURE__ */ M((e, t) => {
  const { __scopePopover: n, ...r } = e, o = xo(bP, n), a = ei(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = o;
  return Ee(() => (i(), () => s()), [
    i,
    s
  ]), /* @__PURE__ */ I(Ws, oe({}, a, r, {
    ref: t
  }));
}), xP = "PopoverTrigger", wP = /* @__PURE__ */ M((e, t) => {
  const { __scopePopover: n, ...r } = e, o = xo(xP, n), a = ei(n), i = ct(t, o.triggerRef), s = /* @__PURE__ */ I(lt.button, oe({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": Av(o.open)
  }, r, {
    ref: i,
    onClick: Le(e.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? s : /* @__PURE__ */ I(Ws, oe({
    asChild: !0
  }, a), s);
}), Cv = "PopoverPortal", [EP, $P] = _v(Cv, {
  forceMount: void 0
}), TP = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, a = xo(Cv, t);
  return /* @__PURE__ */ I(EP, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ I(Hu, {
    present: n || a.open
  }, /* @__PURE__ */ I(Ss, {
    asChild: !0,
    container: o
  }, r)));
}, Da = "PopoverContent", SP = /* @__PURE__ */ M((e, t) => {
  const n = $P(Da, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, a = xo(Da, e.__scopePopover);
  return /* @__PURE__ */ I(Hu, {
    present: r || a.open
  }, a.modal ? /* @__PURE__ */ I(kP, oe({}, o, {
    ref: t
  })) : /* @__PURE__ */ I(_P, oe({}, o, {
    ref: t
  })));
}), kP = /* @__PURE__ */ M((e, t) => {
  const n = xo(Da, e.__scopePopover), r = Z(null), o = ct(t, r), a = Z(!1);
  return Ee(() => {
    const i = r.current;
    if (i)
      return nu(i);
  }, []), /* @__PURE__ */ I(tu, {
    as: Tr,
    allowPinchZoom: !0
  }, /* @__PURE__ */ I(Pv, oe({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Le(e.onCloseAutoFocus, (i) => {
      var s;
      i.preventDefault(), a.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: Le(e.onPointerDownOutside, (i) => {
      const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
      a.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: Le(
      e.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), _P = /* @__PURE__ */ M((e, t) => {
  const n = xo(Da, e.__scopePopover), r = Z(!1), o = Z(!1);
  return /* @__PURE__ */ I(Pv, oe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (a) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, a), !a.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), a.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (a) => {
      var i, s;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const c = a.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
    }
  }));
}), Pv = /* @__PURE__ */ M((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, disableOutsidePointerEvents: i, onEscapeKeyDown: s, onPointerDownOutside: c, onFocusOutside: l, onInteractOutside: d, ...u } = e, v = xo(Da, n), m = ei(n);
  return eu(), /* @__PURE__ */ I(Jl, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ I(Ba, {
    asChild: !0,
    disableOutsidePointerEvents: i,
    onInteractOutside: d,
    onEscapeKeyDown: s,
    onPointerDownOutside: c,
    onFocusOutside: l,
    onDismiss: () => v.onOpenChange(!1)
  }, /* @__PURE__ */ I(Nu, oe({
    "data-state": Av(v.open),
    role: "dialog",
    id: v.contentId
  }, m, u, {
    ref: t,
    style: {
      ...u.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), CP = /* @__PURE__ */ M((e, t) => {
  const { __scopePopover: n, ...r } = e, o = ei(n);
  return /* @__PURE__ */ I(cv, oe({}, o, r, {
    ref: t
  }));
});
function Av(e) {
  return e ? "open" : "closed";
}
const PP = gP, AP = yP, OP = wP, NP = TP, Ov = SP, Sm = CP, RP = Wn(
  "group relative z-50 box-border max-w-sm bg-white p-6 text-label-l text-sky.1 outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
  {
    variants: {
      variant: {
        accent: "rounded-xl border-sky.1 bg-white shadow-popover data-[side=bottom]:border-t-4 data-[side=left]:border-r-4 data-[side=right]:border-l-4 data-[side=top]:border-b-4",
        default: "rounded-xl bg-white shadow-popover",
        legacy: "bg-grey.7"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), MP = PP, DP = OP, Nv = M(
  ({
    className: e,
    align: t = "center",
    side: n = "bottom",
    sideOffset: r = 16,
    variant: o = "default",
    children: a,
    ...i
  }, s) => /* @__PURE__ */ w.jsx(NP, { children: /* @__PURE__ */ w.jsxs(
    Ov,
    {
      ref: s,
      align: t,
      side: n,
      sideOffset: r,
      className: z(RP({ variant: o, className: e })),
      ...i,
      children: [
        o === "legacy" && /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
          /* @__PURE__ */ w.jsx(Sm, { className: "border-sky.1" }),
          /* @__PURE__ */ w.jsx(
            "div",
            {
              className: z(
                "absolute bg-sky.1",
                "group-data-[side=top]:inset-x-0 group-data-[side=top]:bottom-0 group-data-[side=top]:h-1",
                "group-data-[side=bottom]:inset-x-0 group-data-[side=bottom]:top-0 group-data-[side=bottom]:h-1",
                "group-data-[side=left]:inset-y-0 group-data-[side=left]:right-0 group-data-[side=left]:w-1",
                "group-data-[side=right]:inset-y-0 group-data-[side=right]:left-0 group-data-[side=right]:w-1"
              )
            }
          )
        ] }),
        o === "accent" && /* @__PURE__ */ w.jsx(
          Sm,
          {
            width: 24,
            height: 10,
            className: "fill-sky.1"
          }
        ),
        a
      ]
    }
  ) })
);
Nv.displayName = Ov.displayName;
const IP = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsx("h2", { ref: r, className: z("mb-2 text-heading-2", e), ...n, children: t }));
IP.displayName = "PopoverHeader";
const jP = AP;
function wr(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function LP(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Rv(...e) {
  return (t) => e.forEach((n) => LP(n, t));
}
function Ia(...e) {
  return P.useCallback(Rv(...e), e);
}
function Gs(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = P.createContext(i), c = n.length;
    n = [...n, i];
    function l(u) {
      const { scope: v, children: m, ...b } = u, x = (v == null ? void 0 : v[e][c]) || s, g = P.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ w.jsx(x.Provider, { value: g, children: m });
    }
    function d(u, v) {
      const m = (v == null ? void 0 : v[e][c]) || s, b = P.useContext(m);
      if (b)
        return b;
      if (i !== void 0)
        return i;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = n.map((i) => P.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return P.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, FP(o, ...t)];
}
function FP(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(a)[`__scope${l}`];
        return { ...s, ...u };
      }, {});
      return P.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var ds = P.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = P.Children.toArray(n), a = o.find(HP);
  if (a) {
    const i = a.props.children, s = o.map((c) => c === a ? P.Children.count(i) > 1 ? P.Children.only(null) : P.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ w.jsx(_l, { ...r, ref: t, children: P.isValidElement(i) ? P.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ w.jsx(_l, { ...r, ref: t, children: n });
});
ds.displayName = "Slot";
var _l = P.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (P.isValidElement(n)) {
    const o = BP(n);
    return P.cloneElement(n, {
      ...UP(r, n.props),
      // @ts-ignore
      ref: t ? Rv(t, o) : o
    });
  }
  return P.Children.count(n) > 1 ? P.Children.only(null) : null;
});
_l.displayName = "SlotClone";
var WP = ({ children: e }) => /* @__PURE__ */ w.jsx(w.Fragment, { children: e });
function HP(e) {
  return P.isValidElement(e) && e.type === WP;
}
function UP(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function BP(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var zP = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ti = zP.reduce((e, t) => {
  const n = P.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? ds : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w.jsx(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function VP(e) {
  const t = e + "CollectionProvider", [n, r] = Gs(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: b, children: x } = m, g = ce.useRef(null), k = ce.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ w.jsx(o, { scope: b, itemMap: k, collectionRef: g, children: x });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", c = ce.forwardRef(
    (m, b) => {
      const { scope: x, children: g } = m, k = a(s, x), $ = Ia(b, k.collectionRef);
      return /* @__PURE__ */ w.jsx(ds, { ref: $, children: g });
    }
  );
  c.displayName = s;
  const l = e + "CollectionItemSlot", d = "data-radix-collection-item", u = ce.forwardRef(
    (m, b) => {
      const { scope: x, children: g, ...k } = m, $ = ce.useRef(null), T = Ia(b, $), S = a(l, x);
      return ce.useEffect(() => (S.itemMap.set($, { ref: $, ...k }), () => void S.itemMap.delete($))), /* @__PURE__ */ w.jsx(ds, { [d]: "", ref: T, children: g });
    }
  );
  u.displayName = l;
  function v(m) {
    const b = a(e + "CollectionConsumer", m);
    return ce.useCallback(() => {
      const g = b.collectionRef.current;
      if (!g)
        return [];
      const k = Array.from(g.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (S, C) => k.indexOf(S.ref.current) - k.indexOf(C.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: u },
    v,
    r
  ];
}
var GP = globalThis != null && globalThis.document ? P.useLayoutEffect : () => {
}, qP = P["useId".toString()] || (() => {
}), YP = 0;
function KP(e) {
  const [t, n] = P.useState(qP());
  return GP(() => {
    e || n((r) => r ?? String(YP++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function XP(e) {
  const t = P.useRef(e);
  return P.useEffect(() => {
    t.current = e;
  }), P.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Mv(e) {
  const t = P.useRef(e);
  return P.useEffect(() => {
    t.current = e;
  }), P.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function ni({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = ZP({ defaultProp: t, onChange: n }), a = e !== void 0, i = a ? e : r, s = Mv(n), c = P.useCallback(
    (l) => {
      if (a) {
        const u = typeof l == "function" ? l(e) : l;
        u !== e && s(u);
      } else
        o(l);
    },
    [a, e, o, s]
  );
  return [i, c];
}
function ZP({
  defaultProp: e,
  onChange: t
}) {
  const n = P.useState(e), [r] = n, o = P.useRef(r), a = Mv(t);
  return P.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [r, o, a]), n;
}
var QP = P.createContext(void 0);
function Dv(e) {
  const t = P.useContext(QP);
  return e || t || "ltr";
}
var Uc = "rovingFocusGroup.onEntryFocus", JP = { bubbles: !1, cancelable: !0 }, qs = "RovingFocusGroup", [Cl, Iv, e7] = VP(qs), [t7, jv] = Gs(
  qs,
  [e7]
), [n7, r7] = t7(qs), Lv = P.forwardRef(
  (e, t) => /* @__PURE__ */ w.jsx(Cl.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ w.jsx(Cl.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ w.jsx(o7, { ...e, ref: t }) }) })
);
Lv.displayName = qs;
var o7 = P.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: d = !1,
    ...u
  } = e, v = P.useRef(null), m = Ia(t, v), b = Dv(a), [x = null, g] = ni({
    prop: i,
    defaultProp: s,
    onChange: c
  }), [k, $] = P.useState(!1), T = XP(l), S = Iv(n), C = P.useRef(!1), [N, U] = P.useState(0);
  return P.useEffect(() => {
    const L = v.current;
    if (L)
      return L.addEventListener(Uc, T), () => L.removeEventListener(Uc, T);
  }, [T]), /* @__PURE__ */ w.jsx(
    n7,
    {
      scope: n,
      orientation: r,
      dir: b,
      loop: o,
      currentTabStopId: x,
      onItemFocus: P.useCallback(
        (L) => g(L),
        [g]
      ),
      onItemShiftTab: P.useCallback(() => $(!0), []),
      onFocusableItemAdd: P.useCallback(
        () => U((L) => L + 1),
        []
      ),
      onFocusableItemRemove: P.useCallback(
        () => U((L) => L - 1),
        []
      ),
      children: /* @__PURE__ */ w.jsx(
        ti.div,
        {
          tabIndex: k || N === 0 ? -1 : 0,
          "data-orientation": r,
          ...u,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: wr(e.onMouseDown, () => {
            C.current = !0;
          }),
          onFocus: wr(e.onFocus, (L) => {
            const j = !C.current;
            if (L.target === L.currentTarget && j && !k) {
              const q = new CustomEvent(Uc, JP);
              if (L.currentTarget.dispatchEvent(q), !q.defaultPrevented) {
                const V = S().filter((he) => he.focusable), Q = V.find((he) => he.active), ke = V.find((he) => he.id === x), X = [Q, ke, ...V].filter(
                  Boolean
                ).map((he) => he.ref.current);
                Hv(X, d);
              }
            }
            C.current = !1;
          }),
          onBlur: wr(e.onBlur, () => $(!1))
        }
      )
    }
  );
}), Fv = "RovingFocusGroupItem", Wv = P.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      ...i
    } = e, s = KP(), c = a || s, l = r7(Fv, n), d = l.currentTabStopId === c, u = Iv(n), { onFocusableItemAdd: v, onFocusableItemRemove: m } = l;
    return P.useEffect(() => {
      if (r)
        return v(), () => m();
    }, [r, v, m]), /* @__PURE__ */ w.jsx(
      Cl.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ w.jsx(
          ti.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": l.orientation,
            ...i,
            ref: t,
            onMouseDown: wr(e.onMouseDown, (b) => {
              r ? l.onItemFocus(c) : b.preventDefault();
            }),
            onFocus: wr(e.onFocus, () => l.onItemFocus(c)),
            onKeyDown: wr(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                l.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget)
                return;
              const x = s7(b, l.orientation, l.dir);
              if (x !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey)
                  return;
                b.preventDefault();
                let k = u().filter(($) => $.focusable).map(($) => $.ref.current);
                if (x === "last")
                  k.reverse();
                else if (x === "prev" || x === "next") {
                  x === "prev" && k.reverse();
                  const $ = k.indexOf(b.currentTarget);
                  k = l.loop ? c7(k, $ + 1) : k.slice($ + 1);
                }
                setTimeout(() => Hv(k));
              }
            })
          }
        )
      }
    );
  }
);
Wv.displayName = Fv;
var a7 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function i7(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function s7(e, t, n) {
  const r = i7(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return a7[r];
}
function Hv(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function c7(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var l7 = Lv, u7 = Wv, d7 = globalThis != null && globalThis.document ? P.useLayoutEffect : () => {
};
function Uu(e) {
  const [t, n] = P.useState(void 0);
  return d7(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function Bu(e) {
  const t = P.useRef({ value: e, previous: e });
  return P.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function f7(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function m7(...e) {
  return (t) => e.forEach((n) => f7(n, t));
}
function p7(...e) {
  return P.useCallback(m7(...e), e);
}
var km = globalThis != null && globalThis.document ? P.useLayoutEffect : () => {
};
function h7(e, t) {
  return P.useReducer((n, r) => t[n][r] ?? n, e);
}
var Ys = (e) => {
  const { present: t, children: n } = e, r = v7(t), o = typeof n == "function" ? n({ present: r.isPresent }) : P.Children.only(n), a = p7(r.ref, g7(o));
  return typeof n == "function" || r.isPresent ? P.cloneElement(o, { ref: a }) : null;
};
Ys.displayName = "Presence";
function v7(e) {
  const [t, n] = P.useState(), r = P.useRef({}), o = P.useRef(e), a = P.useRef("none"), i = e ? "mounted" : "unmounted", [s, c] = h7(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return P.useEffect(() => {
    const l = Ri(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [s]), km(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, m = Ri(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && v !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), km(() => {
    if (t) {
      const l = (u) => {
        const m = Ri(r.current).includes(u.animationName);
        u.target === t && m && Wr.flushSync(() => c("ANIMATION_END"));
      }, d = (u) => {
        u.target === t && (a.current = Ri(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: P.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Ri(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function g7(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var zu = "Radio", [b7, Uv] = Gs(zu), [y7, x7] = b7(zu), Bv = P.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: a,
      disabled: i,
      value: s = "on",
      onCheck: c,
      ...l
    } = e, [d, u] = P.useState(null), v = Ia(t, (x) => u(x)), m = P.useRef(!1), b = d ? !!d.closest("form") : !0;
    return /* @__PURE__ */ w.jsxs(y7, { scope: n, checked: o, disabled: i, children: [
      /* @__PURE__ */ w.jsx(
        ti.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Gv(o),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...l,
          ref: v,
          onClick: wr(e.onClick, (x) => {
            o || c == null || c(), b && (m.current = x.isPropagationStopped(), m.current || x.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ w.jsx(
        w7,
        {
          control: d,
          bubbles: !m.current,
          name: r,
          value: s,
          checked: o,
          required: a,
          disabled: i,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Bv.displayName = zu;
var zv = "RadioIndicator", Vv = P.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, a = x7(zv, n);
    return /* @__PURE__ */ w.jsx(Ys, { present: r || a.checked, children: /* @__PURE__ */ w.jsx(
      ti.span,
      {
        "data-state": Gv(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
Vv.displayName = zv;
var w7 = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = P.useRef(null), i = Bu(n), s = Uu(t);
  return P.useEffect(() => {
    const c = a.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== n && u) {
      const v = new Event("click", { bubbles: r });
      u.call(c, n), c.dispatchEvent(v);
    }
  }, [i, n, r]), /* @__PURE__ */ w.jsx(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Gv(e) {
  return e ? "checked" : "unchecked";
}
var E7 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Vu = "RadioGroup", [$7, eV] = Gs(Vu, [
  jv,
  Uv
]), qv = jv(), Yv = Uv(), [T7, S7] = $7(Vu), Kv = P.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: a,
      required: i = !1,
      disabled: s = !1,
      orientation: c,
      dir: l,
      loop: d = !0,
      onValueChange: u,
      ...v
    } = e, m = qv(n), b = Dv(l), [x, g] = ni({
      prop: a,
      defaultProp: o,
      onChange: u
    });
    return /* @__PURE__ */ w.jsx(
      T7,
      {
        scope: n,
        name: r,
        required: i,
        disabled: s,
        value: x,
        onValueChange: g,
        children: /* @__PURE__ */ w.jsx(
          l7,
          {
            asChild: !0,
            ...m,
            orientation: c,
            dir: b,
            loop: d,
            children: /* @__PURE__ */ w.jsx(
              ti.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": c,
                "data-disabled": s ? "" : void 0,
                dir: b,
                ...v,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Kv.displayName = Vu;
var Xv = "RadioGroupItem", Zv = P.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, a = S7(Xv, n), i = a.disabled || r, s = qv(n), c = Yv(n), l = P.useRef(null), d = Ia(t, l), u = a.value === o.value, v = P.useRef(!1);
    return P.useEffect(() => {
      const m = (x) => {
        E7.includes(x.key) && (v.current = !0);
      }, b = () => v.current = !1;
      return document.addEventListener("keydown", m), document.addEventListener("keyup", b), () => {
        document.removeEventListener("keydown", m), document.removeEventListener("keyup", b);
      };
    }, []), /* @__PURE__ */ w.jsx(
      u7,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: u,
        children: /* @__PURE__ */ w.jsx(
          Bv,
          {
            disabled: i,
            required: a.required,
            checked: u,
            ...c,
            ...o,
            name: a.name,
            ref: d,
            onCheck: () => a.onValueChange(o.value),
            onKeyDown: wr((m) => {
              m.key === "Enter" && m.preventDefault();
            }),
            onFocus: wr(o.onFocus, () => {
              var m;
              v.current && ((m = l.current) == null || m.click());
            })
          }
        )
      }
    );
  }
);
Zv.displayName = Xv;
var k7 = "RadioGroupIndicator", Qv = P.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = Yv(n);
    return /* @__PURE__ */ w.jsx(Vv, { ...o, ...r, ref: t });
  }
);
Qv.displayName = k7;
var Jv = Kv, eg = Zv, _7 = Qv;
function C7(e) {
  return go({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "circle", attr: { cx: "8", cy: "8", r: "8" } }] })(e);
}
function P7(e) {
  return go({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" } }] })(e);
}
function A7(e) {
  return go({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" } }] })(e);
}
const O7 = /* @__PURE__ */ M((e, t) => /* @__PURE__ */ I(lt.label, oe({}, e, {
  ref: t,
  onMouseDown: (n) => {
    var r;
    (r = e.onMouseDown) === null || r === void 0 || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault();
  }
}))), tg = O7, ri = M(
  ({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
    tg,
    {
      ref: n,
      className: z(
        "text-sm leading-none peer-disabled:cursor-not-allowed",
        e
      ),
      ...t
    }
  )
);
ri.displayName = tg.displayName;
const N7 = Wn("gap-3", {
  variants: {
    orientation: {
      horizontal: "inline-flex",
      vertical: "grid"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
}), ng = M(({ className: e, orientation: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  Jv,
  {
    ...n,
    className: z(N7({ orientation: t, className: e })),
    ref: r,
    orientation: t
  }
));
ng.displayName = Jv.displayName;
const Gu = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  eg,
  {
    ...t,
    ref: n,
    className: z(
      "aspect-square h-4 w-4 shrink-0 rounded-full border border-sky.1 text-sky.1 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    children: /* @__PURE__ */ w.jsx(_7, { className: "flex items-center justify-center", children: /* @__PURE__ */ w.jsx(C7, { size: 10 }) })
  }
));
Gu.displayName = eg.displayName;
const R7 = M(({ id: e, value: t, label: n, className: r, ...o }, a) => /* @__PURE__ */ w.jsxs(
  "div",
  {
    className: z("my-1 flex items-center space-x-1.5", r),
    ref: a,
    children: [
      /* @__PURE__ */ w.jsx(Gu, { ...o, value: t, id: e }),
      /* @__PURE__ */ w.jsx(ri, { className: "cursor-pointer leading-[18px]", htmlFor: e, children: n })
    ]
  }
));
R7.displayName = "RadioInput";
function M7(e, t) {
  return mr((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const oi = (e) => {
  const { present: t, children: n } = e, r = D7(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Tn.only(n), a = ct(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ fr(o, {
    ref: a
  }) : null;
};
oi.displayName = "Presence";
function D7(e) {
  const [t, n] = Ce(), r = Z({}), o = Z(e), a = Z("none"), i = e ? "mounted" : "unmounted", [s, c] = M7(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const l = Mi(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), qt(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, m = Mi(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && v !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), qt(() => {
    if (t) {
      const l = (u) => {
        const m = Mi(r.current).includes(u.animationName);
        u.target === t && m && Vr(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (a.current = Mi(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Ie((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Mi(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const I7 = /* @__PURE__ */ Et(void 0);
function Ks(e) {
  const t = Ye(I7);
  return e || t || "ltr";
}
function j7(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function L7(e, t) {
  return mr((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const rg = "ScrollArea", [og, tV] = Hn(rg), [F7, Un] = og(rg), W7 = /* @__PURE__ */ M((e, t) => {
  const { __scopeScrollArea: n, type: r = "hover", dir: o, scrollHideDelay: a = 600, ...i } = e, [s, c] = Ce(null), [l, d] = Ce(null), [u, v] = Ce(null), [m, b] = Ce(null), [x, g] = Ce(null), [k, $] = Ce(0), [T, S] = Ce(0), [C, N] = Ce(!1), [U, L] = Ce(!1), j = ct(
    t,
    (V) => c(V)
  ), q = Ks(o);
  return /* @__PURE__ */ I(F7, {
    scope: n,
    type: r,
    dir: q,
    scrollHideDelay: a,
    scrollArea: s,
    viewport: l,
    onViewportChange: d,
    content: u,
    onContentChange: v,
    scrollbarX: m,
    onScrollbarXChange: b,
    scrollbarXEnabled: C,
    onScrollbarXEnabledChange: N,
    scrollbarY: x,
    onScrollbarYChange: g,
    scrollbarYEnabled: U,
    onScrollbarYEnabledChange: L,
    onCornerWidthChange: $,
    onCornerHeightChange: S
  }, /* @__PURE__ */ I(lt.div, oe({
    dir: q
  }, i, {
    ref: j,
    style: {
      position: "relative",
      // Pass corner sizes as CSS vars to reduce re-renders of context consumers
      "--radix-scroll-area-corner-width": k + "px",
      "--radix-scroll-area-corner-height": T + "px",
      ...e.style
    }
  })));
}), H7 = "ScrollAreaViewport", U7 = /* @__PURE__ */ M((e, t) => {
  const { __scopeScrollArea: n, children: r, ...o } = e, a = Un(H7, n), i = Z(null), s = ct(t, i, a.onViewportChange);
  return /* @__PURE__ */ I(Jt, null, /* @__PURE__ */ I("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ I(lt.div, oe({
    "data-radix-scroll-area-viewport": ""
  }, o, {
    ref: s,
    style: {
      /**
      * We don't support `visible` because the intention is to have at least one scrollbar
      * if this component is used and `visible` will behave like `auto` in that case
      * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
      *
      * We don't handle `auto` because the intention is for the native implementation
      * to be hidden if using this component. We just want to ensure the node is scrollable
      * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
      * the browser from having to work out whether to render native scrollbars or not,
      * we tell it to with the intention of hiding them in CSS.
      */
      overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
      ...e.style
    }
  }), /* @__PURE__ */ I("div", {
    ref: a.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, r)));
}), Ar = "ScrollAreaScrollbar", qu = /* @__PURE__ */ M((e, t) => {
  const { forceMount: n, ...r } = e, o = Un(Ar, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = o, s = e.orientation === "horizontal";
  return Ee(() => (s ? a(!0) : i(!0), () => {
    s ? a(!1) : i(!1);
  }), [
    s,
    a,
    i
  ]), o.type === "hover" ? /* @__PURE__ */ I(B7, oe({}, r, {
    ref: t,
    forceMount: n
  })) : o.type === "scroll" ? /* @__PURE__ */ I(z7, oe({}, r, {
    ref: t,
    forceMount: n
  })) : o.type === "auto" ? /* @__PURE__ */ I(ag, oe({}, r, {
    ref: t,
    forceMount: n
  })) : o.type === "always" ? /* @__PURE__ */ I(Yu, oe({}, r, {
    ref: t
  })) : null;
}), B7 = /* @__PURE__ */ M((e, t) => {
  const { forceMount: n, ...r } = e, o = Un(Ar, e.__scopeScrollArea), [a, i] = Ce(!1);
  return Ee(() => {
    const s = o.scrollArea;
    let c = 0;
    if (s) {
      const l = () => {
        window.clearTimeout(c), i(!0);
      }, d = () => {
        c = window.setTimeout(
          () => i(!1),
          o.scrollHideDelay
        );
      };
      return s.addEventListener("pointerenter", l), s.addEventListener("pointerleave", d), () => {
        window.clearTimeout(c), s.removeEventListener("pointerenter", l), s.removeEventListener("pointerleave", d);
      };
    }
  }, [
    o.scrollArea,
    o.scrollHideDelay
  ]), /* @__PURE__ */ I(oi, {
    present: n || a
  }, /* @__PURE__ */ I(ag, oe({
    "data-state": a ? "visible" : "hidden"
  }, r, {
    ref: t
  })));
}), z7 = /* @__PURE__ */ M((e, t) => {
  const { forceMount: n, ...r } = e, o = Un(Ar, e.__scopeScrollArea), a = e.orientation === "horizontal", i = Zs(
    () => c("SCROLL_END"),
    100
  ), [s, c] = L7("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return Ee(() => {
    if (s === "idle") {
      const l = window.setTimeout(
        () => c("HIDE"),
        o.scrollHideDelay
      );
      return () => window.clearTimeout(l);
    }
  }, [
    s,
    o.scrollHideDelay,
    c
  ]), Ee(() => {
    const l = o.viewport, d = a ? "scrollLeft" : "scrollTop";
    if (l) {
      let u = l[d];
      const v = () => {
        const m = l[d];
        u !== m && (c("SCROLL"), i()), u = m;
      };
      return l.addEventListener("scroll", v), () => l.removeEventListener("scroll", v);
    }
  }, [
    o.viewport,
    a,
    c,
    i
  ]), /* @__PURE__ */ I(oi, {
    present: n || s !== "hidden"
  }, /* @__PURE__ */ I(Yu, oe({
    "data-state": s === "hidden" ? "hidden" : "visible"
  }, r, {
    ref: t,
    onPointerEnter: Le(
      e.onPointerEnter,
      () => c("POINTER_ENTER")
    ),
    onPointerLeave: Le(
      e.onPointerLeave,
      () => c("POINTER_LEAVE")
    )
  })));
}), ag = /* @__PURE__ */ M((e, t) => {
  const n = Un(Ar, e.__scopeScrollArea), { forceMount: r, ...o } = e, [a, i] = Ce(!1), s = e.orientation === "horizontal", c = Zs(() => {
    if (n.viewport) {
      const l = n.viewport.offsetWidth < n.viewport.scrollWidth, d = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(s ? l : d);
    }
  }, 10);
  return Fo(n.viewport, c), Fo(n.content, c), /* @__PURE__ */ I(oi, {
    present: r || a
  }, /* @__PURE__ */ I(Yu, oe({
    "data-state": a ? "visible" : "hidden"
  }, o, {
    ref: t
  })));
}), Yu = /* @__PURE__ */ M((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = Un(Ar, e.__scopeScrollArea), a = Z(null), i = Z(0), [s, c] = Ce({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), l = lg(s.viewport, s.content), d = {
    ...r,
    sizes: s,
    onSizesChange: c,
    hasThumb: l > 0 && l < 1,
    onThumbChange: (v) => a.current = v,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (v) => i.current = v
  };
  function u(v, m) {
    return Q7(v, i.current, s, m);
  }
  return n === "horizontal" ? /* @__PURE__ */ I(V7, oe({}, d, {
    ref: t,
    onThumbPositionChange: () => {
      if (o.viewport && a.current) {
        const v = o.viewport.scrollLeft, m = _m(v, s, o.dir);
        a.current.style.transform = `translate3d(${m}px, 0, 0)`;
      }
    },
    onWheelScroll: (v) => {
      o.viewport && (o.viewport.scrollLeft = v);
    },
    onDragScroll: (v) => {
      o.viewport && (o.viewport.scrollLeft = u(v, o.dir));
    }
  })) : n === "vertical" ? /* @__PURE__ */ I(G7, oe({}, d, {
    ref: t,
    onThumbPositionChange: () => {
      if (o.viewport && a.current) {
        const v = o.viewport.scrollTop, m = _m(v, s);
        a.current.style.transform = `translate3d(0, ${m}px, 0)`;
      }
    },
    onWheelScroll: (v) => {
      o.viewport && (o.viewport.scrollTop = v);
    },
    onDragScroll: (v) => {
      o.viewport && (o.viewport.scrollTop = u(v));
    }
  })) : null;
}), V7 = /* @__PURE__ */ M((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, a = Un(Ar, e.__scopeScrollArea), [i, s] = Ce(), c = Z(null), l = ct(t, c, a.onScrollbarXChange);
  return Ee(() => {
    c.current && s(getComputedStyle(c.current));
  }, [
    c
  ]), /* @__PURE__ */ I(sg, oe({
    "data-orientation": "horizontal"
  }, o, {
    ref: l,
    sizes: n,
    style: {
      bottom: 0,
      left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      "--radix-scroll-area-thumb-width": Xs(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (d) => e.onThumbPointerDown(d.x),
    onDragScroll: (d) => e.onDragScroll(d.x),
    onWheelScroll: (d, u) => {
      if (a.viewport) {
        const v = a.viewport.scrollLeft + d.deltaX;
        e.onWheelScroll(v), dg(v, u) && d.preventDefault();
      }
    },
    onResize: () => {
      c.current && a.viewport && i && r({
        content: a.viewport.scrollWidth,
        viewport: a.viewport.offsetWidth,
        scrollbar: {
          size: c.current.clientWidth,
          paddingStart: fs(i.paddingLeft),
          paddingEnd: fs(i.paddingRight)
        }
      });
    }
  }));
}), G7 = /* @__PURE__ */ M((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, a = Un(Ar, e.__scopeScrollArea), [i, s] = Ce(), c = Z(null), l = ct(t, c, a.onScrollbarYChange);
  return Ee(() => {
    c.current && s(getComputedStyle(c.current));
  }, [
    c
  ]), /* @__PURE__ */ I(sg, oe({
    "data-orientation": "vertical"
  }, o, {
    ref: l,
    sizes: n,
    style: {
      top: 0,
      right: a.dir === "ltr" ? 0 : void 0,
      left: a.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      "--radix-scroll-area-thumb-height": Xs(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (d) => e.onThumbPointerDown(d.y),
    onDragScroll: (d) => e.onDragScroll(d.y),
    onWheelScroll: (d, u) => {
      if (a.viewport) {
        const v = a.viewport.scrollTop + d.deltaY;
        e.onWheelScroll(v), dg(v, u) && d.preventDefault();
      }
    },
    onResize: () => {
      c.current && a.viewport && i && r({
        content: a.viewport.scrollHeight,
        viewport: a.viewport.offsetHeight,
        scrollbar: {
          size: c.current.clientHeight,
          paddingStart: fs(i.paddingTop),
          paddingEnd: fs(i.paddingBottom)
        }
      });
    }
  }));
}), [q7, ig] = og(Ar), sg = /* @__PURE__ */ M((e, t) => {
  const { __scopeScrollArea: n, sizes: r, hasThumb: o, onThumbChange: a, onThumbPointerUp: i, onThumbPointerDown: s, onThumbPositionChange: c, onDragScroll: l, onWheelScroll: d, onResize: u, ...v } = e, m = Un(Ar, n), [b, x] = Ce(null), g = ct(
    t,
    (j) => x(j)
  ), k = Z(null), $ = Z(""), T = m.viewport, S = r.content - r.viewport, C = wt(d), N = wt(c), U = Zs(u, 10);
  function L(j) {
    if (k.current) {
      const q = j.clientX - k.current.left, V = j.clientY - k.current.top;
      l({
        x: q,
        y: V
      });
    }
  }
  return Ee(() => {
    const j = (q) => {
      const V = q.target;
      (b == null ? void 0 : b.contains(V)) && C(q, S);
    };
    return document.addEventListener("wheel", j, {
      passive: !1
    }), () => document.removeEventListener("wheel", j, {
      passive: !1
    });
  }, [
    T,
    b,
    S,
    C
  ]), Ee(N, [
    r,
    N
  ]), Fo(b, U), Fo(m.content, U), /* @__PURE__ */ I(q7, {
    scope: n,
    scrollbar: b,
    hasThumb: o,
    onThumbChange: wt(a),
    onThumbPointerUp: wt(i),
    onThumbPositionChange: N,
    onThumbPointerDown: wt(s)
  }, /* @__PURE__ */ I(lt.div, oe({}, v, {
    ref: g,
    style: {
      position: "absolute",
      ...v.style
    },
    onPointerDown: Le(e.onPointerDown, (j) => {
      j.button === 0 && (j.target.setPointerCapture(j.pointerId), k.current = b.getBoundingClientRect(), $.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", m.viewport && (m.viewport.style.scrollBehavior = "auto"), L(j));
    }),
    onPointerMove: Le(e.onPointerMove, L),
    onPointerUp: Le(e.onPointerUp, (j) => {
      const q = j.target;
      q.hasPointerCapture(j.pointerId) && q.releasePointerCapture(j.pointerId), document.body.style.webkitUserSelect = $.current, m.viewport && (m.viewport.style.scrollBehavior = ""), k.current = null;
    })
  })));
}), Pl = "ScrollAreaThumb", Y7 = /* @__PURE__ */ M((e, t) => {
  const { forceMount: n, ...r } = e, o = ig(Pl, e.__scopeScrollArea);
  return /* @__PURE__ */ I(oi, {
    present: n || o.hasThumb
  }, /* @__PURE__ */ I(K7, oe({
    ref: t
  }, r)));
}), K7 = /* @__PURE__ */ M((e, t) => {
  const { __scopeScrollArea: n, style: r, ...o } = e, a = Un(Pl, n), i = ig(Pl, n), { onThumbPositionChange: s } = i, c = ct(
    t,
    (u) => i.onThumbChange(u)
  ), l = Z(), d = Zs(() => {
    l.current && (l.current(), l.current = void 0);
  }, 100);
  return Ee(() => {
    const u = a.viewport;
    if (u) {
      const v = () => {
        if (d(), !l.current) {
          const m = J7(u, s);
          l.current = m, s();
        }
      };
      return s(), u.addEventListener("scroll", v), () => u.removeEventListener("scroll", v);
    }
  }, [
    a.viewport,
    d,
    s
  ]), /* @__PURE__ */ I(lt.div, oe({
    "data-state": i.hasThumb ? "visible" : "hidden"
  }, o, {
    ref: c,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...r
    },
    onPointerDownCapture: Le(e.onPointerDownCapture, (u) => {
      const m = u.target.getBoundingClientRect(), b = u.clientX - m.left, x = u.clientY - m.top;
      i.onThumbPointerDown({
        x: b,
        y: x
      });
    }),
    onPointerUp: Le(e.onPointerUp, i.onThumbPointerUp)
  }));
}), cg = "ScrollAreaCorner", X7 = /* @__PURE__ */ M((e, t) => {
  const n = Un(cg, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
  return n.type !== "scroll" && r ? /* @__PURE__ */ I(Z7, oe({}, e, {
    ref: t
  })) : null;
}), Z7 = /* @__PURE__ */ M((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, o = Un(cg, n), [a, i] = Ce(0), [s, c] = Ce(0), l = !!(a && s);
  return Fo(o.scrollbarX, () => {
    var d;
    const u = ((d = o.scrollbarX) === null || d === void 0 ? void 0 : d.offsetHeight) || 0;
    o.onCornerHeightChange(u), c(u);
  }), Fo(o.scrollbarY, () => {
    var d;
    const u = ((d = o.scrollbarY) === null || d === void 0 ? void 0 : d.offsetWidth) || 0;
    o.onCornerWidthChange(u), i(u);
  }), l ? /* @__PURE__ */ I(lt.div, oe({}, r, {
    ref: t,
    style: {
      width: a,
      height: s,
      position: "absolute",
      right: o.dir === "ltr" ? 0 : void 0,
      left: o.dir === "rtl" ? 0 : void 0,
      bottom: 0,
      ...e.style
    }
  })) : null;
});
function fs(e) {
  return e ? parseInt(e, 10) : 0;
}
function lg(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Xs(e) {
  const t = lg(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function Q7(e, t, n, r = "ltr") {
  const o = Xs(n), a = o / 2, i = t || a, s = o - i, c = n.scrollbar.paddingStart + i, l = n.scrollbar.size - n.scrollbar.paddingEnd - s, d = n.content - n.viewport, u = r === "ltr" ? [
    0,
    d
  ] : [
    d * -1,
    0
  ];
  return ug([
    c,
    l
  ], u)(e);
}
function _m(e, t, n = "ltr") {
  const r = Xs(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - o, i = t.content - t.viewport, s = a - r, c = n === "ltr" ? [
    0,
    i
  ] : [
    i * -1,
    0
  ], l = j7(e, c);
  return ug([
    0,
    i
  ], [
    0,
    s
  ])(l);
}
function ug(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function dg(e, t) {
  return e > 0 && e < t;
}
const J7 = (e, t = () => {
}) => {
  let n = {
    left: e.scrollLeft,
    top: e.scrollTop
  }, r = 0;
  return function o() {
    const a = {
      left: e.scrollLeft,
      top: e.scrollTop
    }, i = n.left !== a.left, s = n.top !== a.top;
    (i || s) && t(), n = a, r = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(r);
};
function Zs(e, t) {
  const n = wt(e), r = Z(0);
  return Ee(
    () => () => window.clearTimeout(r.current),
    []
  ), Ie(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [
    n,
    t
  ]);
}
function Fo(e, t) {
  const n = wt(t);
  qt(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [
    e,
    n
  ]);
}
const Ku = W7, Xu = U7, e6 = qu, t6 = X7, Qs = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsxs(
  Ku,
  {
    ref: r,
    className: z("relative overflow-hidden [&>div>div]:!block", e),
    ...n,
    children: [
      t,
      /* @__PURE__ */ w.jsx(fg, {}),
      /* @__PURE__ */ w.jsx(t6, {})
    ]
  }
));
Qs.displayName = Ku.displayName;
const Js = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  Xu,
  {
    ref: r,
    className: z("max-h-full w-full rounded-[inherit]", e),
    ...n,
    children: t
  }
));
Js.displayName = Xu.displayName;
const fg = M(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ w.jsx(
  qu,
  {
    ref: r,
    orientation: t,
    className: z(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ w.jsx(Y7, { className: "relative flex-1 rounded-full bg-grey.4" })
  }
));
fg.displayName = qu.displayName;
const Bc = 4, n6 = M(({ className: e, showSimilarity: t = !0, ...n }, r) => {
  var L;
  const {
    article: o,
    activeArticle: a,
    onSetArticleSource: i,
    onDeleteArticleSource: s,
    componentsConfig: c
  } = Rn(), [l, d] = Ce(!1);
  if (!vn(
    Kt.SourceName,
    c
  ))
    return null;
  const { first_source: u, topics: v, mediatype: m } = a, b = Xa(u.id), x = (b == null ? void 0 : b.name) || u.name, g = du({
    topics: v || [],
    mediatype: m == null ? void 0 : m.text
  }), k = b == null ? void 0 : b.icon, $ = uh({
    mainArticle: o,
    similarArticles: uu(o)
  }), T = E2(o), S = i ? $ : $.filter(
    (j) => Qt(j) !== Qt(a)
  ), C = l ? S : S.slice(0, Bc), N = S.length > Bc && !l, U = (j) => {
    if (!i)
      return;
    const q = S.find(
      (V) => Qt(V) === j
    );
    if (q) {
      const V = Qt(q);
      i(V);
    }
  };
  return /* @__PURE__ */ w.jsxs(MP, { children: [
    /* @__PURE__ */ w.jsxs(
      "div",
      {
        ref: r,
        className: z("flex items-center gap-x-2 overflow-x-hidden", e),
        ...n,
        children: [
          /* @__PURE__ */ w.jsxs("div", { className: "flex items-center gap-x-1 overflow-x-hidden", children: [
            /* @__PURE__ */ w.jsx(jP, { asChild: !0, children: /* @__PURE__ */ w.jsx(
              Vs,
              {
                mediaType: g,
                socialMediaType: k
              }
            ) }),
            /* @__PURE__ */ w.jsx(Wu, { sourceName: x || "" })
          ] }),
          t && T && /* @__PURE__ */ w.jsxs(
            DP,
            {
              onClick: (j) => j.stopPropagation(),
              className: "rounded border border-grey.5 bg-white px-2 py-0.5 text-label-s transition-colors hover:border-sky.cloudy focus:outline-none focus-visible:border-sky.6 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sky.6",
              children: [
                "+",
                (L = o.identical_documents) == null ? void 0 : L.cnt
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ w.jsx(
      Nv,
      {
        variant: "accent",
        sideOffset: 0,
        align: "start",
        side: "top",
        className: "max-w-lg rounded px-3 py-5",
        onClick: (j) => j.stopPropagation(),
        children: /* @__PURE__ */ w.jsx(Qs, { children: /* @__PURE__ */ w.jsxs(
          Js,
          {
            className: z("max-h-72", s && "pr-4"),
            children: [
              /* @__PURE__ */ w.jsx(
                ng,
                {
                  onValueChange: U,
                  value: Qt(a),
                  className: "flex flex-col gap-y-0",
                  children: C.map((j) => /* @__PURE__ */ w.jsx(
                    r6,
                    {
                      article: j
                    },
                    Qt(j)
                  ))
                }
              ),
              N && /* @__PURE__ */ w.jsx(
                vo,
                {
                  variant: "outline",
                  className: "mt-3 h-8 w-full text-label-m",
                  onClick: () => d(!0),
                  children: /* @__PURE__ */ w.jsx(
                    Fr,
                    {
                      _str: "View all +{count}",
                      count: $.length - Bc
                    }
                  )
                }
              )
            ]
          }
        ) })
      }
    )
  ] });
});
n6.displayName = "ArticleItem.ActiveSource";
const r6 = ({ article: e }) => {
  const { onDeleteArticleSource: t, onSetArticleSource: n } = Rn(), { first_source: r, topics: o, mediatype: a, similarity: i, unix_timestamp: s } = e, c = Xa(r.id), l = (c == null ? void 0 : c.name) || r.name, d = du({
    topics: o || [],
    mediatype: a == null ? void 0 : a.text
  });
  return /* @__PURE__ */ w.jsx(Cs, { instance: Za, children: /* @__PURE__ */ w.jsxs(
    "div",
    {
      className: "relative flex w-full cursor-pointer items-center justify-between gap-x-2 rounded",
      children: [
        /* @__PURE__ */ w.jsxs(
          "div",
          {
            className: z(
              "relative flex w-full items-center gap-x-0.5 truncate rounded p-2 transition-colors",
              n && "hover:bg-sky.9"
            ),
            children: [
              n && /* @__PURE__ */ w.jsx(
                Gu,
                {
                  id: Qt(e),
                  value: Qt(e)
                }
              ),
              /* @__PURE__ */ w.jsxs(
                ri,
                {
                  htmlFor: Qt(e),
                  className: z(
                    "flex w-full items-center space-x-1.5 truncate",
                    n && "cursor-pointer"
                  ),
                  children: [
                    /* @__PURE__ */ w.jsx("span", { className: "absolute inset-0" }),
                    /* @__PURE__ */ w.jsx(Fu, { unixTimestamp: s }),
                    /* @__PURE__ */ w.jsx("span", { children: "|" }),
                    /* @__PURE__ */ w.jsx(
                      Sv,
                      {
                        mediaType: d,
                        socialMediaType: c == null ? void 0 : c.icon,
                        sourceName: l
                      }
                    ),
                    /* @__PURE__ */ w.jsx("span", { children: "|" }),
                    /* @__PURE__ */ w.jsx(WS, { similarity: i })
                  ]
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ w.jsx(
          s2,
          {
            className: "text-grey.4 transition-colors hover:text-berry.1",
            onClick: (u) => {
              u.stopPropagation(), t(Qt(e));
            }
          }
        )
      ]
    },
    Qt(e)
  ) });
}, o6 = M((e, t) => {
  const { activeArticle: n, componentsConfig: r } = Rn(), { unix_timestamp: o } = n;
  return vn(
    Kt.SourceDate,
    r
  ) ? /* @__PURE__ */ w.jsx(
    Fu,
    {
      ref: t,
      unixTimestamp: o,
      ...e
    }
  ) : null;
});
o6.displayName = "ArticleItem.ActiveSourceDate";
const a6 = M(({ children: e, className: t, ...n }, r) => {
  const o = Tn.toArray(e).filter(Boolean), { articleLayout: a, componentsConfig: i } = Rn(), s = vn(
    Kt.SourceDate,
    i
  ) || vn(
    Kt.SourceName,
    i
  ), c = vn(
    Kt.SourceDate,
    i
  ) && vn(
    Kt.SourceName,
    i
  );
  if (!s)
    return null;
  const l = o.map((d, u) => /* @__PURE__ */ w.jsxs(Jt, { children: [
    d,
    u !== o.length - 1 && c && /* @__PURE__ */ w.jsx("span", { children: "|" })
  ] }, u));
  return /* @__PURE__ */ w.jsx(
    "div",
    {
      className: z(
        "relative flex items-center gap-x-2 overflow-x-hidden text-label-l",
        { "text-label-s": a === Hr.COMPACT },
        {
          "mt-3": !(i & Kt.Thumbnail && (Kt.SourceDate || Kt.SourceName))
        },
        t
      ),
      ...n,
      ref: r,
      children: l
    }
  );
});
a6.displayName = "ArticleItem.SourceRow";
function i6({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = s6({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = wt(n), c = Ie((l) => {
    if (a) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    c
  ];
}
function s6({ defaultProp: e, onChange: t }) {
  const n = Ce(e), [r] = n, o = Z(r), a = wt(t);
  return Ee(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
function c6(e, t) {
  return mr((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const mg = (e) => {
  const { present: t, children: n } = e, r = l6(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Tn.only(n), a = ct(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ fr(o, {
    ref: a
  }) : null;
};
mg.displayName = "Presence";
function l6(e) {
  const [t, n] = Ce(), r = Z({}), o = Z(e), a = Z("none"), i = e ? "mounted" : "unmounted", [s, c] = c6(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const l = Di(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), qt(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, m = Di(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && v !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), qt(() => {
    if (t) {
      const l = (u) => {
        const m = Di(r.current).includes(u.animationName);
        u.target === t && m && Vr(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (a.current = Di(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Ie((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Di(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const pg = "Collapsible", [u6, nV] = Hn(pg), [d6, Zu] = u6(pg), f6 = /* @__PURE__ */ M((e, t) => {
  const { __scopeCollapsible: n, open: r, defaultOpen: o, disabled: a, onOpenChange: i, ...s } = e, [c = !1, l] = i6({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ I(d6, {
    scope: n,
    disabled: a,
    contentId: Ln(),
    open: c,
    onOpenToggle: Ie(
      () => l(
        (d) => !d
      ),
      [
        l
      ]
    )
  }, /* @__PURE__ */ I(lt.div, oe({
    "data-state": Qu(c),
    "data-disabled": a ? "" : void 0
  }, s, {
    ref: t
  })));
}), m6 = "CollapsibleTrigger", p6 = /* @__PURE__ */ M((e, t) => {
  const { __scopeCollapsible: n, ...r } = e, o = Zu(m6, n);
  return /* @__PURE__ */ I(lt.button, oe({
    type: "button",
    "aria-controls": o.contentId,
    "aria-expanded": o.open || !1,
    "data-state": Qu(o.open),
    "data-disabled": o.disabled ? "" : void 0,
    disabled: o.disabled
  }, r, {
    ref: t,
    onClick: Le(e.onClick, o.onOpenToggle)
  }));
}), hg = "CollapsibleContent", h6 = /* @__PURE__ */ M((e, t) => {
  const { forceMount: n, ...r } = e, o = Zu(hg, e.__scopeCollapsible);
  return /* @__PURE__ */ I(
    mg,
    {
      present: n || o.open
    },
    ({ present: a }) => /* @__PURE__ */ I(v6, oe({}, r, {
      ref: t,
      present: a
    }))
  );
}), v6 = /* @__PURE__ */ M((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...a } = e, i = Zu(hg, n), [s, c] = Ce(r), l = Z(null), d = ct(t, l), u = Z(0), v = u.current, m = Z(0), b = m.current, x = i.open || s, g = Z(x), k = Z();
  return Ee(() => {
    const $ = requestAnimationFrame(
      () => g.current = !1
    );
    return () => cancelAnimationFrame($);
  }, []), qt(() => {
    const $ = l.current;
    if ($) {
      k.current = k.current || {
        transitionDuration: $.style.transitionDuration,
        animationName: $.style.animationName
      }, $.style.transitionDuration = "0s", $.style.animationName = "none";
      const T = $.getBoundingClientRect();
      u.current = T.height, m.current = T.width, g.current || ($.style.transitionDuration = k.current.transitionDuration, $.style.animationName = k.current.animationName), c(r);
    }
  }, [
    i.open,
    r
  ]), /* @__PURE__ */ I(lt.div, oe({
    "data-state": Qu(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    id: i.contentId,
    hidden: !x
  }, a, {
    ref: d,
    style: {
      "--radix-collapsible-content-height": v ? `${v}px` : void 0,
      "--radix-collapsible-content-width": b ? `${b}px` : void 0,
      ...e.style
    }
  }), x && o);
});
function Qu(e) {
  return e ? "open" : "closed";
}
const g6 = f6, b6 = p6, y6 = h6, x6 = M(
  ({ children: e, className: t, ...n }, r) => /* @__PURE__ */ w.jsx(
    "article",
    {
      ...n,
      ref: r,
      className: z("mt-[3.75rem] border-b border-b-grey.5 p-6", t),
      children: e
    }
  )
);
x6.displayName = "ArticlePreview.Root";
const w6 = M(
  ({
    mediaType: e,
    sourceName: t,
    unixTimestamp: n,
    socialMediaType: r,
    className: o,
    dateVariant: a,
    localeName: i,
    ...s
  }, c) => /* @__PURE__ */ w.jsxs(
    "div",
    {
      className: z(
        "mb-1.5 flex flex-wrap items-center font-sans text-label-l font-bold leading-[1.125rem] text-sky.1",
        o
      ),
      ref: c,
      ...s,
      children: [
        /* @__PURE__ */ w.jsx("span", { children: us({ dateVariant: a, localeName: i, unixTimestamp: n }) }),
        /* @__PURE__ */ w.jsx("span", { className: "mx-1.5", children: "|" }),
        /* @__PURE__ */ w.jsx("span", { children: lu({ sourceType: e, socialMediaType: r }) }),
        /* @__PURE__ */ w.jsx("span", { className: "ps-1.5", children: t })
      ]
    }
  )
);
w6.displayName = "ArticlePreview.SourceDate";
const E6 = M(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "div",
  {
    className: z("font-slab text-sm text-sky.1", t),
    ref: r,
    ...n,
    children: e
  }
));
E6.displayName = "ArticlePreview.Author";
const $6 = M(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "div",
  {
    className: z(
      "mt-1.5 font-slab text-3xl font-bold leading-normal text-sky.1",
      t
    ),
    ref: r,
    ...n,
    children: e
  }
));
$6.displayName = "ArticlePreview.Title";
const T6 = M(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "p",
  {
    className: z(
      "mb-6 pt-[1.125rem] font-slab text-[1.3125rem] font-bold leading-normal text-sky.1",
      t
    ),
    ref: r,
    ...n,
    children: e
  }
));
T6.displayName = "ArticlePreview.Excerpt";
const S6 = M(({ className: e, imageUrl: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "img",
  {
    className: z("mt-3 w-full", e),
    ref: r,
    alt: "article preview",
    src: t,
    ...n
  }
));
S6.displayName = "ArticlePreview.Image";
const k6 = M(
  ({
    className: e,
    children: t,
    articleId: n,
    siteId: r,
    bodyText: o,
    useHighlightMatching: a,
    keepOpen: i = !1,
    ...s
  }, c) => {
    const [l, d] = Ce(i);
    Ee(() => {
      d(i);
    }, [i]);
    const u = () => {
      d((x) => !x);
    }, { allParagraphs: v, paragraphsToShow: m, paragraphsToExpand: b } = w2(o);
    return v.length === 0 ? null : /* @__PURE__ */ w.jsxs(
      "div",
      {
        className: z("mt-6 text-lg text-sky.1 ", e),
        ref: c,
        ...s,
        children: [
          m.map((x, g) => {
            const k = `show-${g}`;
            return a ? /* @__PURE__ */ w.jsx("div", { className: "font-slab [&>*]:mb-6", children: /* @__PURE__ */ w.jsx(Lo, { text: x }) }, k) : /* @__PURE__ */ w.jsx(
              "div",
              {
                className: "font-slab [&>*]:mb-6",
                dangerouslySetInnerHTML: { __html: x }
              },
              k
            );
          }),
          /* @__PURE__ */ w.jsxs(g6, { open: l, children: [
            /* @__PURE__ */ w.jsxs(
              y6,
              {
                className: "overflow-hidden data-[state=closed]:animate-article-top data-[state=open]:animate-article-down",
                children: [
                  b.map((x, g) => {
                    const k = `expand-${g}`;
                    return a ? /* @__PURE__ */ w.jsx("div", { className: "[&>*]:mb-6", children: /* @__PURE__ */ w.jsx(Lo, { text: x }) }, k) : /* @__PURE__ */ w.jsx(
                      "div",
                      {
                        className: "[&>*]:mb-6",
                        dangerouslySetInnerHTML: { __html: x }
                      },
                      k
                    );
                  }),
                  t,
                  !!n && !!r && /* @__PURE__ */ w.jsx("div", { className: "mt-6 text-xs", children: `id:${r}_${n}` })
                ]
              }
            ),
            /* @__PURE__ */ w.jsx(
              "div",
              {
                className: z("mb-0 flex justify-center pt-[1.125rem]", {
                  "relative shadow-[0_-1.875rem_1.5625rem_0.375rem_#fff]": !l
                }),
                children: !i && /* @__PURE__ */ w.jsx(b6, { asChild: !0, children: /* @__PURE__ */ w.jsx(
                  vo,
                  {
                    className: "px-[1.125rem] py-1.5 font-sans",
                    onClick: u,
                    variant: "outline",
                    children: l ? "Show less" : "Show more"
                  }
                ) })
              }
            )
          ] })
        ]
      }
    );
  }
);
k6.displayName = "ArticlePreview.Body";
function _6(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function vg(...e) {
  return (t) => e.forEach((n) => _6(n, t));
}
function C6(...e) {
  return P.useCallback(vg(...e), e);
}
function P6(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = P.createContext(i), c = n.length;
    n = [...n, i];
    function l(u) {
      const { scope: v, children: m, ...b } = u, x = (v == null ? void 0 : v[e][c]) || s, g = P.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ w.jsx(x.Provider, { value: g, children: m });
    }
    function d(u, v) {
      const m = (v == null ? void 0 : v[e][c]) || s, b = P.useContext(m);
      if (b)
        return b;
      if (i !== void 0)
        return i;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = n.map((i) => P.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return P.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, A6(o, ...t)];
}
function A6(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(a)[`__scope${l}`];
        return { ...s, ...u };
      }, {});
      return P.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Cm(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
var gg = P.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = P.Children.toArray(n), a = o.find(N6);
  if (a) {
    const i = a.props.children, s = o.map((c) => c === a ? P.Children.count(i) > 1 ? P.Children.only(null) : P.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ w.jsx(Al, { ...r, ref: t, children: P.isValidElement(i) ? P.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ w.jsx(Al, { ...r, ref: t, children: n });
});
gg.displayName = "Slot";
var Al = P.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (P.isValidElement(n)) {
    const o = M6(n);
    return P.cloneElement(n, {
      ...R6(r, n.props),
      // @ts-ignore
      ref: t ? vg(t, o) : o
    });
  }
  return P.Children.count(n) > 1 ? P.Children.only(null) : null;
});
Al.displayName = "SlotClone";
var O6 = ({ children: e }) => /* @__PURE__ */ w.jsx(w.Fragment, { children: e });
function N6(e) {
  return P.isValidElement(e) && e.type === O6;
}
function R6(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function M6(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var D6 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], bg = D6.reduce((e, t) => {
  const n = P.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? gg : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w.jsx(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Ju = "Checkbox", [I6, rV] = P6(Ju), [j6, L6] = I6(Ju), yg = P.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      ...d
    } = e, [u, v] = P.useState(null), m = C6(t, (T) => v(T)), b = P.useRef(!1), x = u ? !!u.closest("form") : !0, [g = !1, k] = ni({
      prop: o,
      defaultProp: a,
      onChange: l
    }), $ = P.useRef(g);
    return P.useEffect(() => {
      const T = u == null ? void 0 : u.form;
      if (T) {
        const S = () => k($.current);
        return T.addEventListener("reset", S), () => T.removeEventListener("reset", S);
      }
    }, [u, k]), /* @__PURE__ */ w.jsxs(j6, { scope: n, state: g, disabled: s, children: [
      /* @__PURE__ */ w.jsx(
        bg.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": co(g) ? "mixed" : g,
          "aria-required": i,
          "data-state": Eg(g),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...d,
          ref: m,
          onKeyDown: Cm(e.onKeyDown, (T) => {
            T.key === "Enter" && T.preventDefault();
          }),
          onClick: Cm(e.onClick, (T) => {
            k((S) => co(S) ? !0 : !S), x && (b.current = T.isPropagationStopped(), b.current || T.stopPropagation());
          })
        }
      ),
      x && /* @__PURE__ */ w.jsx(
        F6,
        {
          control: u,
          bubbles: !b.current,
          name: r,
          value: c,
          checked: g,
          required: i,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
yg.displayName = Ju;
var xg = "CheckboxIndicator", wg = P.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = L6(xg, n);
    return /* @__PURE__ */ w.jsx(Ys, { present: r || co(a.state) || a.state === !0, children: /* @__PURE__ */ w.jsx(
      bg.span,
      {
        "data-state": Eg(a.state),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
wg.displayName = xg;
var F6 = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = P.useRef(null), i = Bu(n), s = Uu(t);
  return P.useEffect(() => {
    const c = a.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== n && u) {
      const v = new Event("click", { bubbles: r });
      c.indeterminate = co(n), u.call(c, co(n) ? !1 : n), c.dispatchEvent(v);
    }
  }, [i, n, r]), /* @__PURE__ */ w.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: co(n) ? !1 : n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function co(e) {
  return e === "indeterminate";
}
function Eg(e) {
  return co(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var $g = yg, W6 = wg;
const H6 = Wn(
  "h-[1.125rem] w-[1.125rem] min-w-[1.125rem] rounded-[0.1875rem] bg-white text-sky.1 focus-visible:outline focus-visible:outline-[0.1875rem] focus-visible:outline-sky.6 disabled:bg-grey.6 data-[state=checked]:bg-sky.1 data-[state=indeterminate]:bg-sky.1 data-[state=checked]:text-white data-[state=indeterminate]:text-white data-[state=checked]:outline data-[state=checked]:outline-[0.1875rem] data-[state=checked]:outline-grey.5 data-[state=indeterminate]:hover:outline data-[state=indeterminate]:hover:outline-[0.1875rem] data-[state=indeterminate]:hover:outline-grey.5 data-[state=checked]:focus-visible:outline-sky.6",
  {
    variants: {
      color: {
        pink: "bg-berry.4 focus-visible:outline-berry.4/50 data-[state=checked]:bg-berry.4 data-[state=checked]:outline-berry.4/50",
        red: "bg-berry.2 focus-visible:outline-berry.2/50 data-[state=checked]:bg-berry.2 data-[state=checked]:outline-berry.2/50",
        turquoise: "bg-sea.4 focus-visible:outline-sea.4/50 data-[state=checked]:bg-sea.4 data-[state=checked]:outline-sea.4/50",
        darkblue: "bg-sea.1 focus-visible:outline-sea.1/50 data-[state=checked]:bg-sea.1 data-[state=checked]:outline-sea.1/50",
        lightgreen: "bg-forest.5 focus-visible:outline-forest.5/50 data-[state=checked]:bg-forest.5 data-[state=checked]:outline-forest.5/50",
        green: "bg-forest.3 focus-visible:outline-forest.3/50 data-[state=checked]:bg-forest.3 data-[state=checked]:outline-forest.3/50",
        yellow: "bg-sand.4 focus-visible:outline-sand.4/50 data-[state=checked]:bg-sand.4 data-[state=checked]:outline-sand.4/50",
        orange: "bg-sand.3 focus-visible:outline-sand.3/50 data-[state=checked]:bg-sand.3 data-[state=checked]:outline-sand.3/50",
        blue: "bg-sky.4 focus-visible:outline-sky.4/50 data-[state=checked]:bg-sky.4 data-[state=checked]:outline-sky.4/50",
        undefined: "data-[state=unchecked]:border data-[state=unchecked]:border-sky.1"
      },
      variant: {
        menu: "border-none bg-grey.5 text-white data-[state=checked]:bg-sky.1 data-[state=indeterminate]:bg-sky.1 data-[state=checked]:outline-transparent data-[state=unchecked]:focus-visible:border-solid data-[state=unchecked]:focus-visible:border-white",
        filter: "border-none bg-grey.7 outline-transparent data-[state=checked]:bg-sky.1 data-[state=checked]:outline-transparent data-[state=checked]:hover:outline-sky.6 data-[state=checked]:focus:outline-sky.6 data-[state=unchecked]:focus:outline-sky.6 data-[state=unchecked]:focus-visible:border-solid data-[state=unchecked]:focus-visible:bg-white"
      }
    }
  }
), Tg = M(({ checked: e, className: t, color: n, variant: r, ...o }, a) => /* @__PURE__ */ w.jsx(
  $g,
  {
    ref: a,
    className: z(H6({ color: n, variant: r }), t),
    checked: e,
    ...o,
    children: /* @__PURE__ */ w.jsx(W6, { className: "hidden items-center justify-center data-[state=checked]:flex data-[state=indeterminate]:flex", children: e === "indeterminate" ? /* @__PURE__ */ w.jsx(A7, { size: 18 }) : /* @__PURE__ */ w.jsx(P7, { size: 18 }) })
  }
));
Tg.displayName = $g.displayName;
const Sg = typeof document < "u" ? ce.useLayoutEffect : () => {
};
function U6(e) {
  const t = Z(null);
  return Sg(() => {
    t.current = e;
  }, [
    e
  ]), Ie((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
const ai = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, io = (e) => e && "window" in e && e.window === e ? e : ai(e).defaultView || window;
function B6(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function z6(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function kg(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const V6 = kg(function() {
  return z6(/^Mac/i);
}), G6 = kg(function() {
  return B6(/Android/i);
});
function q6(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : G6() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
class Y6 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, n) {
    this.nativeEvent = n, this.target = n.target, this.currentTarget = n.currentTarget, this.relatedTarget = n.relatedTarget, this.bubbles = n.bubbles, this.cancelable = n.cancelable, this.defaultPrevented = n.defaultPrevented, this.eventPhase = n.eventPhase, this.isTrusted = n.isTrusted, this.timeStamp = n.timeStamp, this.type = t;
  }
}
function _g(e) {
  let t = Z({
    isFocused: !1,
    observer: null
  });
  Sg(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = U6((r) => {
    e == null || e(r);
  });
  return Ie((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let o = r.target, a = (i) => {
        t.current.isFocused = !1, o.disabled && n(new Y6("blur", i)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      o.addEventListener("focusout", a, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && o.disabled) {
          var i;
          (i = t.current.observer) === null || i === void 0 || i.disconnect();
          let s = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
function K6(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: o } = e;
  const a = Ie((c) => {
    if (c.target === c.currentTarget)
      return r && r(c), o && o(!1), !0;
  }, [
    r,
    o
  ]), i = _g(a), s = Ie((c) => {
    const l = ai(c.target);
    c.target === c.currentTarget && l.activeElement === c.target && (n && n(c), o && o(!0), i(c));
  }, [
    o,
    n,
    i
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || o || r) ? s : void 0,
      onBlur: !t && (r || o) ? a : void 0
    }
  };
}
let ii = null, Ol = /* @__PURE__ */ new Set(), _a = /* @__PURE__ */ new Map(), fo = !1, Nl = !1;
const X6 = {
  Tab: !0,
  Escape: !0
};
function ed(e, t) {
  for (let n of Ol)
    n(e, t);
}
function Z6(e) {
  return !(e.metaKey || !V6() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function ms(e) {
  fo = !0, Z6(e) && (ii = "keyboard", ed("keyboard", e));
}
function jn(e) {
  ii = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (fo = !0, ed("pointer", e));
}
function Cg(e) {
  q6(e) && (fo = !0, ii = "virtual");
}
function Pg(e) {
  e.target === window || e.target === document || (!fo && !Nl && (ii = "virtual", ed("virtual", e)), fo = !1, Nl = !1);
}
function Ag() {
  fo = !1, Nl = !0;
}
function Rl(e) {
  if (typeof window > "u" || _a.get(io(e)))
    return;
  const t = io(e), n = ai(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    fo = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", ms, !0), n.addEventListener("keyup", ms, !0), n.addEventListener("click", Cg, !0), t.addEventListener("focus", Pg, !0), t.addEventListener("blur", Ag, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", jn, !0), n.addEventListener("pointermove", jn, !0), n.addEventListener("pointerup", jn, !0)) : (n.addEventListener("mousedown", jn, !0), n.addEventListener("mousemove", jn, !0), n.addEventListener("mouseup", jn, !0)), t.addEventListener("beforeunload", () => {
    Og(e);
  }, {
    once: !0
  }), _a.set(t, {
    focus: r
  });
}
const Og = (e, t) => {
  const n = io(e), r = ai(e);
  t && r.removeEventListener("DOMContentLoaded", t), _a.has(n) && (n.HTMLElement.prototype.focus = _a.get(n).focus, r.removeEventListener("keydown", ms, !0), r.removeEventListener("keyup", ms, !0), r.removeEventListener("click", Cg, !0), n.removeEventListener("focus", Pg, !0), n.removeEventListener("blur", Ag, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", jn, !0), r.removeEventListener("pointermove", jn, !0), r.removeEventListener("pointerup", jn, !0)) : (r.removeEventListener("mousedown", jn, !0), r.removeEventListener("mousemove", jn, !0), r.removeEventListener("mouseup", jn, !0)), _a.delete(n));
};
function Q6(e) {
  const t = ai(e);
  let n;
  return t.readyState !== "loading" ? Rl(e) : (n = () => {
    Rl(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => Og(e, n);
}
typeof document < "u" && Q6();
function Ng() {
  return ii !== "pointer";
}
const J6 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function eA(e, t, n) {
  var r;
  const o = typeof window < "u" ? io(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, a = typeof window < "u" ? io(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, i = typeof window < "u" ? io(n == null ? void 0 : n.target).HTMLElement : HTMLElement, s = typeof window < "u" ? io(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || (n == null ? void 0 : n.target) instanceof o && !J6.has(n == null || (r = n.target) === null || r === void 0 ? void 0 : r.type) || (n == null ? void 0 : n.target) instanceof a || (n == null ? void 0 : n.target) instanceof i && (n == null ? void 0 : n.target.isContentEditable), !(e && t === "keyboard" && n instanceof s && !X6[n.key]);
}
function tA(e, t, n) {
  Rl(), Ee(() => {
    let r = (o, a) => {
      eA(!!(n != null && n.isTextInput), o, a) && e(Ng());
    };
    return Ol.add(r), () => {
      Ol.delete(r);
    };
  }, t);
}
function nA(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: o } = e, a = Z({
    isFocusWithin: !1
  }), i = Ie((l) => {
    a.current.isFocusWithin && !l.currentTarget.contains(l.relatedTarget) && (a.current.isFocusWithin = !1, n && n(l), o && o(!1));
  }, [
    n,
    o,
    a
  ]), s = _g(i), c = Ie((l) => {
    !a.current.isFocusWithin && document.activeElement === l.target && (r && r(l), o && o(!0), a.current.isFocusWithin = !0, s(l));
  }, [
    r,
    o,
    s
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: c,
      onBlur: i
    }
  };
}
function td(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, o = Z({
    isFocused: !1,
    isFocusVisible: t || Ng()
  }), [a, i] = Ce(!1), [s, c] = Ce(() => o.current.isFocused && o.current.isFocusVisible), l = Ie(() => c(o.current.isFocused && o.current.isFocusVisible), []), d = Ie((m) => {
    o.current.isFocused = m, i(m), l();
  }, [
    l
  ]);
  tA((m) => {
    o.current.isFocusVisible = m, l();
  }, [], {
    isTextInput: n
  });
  let { focusProps: u } = K6({
    isDisabled: r,
    onFocusChange: d
  }), { focusWithinProps: v } = nA({
    isDisabled: !r,
    onFocusWithinChange: d
  });
  return {
    isFocused: a,
    isFocusVisible: s,
    focusProps: r ? v : u
  };
}
typeof document < "u" && ce.useLayoutEffect;
function rA(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function oA(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function aA() {
  return oA(/^Mac/i);
}
function iA() {
  return rA(/Android/i);
}
let va = /* @__PURE__ */ new Map(), Pm = /* @__PURE__ */ new Set();
function Am() {
  if (typeof window > "u")
    return;
  let e = (n) => {
    let r = va.get(n.target);
    r || (r = /* @__PURE__ */ new Set(), va.set(n.target, r), n.target.addEventListener("transitioncancel", t)), r.add(n.propertyName);
  }, t = (n) => {
    let r = va.get(n.target);
    if (r && (r.delete(n.propertyName), r.size === 0 && (n.target.removeEventListener("transitioncancel", t), va.delete(n.target)), va.size === 0)) {
      for (let o of Pm)
        o();
      Pm.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", t);
}
typeof document < "u" && (document.readyState !== "loading" ? Am() : document.addEventListener("DOMContentLoaded", Am));
function sA(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : iA() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
const cA = ce.createContext({
  register: () => {
  }
});
cA.displayName = "PressResponderContext";
let lA = /* @__PURE__ */ new Set(), Om = !1, mo = !1, Ml = !1;
function nd(e, t) {
  for (let n of lA)
    n(e, t);
}
function uA(e) {
  return !(e.metaKey || !aA() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Nm(e) {
  mo = !0, uA(e) && nd("keyboard", e);
}
function Po(e) {
  (e.type === "mousedown" || e.type === "pointerdown") && (mo = !0, nd("pointer", e));
}
function dA(e) {
  sA(e) && (mo = !0);
}
function fA(e) {
  e.target === window || e.target === document || (!mo && !Ml && nd("virtual", e), mo = !1, Ml = !1);
}
function mA() {
  mo = !1, Ml = !0;
}
function Rm() {
  if (typeof window > "u" || Om)
    return;
  let e = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function() {
    mo = !0, e.apply(this, arguments);
  }, document.addEventListener("keydown", Nm, !0), document.addEventListener("keyup", Nm, !0), document.addEventListener("click", dA, !0), window.addEventListener("focus", fA, !0), window.addEventListener("blur", mA, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", Po, !0), document.addEventListener("pointermove", Po, !0), document.addEventListener("pointerup", Po, !0)) : (document.addEventListener("mousedown", Po, !0), document.addEventListener("mousemove", Po, !0), document.addEventListener("mouseup", Po, !0)), Om = !0;
}
typeof document < "u" && (document.readyState !== "loading" ? Rm() : document.addEventListener("DOMContentLoaded", Rm));
let ps = !1, zc = 0;
function Dl() {
  ps = !0, setTimeout(() => {
    ps = !1;
  }, 50);
}
function Mm(e) {
  e.pointerType === "touch" && Dl();
}
function pA() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", Mm) : document.addEventListener("touchend", Dl), zc++, () => {
      zc--, !(zc > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Mm) : document.removeEventListener("touchend", Dl));
    };
}
function rd(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: o } = e, [a, i] = Ce(!1), s = Z({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Ee(pA, []);
  let { hoverProps: c, triggerHoverEnd: l } = qe(() => {
    let d = (m, b) => {
      if (s.pointerType = b, o || b === "touch" || s.isHovered || !m.currentTarget.contains(m.target))
        return;
      s.isHovered = !0;
      let x = m.currentTarget;
      s.target = x, t && t({
        type: "hoverstart",
        target: x,
        pointerType: b
      }), n && n(!0), i(!0);
    }, u = (m, b) => {
      if (s.pointerType = "", s.target = null, b === "touch" || !s.isHovered)
        return;
      s.isHovered = !1;
      let x = m.currentTarget;
      r && r({
        type: "hoverend",
        target: x,
        pointerType: b
      }), n && n(!1), i(!1);
    }, v = {};
    return typeof PointerEvent < "u" ? (v.onPointerEnter = (m) => {
      ps && m.pointerType === "mouse" || d(m, m.pointerType);
    }, v.onPointerLeave = (m) => {
      !o && m.currentTarget.contains(m.target) && u(m, m.pointerType);
    }) : (v.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, v.onMouseEnter = (m) => {
      !s.ignoreEmulatedMouseEvents && !ps && d(m, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, v.onMouseLeave = (m) => {
      !o && m.currentTarget.contains(m.target) && u(m, "mouse");
    }), {
      hoverProps: v,
      triggerHoverEnd: u
    };
  }, [
    t,
    n,
    r,
    o,
    s
  ]);
  return Ee(() => {
    o && l({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    o
  ]), {
    hoverProps: c,
    isHovered: a
  };
}
var hA = Object.defineProperty, vA = (e, t, n) => t in e ? hA(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Vc = (e, t, n) => (vA(e, typeof t != "symbol" ? t + "" : t, n), n);
let gA = class {
  constructor() {
    Vc(this, "current", this.detect()), Vc(this, "handoffState", "pending"), Vc(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, Er = new gA();
function si(e) {
  return Er.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function ec(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function kr() {
  let e = [], t = { addEventListener(n, r, o, a) {
    return n.addEventListener(r, o, a), t.add(() => n.removeEventListener(r, o, a));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return ec(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, o) {
    let a = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: o }), this.add(() => {
      Object.assign(n.style, { [r]: a });
    });
  }, group(n) {
    let r = kr();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0)
        for (let o of e.splice(r, 1))
          o();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function dr() {
  let [e] = Ce(kr);
  return Ee(() => () => e.dispose(), [e]), e;
}
let _t = (e, t) => {
  Er.isServer ? Ee(e, t) : Ua(e, t);
};
function wo(e) {
  let t = Z(e);
  return _t(() => {
    t.current = e;
  }, [e]), t;
}
let Fe = function(e) {
  let t = wo(e);
  return ce.useCallback((...n) => t.current(...n), [t]);
};
function bA(e) {
  let t = e.width / 2, n = e.height / 2;
  return { top: e.clientY - n, right: e.clientX + t, bottom: e.clientY + n, left: e.clientX - t };
}
function yA(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function Rg({ disabled: e = !1 } = {}) {
  let t = Z(null), [n, r] = Ce(!1), o = dr(), a = Fe(() => {
    t.current = null, r(!1), o.dispose();
  }), i = Fe((s) => {
    if (o.dispose(), t.current === null) {
      t.current = s.currentTarget, r(!0);
      {
        let c = si(s.currentTarget);
        o.addEventListener(c, "pointerup", a, !1), o.addEventListener(c, "pointermove", (l) => {
          if (t.current) {
            let d = bA(l);
            r(yA(d, t.current.getBoundingClientRect()));
          }
        }, !1), o.addEventListener(c, "pointercancel", a, !1);
      }
    }
  });
  return { pressed: n, pressProps: e ? {} : { onPointerDown: i, onPointerUp: a, onClick: a } };
}
let xA = Et(void 0);
function tc() {
  return Ye(xA);
}
function Dm(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function nn(e, t, ...n) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, nn), r;
}
var po = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(po || {}), wA = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(wA || {});
function on({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: o, visible: a = !0, name: i, mergeRefs: s }) {
  s = s ?? EA;
  let c = Mg(t, e);
  if (a)
    return Ii(c, n, r, i, s);
  let l = o ?? 0;
  if (l & 2) {
    let { static: d = !1, ...u } = c;
    if (d)
      return Ii(u, n, r, i, s);
  }
  if (l & 1) {
    let { unmount: d = !0, ...u } = c;
    return nn(d ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Ii({ ...u, hidden: !0, style: { display: "none" } }, n, r, i, s);
    } });
  }
  return Ii(c, n, r, i, s);
}
function Ii(e, t = {}, n, r, o) {
  let { as: a = n, children: i, refName: s = "ref", ...c } = Gc(e, ["unmount", "static"]), l = e.ref !== void 0 ? { [s]: e.ref } : {}, d = typeof i == "function" ? i(t) : i;
  "className" in c && c.className && typeof c.className == "function" && (c.className = c.className(t)), c["aria-labelledby"] && c["aria-labelledby"] === c.id && (c["aria-labelledby"] = void 0);
  let u = {};
  if (t) {
    let v = !1, m = [];
    for (let [b, x] of Object.entries(t))
      typeof x == "boolean" && (v = !0), x === !0 && m.push(b.replace(/([A-Z])/g, (g) => `-${g.toLowerCase()}`));
    if (v) {
      u["data-headlessui-state"] = m.join(" ");
      for (let b of m)
        u[`data-${b}`] = "";
    }
  }
  if (a === Jt && (Object.keys(no(c)).length > 0 || Object.keys(no(u)).length > 0))
    if (!Oa(d) || Array.isArray(d) && d.length > 1) {
      if (Object.keys(no(c)).length > 0)
        throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(no(c)).concat(Object.keys(no(u))).map((v) => `  - ${v}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((v) => `  - ${v}`).join(`
`)].join(`
`));
    } else {
      let v = d.props, m = v == null ? void 0 : v.className, b = typeof m == "function" ? (...g) => Dm(m(...g), c.className) : Dm(m, c.className), x = b ? { className: b } : {};
      return fr(d, Object.assign({}, Mg(d.props, no(Gc(c, ["ref"]))), u, l, { ref: o(d.ref, l.ref) }, x));
    }
  return I(a, Object.assign({}, Gc(c, ["ref"]), a !== Jt && l, a !== Jt && u), d);
}
function EA(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e)
      n != null && (typeof n == "function" ? n(t) : n.current = t);
  };
}
function Mg(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let o in r)
      o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  if (t.disabled || t["aria-disabled"])
    for (let r in n)
      /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(r) && (n[r] = [(o) => {
        var a;
        return (a = o == null ? void 0 : o.preventDefault) == null ? void 0 : a.call(o);
      }]);
  for (let r in n)
    Object.assign(t, { [r](o, ...a) {
      let i = n[r];
      for (let s of i) {
        if ((o instanceof Event || (o == null ? void 0 : o.nativeEvent) instanceof Event) && o.defaultPrevented)
          return;
        s(o, ...a);
      }
    } });
  return t;
}
function ci(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let o in r)
      o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  for (let r in n)
    Object.assign(t, { [r](...o) {
      let a = n[r];
      for (let i of a)
        i == null || i(...o);
    } });
  return t;
}
function an(e) {
  var t;
  return Object.assign(M(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function no(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function Gc(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t)
    r in n && delete n[r];
  return n;
}
function Dg(e, t, n) {
  let [r, o] = Ce(n), a = e !== void 0, i = Z(a), s = Z(!1), c = Z(!1);
  return a && !i.current && !s.current ? (s.current = !0, i.current = a, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !a && i.current && !c.current && (c.current = !0, i.current = a, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [a ? e : r, Fe((l) => (a || o(l), t == null ? void 0 : t(l)))];
}
function $A() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in P ? ((t) => t.useSyncExternalStore)(P)(() => () => {
  }, () => !1, () => !e) : !1;
}
function od() {
  let e = $A(), [t, n] = P.useState(Er.isHandoffComplete);
  return t && Er.isHandoffComplete === !1 && n(!1), P.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), P.useEffect(() => Er.handoff(), []), e ? !1 : t;
}
var Im;
let pr = (Im = ce.useId) != null ? Im : function() {
  let e = od(), [t, n] = ce.useState(e ? () => Er.nextId() : null);
  return _t(() => {
    t === null && n(Er.nextId());
  }, [t]), t != null ? "" + t : void 0;
};
function Ig(e = {}, t = null, n = []) {
  for (let [r, o] of Object.entries(e))
    Lg(n, jg(t, r), o);
  return n;
}
function jg(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function Lg(e, t, n) {
  if (Array.isArray(n))
    for (let [r, o] of n.entries())
      Lg(e, jg(t, r.toString()), o);
  else
    n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : Ig(n, t, e);
}
let TA = "div";
var Wo = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Wo || {});
function SA(e, t) {
  var n;
  let { features: r = 1, ...o } = e, a = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : (n = o["aria-hidden"]) != null ? n : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return on({ ourProps: a, theirProps: o, slot: {}, defaultTag: TA, name: "Hidden" });
}
let ja = an(SA), kA = Et(null);
function Fg({ children: e }) {
  let t = Ye(kA);
  if (!t)
    return ce.createElement(ce.Fragment, null, e);
  let { target: n } = t;
  return n ? ip(ce.createElement(ce.Fragment, null, e), n) : null;
}
function Wg({ data: e, form: t, onReset: n }) {
  let [r, o] = Ce(null), a = dr();
  return Ee(() => {
    if (n && r)
      return a.addEventListener(r, "reset", n);
  }, [r, t, n]), ce.createElement(Fg, null, ce.createElement(_A, { setForm: o, formId: t }), Ig(e).map(([i, s]) => ce.createElement(ja, { features: Wo.Hidden, ...no({ key: i, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, name: i, value: s }) })));
}
function _A({ setForm: e, formId: t }) {
  return Ee(() => {
    if (t) {
      let n = document.getElementById(t);
      n && e(n);
    }
  }, [e, t]), t ? null : ce.createElement(ja, { features: Wo.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (n) => {
    if (!n)
      return;
    let r = n.closest("form");
    r && e(r);
  } });
}
let CA = Et(void 0);
function ad() {
  return Ye(CA);
}
function Hg(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && PA(n) ? !1 : r;
}
function PA(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let Ug = Symbol();
function AA(e, t = !0) {
  return Object.assign(e, { [Ug]: t });
}
function yn(...e) {
  let t = Z(e);
  Ee(() => {
    t.current = e;
  }, [e]);
  let n = Fe((r) => {
    for (let o of t.current)
      o != null && (typeof o == "function" ? o(r) : o.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[Ug])) ? void 0 : n;
}
let id = Et(null);
id.displayName = "DescriptionContext";
function Bg() {
  let e = Ye(id);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Bg), t;
  }
  return e;
}
function zg() {
  var e, t;
  return (t = (e = Ye(id)) == null ? void 0 : e.value) != null ? t : void 0;
}
let OA = "p";
function NA(e, t) {
  let n = pr(), r = tc(), { id: o = `headlessui-description-${n}`, ...a } = e, i = Bg(), s = yn(t);
  _t(() => i.register(o), [o, i.register]);
  let c = r || !1, l = qe(() => ({ ...i.slot, disabled: c }), [i.slot, c]), d = { ref: s, ...i.props, id: o };
  return on({ ourProps: d, theirProps: a, slot: l, defaultTag: OA, name: i.name || "Description" });
}
let RA = an(NA);
Object.assign(RA, {});
var kt = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(kt || {});
let nc = Et(null);
nc.displayName = "LabelContext";
function Vg() {
  let e = Ye(nc);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Vg), t;
  }
  return e;
}
function li(e) {
  var t, n, r;
  let o = (n = (t = Ye(nc)) == null ? void 0 : t.value) != null ? n : void 0;
  return ((r = e == null ? void 0 : e.length) != null ? r : 0) > 0 ? [o, ...e].filter(Boolean).join(" ") : o;
}
function Gg({ inherit: e = !1 } = {}) {
  let t = li(), [n, r] = Ce([]), o = e ? [t, ...n].filter(Boolean) : n;
  return [o.length > 0 ? o.join(" ") : void 0, qe(() => function(a) {
    let i = Fe((c) => (r((l) => [...l, c]), () => r((l) => {
      let d = l.slice(), u = d.indexOf(c);
      return u !== -1 && d.splice(u, 1), d;
    }))), s = qe(() => ({ register: i, slot: a.slot, name: a.name, props: a.props, value: a.value }), [i, a.slot, a.name, a.props, a.value]);
    return ce.createElement(nc.Provider, { value: s }, a.children);
  }, [r])];
}
let MA = "label";
function DA(e, t) {
  var n;
  let r = pr(), o = Vg(), a = ad(), i = tc(), { id: s = `headlessui-label-${r}`, htmlFor: c = a ?? ((n = o.props) == null ? void 0 : n.htmlFor), passive: l = !1, ...d } = e, u = yn(t);
  _t(() => o.register(s), [s, o.register]);
  let v = Fe((g) => {
    let k = g.currentTarget;
    if (k instanceof HTMLLabelElement && g.preventDefault(), o.props && "onClick" in o.props && typeof o.props.onClick == "function" && o.props.onClick(g), k instanceof HTMLLabelElement) {
      let $ = document.getElementById(k.htmlFor);
      if ($) {
        let T = $.getAttribute("disabled");
        if (T === "true" || T === "")
          return;
        let S = $.getAttribute("aria-disabled");
        if (S === "true" || S === "")
          return;
        ($ instanceof HTMLInputElement && ($.type === "radio" || $.type === "checkbox") || $.role === "radio" || $.role === "checkbox" || $.role === "switch") && $.click(), $.focus({ preventScroll: !0 });
      }
    }
  }), m = i || !1, b = qe(() => ({ ...o.slot, disabled: m }), [o.slot, m]), x = { ref: u, ...o.props, id: s, htmlFor: c, onClick: v };
  return l && ("onClick" in x && (delete x.htmlFor, delete x.onClick), "onClick" in d && delete d.onClick), on({ ourProps: x, theirProps: d, slot: b, defaultTag: c ? MA : "div", name: o.name || "Label" });
}
let IA = an(DA), qg = Object.assign(IA, {});
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function hs() {
  return hs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hs.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function vs() {
  return vs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, vs.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Ao(e, t, n) {
  var r, o = (r = n.initialDeps) != null ? r : [], a;
  return function() {
    var i;
    n.key && n.debug != null && n.debug() && (i = Date.now());
    var s = e(), c = s.length !== o.length || s.some(function(b, x) {
      return o[x] !== b;
    });
    if (!c)
      return a;
    o = s;
    var l;
    if (n.key && n.debug != null && n.debug() && (l = Date.now()), a = t.apply(void 0, s), n.key && n.debug != null && n.debug()) {
      var d = Math.round((Date.now() - i) * 100) / 100, u = Math.round((Date.now() - l) * 100) / 100, v = u / 16, m = function(x, g) {
        for (x = String(x); x.length < g; )
          x = " " + x;
        return x;
      };
      console.info("%c⏱ " + m(u, 5) + " /" + m(d, 5) + " ms", `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(` + Math.max(0, Math.min(120 - 120 * v, 120)) + "deg 100% 31%);", n == null ? void 0 : n.key);
    }
    return n == null || n.onChange == null || n.onChange(a), a;
  };
}
function qc(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined" + (t ? ": " + t : ""));
  return e;
}
var jA = function(t, n) {
  return Math.abs(t - n) < 1;
};
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var LA = function(t) {
  return t;
}, FA = function(t) {
  for (var n = Math.max(t.startIndex - t.overscan, 0), r = Math.min(t.endIndex + t.overscan, t.count - 1), o = [], a = n; a <= r; a++)
    o.push(a);
  return o;
}, WA = function(t, n) {
  var r = t.scrollElement;
  if (r) {
    var o = function(s) {
      var c = s.width, l = s.height;
      n({
        width: Math.round(c),
        height: Math.round(l)
      });
    };
    o(r.getBoundingClientRect());
    var a = new ResizeObserver(function(i) {
      var s = i[0];
      if (s != null && s.borderBoxSize) {
        var c = s.borderBoxSize[0];
        if (c) {
          o({
            width: c.inlineSize,
            height: c.blockSize
          });
          return;
        }
      }
      o(r.getBoundingClientRect());
    });
    return a.observe(r, {
      box: "border-box"
    }), function() {
      a.unobserve(r);
    };
  }
}, HA = function(t, n) {
  var r = t.scrollElement;
  if (r) {
    var o = function() {
      n(r[t.options.horizontal ? "scrollLeft" : "scrollTop"]);
    };
    return o(), r.addEventListener("scroll", o, {
      passive: !0
    }), function() {
      r.removeEventListener("scroll", o);
    };
  }
}, UA = function(t, n, r) {
  if (n != null && n.borderBoxSize) {
    var o = n.borderBoxSize[0];
    if (o) {
      var a = Math.round(o[r.options.horizontal ? "inlineSize" : "blockSize"]);
      return a;
    }
  }
  return Math.round(t.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]);
}, BA = function(t, n, r) {
  var o, a, i = n.adjustments, s = i === void 0 ? 0 : i, c = n.behavior, l = t + s;
  (o = r.scrollElement) == null || o.scrollTo == null || o.scrollTo((a = {}, a[r.options.horizontal ? "left" : "top"] = l, a.behavior = c, a));
}, zA = function(t) {
  var n = this;
  this.unsubs = [], this.scrollElement = null, this.isScrolling = !1, this.isScrollingTimeoutId = null, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollDirection = null, this.scrollAdjustments = 0, this.measureElementCache = /* @__PURE__ */ new Map(), this.observer = function() {
    var r = null, o = function() {
      return r || (typeof ResizeObserver < "u" ? r = new ResizeObserver(function(i) {
        i.forEach(function(s) {
          n._measureElement(s.target, s);
        });
      }) : null);
    };
    return {
      disconnect: function() {
        var i;
        return (i = o()) == null ? void 0 : i.disconnect();
      },
      observe: function(i) {
        var s;
        return (s = o()) == null ? void 0 : s.observe(i, {
          box: "border-box"
        });
      },
      unobserve: function(i) {
        var s;
        return (s = o()) == null ? void 0 : s.unobserve(i);
      }
    };
  }(), this.range = {
    startIndex: 0,
    endIndex: 0
  }, this.setOptions = function(r) {
    Object.entries(r).forEach(function(o) {
      var a = o[0], i = o[1];
      typeof i > "u" && delete r[a];
    }), n.options = vs({
      debug: !1,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: !1,
      getItemKey: LA,
      rangeExtractor: FA,
      onChange: function() {
      },
      measureElement: UA,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      scrollingDelay: 150,
      indexAttribute: "data-index",
      initialMeasurementsCache: [],
      lanes: 1
    }, r);
  }, this.notify = function() {
    n.options.onChange == null || n.options.onChange(n);
  }, this.cleanup = function() {
    n.unsubs.filter(Boolean).forEach(function(r) {
      return r();
    }), n.unsubs = [], n.scrollElement = null;
  }, this._didMount = function() {
    return n.measureElementCache.forEach(n.observer.observe), function() {
      n.observer.disconnect(), n.cleanup();
    };
  }, this._willUpdate = function() {
    var r = n.options.getScrollElement();
    n.scrollElement !== r && (n.cleanup(), n.scrollElement = r, n._scrollToOffset(n.scrollOffset, {
      adjustments: void 0,
      behavior: void 0
    }), n.unsubs.push(n.options.observeElementRect(n, function(o) {
      var a = n.scrollRect;
      n.scrollRect = o, (n.options.horizontal ? o.width !== a.width : o.height !== a.height) && n.maybeNotify();
    })), n.unsubs.push(n.options.observeElementOffset(n, function(o) {
      n.scrollAdjustments = 0, n.scrollOffset !== o && (n.isScrollingTimeoutId !== null && (clearTimeout(n.isScrollingTimeoutId), n.isScrollingTimeoutId = null), n.isScrolling = !0, n.scrollDirection = n.scrollOffset < o ? "forward" : "backward", n.scrollOffset = o, n.maybeNotify(), n.isScrollingTimeoutId = setTimeout(function() {
        n.isScrollingTimeoutId = null, n.isScrolling = !1, n.scrollDirection = null, n.maybeNotify();
      }, n.options.scrollingDelay));
    })));
  }, this.getSize = function() {
    return n.scrollRect[n.options.horizontal ? "width" : "height"];
  }, this.memoOptions = Ao(function() {
    return [n.options.count, n.options.paddingStart, n.options.scrollMargin, n.options.getItemKey];
  }, function(r, o, a, i) {
    return n.pendingMeasuredCacheIndexes = [], {
      count: r,
      paddingStart: o,
      scrollMargin: a,
      getItemKey: i
    };
  }, {
    key: !1
  }), this.getFurthestMeasurement = function(r, o) {
    for (var a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = o - 1; s >= 0; s--) {
      var c = r[s];
      if (!a.has(c.lane)) {
        var l = i.get(c.lane);
        if (l == null || c.end > l.end ? i.set(c.lane, c) : c.end < l.end && a.set(c.lane, !0), a.size === n.options.lanes)
          break;
      }
    }
    return i.size === n.options.lanes ? Array.from(i.values()).sort(function(d, u) {
      return d.end - u.end;
    })[0] : void 0;
  }, this.getMeasurements = Ao(function() {
    return [n.memoOptions(), n.itemSizeCache];
  }, function(r, o) {
    var a = r.count, i = r.paddingStart, s = r.scrollMargin, c = r.getItemKey, l = n.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, n.pendingMeasuredCacheIndexes) : 0;
    n.pendingMeasuredCacheIndexes = [];
    for (var d = n.measurementsCache.slice(0, l), u = l; u < a; u++) {
      var v = c(u), m = n.options.lanes === 1 ? d[u - 1] : n.getFurthestMeasurement(d, u), b = m ? m.end : i + s, x = o.get(v), g = typeof x == "number" ? x : n.options.estimateSize(u), k = b + g, $ = m ? m.lane : u % n.options.lanes;
      d[u] = {
        index: u,
        start: b,
        size: g,
        end: k,
        key: v,
        lane: $
      };
    }
    return n.measurementsCache = d, d;
  }, {
    key: process.env.NODE_ENV !== "production" && "getMeasurements",
    debug: function() {
      return n.options.debug;
    }
  }), this.calculateRange = Ao(function() {
    return [n.getMeasurements(), n.getSize(), n.scrollOffset];
  }, function(r, o, a) {
    return n.range = VA({
      measurements: r,
      outerSize: o,
      scrollOffset: a
    });
  }, {
    key: process.env.NODE_ENV !== "production" && "calculateRange",
    debug: function() {
      return n.options.debug;
    }
  }), this.maybeNotify = Ao(function() {
    var r = n.calculateRange();
    return [r.startIndex, r.endIndex, n.isScrolling];
  }, function() {
    n.notify();
  }, {
    key: process.env.NODE_ENV !== "production" && "maybeNotify",
    debug: function() {
      return n.options.debug;
    },
    initialDeps: [this.range.startIndex, this.range.endIndex, this.isScrolling]
  }), this.getIndexes = Ao(function() {
    return [n.options.rangeExtractor, n.calculateRange(), n.options.overscan, n.options.count];
  }, function(r, o, a, i) {
    return r(vs({}, o, {
      overscan: a,
      count: i
    }));
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return n.options.debug;
    }
  }), this.indexFromElement = function(r) {
    var o = n.options.indexAttribute, a = r.getAttribute(o);
    return a ? parseInt(a, 10) : (console.warn("Missing attribute name '" + o + "={index}' on measured element."), -1);
  }, this._measureElement = function(r, o) {
    var a = n.measurementsCache[n.indexFromElement(r)];
    if (!a) {
      n.measureElementCache.forEach(function(c, l) {
        c === r && (n.observer.unobserve(r), n.measureElementCache.delete(l));
      });
      return;
    }
    var i = n.measureElementCache.get(a.key);
    if (!r.isConnected) {
      i && (n.observer.unobserve(i), n.measureElementCache.delete(a.key));
      return;
    }
    i !== r && (i && n.observer.unobserve(i), n.observer.observe(r), n.measureElementCache.set(a.key, r));
    var s = n.options.measureElement(r, o, n);
    n.resizeItem(a, s);
  }, this.resizeItem = function(r, o) {
    var a, i = (a = n.itemSizeCache.get(r.key)) != null ? a : r.size, s = o - i;
    s !== 0 && (r.start < n.scrollOffset && (process.env.NODE_ENV !== "production" && n.options.debug && console.info("correction", s), n._scrollToOffset(n.scrollOffset, {
      adjustments: n.scrollAdjustments += s,
      behavior: void 0
    })), n.pendingMeasuredCacheIndexes.push(r.index), n.itemSizeCache = new Map(n.itemSizeCache.set(r.key, o)), n.notify());
  }, this.measureElement = function(r) {
    r && n._measureElement(r, void 0);
  }, this.getVirtualItems = Ao(function() {
    return [n.getIndexes(), n.getMeasurements()];
  }, function(r, o) {
    for (var a = [], i = 0, s = r.length; i < s; i++) {
      var c = r[i], l = o[c];
      a.push(l);
    }
    return a;
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return n.options.debug;
    }
  }), this.getVirtualItemForOffset = function(r) {
    var o = n.getMeasurements();
    return qc(o[Yg(0, o.length - 1, function(a) {
      return qc(o[a]).start;
    }, r)]);
  }, this.getOffsetForAlignment = function(r, o) {
    var a = n.getSize();
    o === "auto" && (r <= n.scrollOffset ? o = "start" : r >= n.scrollOffset + a ? o = "end" : o = "start"), o === "start" ? r = r : o === "end" ? r = r - a : o === "center" && (r = r - a / 2);
    var i = n.options.horizontal ? "scrollWidth" : "scrollHeight", s = n.scrollElement ? "document" in n.scrollElement ? n.scrollElement.document.documentElement[i] : n.scrollElement[i] : 0, c = s - n.getSize();
    return Math.max(Math.min(c, r), 0);
  }, this.getOffsetForIndex = function(r, o) {
    o === void 0 && (o = "auto"), r = Math.max(0, Math.min(r, n.options.count - 1));
    var a = qc(n.getMeasurements()[r]);
    if (o === "auto")
      if (a.end >= n.scrollOffset + n.getSize() - n.options.scrollPaddingEnd)
        o = "end";
      else if (a.start <= n.scrollOffset + n.options.scrollPaddingStart)
        o = "start";
      else
        return [n.scrollOffset, o];
    var i = o === "end" ? a.end + n.options.scrollPaddingEnd : a.start - n.options.scrollPaddingStart;
    return [n.getOffsetForAlignment(i, o), o];
  }, this.isDynamicMode = function() {
    return n.measureElementCache.size > 0;
  }, this.cancelScrollToIndex = function() {
    n.scrollToIndexTimeoutId !== null && (clearTimeout(n.scrollToIndexTimeoutId), n.scrollToIndexTimeoutId = null);
  }, this.scrollToOffset = function(r, o) {
    var a = o === void 0 ? {} : o, i = a.align, s = i === void 0 ? "start" : i, c = a.behavior;
    n.cancelScrollToIndex(), c === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), n._scrollToOffset(n.getOffsetForAlignment(r, s), {
      adjustments: void 0,
      behavior: c
    });
  }, this.scrollToIndex = function(r, o) {
    var a = o === void 0 ? {} : o, i = a.align, s = i === void 0 ? "auto" : i, c = a.behavior;
    r = Math.max(0, Math.min(r, n.options.count - 1)), n.cancelScrollToIndex(), c === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    var l = n.getOffsetForIndex(r, s), d = l[0], u = l[1];
    n._scrollToOffset(d, {
      adjustments: void 0,
      behavior: c
    }), c !== "smooth" && n.isDynamicMode() && (n.scrollToIndexTimeoutId = setTimeout(function() {
      n.scrollToIndexTimeoutId = null;
      var v = n.measureElementCache.has(n.options.getItemKey(r));
      if (v) {
        var m = n.getOffsetForIndex(r, u), b = m[0];
        jA(b, n.scrollOffset) || n.scrollToIndex(r, {
          align: u,
          behavior: c
        });
      } else
        n.scrollToIndex(r, {
          align: u,
          behavior: c
        });
    }));
  }, this.scrollBy = function(r, o) {
    var a = o === void 0 ? {} : o, i = a.behavior;
    n.cancelScrollToIndex(), i === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), n._scrollToOffset(n.scrollOffset + r, {
      adjustments: void 0,
      behavior: i
    });
  }, this.getTotalSize = function() {
    var r;
    return (((r = n.getMeasurements()[n.options.count - 1]) == null ? void 0 : r.end) || n.options.paddingStart) - n.options.scrollMargin + n.options.paddingEnd;
  }, this._scrollToOffset = function(r, o) {
    var a = o.adjustments, i = o.behavior;
    n.options.scrollToFn(r, {
      behavior: i,
      adjustments: a
    }, n);
  }, this.measure = function() {
    n.itemSizeCache = /* @__PURE__ */ new Map(), n.notify();
  }, this.setOptions(t), this.scrollRect = this.options.initialRect, this.scrollOffset = this.options.initialOffset, this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach(function(r) {
    n.itemSizeCache.set(r.key, r.size);
  }), this.maybeNotify();
}, Yg = function(t, n, r, o) {
  for (; t <= n; ) {
    var a = (t + n) / 2 | 0, i = r(a);
    if (i < o)
      t = a + 1;
    else if (i > o)
      n = a - 1;
    else
      return a;
  }
  return t > 0 ? t - 1 : 0;
};
function VA(e) {
  for (var t = e.measurements, n = e.outerSize, r = e.scrollOffset, o = t.length - 1, a = function(l) {
    return t[l].start;
  }, i = Yg(0, o, a, r), s = i; s < o && t[s].end < r + n; )
    s++;
  return {
    startIndex: i,
    endIndex: s
  };
}
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var GA = typeof document < "u" ? P.useLayoutEffect : P.useEffect;
function qA(e) {
  var t = P.useReducer(function() {
    return {};
  }, {})[1], n = hs({}, e, {
    onChange: function(i) {
      t(), e.onChange == null || e.onChange(i);
    }
  }), r = P.useState(function() {
    return new zA(n);
  }), o = r[0];
  return o.setOptions(n), P.useEffect(function() {
    return o._didMount();
  }, []), GA(function() {
    return o._willUpdate();
  }), o;
}
function YA(e) {
  return qA(hs({
    observeElementRect: WA,
    observeElementOffset: HA,
    scrollToFn: BA
  }, e));
}
function KA(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function Kg(e = KA) {
  return Ie((t, n) => {
    if (typeof e == "string") {
      let r = e;
      return (t == null ? void 0 : t[r]) === (n == null ? void 0 : n[r]);
    }
    return e(t, n);
  }, [e]);
}
let Il = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), XA = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var xr = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(xr || {}), jl = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(jl || {}), ZA = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(ZA || {});
function QA(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Il)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function JA(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(XA)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var sd = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(sd || {});
function Xg(e, t = 0) {
  var n;
  return e === ((n = si(e)) == null ? void 0 : n.body) ? !1 : nn(t, { 0() {
    return e.matches(Il);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(Il))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var eO = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(eO || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $r(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let tO = ["textarea", "input"].join(",");
function nO(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, tO)) != null ? n : !1;
}
function cd(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let o = t(n), a = t(r);
    if (o === null || a === null)
      return 0;
    let i = o.compareDocumentPosition(a);
    return i & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : i & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Ca(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: o = [] } = {}) {
  let a = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, i = Array.isArray(e) ? n ? cd(e) : e : t & 64 ? JA(e) : QA(e);
  o.length > 0 && i.length > 1 && (i = i.filter((m) => !o.some((b) => b != null && "current" in b ? (b == null ? void 0 : b.current) === m : b === m))), r = r ?? a.activeElement;
  let s = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, i.indexOf(r)) - 1;
    if (t & 4)
      return Math.max(0, i.indexOf(r)) + 1;
    if (t & 8)
      return i.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = t & 32 ? { preventScroll: !0 } : {}, d = 0, u = i.length, v;
  do {
    if (d >= u || d + u <= 0)
      return 0;
    let m = c + d;
    if (t & 16)
      m = (m + u) % u;
    else {
      if (m < 0)
        return 3;
      if (m >= u)
        return 1;
    }
    v = i[m], v == null || v.focus(l), d += s;
  } while (v !== a.activeElement);
  return t & 6 && nO(v) && v.select(), 2;
}
function Zg() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function rO() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Qg() {
  return Zg() || rO();
}
function ji(e, t, n) {
  let r = wo(t);
  Ee(() => {
    function o(a) {
      r.current(a);
    }
    return document.addEventListener(e, o, n), () => document.removeEventListener(e, o, n);
  }, [e, n]);
}
function Jg(e, t, n) {
  let r = wo(t);
  Ee(() => {
    function o(a) {
      r.current(a);
    }
    return window.addEventListener(e, o, n), () => window.removeEventListener(e, o, n);
  }, [e, n]);
}
function e0(e, t, n = !0) {
  let r = Z(!1);
  Ee(() => {
    requestAnimationFrame(() => {
      r.current = n;
    });
  }, [n]);
  function o(i, s) {
    if (!r.current || i.defaultPrevented)
      return;
    let c = s(i);
    if (c === null || !c.getRootNode().contains(c) || !c.isConnected)
      return;
    let l = function d(u) {
      return typeof u == "function" ? d(u()) : Array.isArray(u) || u instanceof Set ? u : [u];
    }(e);
    for (let d of l) {
      if (d === null)
        continue;
      let u = d instanceof HTMLElement ? d : d.current;
      if (u != null && u.contains(c) || i.composed && i.composedPath().includes(u))
        return;
    }
    return !Xg(c, sd.Loose) && c.tabIndex !== -1 && i.preventDefault(), t(i, c);
  }
  let a = Z(null);
  ji("pointerdown", (i) => {
    var s, c;
    r.current && (a.current = ((c = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : c[0]) || i.target);
  }, !0), ji("mousedown", (i) => {
    var s, c;
    r.current && (a.current = ((c = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : c[0]) || i.target);
  }, !0), ji("click", (i) => {
    Qg() || a.current && (o(i, () => a.current), a.current = null);
  }, !0), ji("touchend", (i) => o(i, () => i.target instanceof HTMLElement ? i.target : null), !0), Jg("blur", (i) => o(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Yo(...e) {
  return qe(() => si(...e), [...e]);
}
function jm(e) {
  var t;
  if (e.type)
    return e.type;
  let n = (t = e.as) != null ? t : "button";
  if (typeof n == "string" && n.toLowerCase() === "button")
    return "button";
}
function t0(e, t) {
  let [n, r] = Ce(() => jm(e));
  return _t(() => {
    r(jm(e));
  }, [e.type, e.as]), _t(() => {
    n || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [n, t]), n;
}
function Lm(e) {
  return [e.screenX, e.screenY];
}
function n0() {
  let e = Z([-1, -1]);
  return { wasMoved(t) {
    let n = Lm(t);
    return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
  }, update(t) {
    e.current = Lm(t);
  } };
}
function oO({ container: e, accept: t, walk: n, enabled: r = !0 }) {
  let o = Z(t), a = Z(n);
  Ee(() => {
    o.current = t, a.current = n;
  }, [t, n]), _t(() => {
    if (!e || !r)
      return;
    let i = si(e);
    if (!i)
      return;
    let s = o.current, c = a.current, l = Object.assign((u) => s(u), { acceptNode: s }), d = i.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, l, !1);
    for (; d.nextNode(); )
      c(d.currentNode);
  }, [e, r, o, a]);
}
function La(e, t) {
  let n = Z([]), r = Fe(e);
  Ee(() => {
    let o = [...n.current];
    for (let [a, i] of t.entries())
      if (n.current[a] !== i) {
        let s = r(t, o);
        return n.current = t, s;
      }
  }, [r, ...t]);
}
function aO() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
const r0 = {
  ...P
}, iO = r0.useInsertionEffect, sO = iO || ((e) => e());
function o0(e) {
  const t = P.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return sO(() => {
    t.current = e;
  }), P.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
var Ll = typeof document < "u" ? Ua : Ee;
let Fm = !1, cO = 0;
const Wm = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + cO++
);
function lO() {
  const [e, t] = P.useState(() => Fm ? Wm() : void 0);
  return Ll(() => {
    e == null && t(Wm());
  }, []), P.useEffect(() => {
    Fm = !0;
  }, []), e;
}
const uO = r0.useId, dO = uO || lO;
let Fa;
process.env.NODE_ENV !== "production" && (Fa = /* @__PURE__ */ new Set());
function fO() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Fa) != null && e.has(o))) {
    var a;
    (a = Fa) == null || a.add(o), console.warn(o);
  }
}
function mO() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Fa) != null && e.has(o))) {
    var a;
    (a = Fa) == null || a.add(o), console.error(o);
  }
}
function pO() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((o) => o !== n)) || []);
    }
  };
}
const hO = /* @__PURE__ */ P.createContext(null), vO = /* @__PURE__ */ P.createContext(null), gO = () => {
  var e;
  return ((e = P.useContext(hO)) == null ? void 0 : e.id) || null;
}, bO = () => P.useContext(vO);
function yO(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = dO(), a = P.useRef({}), [i] = P.useState(() => pO()), s = gO() != null;
  if (process.env.NODE_ENV !== "production") {
    const m = r.reference;
    m && !dn(m) && mO("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [c, l] = P.useState(r.reference), d = o0((m, b, x) => {
    a.current.openEvent = m ? b : void 0, i.emit("openchange", {
      open: m,
      event: b,
      reason: x,
      nested: s
    }), n == null || n(m, b, x);
  }), u = P.useMemo(() => ({
    setPositionReference: l
  }), []), v = P.useMemo(() => ({
    reference: c || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [c, r.reference, r.floating]);
  return P.useMemo(() => ({
    dataRef: a,
    open: t,
    onOpenChange: d,
    elements: v,
    events: i,
    floatingId: o,
    refs: u
  }), [t, d, v, i, o, u]);
}
function xO(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = yO({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, o = r.elements, [a, i] = P.useState(null), [s, c] = P.useState(null), d = (o == null ? void 0 : o.reference) || a, u = P.useRef(null), v = bO();
  Ll(() => {
    d && (u.current = d);
  }, [d]);
  const m = Jh({
    ...e,
    elements: {
      ...o,
      ...s && {
        reference: s
      }
    }
  }), b = P.useCallback((T) => {
    const S = dn(T) ? {
      getBoundingClientRect: () => T.getBoundingClientRect(),
      contextElement: T
    } : T;
    c(S), m.refs.setReference(S);
  }, [m.refs]), x = P.useCallback((T) => {
    (dn(T) || T === null) && (u.current = T, i(T)), (dn(m.refs.reference.current) || m.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    T !== null && !dn(T)) && m.refs.setReference(T);
  }, [m.refs]), g = P.useMemo(() => ({
    ...m.refs,
    setReference: x,
    setPositionReference: b,
    domReference: u
  }), [m.refs, x, b]), k = P.useMemo(() => ({
    ...m.elements,
    domReference: d
  }), [m.elements, d]), $ = P.useMemo(() => ({
    ...m,
    ...r,
    refs: g,
    elements: k,
    nodeId: t
  }), [m, g, k, t, r]);
  return Ll(() => {
    r.dataRef.current.floatingContext = $;
    const T = v == null ? void 0 : v.nodesRef.current.find((S) => S.id === t);
    T && (T.context = $);
  }), P.useMemo(() => ({
    ...m,
    context: $,
    refs: g,
    elements: k
  }), [m, g, k, $]);
}
const Hm = "active", Um = "selected";
function Yc(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let a = e;
  if (o && e) {
    const {
      [Hm]: i,
      [Um]: s,
      ...c
    } = e;
    a = c;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1
    },
    ...a,
    ...t.map((i) => {
      const s = i ? i[n] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((i, s) => (s && Object.entries(s).forEach((c) => {
      let [l, d] = c;
      if (!(o && [Hm, Um].includes(l)))
        if (l.indexOf("on") === 0) {
          if (r.has(l) || r.set(l, []), typeof d == "function") {
            var u;
            (u = r.get(l)) == null || u.push(d), i[l] = function() {
              for (var v, m = arguments.length, b = new Array(m), x = 0; x < m; x++)
                b[x] = arguments[x];
              return (v = r.get(l)) == null ? void 0 : v.map((g) => g(...b)).find((g) => g !== void 0);
            };
          }
        } else
          i[l] = d;
    }), i), {})
  };
}
function wO(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s == null ? void 0 : s.reference), n = e.map((s) => s == null ? void 0 : s.floating), r = e.map((s) => s == null ? void 0 : s.item), o = P.useCallback(
    (s) => Yc(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), a = P.useCallback(
    (s) => Yc(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), i = P.useCallback(
    (s) => Yc(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return P.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: a,
    getItemProps: i
  }), [o, a, i]);
}
function Bm(e, t) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: t
      }
    }
  };
}
const EO = (e) => ({
  name: "inner",
  options: e,
  async fn(t) {
    const {
      listRef: n,
      overflowRef: r,
      onFallbackChange: o,
      offset: a = 0,
      index: i = 0,
      minItemsVisible: s = 4,
      referenceOverflowThreshold: c = 0,
      scrollRef: l,
      ...d
    } = lr(e, t), {
      rects: u,
      elements: {
        floating: v
      }
    } = t, m = n.current[i];
    if (process.env.NODE_ENV !== "production" && (t.placement.startsWith("bottom") || fO('`placement` side must be "bottom" when using the `inner`', "middleware.")), !m)
      return {};
    const b = {
      ...t,
      ...await Ou(-m.offsetTop - v.clientTop - u.reference.height / 2 - m.offsetHeight / 2 - a).fn(t)
    }, x = (l == null ? void 0 : l.current) || v, g = await Hc(Bm(b, x.scrollHeight), d), k = await Hc(b, {
      ...d,
      elementContext: "reference"
    }), $ = Math.max(0, g.top), T = b.y + $, S = Math.max(0, x.scrollHeight - $ - Math.max(0, g.bottom));
    return x.style.maxHeight = S + "px", x.scrollTop = $, o && (x.offsetHeight < m.offsetHeight * Math.min(s, n.current.length - 1) - 1 || k.top >= -c || k.bottom >= -c ? Wr.flushSync(() => o(!0)) : Wr.flushSync(() => o(!1))), r && (r.current = await Hc(Bm({
      ...b,
      y: T
    }, x.offsetHeight), d)), {
      y: T
    };
  }
});
function $O(e, t) {
  const {
    open: n,
    elements: r
  } = e, {
    enabled: o = !0,
    overflowRef: a,
    scrollRef: i,
    onChange: s
  } = t, c = o0(s), l = P.useRef(!1), d = P.useRef(null), u = P.useRef(null);
  P.useEffect(() => {
    if (!o)
      return;
    function m(x) {
      if (x.ctrlKey || !b || a.current == null)
        return;
      const g = x.deltaY, k = a.current.top >= -0.5, $ = a.current.bottom >= -0.5, T = b.scrollHeight - b.clientHeight, S = g < 0 ? -1 : 1, C = g < 0 ? "max" : "min";
      b.scrollHeight <= b.clientHeight || (!k && g > 0 || !$ && g < 0 ? (x.preventDefault(), Wr.flushSync(() => {
        c((N) => N + Math[C](g, T * S));
      })) : /firefox/i.test(aO()) && (b.scrollTop += g));
    }
    const b = (i == null ? void 0 : i.current) || r.floating;
    if (n && b)
      return b.addEventListener("wheel", m), requestAnimationFrame(() => {
        d.current = b.scrollTop, a.current != null && (u.current = {
          ...a.current
        });
      }), () => {
        d.current = null, u.current = null, b.removeEventListener("wheel", m);
      };
  }, [o, n, r.floating, a, i, c]);
  const v = P.useMemo(() => ({
    onKeyDown() {
      l.current = !0;
    },
    onWheel() {
      l.current = !1;
    },
    onPointerMove() {
      l.current = !1;
    },
    onScroll() {
      const m = (i == null ? void 0 : i.current) || r.floating;
      if (!(!a.current || !m || !l.current)) {
        if (d.current !== null) {
          const b = m.scrollTop - d.current;
          (a.current.bottom < -0.5 && b < -1 || a.current.top < -0.5 && b > 1) && Wr.flushSync(() => c((x) => x + b));
        }
        requestAnimationFrame(() => {
          d.current = m.scrollTop;
        });
      }
    }
  }), [r.floating, c, a, i]);
  return P.useMemo(() => o ? {
    floating: v
  } : {}, [o, v]);
}
let Ko = Et({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
Ko.displayName = "FloatingContext";
let ld = Et(null);
ld.displayName = "PlacementContext";
function a0() {
  return Ye(Ko).setReference;
}
function TO() {
  return Ye(Ko).getReferenceProps;
}
function i0() {
  let { getFloatingProps: e, slot: t } = Ye(Ko);
  return Ie((...n) => Object.assign({}, e(...n), { "data-anchor": t.anchor }), [e, t]);
}
function s0(e) {
  let t = Ye(ld), n = qe(() => e, [JSON.stringify(e, typeof HTMLElement < "u" ? (o, a) => a instanceof HTMLElement ? a.outerHTML : a : void 0)]);
  _t(() => {
    t == null || t(n ?? null);
  }, [t, n]);
  let r = Ye(Ko);
  return qe(() => [r.setFloating, r.styles], [r.setFloating, r.styles]);
}
let zm = 4;
function c0({ children: e, enabled: t = !0 }) {
  let [n, r] = Ce(null), [o, a] = Ce(0), i = Z(null), [s, c] = Ce(null);
  SO(s);
  let l = t && n !== null && s !== null, { to: d = "bottom", gap: u = 0, offset: v = 0, padding: m = 0, inner: b } = kO(n, s), [x, g = "center"] = d.split(" ");
  _t(() => {
    l && a(0);
  }, [l]);
  let { refs: k, floatingStyles: $, context: T } = xO({ open: l, placement: x === "selection" ? g === "center" ? "bottom" : `bottom-${g}` : g === "center" ? `${x}` : `${x}-${g}`, strategy: "fixed", transform: !1, middleware: [Ou({ mainAxis: x === "selection" ? 0 : u, crossAxis: v }), ev({ padding: m }), x !== "selection" && tv(), x === "selection" && b ? EO({ ...b, padding: m, overflowRef: i, offset: o, minItemsVisible: zm, referenceOverflowThreshold: m, onFallbackChange(V) {
    var Q, ke;
    if (!V)
      return;
    let H = T.elements.floating;
    if (!H)
      return;
    let X = parseFloat(getComputedStyle(H).scrollPaddingBottom) || 0, he = Math.min(zm, H.childElementCount), $e = 0, Te = 0;
    for (let fe of (ke = (Q = T.elements.floating) == null ? void 0 : Q.childNodes) != null ? ke : [])
      if (fe instanceof HTMLElement) {
        let Y = fe.offsetTop, O = Y + fe.clientHeight + X, G = H.scrollTop, W = G + H.clientHeight;
        if (Y >= G && O <= W)
          he--;
        else {
          Te = Math.max(0, Math.min(O, W) - Math.max(Y, G)), $e = fe.clientHeight;
          break;
        }
      }
    he >= 1 && a((fe) => {
      let Y = $e * he - Te + X;
      return fe >= Y ? fe : Y;
    });
  } }) : null, nv({ apply({ availableWidth: V, availableHeight: Q, elements: ke }) {
    Object.assign(ke.floating.style, { maxWidth: `${V - m}px`, maxHeight: `${Q - m}px` });
  } })].filter(Boolean), whileElementsMounted: Zh }), [S = x, C = g] = T.placement.split("-");
  x === "selection" && (S = "selection");
  let N = qe(() => ({ anchor: [S, C].filter(Boolean).join(" ") }), [S, C]), U = $O(T, { overflowRef: i, onChange: a }), { getReferenceProps: L, getFloatingProps: j } = wO([U]), q = Fe((V) => {
    c(V), k.setFloating(V);
  });
  return P.createElement(ld.Provider, { value: r }, P.createElement(Ko.Provider, { value: { setFloating: q, setReference: k.setReference, styles: l ? $ : {}, getReferenceProps: L, getFloatingProps: j, slot: N } }, e));
}
function SO(e) {
  _t(() => {
    if (!e)
      return;
    let t = new MutationObserver(() => {
      let n = e.style.maxHeight;
      parseFloat(n) !== parseInt(n) && (e.style.maxHeight = `${Math.ceil(parseFloat(n))}px`);
    });
    return t.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function kO(e, t) {
  let n = Kc(e == null ? void 0 : e.gap, t), r = Kc(e == null ? void 0 : e.offset, t), o = Kc(e == null ? void 0 : e.padding, t);
  return { ...e, gap: n, offset: r, padding: o };
}
function Kc(e, t, n = void 0) {
  let r = dr(), o = Fe((c, l) => {
    if (c == null)
      return [n, null];
    if (typeof c == "number")
      return [c, null];
    if (typeof c == "string") {
      if (!l)
        return [n, null];
      let d = Vm(c, l);
      return [d, (u) => {
        let v = l0(c);
        {
          let m = v.map((b) => window.getComputedStyle(l).getPropertyValue(b));
          r.requestAnimationFrame(function b() {
            r.nextFrame(b);
            let x = !1;
            for (let [k, $] of v.entries()) {
              let T = window.getComputedStyle(l).getPropertyValue($);
              if (m[k] !== T) {
                m[k] = T, x = !0;
                break;
              }
            }
            if (!x)
              return;
            let g = Vm(c, l);
            d !== g && (u(g), d = g);
          });
        }
        return r.dispose;
      }];
    }
    return [n, null];
  }), a = qe(() => o(e, t)[0], [e, t]), [i = a, s] = Ce();
  return _t(() => {
    let [c, l] = o(e, t);
    if (s(c), !!l)
      return l(s);
  }, [e, t]), i;
}
function l0(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let n = t[1].indexOf(",");
    if (n === -1)
      return [t[1]];
    let r = t[1].slice(0, n).trim(), o = t[1].slice(n + 1).trim();
    return o ? [r, ...l0(o)] : [r];
  }
  return [];
}
function Vm(e, t) {
  let n = document.createElement("div");
  t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
  let r = parseFloat(window.getComputedStyle(n).marginTop) || 0;
  return t.removeChild(n), r;
}
let ud = Et(null);
ud.displayName = "OpenClosedContext";
var _r = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(_r || {});
function u0() {
  return Ye(ud);
}
function d0({ value: e, children: t }) {
  return ce.createElement(ud.Provider, { value: e }, t);
}
function _O(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let ar = [];
_O(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && ar[0] !== t.target && (ar.unshift(t.target), ar = ar.filter((n) => n != null && n.isConnected), ar.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function CO(e) {
  throw new Error("Unexpected object: " + e);
}
var nt = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(nt || {});
function Pa(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let r = t.resolveActiveIndex(), o = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let a = 0; a < n.length; ++a)
        if (!t.resolveDisabled(n[a], a, n))
          return a;
      return r;
    }
    case 1: {
      o === -1 && (o = n.length);
      for (let a = o - 1; a >= 0; --a)
        if (!t.resolveDisabled(n[a], a, n))
          return a;
      return r;
    }
    case 2: {
      for (let a = o + 1; a < n.length; ++a)
        if (!t.resolveDisabled(n[a], a, n))
          return a;
      return r;
    }
    case 3: {
      for (let a = n.length - 1; a >= 0; --a)
        if (!t.resolveDisabled(n[a], a, n))
          return a;
      return r;
    }
    case 4: {
      for (let a = 0; a < n.length; ++a)
        if (t.resolveId(n[a], a, n) === e.id)
          return a;
      return r;
    }
    case 5:
      return null;
    default:
      CO(e);
  }
}
var PO = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(PO || {}), AO = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(AO || {}), OO = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(OO || {}), NO = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.SetActivationTrigger = 5] = "SetActivationTrigger", e[e.UpdateVirtualOptions = 6] = "UpdateVirtualOptions", e))(NO || {});
function Xc(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = t(e.options.slice()), o = r.length > 0 && r[0].dataRef.current.order !== null ? r.sort((i, s) => i.dataRef.current.order - s.dataRef.current.order) : cd(r, (i) => i.dataRef.current.domRef.current), a = n ? o.indexOf(n) : null;
  return a === -1 && (a = null), { options: o, activeOptionIndex: a };
}
let RO = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1 };
}, 0(e) {
  var t, n;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0)
    return e;
  if ((n = e.dataRef.current) != null && n.value) {
    let r = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (r !== -1)
      return { ...e, activeOptionIndex: r, comboboxState: 0 };
  }
  return { ...e, comboboxState: 0 };
}, 2(e, t) {
  var n, r, o, a, i;
  if ((n = e.dataRef.current) != null && n.disabled || (r = e.dataRef.current) != null && r.optionsRef.current && !((o = e.dataRef.current) != null && o.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  if (e.virtual) {
    let d = t.focus === nt.Specific ? t.idx : Pa(t, { resolveItems: () => e.virtual.options, resolveActiveIndex: () => {
      var v, m;
      return (m = (v = e.activeOptionIndex) != null ? v : e.virtual.options.findIndex((b) => !e.virtual.disabled(b))) != null ? m : null;
    }, resolveDisabled: e.virtual.disabled, resolveId() {
      throw new Error("Function not implemented.");
    } }), u = (a = t.trigger) != null ? a : 2;
    return e.activeOptionIndex === d && e.activationTrigger === u ? e : { ...e, activeOptionIndex: d, activationTrigger: u };
  }
  let s = Xc(e);
  if (s.activeOptionIndex === null) {
    let d = s.options.findIndex((u) => !u.dataRef.current.disabled);
    d !== -1 && (s.activeOptionIndex = d);
  }
  let c = t.focus === nt.Specific ? t.idx : Pa(t, { resolveItems: () => s.options, resolveActiveIndex: () => s.activeOptionIndex, resolveId: (d) => d.id, resolveDisabled: (d) => d.dataRef.current.disabled }), l = (i = t.trigger) != null ? i : 2;
  return e.activeOptionIndex === c && e.activationTrigger === l ? e : { ...e, ...s, activeOptionIndex: c, activationTrigger: l };
}, 3: (e, t) => {
  var n, r, o;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: [...e.options, t.payload] };
  let a = t.payload, i = Xc(e, (c) => (c.push(a), c));
  e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.payload.dataRef.current.value) && (i.activeOptionIndex = i.options.indexOf(a));
  let s = { ...e, ...i, activationTrigger: 2 };
  return (o = e.dataRef.current) != null && o.__demoMode && e.dataRef.current.value === void 0 && (s.activeOptionIndex = 0), s;
}, 4: (e, t) => {
  var n;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: e.options.filter((o) => o.id !== t.id) };
  let r = Xc(e, (o) => {
    let a = o.findIndex((i) => i.id === t.id);
    return a !== -1 && o.splice(a, 1), o;
  });
  return { ...e, ...r, activationTrigger: 2 };
}, 5: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 6: (e, t) => {
  var n;
  if (((n = e.virtual) == null ? void 0 : n.options) === t.options)
    return e;
  let r = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let o = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    o !== -1 ? r = o : r = null;
  }
  return { ...e, activeOptionIndex: r, virtual: Object.assign({}, e.virtual, { options: t.options }) };
} }, dd = Et(null);
dd.displayName = "ComboboxActionsContext";
function rc(e) {
  let t = Ye(dd);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, rc), n;
  }
  return t;
}
let f0 = Et(null);
function MO(e) {
  var t;
  let n = Xo("VirtualProvider"), [r, o] = qe(() => {
    let c = n.optionsRef.current;
    if (!c)
      return [0, 0];
    let l = window.getComputedStyle(c);
    return [parseFloat(l.paddingBlockStart || l.paddingTop), parseFloat(l.paddingBlockEnd || l.paddingBottom)];
  }, [n.optionsRef.current]), a = YA({ scrollPaddingStart: r, scrollPaddingEnd: o, count: n.virtual.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    var c;
    return (c = n.optionsRef.current) != null ? c : null;
  }, overscan: 12 }), [i, s] = Ce(0);
  return _t(() => {
    s((c) => c + 1);
  }, [(t = n.virtual) == null ? void 0 : t.options]), ce.createElement(f0.Provider, { value: a }, ce.createElement("div", { style: { position: "relative", width: "100%", height: `${a.getTotalSize()}px` }, ref: (c) => {
    if (c) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || n.activationTrigger === 0)
        return;
      n.activeOptionIndex !== null && n.virtual.options.length > n.activeOptionIndex && a.scrollToIndex(n.activeOptionIndex);
    }
  } }, a.getVirtualItems().map((c) => {
    var l;
    return ce.createElement(Jt, { key: c.key }, ce.cloneElement((l = e.children) == null ? void 0 : l.call(e, { option: n.virtual.options[c.index], open: n.comboboxState === 0 }), { key: `${i}-${c.key}`, "data-index": c.index, "aria-setsize": n.virtual.options.length, "aria-posinset": c.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${c.start}px)`, overflowAnchor: "none" } }));
  })));
}
let fd = Et(null);
fd.displayName = "ComboboxDataContext";
function Xo(e) {
  let t = Ye(fd);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Xo), n;
  }
  return t;
}
function DO(e, t) {
  return nn(t.type, RO, e, t);
}
let IO = Jt;
function jO(e, t) {
  var n, r;
  let o = tc(), { value: a, defaultValue: i, onChange: s, form: c, name: l, by: d, disabled: u = o || !1, __demoMode: v = !1, nullable: m = !1, multiple: b = !1, immediate: x = !1, virtual: g = null, ...k } = e, [$ = b ? [] : void 0, T] = Dg(a, s, i), [S, C] = mr(DO, { dataRef: op(), comboboxState: v ? 0 : 1, options: [], virtual: g ? { options: g.options, disabled: (n = g.disabled) != null ? n : () => !1 } : null, activeOptionIndex: null, activationTrigger: 2 }), N = Z(!1), U = Z({ static: !1, hold: !1 }), L = Z(null), j = Z(null), q = Z(null), V = Kg(d), Q = Fe((ne) => g ? d === null ? g.options.indexOf(ne) : g.options.findIndex((ye) => V(ye, ne)) : S.options.findIndex((ye) => V(ye.dataRef.current.value, ne))), ke = Ie((ne) => nn(X.mode, { 1: () => $.some((ye) => V(ye, ne)), 0: () => V($, ne) }), [$]), H = Fe((ne) => S.activeOptionIndex === Q(ne)), X = qe(() => ({ ...S, immediate: x, optionsPropsRef: U, inputRef: L, buttonRef: j, optionsRef: q, value: $, defaultValue: i, disabled: u, mode: b ? 1 : 0, virtual: S.virtual, get activeOptionIndex() {
    if (N.current && S.activeOptionIndex === null && (g ? g.options.length > 0 : S.options.length > 0)) {
      if (g) {
        let ye = g.options.findIndex((ze) => {
          var pe, mt;
          return !((mt = (pe = g == null ? void 0 : g.disabled) == null ? void 0 : pe.call(g, ze)) != null && mt);
        });
        if (ye !== -1)
          return ye;
      }
      let ne = S.options.findIndex((ye) => !ye.dataRef.current.disabled);
      if (ne !== -1)
        return ne;
    }
    return S.activeOptionIndex;
  }, calculateIndex: Q, compare: V, isSelected: ke, isActive: H, nullable: m, __demoMode: v }), [$, i, u, b, m, v, S, g]);
  _t(() => {
    g && C({ type: 6, options: g.options });
  }, [g, g == null ? void 0 : g.options]), _t(() => {
    S.dataRef.current = X;
  }, [X]), e0([X.buttonRef, X.inputRef, X.optionsRef], () => ae.closeCombobox(), X.comboboxState === 0);
  let he = qe(() => {
    var ne, ye, ze;
    return { open: X.comboboxState === 0, disabled: u, activeIndex: X.activeOptionIndex, activeOption: X.activeOptionIndex === null ? null : X.virtual ? X.virtual.options[(ne = X.activeOptionIndex) != null ? ne : 0] : (ze = (ye = X.options[X.activeOptionIndex]) == null ? void 0 : ye.dataRef.current.value) != null ? ze : null, value: $ };
  }, [X, u, $]), $e = Fe(() => {
    if (X.activeOptionIndex !== null) {
      if (X.virtual)
        G(X.virtual.options[X.activeOptionIndex]);
      else {
        let { dataRef: ne } = X.options[X.activeOptionIndex];
        G(ne.current.value);
      }
      ae.goToOption(nt.Specific, X.activeOptionIndex);
    }
  }), Te = Fe(() => {
    C({ type: 0 }), N.current = !0;
  }), fe = Fe(() => {
    C({ type: 1 }), N.current = !1;
  }), Y = Fe((ne, ye, ze) => (N.current = !1, ne === nt.Specific ? C({ type: 2, focus: nt.Specific, idx: ye, trigger: ze }) : C({ type: 2, focus: ne, trigger: ze }))), O = Fe((ne, ye) => (C({ type: 3, payload: { id: ne, dataRef: ye } }), () => {
    X.isActive(ye.current.value) && (N.current = !0), C({ type: 4, id: ne });
  })), G = Fe((ne) => nn(X.mode, { 0() {
    return T == null ? void 0 : T(ne);
  }, 1() {
    let ye = X.value.slice(), ze = ye.findIndex((pe) => V(pe, ne));
    return ze === -1 ? ye.push(ne) : ye.splice(ze, 1), T == null ? void 0 : T(ye);
  } })), W = Fe((ne) => {
    C({ type: 5, trigger: ne });
  }), ae = qe(() => ({ onChange: G, registerOption: O, goToOption: Y, closeCombobox: fe, openCombobox: Te, setActivationTrigger: W, selectActiveOption: $e }), []), [te, se] = Gg(), Se = t === null ? {} : { ref: t }, me = Ie(() => T == null ? void 0 : T(i), [T]);
  return ce.createElement(se, { value: te, props: { htmlFor: (r = X.inputRef.current) == null ? void 0 : r.id }, slot: { open: X.comboboxState === 0, disabled: u } }, ce.createElement(c0, null, ce.createElement(dd.Provider, { value: ae }, ce.createElement(fd.Provider, { value: X }, ce.createElement(d0, { value: nn(X.comboboxState, { 0: _r.Open, 1: _r.Closed }) }, l != null && ce.createElement(Wg, { data: $ != null ? { [l]: $ } : {}, form: c, onReset: me }), on({ ourProps: Se, theirProps: k, slot: he, defaultTag: IO, name: "Combobox" }))))));
}
let LO = "input";
function FO(e, t) {
  var n, r, o, a, i, s, c;
  let l = pr(), d = ad(), { id: u = d || `headlessui-combobox-input-${l}`, onChange: v, displayValue: m, type: b = "text", ...x } = e, g = Xo("Combobox.Input"), k = rc("Combobox.Input"), $ = yn(g.inputRef, t, a0()), T = Yo(g.inputRef), S = Z(!1), C = dr(), N = Fe(() => {
    k.onChange(null), g.optionsRef.current && (g.optionsRef.current.scrollTop = 0), k.goToOption(nt.Nothing);
  }), U = function() {
    var W;
    return typeof m == "function" && g.value !== void 0 ? (W = m(g.value)) != null ? W : "" : typeof g.value == "string" ? g.value : "";
  }();
  La(([W, ae], [te, se]) => {
    if (S.current)
      return;
    let Se = g.inputRef.current;
    Se && ((se === 0 && ae === 1 || W !== te) && (Se.value = W), requestAnimationFrame(() => {
      if (S.current || !Se || (T == null ? void 0 : T.activeElement) !== Se)
        return;
      let { selectionStart: me, selectionEnd: ne } = Se;
      Math.abs((ne ?? 0) - (me ?? 0)) === 0 && me === 0 && Se.setSelectionRange(Se.value.length, Se.value.length);
    }));
  }, [U, g.comboboxState, T]), La(([W], [ae]) => {
    if (W === 0 && ae === 1) {
      if (S.current)
        return;
      let te = g.inputRef.current;
      if (!te)
        return;
      let se = te.value, { selectionStart: Se, selectionEnd: me, selectionDirection: ne } = te;
      te.value = "", te.value = se, ne !== null ? te.setSelectionRange(Se, me, ne) : te.setSelectionRange(Se, me);
    }
  }, [g.comboboxState]);
  let L = Z(!1), j = Fe(() => {
    L.current = !0;
  }), q = Fe(() => {
    C.nextFrame(() => {
      L.current = !1;
    });
  }), V = Fe((W) => {
    switch (S.current = !0, W.key) {
      case kt.Enter:
        if (S.current = !1, g.comboboxState !== 0 || L.current)
          return;
        if (W.preventDefault(), W.stopPropagation(), g.activeOptionIndex === null) {
          k.closeCombobox();
          return;
        }
        k.selectActiveOption(), g.mode === 0 && k.closeCombobox();
        break;
      case kt.ArrowDown:
        return S.current = !1, W.preventDefault(), W.stopPropagation(), nn(g.comboboxState, { 0: () => k.goToOption(nt.Next), 1: () => k.openCombobox() });
      case kt.ArrowUp:
        return S.current = !1, W.preventDefault(), W.stopPropagation(), nn(g.comboboxState, { 0: () => k.goToOption(nt.Previous), 1: () => {
          k.openCombobox(), C.nextFrame(() => {
            g.value || k.goToOption(nt.Last);
          });
        } });
      case kt.Home:
        if (W.shiftKey)
          break;
        return S.current = !1, W.preventDefault(), W.stopPropagation(), k.goToOption(nt.First);
      case kt.PageUp:
        return S.current = !1, W.preventDefault(), W.stopPropagation(), k.goToOption(nt.First);
      case kt.End:
        if (W.shiftKey)
          break;
        return S.current = !1, W.preventDefault(), W.stopPropagation(), k.goToOption(nt.Last);
      case kt.PageDown:
        return S.current = !1, W.preventDefault(), W.stopPropagation(), k.goToOption(nt.Last);
      case kt.Escape:
        return S.current = !1, g.comboboxState !== 0 ? void 0 : (W.preventDefault(), g.optionsRef.current && !g.optionsPropsRef.current.static && W.stopPropagation(), g.nullable && g.mode === 0 && g.value === null && N(), k.closeCombobox());
      case kt.Tab:
        if (S.current = !1, g.comboboxState !== 0)
          return;
        g.mode === 0 && g.activationTrigger !== 1 && k.selectActiveOption(), k.closeCombobox();
        break;
    }
  }), Q = Fe((W) => {
    v == null || v(W), g.nullable && g.mode === 0 && W.target.value === "" && N(), k.openCombobox();
  }), ke = Fe((W) => {
    var ae, te, se;
    let Se = (ae = W.relatedTarget) != null ? ae : ar.find((me) => me !== W.currentTarget);
    if (S.current = !1, !((te = g.optionsRef.current) != null && te.contains(Se)) && !((se = g.buttonRef.current) != null && se.contains(Se)) && g.comboboxState === 0)
      return W.preventDefault(), g.mode === 0 && (g.nullable && g.value === null ? N() : g.activationTrigger !== 1 && k.selectActiveOption()), k.closeCombobox();
  }), H = Fe((W) => {
    var ae, te, se;
    let Se = (ae = W.relatedTarget) != null ? ae : ar.find((me) => me !== W.currentTarget);
    (te = g.buttonRef.current) != null && te.contains(Se) || (se = g.optionsRef.current) != null && se.contains(Se) || g.disabled || g.immediate && g.comboboxState !== 0 && (k.openCombobox(), C.nextFrame(() => {
      k.setActivationTrigger(1);
    }));
  }), X = li(), he = zg(), { isFocusVisible: $e, focusProps: Te } = td({ isTextInput: !0, autoFocus: (n = e.autoFocus) != null ? n : !1 }), { isHovered: fe, hoverProps: Y } = rd({ isDisabled: (r = g.disabled) != null ? r : !1 }), O = qe(() => {
    var W;
    return { open: g.comboboxState === 0, disabled: g.disabled, hover: fe, focus: $e, autofocus: (W = e.autoFocus) != null ? W : !1 };
  }, [g, fe, $e, e.autoFocus]), G = ci({ ref: $, id: u, role: "combobox", type: b, "aria-controls": (o = g.optionsRef.current) == null ? void 0 : o.id, "aria-expanded": g.comboboxState === 0, "aria-activedescendant": g.activeOptionIndex === null ? void 0 : g.virtual ? (a = g.options.find((W) => {
    var ae;
    return !((ae = g.virtual) != null && ae.disabled(W.dataRef.current.value)) && g.compare(W.dataRef.current.value, g.virtual.options[g.activeOptionIndex]);
  })) == null ? void 0 : a.id : (i = g.options[g.activeOptionIndex]) == null ? void 0 : i.id, "aria-labelledby": X, "aria-describedby": he, "aria-autocomplete": "list", defaultValue: (c = (s = e.defaultValue) != null ? s : g.defaultValue !== void 0 ? m == null ? void 0 : m(g.defaultValue) : null) != null ? c : g.defaultValue, disabled: g.disabled, onCompositionStart: j, onCompositionEnd: q, onKeyDown: V, onChange: Q, onFocus: H, onBlur: ke }, Te, Y);
  return on({ ourProps: G, theirProps: x, slot: O, defaultTag: LO, name: "Combobox.Input" });
}
let WO = "button";
function HO(e, t) {
  var n, r, o, a;
  let i = Xo("Combobox.Button"), s = rc("Combobox.Button"), c = yn(i.buttonRef, t), l = pr(), { id: d = `headlessui-combobox-button-${l}`, ...u } = e, v = dr(), m = Fe((L) => {
    switch (L.key) {
      case kt.ArrowDown:
        return L.preventDefault(), L.stopPropagation(), i.comboboxState === 1 && s.openCombobox(), v.nextFrame(() => {
          var j;
          return (j = i.inputRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
        });
      case kt.ArrowUp:
        return L.preventDefault(), L.stopPropagation(), i.comboboxState === 1 && (s.openCombobox(), v.nextFrame(() => {
          i.value || s.goToOption(nt.Last);
        })), v.nextFrame(() => {
          var j;
          return (j = i.inputRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
        });
      case kt.Escape:
        return i.comboboxState !== 0 ? void 0 : (L.preventDefault(), i.optionsRef.current && !i.optionsPropsRef.current.static && L.stopPropagation(), s.closeCombobox(), v.nextFrame(() => {
          var j;
          return (j = i.inputRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
        }));
      default:
        return;
    }
  }), b = Fe((L) => {
    if (Hg(L.currentTarget))
      return L.preventDefault();
    i.comboboxState === 0 ? s.closeCombobox() : (L.preventDefault(), s.openCombobox()), v.nextFrame(() => {
      var j;
      return (j = i.inputRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
    });
  }), x = li([d]), { isFocusVisible: g, focusProps: k } = td({ isTextInput: !0, autoFocus: (n = e.autoFocus) != null ? n : !1 }), { isHovered: $, hoverProps: T } = rd({ isDisabled: (r = i.disabled) != null ? r : !1 }), { pressed: S, pressProps: C } = Rg({ disabled: (o = i.disabled) != null ? o : !1 }), N = qe(() => ({ open: i.comboboxState === 0, active: S || i.comboboxState === 0, disabled: i.disabled, value: i.value, hover: $, focus: g }), [i, $, g, S]), U = ci({ ref: c, id: d, type: t0(e, i.buttonRef), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (a = i.optionsRef.current) == null ? void 0 : a.id, "aria-expanded": i.comboboxState === 0, "aria-labelledby": x, disabled: i.disabled, onClick: b, onKeyDown: m }, k, T, C);
  return on({ ourProps: U, theirProps: u, slot: N, defaultTag: WO, name: "Combobox.Button" });
}
let UO = "ul", BO = po.RenderStrategy | po.Static;
function zO(e, t) {
  var n;
  let r = pr(), { id: o = `headlessui-combobox-options-${r}`, hold: a = !1, anchor: i, ...s } = e, c = Xo("Combobox.Options"), [l, d] = s0(i), u = i0(), v = yn(c.optionsRef, t, i ? l : null), m = u0(), b = (() => m !== null ? (m & _r.Open) === _r.Open : c.comboboxState === 0)();
  _t(() => {
    var $;
    c.optionsPropsRef.current.static = ($ = e.static) != null ? $ : !1;
  }, [c.optionsPropsRef, e.static]), _t(() => {
    c.optionsPropsRef.current.hold = a;
  }, [c.optionsPropsRef, a]), oO({ container: c.optionsRef.current, enabled: c.comboboxState === 0, accept($) {
    return $.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : $.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk($) {
    $.setAttribute("role", "none");
  } });
  let x = li([(n = c.buttonRef.current) == null ? void 0 : n.id]), g = qe(() => ({ open: c.comboboxState === 0, option: void 0 }), [c]), k = ci(i ? u() : {}, { "aria-labelledby": x, role: "listbox", "aria-multiselectable": c.mode === 1 ? !0 : void 0, id: o, ref: v, ...d ? { style: d } : {} });
  return c.virtual && c.comboboxState === 0 && Object.assign(s, { children: ce.createElement(MO, null, s.children) }), on({ ourProps: k, theirProps: s, slot: g, defaultTag: UO, features: BO, visible: b, name: "Combobox.Options" });
}
let VO = "li";
function GO(e, t) {
  var n;
  let r = pr(), { id: o = `headlessui-combobox-option-${r}`, disabled: a = !1, value: i, order: s = null, ...c } = e, l = Xo("Combobox.Option"), d = rc("Combobox.Option"), u = l.virtual ? l.activeOptionIndex === l.calculateIndex(i) : l.activeOptionIndex === null ? !1 : ((n = l.options[l.activeOptionIndex]) == null ? void 0 : n.id) === o, v = l.isSelected(i), m = Z(null), b = wo({ disabled: a, value: i, domRef: m, order: s }), x = Ye(f0), g = yn(t, m, x ? x.measureElement : null), k = Fe(() => d.onChange(i));
  _t(() => d.registerOption(o, b), [b, o]);
  let $ = Z(!(l.virtual || l.__demoMode));
  _t(() => {
    if (!l.virtual || !l.__demoMode)
      return;
    let q = kr();
    return q.requestAnimationFrame(() => {
      $.current = !0;
    }), q.dispose;
  }, [l.virtual, l.__demoMode]), _t(() => {
    if (!$.current || l.comboboxState !== 0 || !u || l.activationTrigger === 0)
      return;
    let q = kr();
    return q.requestAnimationFrame(() => {
      var V, Q;
      (Q = (V = m.current) == null ? void 0 : V.scrollIntoView) == null || Q.call(V, { block: "nearest" });
    }), q.dispose;
  }, [m, u, l.comboboxState, l.activationTrigger, l.activeOptionIndex]);
  let T = Fe((q) => {
    var V;
    if (a || (V = l.virtual) != null && V.disabled(i))
      return q.preventDefault();
    k(), Qg() || requestAnimationFrame(() => {
      var Q;
      return (Q = l.inputRef.current) == null ? void 0 : Q.focus({ preventScroll: !0 });
    }), l.mode === 0 && requestAnimationFrame(() => d.closeCombobox());
  }), S = Fe(() => {
    var q;
    if (a || (q = l.virtual) != null && q.disabled(i))
      return d.goToOption(nt.Nothing);
    let V = l.calculateIndex(i);
    d.goToOption(nt.Specific, V);
  }), C = n0(), N = Fe((q) => C.update(q)), U = Fe((q) => {
    var V;
    if (!C.wasMoved(q) || a || (V = l.virtual) != null && V.disabled(i) || u)
      return;
    let Q = l.calculateIndex(i);
    d.goToOption(nt.Specific, Q, 0);
  }), L = Fe((q) => {
    var V;
    C.wasMoved(q) && (a || (V = l.virtual) != null && V.disabled(i) || u && (l.optionsPropsRef.current.hold || d.goToOption(nt.Nothing)));
  }), j = qe(() => ({ active: u, focus: u, selected: v, disabled: a }), [u, v, a]);
  return on({ ourProps: { id: o, ref: g, role: "option", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-selected": v, disabled: void 0, onClick: T, onFocus: S, onPointerEnter: N, onMouseEnter: N, onPointerMove: U, onMouseMove: U, onPointerLeave: L, onMouseLeave: L }, theirProps: c, slot: j, defaultTag: VO, name: "Combobox.Option" });
}
let qO = an(jO), m0 = an(HO), p0 = an(FO), YO = qg, KO = an(zO), XO = an(GO), en = Object.assign(qO, { Input: p0, Button: m0, Label: YO, Options: KO, Option: XO });
function ZO(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const QO = typeof Object.is == "function" ? Object.is : ZO, { useState: JO, useEffect: e8, useLayoutEffect: t8, useDebugValue: n8 } = P;
function r8(e, t, n) {
  const r = t(), [{ inst: o }, a] = JO({ inst: { value: r, getSnapshot: t } });
  return t8(() => {
    o.value = r, o.getSnapshot = t, Zc(o) && a({ inst: o });
  }, [e, r, t]), e8(() => (Zc(o) && a({ inst: o }), e(() => {
    Zc(o) && a({ inst: o });
  })), [e]), n8(r), r;
}
function Zc(e) {
  const t = e.getSnapshot, n = e.value;
  try {
    const r = t();
    return !QO(n, r);
  } catch {
    return !0;
  }
}
function o8(e, t, n) {
  return t();
}
const a8 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", i8 = !a8, s8 = i8 ? o8 : r8, c8 = "useSyncExternalStore" in P ? ((e) => e.useSyncExternalStore)(P) : s8;
function l8(e) {
  return c8(e.subscribe, e.getSnapshot, e.getSnapshot);
}
function u8(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(o) {
    return r.add(o), () => r.delete(o);
  }, dispatch(o, ...a) {
    let i = t[o].call(n, ...a);
    i && (n = i, r.forEach((s) => s()));
  } };
}
function d8() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement, o = (n = t.defaultView) != null ? n : window;
    e = Math.max(0, o.innerWidth - r.clientWidth);
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, o = Math.max(0, r.clientWidth - r.offsetWidth), a = Math.max(0, e - o);
    n.style(r, "paddingRight", `${a}px`);
  } };
}
function f8() {
  return Zg() ? { before({ doc: e, d: t, meta: n }) {
    function r(o) {
      return n.containers.flatMap((a) => a()).some((a) => a.contains(o));
    }
    t.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let s = kr();
        s.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => s.dispose()));
      }
      let a = (o = window.scrollY) != null ? o : window.pageYOffset, i = null;
      t.addEventListener(e, "click", (s) => {
        if (s.target instanceof HTMLElement)
          try {
            let c = s.target.closest("a");
            if (!c)
              return;
            let { hash: l } = new URL(c.href), d = e.querySelector(l);
            d && !r(d) && (i = d);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (s) => {
        if (s.target instanceof HTMLElement)
          if (r(s.target)) {
            let c = s.target;
            for (; c.parentElement && r(c.parentElement); )
              c = c.parentElement;
            t.style(c, "overscrollBehavior", "contain");
          } else
            t.style(s.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (s) => {
        if (s.target instanceof HTMLElement)
          if (r(s.target)) {
            let c = s.target;
            for (; c.parentElement && c.dataset.headlessuiPortal !== "" && !(c.scrollHeight > c.clientHeight || c.scrollWidth > c.clientWidth); )
              c = c.parentElement;
            c.dataset.headlessuiPortal === "" && s.preventDefault();
          } else
            s.preventDefault();
      }, { passive: !1 }), t.add(() => {
        var s;
        let c = (s = window.scrollY) != null ? s : window.pageYOffset;
        a !== c && window.scrollTo(0, a), i && i.isConnected && (i.scrollIntoView({ block: "nearest" }), i = null);
      });
    });
  } } : {};
}
function m8() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function p8(e) {
  let t = {};
  for (let n of e)
    Object.assign(t, n(t));
  return t;
}
let so = u8(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: kr(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: p8(n) }, o = [f8(), d8(), m8()];
  o.forEach(({ before: a }) => a == null ? void 0 : a(r)), o.forEach(({ after: a }) => a == null ? void 0 : a(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
so.subscribe(() => {
  let e = so.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e)
    t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", o = n.count !== 0;
    (o && !r || !o && r) && so.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && so.dispatch("TEARDOWN", n);
  }
});
function h8(e, t, n = () => ({ containers: [] })) {
  let r = l8(so), o = e ? r.get(e) : void 0, a = o ? o.count > 0 : !1;
  return _t(() => {
    if (!(!e || !t))
      return so.dispatch("PUSH", e, n), () => so.dispatch("POP", e, n);
  }, [t, e]), a;
}
function v8(e, t, n, r) {
  let o = wo(n);
  Ee(() => {
    e = e ?? window;
    function a(i) {
      o.current(i);
    }
    return e.addEventListener(t, a, r), () => e.removeEventListener(t, a, r);
  }, [e, t, r]);
}
let Qc = /* @__PURE__ */ new Map(), ga = /* @__PURE__ */ new Map();
function Gm(e, t = !0) {
  _t(() => {
    var n;
    if (!t)
      return;
    let r = typeof e == "function" ? e() : e.current;
    if (!r)
      return;
    function o() {
      var i;
      if (!r)
        return;
      let s = (i = ga.get(r)) != null ? i : 1;
      if (s === 1 ? ga.delete(r) : ga.set(r, s - 1), s !== 1)
        return;
      let c = Qc.get(r);
      c && (c["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", c["aria-hidden"]), r.inert = c.inert, Qc.delete(r));
    }
    let a = (n = ga.get(r)) != null ? n : 0;
    return ga.set(r, a + 1), a !== 0 || (Qc.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0), o;
  }, [e, t]);
}
function g8({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  var r;
  let o = Z((r = n == null ? void 0 : n.current) != null ? r : null), a = Yo(o), i = Fe(() => {
    var s, c, l;
    let d = [];
    for (let u of e)
      u !== null && (u instanceof HTMLElement ? d.push(u) : "current" in u && u.current instanceof HTMLElement && d.push(u.current));
    if (t != null && t.current)
      for (let u of t.current)
        d.push(u);
    for (let u of (s = a == null ? void 0 : a.querySelectorAll("html > *, body > *")) != null ? s : [])
      u !== document.body && u !== document.head && u instanceof HTMLElement && u.id !== "headlessui-portal-root" && (u.contains(o.current) || u.contains((l = (c = o.current) == null ? void 0 : c.getRootNode()) == null ? void 0 : l.host) || d.some((v) => u.contains(v)) || d.push(u));
    return d;
  });
  return { resolveContainers: i, contains: Fe((s) => i().some((c) => c.contains(s))), mainTreeNodeRef: o, MainTreeNode: qe(() => function() {
    return n != null ? null : ce.createElement(ja, { features: Wo.Hidden, ref: o });
  }, [o, n]) };
}
let h0 = Et(!1);
function b8() {
  return Ye(h0);
}
function qm(e) {
  return ce.createElement(h0.Provider, { value: e.force }, e.children);
}
function v0() {
  let e = Z(!1);
  return _t(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function g0(e) {
  let t = Fe(e), n = Z(!1);
  Ee(() => (n.current = !1, () => {
    n.current = !0, ec(() => {
      n.current && t();
    });
  }), [t]);
}
var xa = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(xa || {});
function y8() {
  let e = Z(0);
  return Jg("keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function b0(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.current)
    n.current instanceof HTMLElement && t.add(n.current);
  return t;
}
let x8 = "div";
var gs = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.AutoFocus = 32] = "AutoFocus", e[e.All = 30] = "All", e))(gs || {});
function w8(e, t) {
  let n = Z(null), r = yn(n, t), { initialFocus: o, initialFocusFallback: a, containers: i, features: s = 30, ...c } = e;
  od() || (s = 1);
  let l = Yo(n);
  S8({ ownerDocument: l }, !!(s & 16));
  let d = k8({ ownerDocument: l, container: n, initialFocus: o, initialFocusFallback: a }, s);
  _8({ ownerDocument: l, container: n, containers: i, previousActiveElement: d }, !!(s & 8));
  let u = y8(), v = Fe((g) => {
    let k = n.current;
    k && (($) => $())(() => {
      nn(u.current, { [xa.Forwards]: () => {
        Ca(k, xr.First, { skipElements: [g.relatedTarget, a] });
      }, [xa.Backwards]: () => {
        Ca(k, xr.Last, { skipElements: [g.relatedTarget, a] });
      } });
    });
  }), m = dr(), b = Z(!1), x = { ref: r, onKeyDown(g) {
    g.key == "Tab" && (b.current = !0, m.requestAnimationFrame(() => {
      b.current = !1;
    }));
  }, onBlur(g) {
    if (!(s & 8))
      return;
    let k = b0(i);
    n.current instanceof HTMLElement && k.add(n.current);
    let $ = g.relatedTarget;
    $ instanceof HTMLElement && $.dataset.headlessuiFocusGuard !== "true" && (y0(k, $) || (b.current ? Ca(n.current, nn(u.current, { [xa.Forwards]: () => xr.Next, [xa.Backwards]: () => xr.Previous }) | xr.WrapAround, { relativeTo: g.target }) : g.target instanceof HTMLElement && $r(g.target)));
  } };
  return ce.createElement(ce.Fragment, null, !!(s & 4) && ce.createElement(ja, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: v, features: Wo.Focusable }), on({ ourProps: x, theirProps: c, defaultTag: x8, name: "FocusTrap" }), !!(s & 4) && ce.createElement(ja, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: v, features: Wo.Focusable }));
}
let E8 = an(w8), $8 = Object.assign(E8, { features: gs });
function T8(e = !0) {
  let t = Z(ar.slice());
  return La(([n], [r]) => {
    r === !0 && n === !1 && ec(() => {
      t.current.splice(0);
    }), r === !1 && n === !0 && (t.current = ar.slice());
  }, [e, ar, t]), Fe(() => {
    var n;
    return (n = t.current.find((r) => r != null && r.isConnected)) != null ? n : null;
  });
}
function S8({ ownerDocument: e }, t) {
  let n = T8(t);
  La(() => {
    t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && $r(n());
  }, [t]), g0(() => {
    t && $r(n());
  });
}
function k8({ ownerDocument: e, container: t, initialFocus: n, initialFocusFallback: r }, o) {
  let a = !!(o & 2), i = Z(null), s = v0();
  return La(() => {
    if (!a) {
      r != null && r.current && $r(r.current);
      return;
    }
    let c = t.current;
    c && ec(() => {
      if (!s.current)
        return;
      let l = e == null ? void 0 : e.activeElement;
      if (n != null && n.current) {
        if ((n == null ? void 0 : n.current) === l) {
          i.current = l;
          return;
        }
      } else if (c.contains(l)) {
        i.current = l;
        return;
      }
      if (n != null && n.current)
        $r(n.current);
      else {
        if (o & 32) {
          if (Ca(c, xr.First | xr.AutoFocus) !== jl.Error)
            return;
        } else if (Ca(c, xr.First) !== jl.Error)
          return;
        if (r != null && r.current && ($r(r.current), (e == null ? void 0 : e.activeElement) === r.current))
          return;
        console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      i.current = e == null ? void 0 : e.activeElement;
    });
  }, [r, a, o]), i;
}
function _8({ ownerDocument: e, container: t, containers: n, previousActiveElement: r }, o) {
  let a = v0();
  v8(e == null ? void 0 : e.defaultView, "focus", (i) => {
    if (!o || !a.current)
      return;
    let s = b0(n);
    t.current instanceof HTMLElement && s.add(t.current);
    let c = r.current;
    if (!c)
      return;
    let l = i.target;
    l && l instanceof HTMLElement ? y0(s, l) ? (r.current = l, $r(l)) : (i.preventDefault(), i.stopPropagation(), $r(c)) : $r(r.current);
  }, !0);
}
function y0(e, t) {
  for (let n of e)
    if (n.contains(t))
      return !0;
  return !1;
}
function C8(e) {
  let t = b8(), n = Ye(x0), r = Yo(e), [o, a] = Ce(() => {
    if (!t && n !== null || Er.isServer)
      return null;
    let i = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (i)
      return i;
    if (r === null)
      return null;
    let s = r.createElement("div");
    return s.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(s);
  });
  return Ee(() => {
    o !== null && (r != null && r.body.contains(o) || r == null || r.body.appendChild(o));
  }, [o, r]), Ee(() => {
    t || n !== null && a(n.current);
  }, [n, a, t]), o;
}
let P8 = Jt;
function A8(e, t) {
  let n = e, r = Z(null), o = yn(AA((d) => {
    r.current = d;
  }), t), a = Yo(r), i = C8(r), [s] = Ce(() => {
    var d;
    return Er.isServer ? null : (d = a == null ? void 0 : a.createElement("div")) != null ? d : null;
  }), c = Ye(Fl), l = od();
  return _t(() => {
    !i || !s || i.contains(s) || (s.setAttribute("data-headlessui-portal", ""), i.appendChild(s));
  }, [i, s]), _t(() => {
    if (s && c)
      return c.register(s);
  }, [c, s]), g0(() => {
    var d;
    !i || !s || (s instanceof Node && i.contains(s) && i.removeChild(s), i.childNodes.length <= 0 && ((d = i.parentElement) == null || d.removeChild(i)));
  }), l ? !i || !s ? null : ip(on({ ourProps: { ref: o }, theirProps: n, slot: {}, defaultTag: P8, name: "Portal" }), s) : null;
}
let O8 = Jt, x0 = Et(null);
function N8(e, t) {
  let { target: n, ...r } = e, o = { ref: yn(t) };
  return ce.createElement(x0.Provider, { value: n }, on({ ourProps: o, theirProps: r, defaultTag: O8, name: "Popover.Group" }));
}
let Fl = Et(null);
function R8() {
  let e = Ye(Fl), t = Z([]), n = Fe((a) => (t.current.push(a), e && e.register(a), () => r(a))), r = Fe((a) => {
    let i = t.current.indexOf(a);
    i !== -1 && t.current.splice(i, 1), e && e.unregister(a);
  }), o = qe(() => ({ register: n, unregister: r, portals: t }), [n, r, t]);
  return [t, qe(() => function({ children: a }) {
    return ce.createElement(Fl.Provider, { value: o }, a);
  }, [o])];
}
let M8 = an(A8), D8 = an(N8), w0 = Object.assign(M8, { Group: D8 });
function I8(e, t) {
  let [n, r] = Ce(e), o = wo(e);
  return _t(() => r(o.current), [o, r, ...t]), n;
}
function j8(e, t = !0) {
  let n = Z({ left: 0, top: 0 });
  if (_t(() => {
    let o = e.current;
    if (!o)
      return;
    let a = o.getBoundingClientRect();
    a && (n.current = a);
  }, [t]), e.current == null || !t || e.current === document.activeElement)
    return !1;
  let r = e.current.getBoundingClientRect();
  return r.top !== n.current.top || r.left !== n.current.left;
}
function Ym(e) {
  if (e === null)
    return { width: 0, height: 0 };
  let { width: t, height: n } = e.getBoundingClientRect();
  return { width: t, height: n };
}
function L8(e, t = !1) {
  let [n, r] = Ce(() => Ym(e.current));
  return _t(() => {
    let o = e.current;
    if (!o)
      return;
    let a = new ResizeObserver(() => {
      r(Ym(o));
    });
    return a.observe(o), () => {
      a.disconnect();
    };
  }, [e]), t ? { width: `${n.width}px`, height: `${n.height}px` } : n;
}
let Km = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Xm(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", o = e.cloneNode(!0);
  if (!(o instanceof HTMLElement))
    return r;
  let a = !1;
  for (let s of o.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    s.remove(), a = !0;
  let i = a ? (n = o.innerText) != null ? n : "" : r;
  return Km.test(i) && (i = i.replace(Km, "")), i;
}
function F8(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((o) => {
      let a = document.getElementById(o);
      if (a) {
        let i = a.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : Xm(a).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0)
      return r.join(", ");
  }
  return Xm(e).trim();
}
function W8(e) {
  let t = Z(""), n = Z("");
  return Fe(() => {
    let r = e.current;
    if (!r)
      return "";
    let o = r.innerText;
    if (t.current === o)
      return n.current;
    let a = F8(r).trim().toLowerCase();
    return t.current = o, n.current = a, a;
  });
}
function H8(e, t, n = () => [document.body]) {
  h8(e, t, (r) => {
    var o;
    return { containers: [...(o = r.containers) != null ? o : [], n] };
  });
}
var U8 = ((e) => (e[e.None = 0] = "None", e[e.Inert = 1] = "Inert", e[e.ScrollLock = 2] = "ScrollLock", e[e.FocusTrap = 4] = "FocusTrap", e[e.All = 7] = "All", e))(U8 || {});
let B8 = "div", z8 = po.RenderStrategy | po.Static;
function V8(e, t) {
  let n = pr(), { id: r = `headlessui-modal-${n}`, initialFocus: o, role: a = "dialog", features: i = 7, enabled: s = !0, focusTrapFeatures: c = gs.All, ...l } = e;
  s || (i = 0);
  let d = Z(!1);
  a = function() {
    return a === "dialog" || a === "alertdialog" ? a : (d.current || (d.current = !0, console.warn(`Invalid role [${a}] passed to <Modal />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let u = Z(null), v = yn(u, t), m = Yo(u), [b, x] = R8(), g = { get current() {
    return u.current;
  } }, { resolveContainers: k, mainTreeNodeRef: $, MainTreeNode: T } = g8({ portals: b, defaultContainers: [g] }), S = Ie(() => {
    var L, j;
    return (j = Array.from((L = m == null ? void 0 : m.querySelectorAll("body > *")) != null ? L : []).find((q) => q.id === "headlessui-portal-root" ? !1 : q.contains($.current) && q instanceof HTMLElement)) != null ? j : null;
  }, [$]);
  Gm(S, !!(i & 1));
  let C = Ie(() => {
    var L, j;
    return (j = Array.from((L = m == null ? void 0 : m.querySelectorAll("[data-headlessui-portal]")) != null ? L : []).find((q) => q.contains($.current) && q instanceof HTMLElement)) != null ? j : null;
  }, [$]);
  Gm(C, !!(i & 1)), H8(m, !!(i & 2), k);
  let N = qe(() => ({}), []), U = { ref: v, id: r, role: a, "aria-modal": s || void 0 };
  return ce.createElement(ce.Fragment, null, ce.createElement(qm, { force: !0 }, ce.createElement(w0, null, ce.createElement($8, { initialFocus: o, containers: k, features: i & 4 ? c : gs.None }, ce.createElement(qm, { force: !1 }, ce.createElement(x, null, on({ ourProps: U, theirProps: l, slot: N, defaultTag: B8, features: z8, name: "Modal" })))))), ce.createElement(Fg, null, ce.createElement(T, null)));
}
let G8 = an(V8), q8 = Object.assign(G8, {});
var Y8 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Y8 || {}), K8 = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(K8 || {}), X8 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(X8 || {}), Z8 = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e))(Z8 || {});
function Jc(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = cd(t(e.options.slice()), (a) => a.dataRef.current.domRef.current), o = n ? r.indexOf(n) : null;
  return o === -1 && (o = null), { options: r, activeOptionIndex: o };
}
let Q8 = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0)
    return e;
  let t = e.activeOptionIndex, { isSelected: n } = e.dataRef.current, r = e.options.findIndex((o) => n(o.dataRef.current.value));
  return r !== -1 && (t = r), { ...e, listboxState: 0, activeOptionIndex: t };
}, 2(e, t) {
  var n, r, o, a, i;
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let s = { ...e, searchQuery: "", activationTrigger: (n = t.trigger) != null ? n : 1 };
  if (t.focus === nt.Nothing)
    return { ...s, activeOptionIndex: null };
  if (t.focus === nt.Specific)
    return { ...s, activeOptionIndex: e.options.findIndex((d) => d.id === t.id) };
  if (t.focus === nt.Previous) {
    let d = e.activeOptionIndex;
    if (d !== null) {
      let u = e.options[d].dataRef.current.domRef, v = Pa(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (m) => m.id, resolveDisabled: (m) => m.dataRef.current.disabled });
      if (v !== null) {
        let m = e.options[v].dataRef.current.domRef;
        if (((r = u.current) == null ? void 0 : r.previousElementSibling) === m.current || ((o = m.current) == null ? void 0 : o.previousElementSibling) === null)
          return { ...s, activeOptionIndex: v };
      }
    }
  } else if (t.focus === nt.Next) {
    let d = e.activeOptionIndex;
    if (d !== null) {
      let u = e.options[d].dataRef.current.domRef, v = Pa(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (m) => m.id, resolveDisabled: (m) => m.dataRef.current.disabled });
      if (v !== null) {
        let m = e.options[v].dataRef.current.domRef;
        if (((a = u.current) == null ? void 0 : a.nextElementSibling) === m.current || ((i = m.current) == null ? void 0 : i.nextElementSibling) === null)
          return { ...s, activeOptionIndex: v };
      }
    }
  }
  let c = Jc(e), l = Pa(t, { resolveItems: () => c.options, resolveActiveIndex: () => c.activeOptionIndex, resolveId: (d) => d.id, resolveDisabled: (d) => d.dataRef.current.disabled });
  return { ...s, ...c, activeOptionIndex: l };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + t.value.toLowerCase(), o = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find((i) => {
    var s;
    return !i.dataRef.current.disabled && ((s = i.dataRef.current.textValue) == null ? void 0 : s.startsWith(r));
  }), a = o ? e.options.indexOf(o) : -1;
  return a === -1 || a === e.activeOptionIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeOptionIndex: a, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let n = { id: t.id, dataRef: t.dataRef }, r = Jc(e, (o) => [...o, n]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), { ...e, ...r };
}, 6: (e, t) => {
  let n = Jc(e, (r) => {
    let o = r.findIndex((a) => a.id === t.id);
    return o !== -1 && r.splice(o, 1), r;
  });
  return { ...e, ...n, activationTrigger: 1 };
} }, md = Et(null);
md.displayName = "ListboxActionsContext";
function oc(e) {
  let t = Ye(md);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, oc), n;
  }
  return t;
}
let ac = Et(null);
ac.displayName = "ListboxDataContext";
function ui(e) {
  let t = Ye(ac);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ui), n;
  }
  return t;
}
function J8(e, t) {
  return nn(t.type, Q8, e, t);
}
let eN = Jt;
function tN(e, t) {
  var n;
  let r = tc(), { value: o, defaultValue: a, form: i, name: s, onChange: c, by: l, invalid: d = !1, disabled: u = r || !1, horizontal: v = !1, multiple: m = !1, ...b } = e;
  const x = v ? "horizontal" : "vertical";
  let g = yn(t), [k = m ? [] : void 0, $] = Dg(o, c, a), [T, S] = mr(J8, { dataRef: op(), listboxState: 1, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1, optionsVisible: !1 }), C = Z({ static: !1, hold: !1 }), N = Z(null), U = Z(null), L = Z(/* @__PURE__ */ new Map()), j = Kg(l), q = Ie((me) => nn(V.mode, { 1: () => k.some((ne) => j(ne, me)), 0: () => j(k, me) }), [k]), V = qe(() => ({ ...T, value: k, disabled: u, invalid: d, mode: m ? 1 : 0, orientation: x, compare: j, isSelected: q, optionsPropsRef: C, buttonRef: N, optionsRef: U, listRef: L }), [k, u, d, m, T, L]);
  _t(() => {
    T.dataRef.current = V;
  }, [V]), e0([V.buttonRef, V.optionsRef], (me, ne) => {
    var ye;
    S({ type: 1 }), Xg(ne, sd.Loose) || (me.preventDefault(), (ye = V.buttonRef.current) == null || ye.focus());
  }, V.listboxState === 0);
  let Q = qe(() => ({ open: V.listboxState === 0, disabled: u, invalid: d, value: k }), [V, u, k, d]), ke = Fe((me) => {
    let ne = V.options.find((ye) => ye.id === me);
    ne && Y(ne.dataRef.current.value);
  }), H = Fe(() => {
    if (V.activeOptionIndex !== null) {
      let { dataRef: me, id: ne } = V.options[V.activeOptionIndex];
      Y(me.current.value), S({ type: 2, focus: nt.Specific, id: ne });
    }
  }), X = Fe(() => S({ type: 0 })), he = Fe(() => S({ type: 1 })), $e = dr(), Te = Fe((me, ne, ye) => {
    $e.dispose(), $e.microTask(() => me === nt.Specific ? S({ type: 2, focus: nt.Specific, id: ne, trigger: ye }) : S({ type: 2, focus: me, trigger: ye }));
  }), fe = Fe((me, ne) => (S({ type: 5, id: me, dataRef: ne }), () => S({ type: 6, id: me }))), Y = Fe((me) => nn(V.mode, { 0() {
    return $ == null ? void 0 : $(me);
  }, 1() {
    let ne = V.value.slice(), ye = ne.findIndex((ze) => j(ze, me));
    return ye === -1 ? ne.push(me) : ne.splice(ye, 1), $ == null ? void 0 : $(ne);
  } })), O = Fe((me) => S({ type: 3, value: me })), G = Fe(() => S({ type: 4 })), W = qe(() => ({ onChange: Y, registerOption: fe, goToOption: Te, closeListbox: he, openListbox: X, selectActiveOption: H, selectOption: ke, search: O, clearSearch: G }), []), [ae, te] = Gg({ inherit: !0 }), se = { ref: g }, Se = Ie(() => $ == null ? void 0 : $(a), [$]);
  return ce.createElement(te, { value: ae, props: { htmlFor: (n = V.buttonRef.current) == null ? void 0 : n.id }, slot: { open: V.listboxState === 0, disabled: u } }, ce.createElement(c0, null, ce.createElement(md.Provider, { value: W }, ce.createElement(ac.Provider, { value: V }, ce.createElement(d0, { value: nn(V.listboxState, { 0: _r.Open, 1: _r.Closed }) }, s != null && k != null && ce.createElement(Wg, { data: { [s]: k }, form: i, onReset: Se }), on({ ourProps: se, theirProps: b, slot: Q, defaultTag: eN, name: "Listbox" }))))));
}
let nN = "button";
function rN(e, t) {
  var n, r, o, a;
  let i = pr(), s = ad(), { id: c = s || `headlessui-listbox-button-${i}`, ...l } = e, d = ui("Listbox.Button"), u = oc("Listbox.Button"), v = yn(d.buttonRef, t, a0()), m = TO(), b = dr(), x = Fe((Q) => {
    switch (Q.key) {
      case kt.Space:
      case kt.Enter:
      case kt.ArrowDown:
        Q.preventDefault(), u.openListbox(), b.nextFrame(() => {
          d.value || u.goToOption(nt.First);
        });
        break;
      case kt.ArrowUp:
        Q.preventDefault(), u.openListbox(), b.nextFrame(() => {
          d.value || u.goToOption(nt.Last);
        });
        break;
    }
  }), g = Fe((Q) => {
    switch (Q.key) {
      case kt.Space:
        Q.preventDefault();
        break;
    }
  }), k = Fe((Q) => {
    if (Hg(Q.currentTarget))
      return Q.preventDefault();
    d.listboxState === 0 ? (u.closeListbox(), b.nextFrame(() => {
      var ke;
      return (ke = d.buttonRef.current) == null ? void 0 : ke.focus({ preventScroll: !0 });
    })) : (Q.preventDefault(), u.openListbox());
  }), $ = li([c]), T = zg(), { isFocusVisible: S, focusProps: C } = td({ autoFocus: (n = e.autoFocus) != null ? n : !1 }), { isHovered: N, hoverProps: U } = rd({ isDisabled: (r = d.disabled) != null ? r : !1 }), { pressed: L, pressProps: j } = Rg({ disabled: (o = d.disabled) != null ? o : !1 }), q = qe(() => {
    var Q;
    return { open: d.listboxState === 0, active: L || d.listboxState === 0, disabled: d.disabled, invalid: d.invalid, value: d.value, hover: N, focus: S, autofocus: (Q = e.autoFocus) != null ? Q : !1 };
  }, [d.listboxState, d.disabled, d.value, N, S, L, d.invalid, e.autoFocus]), V = ci(m(), { ref: v, id: c, type: t0(e, d.buttonRef), "aria-haspopup": "listbox", "aria-controls": (a = d.optionsRef.current) == null ? void 0 : a.id, "aria-expanded": d.listboxState === 0, "aria-labelledby": $, "aria-describedby": T, disabled: d.disabled, onKeyDown: x, onKeyUp: g, onClick: k }, C, U, j);
  return on({ ourProps: V, theirProps: l, slot: q, defaultTag: nN, name: "Listbox.Button" });
}
let E0 = Et(!1), oN = "ul", aN = po.RenderStrategy | po.Static;
function iN(e, t) {
  var n;
  let r = pr(), { id: o = `headlessui-listbox-options-${r}`, anchor: a, modal: i, ...s } = e;
  a != null && i == null ? i = !0 : i == null && (i = !1);
  let c = ui("Listbox.Options"), l = oc("Listbox.Options"), d = u0(), u = (() => d !== null ? (d & _r.Open) === _r.Open : c.listboxState === 0)(), v = Z(null);
  Ee(() => {
    var H;
    if (!((H = a == null ? void 0 : a.to) != null && H.includes("selection")))
      return;
    if (!u) {
      v.current = null;
      return;
    }
    let X = Array.from(c.listRef.current.values());
    v.current = X.findIndex((he) => (he == null ? void 0 : he.dataset.selected) === ""), v.current === -1 && (v.current = X.findIndex((he) => (he == null ? void 0 : he.dataset.disabled) === void 0), l.goToOption(nt.First));
  }, [u, c.listRef]);
  let m = j8(c.buttonRef, c.listboxState !== 0) ? !1 : u, b = (() => {
    if (a == null)
      return;
    if (c.listRef.current.size <= 0)
      return { ...a, inner: void 0 };
    let H = Array.from(c.listRef.current.values());
    return { ...a, inner: { listRef: { current: H }, index: v.current } };
  })(), [x, g] = s0(b), k = i0(), $ = yn(c.optionsRef, t, a ? x : null), T = dr(), S = dr();
  Ee(() => {
    var H;
    let X = c.optionsRef.current;
    X && c.listboxState === 0 && X !== ((H = si(X)) == null ? void 0 : H.activeElement) && (X == null || X.focus({ preventScroll: !0 }));
  }, [c.listboxState, c.optionsRef]);
  let C = Fe((H) => {
    switch (S.dispose(), H.key) {
      case kt.Space:
        if (c.searchQuery !== "")
          return H.preventDefault(), H.stopPropagation(), l.search(H.key);
      case kt.Enter:
        if (H.preventDefault(), H.stopPropagation(), c.activeOptionIndex !== null) {
          let { dataRef: X } = c.options[c.activeOptionIndex];
          l.onChange(X.current.value);
        }
        c.mode === 0 && (l.closeListbox(), kr().nextFrame(() => {
          var X;
          return (X = c.buttonRef.current) == null ? void 0 : X.focus({ preventScroll: !0 });
        }));
        break;
      case nn(c.orientation, { vertical: kt.ArrowDown, horizontal: kt.ArrowRight }):
        return H.preventDefault(), H.stopPropagation(), l.goToOption(nt.Next);
      case nn(c.orientation, { vertical: kt.ArrowUp, horizontal: kt.ArrowLeft }):
        return H.preventDefault(), H.stopPropagation(), l.goToOption(nt.Previous);
      case kt.Home:
      case kt.PageUp:
        return H.preventDefault(), H.stopPropagation(), l.goToOption(nt.First);
      case kt.End:
      case kt.PageDown:
        return H.preventDefault(), H.stopPropagation(), l.goToOption(nt.Last);
      case kt.Escape:
        return H.preventDefault(), H.stopPropagation(), l.closeListbox(), T.nextFrame(() => {
          var X;
          return (X = c.buttonRef.current) == null ? void 0 : X.focus({ preventScroll: !0 });
        });
      case kt.Tab:
        H.preventDefault(), H.stopPropagation();
        break;
      default:
        H.key.length === 1 && (l.search(H.key), S.setTimeout(() => l.clearSearch(), 350));
        break;
    }
  }), N = I8(() => {
    var H;
    return (H = c.buttonRef.current) == null ? void 0 : H.id;
  }, [c.buttonRef.current]), U = qe(() => ({ open: c.listboxState === 0 }), [c]), L = ci(a ? k() : {}, { id: o, ref: $, "aria-activedescendant": c.activeOptionIndex === null || (n = c.options[c.activeOptionIndex]) == null ? void 0 : n.id, "aria-multiselectable": c.mode === 1 ? !0 : void 0, "aria-labelledby": N, "aria-orientation": c.orientation, onKeyDown: C, role: "listbox", tabIndex: 0, style: { ...g, "--button-width": L8(c.buttonRef, !0).width } }), j = i ? q8 : a ? w0 : Jt, q = i ? { enabled: c.listboxState === 0 } : {}, [V, Q] = Ce(c.value);
  c.value !== V && c.listboxState === 0 && c.mode !== 1 && Q(c.value);
  let ke = Fe((H) => c.compare(V, H));
  return ce.createElement(j, { ...q }, ce.createElement(ac.Provider, { value: c.mode === 1 ? c : { ...c, isSelected: ke } }, on({ ourProps: L, theirProps: s, slot: U, defaultTag: oN, features: aN, visible: m, name: "Listbox.Options" })));
}
let sN = "li";
function cN(e, t) {
  let n = pr(), { id: r = `headlessui-listbox-option-${n}`, disabled: o = !1, value: a, ...i } = e, s = Ye(E0) === !0, c = ui("Listbox.Option"), l = oc("Listbox.Option"), d = c.activeOptionIndex !== null ? c.options[c.activeOptionIndex].id === r : !1, u = c.isSelected(a), v = Z(null), m = W8(v), b = wo({ disabled: o, value: a, domRef: v, get textValue() {
    return m();
  } }), x = yn(t, v, (L) => {
    L ? c.listRef.current.set(r, L) : c.listRef.current.delete(r);
  });
  _t(() => {
    if (c.listboxState !== 0 || !d || c.activationTrigger === 0)
      return;
    let L = kr();
    return L.requestAnimationFrame(() => {
      var j, q;
      (q = (j = v.current) == null ? void 0 : j.scrollIntoView) == null || q.call(j, { block: "nearest" });
    }), L.dispose;
  }, [v, d, c.listboxState, c.activationTrigger, c.activeOptionIndex]), _t(() => {
    if (!s)
      return l.registerOption(r, b);
  }, [b, r, s]);
  let g = Fe((L) => {
    if (o)
      return L.preventDefault();
    l.onChange(a), c.mode === 0 && (l.closeListbox(), kr().nextFrame(() => {
      var j;
      return (j = c.buttonRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
    }));
  }), k = Fe(() => {
    if (o)
      return l.goToOption(nt.Nothing);
    l.goToOption(nt.Specific, r);
  }), $ = n0(), T = Fe((L) => {
    $.update(L), !o && (d || l.goToOption(nt.Specific, r, 0));
  }), S = Fe((L) => {
    $.wasMoved(L) && (o || d || l.goToOption(nt.Specific, r, 0));
  }), C = Fe((L) => {
    $.wasMoved(L) && (o || d && l.goToOption(nt.Nothing));
  }), N = qe(() => ({ active: d, focus: d, selected: u, disabled: o, selectedOption: u && s }), [d, u, o, s]);
  return !u && s ? null : on({ ourProps: s ? {} : { id: r, ref: x, role: "option", tabIndex: o === !0 ? void 0 : -1, "aria-disabled": o === !0 ? !0 : void 0, "aria-selected": u, disabled: void 0, onClick: g, onFocus: k, onPointerEnter: T, onMouseEnter: T, onPointerMove: S, onMouseMove: S, onPointerLeave: C, onMouseLeave: C }, theirProps: i, slot: N, defaultTag: sN, name: "Listbox.Option" });
}
let lN = Jt;
function uN(e, t) {
  let { options: n, placeholder: r, ...o } = e, a = { ref: yn(t) }, i = ui("ListboxSelectedOption"), s = qe(() => ({}), []), c = i.value === void 0 || i.value === null || i.mode === 1 && Array.isArray(i.value) && i.value.length === 0;
  return ce.createElement(E0.Provider, { value: !0 }, on({ ourProps: a, theirProps: { ...o, children: ce.createElement(ce.Fragment, null, r && c ? r : n) }, slot: s, defaultTag: lN, name: "ListboxSelectedOption" }));
}
let dN = an(tN), $0 = an(rN), fN = qg, T0 = an(iN), S0 = an(cN);
an(uN);
let mN = Object.assign(dN, { Button: $0, Label: fN, Options: T0, Option: S0 });
const pN = {
  value: "",
  onChange: () => {
  },
  disabled: !1
}, k0 = Et(
  pN
), hN = M(
  ({ className: e, immediate: t = !0, value: n, onChange: r, disabled: o, ...a }, i) => /* @__PURE__ */ w.jsx(k0.Provider, { value: { value: n, onChange: r, disabled: o }, children: /* @__PURE__ */ w.jsx(
    en,
    {
      ref: i,
      as: "div",
      className: z("group/combobox relative", e),
      immediate: t,
      value: n,
      onChange: r,
      disabled: o,
      ...a
    }
  ) })
);
hN.displayName = "Combobox";
const vN = M(({ displayValue: e, onQueryChange: t, placeholder: n, className: r }, o) => {
  const {
    value: a,
    onChange: i,
    disabled: s
  } = Ye(k0), [c, l] = Ce(""), d = Z();
  Ee(() => {
    const b = d.current;
    if (a && a !== b) {
      const x = e ? e(a) : a;
      x !== c && (l(x), t(x));
    }
    d.current = a;
  }, [a, e, c, t]);
  const u = Ie(
    (b) => {
      l(b), t(b), b || i("");
    },
    [i, l, t]
  ), v = !!a || !!c, m = (b) => {
    b.preventDefault(), u("");
  };
  return /* @__PURE__ */ w.jsxs(
    m0,
    {
      as: "div",
      className: z(
        "relative flex min-h-[2.5rem] w-full flex-wrap items-center rounded-[3px] border border-solid border-grey.6 bg-white px-3 text-left text-label-l transition-colors hover:border-sky.cloudy focus:outline-none focus-visible:border-sky.6 focus-visible:ring-2 focus-visible:ring-sky.6",
        "data-[disabled]:cursor-not-allowed data-[disabled]:border-grey.6 data-[disabled]:bg-grey.8",
        "data-[open]:rounded-b-none data-[open]:border-sky.6 data-[open]:ring-2 data-[open]:ring-sky.6",
        r
      ),
      children: [
        /* @__PURE__ */ w.jsx(
          "span",
          {
            className: "pointer-events-none absolute inset-x-0 -bottom-0.5 z-50 hidden h-1 bg-white group-data-[open]/combobox:block",
            "aria-hidden": !0
          }
        ),
        /* @__PURE__ */ w.jsx(
          p0,
          {
            ref: o,
            value: c,
            displayValue: e,
            onChange: (b) => {
              b.stopPropagation(), u(b.target.value);
            },
            placeholder: n,
            className: z(
              "w-full focus:outline-none",
              "data-[disabled]:cursor-not-allowed data-[disabled]:bg-grey.8"
            ),
            onClick: (b) => {
              b.stopPropagation();
            }
          }
        ),
        /* @__PURE__ */ w.jsx("div", { className: "absolute inset-y-0 right-0 flex items-center px-3", children: v ? /* @__PURE__ */ w.jsx(
          "button",
          {
            disabled: s,
            className: "disabled:cursor-not-allowed",
            type: "button",
            onClick: m,
            "aria-label": "Clear selection",
            children: /* @__PURE__ */ w.jsx(ah, { className: "text-sky.1", "aria-hidden": !0 })
          }
        ) : /* @__PURE__ */ w.jsx("span", { className: "disabled:cursor-not-allowed", children: /* @__PURE__ */ w.jsx(Ya, { className: "text-sky.1", "aria-hidden": !0 }) }) })
      ]
    }
  );
});
vN.displayName = "ComboboxTrigger";
const gN = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  en.Options,
  {
    ref: n,
    className: z(
      "absolute z-40 max-h-48 w-full overflow-y-auto rounded-b-[3px] border bg-white focus-visible:outline-none",
      "data-[open]:rounded-t-none data-[open]:border-sky.6 data-[open]:ring-2 data-[open]:ring-sky.6",
      e
    ),
    ...t
  }
));
gN.displayName = "ComboboxContent";
const bN = M(({ className: e, value: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  en.Option,
  {
    ref: r,
    className: ({ focus: o, selected: a, disabled: i }) => z(
      "cursor-pointer items-start truncate bg-white px-3 py-2.5 text-label-l text-sky.1 hover:bg-grey.7",
      {
        "opacity-50 pointer-events-none": i,
        "font-bold": a,
        "bg-grey.7": o
      },
      e
    ),
    value: t,
    ...n
  }
));
bN.displayName = "ComboboxItem";
const yN = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z("my-l flex justify-center", e),
    ...t,
    children: /* @__PURE__ */ w.jsx(Bo, { size: "small" })
  }
));
yN.displayName = "ComboboxContentLoader";
const xN = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z(
      "my-l flex items-center justify-center px-1 text-label-l text-sky.cloudy",
      e
    ),
    ...t
  }
));
xN.displayName = "ComboboxContentEmpty";
const _0 = Et({
  onChange: () => null,
  onRemove: () => null
}), wN = M(({ value: e, onChange: t, className: n, immediate: r = !0, ...o }, a) => {
  const i = (s) => {
    t(e.filter((c) => c !== s));
  };
  return /* @__PURE__ */ w.jsx(
    _0.Provider,
    {
      value: {
        onChange: t,
        onRemove: i
      },
      children: /* @__PURE__ */ w.jsx(
        en,
        {
          ref: a,
          as: "div",
          onChange: t,
          value: e,
          immediate: r,
          className: z("group/combobox relative", n),
          multiple: !0,
          ...o
        }
      )
    }
  );
});
wN.displayName = "MultiCombobox";
const EN = M(({ id: e, displayValue: t, query: n, onQueryChange: r, placeholder: o, className: a }, i) => {
  const { onChange: s, onRemove: c } = Ye(_0), l = (u) => {
    typeof r == "function" && r(u.target.value);
  }, d = (u, v) => {
    u.key === "Backspace" && n === "" && v.length && c(v[v.length - 1]);
  };
  return /* @__PURE__ */ w.jsx(
    en.Button,
    {
      as: "div",
      className: z(
        "relative flex min-h-[2.5rem] w-full flex-wrap items-center gap-1 rounded-[3px] border border-solid border-grey.6 bg-white py-1.5 pl-3 pr-10 text-left text-label-l transition-colors hover:border-sky.cloudy focus:outline-none focus-visible:border-sky.6 focus-visible:ring-2 focus-visible:ring-sky.6",
        "data-[disabled]:cursor-not-allowed data-[disabled]:border-grey.6 data-[disabled]:bg-grey.8",
        "data-[open]:rounded-b-none data-[open]:border-sky.6 data-[open]:ring-2 data-[open]:ring-sky.6",
        a
      ),
      children: ({ value: u, disabled: v }) => /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
        /* @__PURE__ */ w.jsx(
          "span",
          {
            className: "pointer-events-none absolute inset-x-0 -bottom-0.5 z-50 hidden h-1 bg-white group-data-[open]/combobox:block",
            "aria-hidden": !0
          }
        ),
        u.map((m) => /* @__PURE__ */ w.jsxs(
          "span",
          {
            className: "flex h-6 items-center gap-1 rounded bg-sky.1 text-white",
            children: [
              /* @__PURE__ */ w.jsx("span", { className: "pl-1.5", children: t(m) }),
              /* @__PURE__ */ w.jsx(
                "button",
                {
                  type: "button",
                  className: "flex h-6 items-center justify-center rounded px-1.5 text-sm focus:outline-none focus:ring focus:ring-sky.6 disabled:pointer-events-none disabled:cursor-not-allowed",
                  onClick: (b) => {
                    b.stopPropagation(), c(m);
                  },
                  disabled: v,
                  children: /* @__PURE__ */ w.jsx(rh, {})
                }
              )
            ]
          },
          m
        )),
        /* @__PURE__ */ w.jsx(
          en.Input,
          {
            id: e,
            ref: i,
            onChange: l,
            value: n,
            placeholder: o,
            className: z(
              "focus:outline-none",
              "data-[disabled]:cursor-not-allowed",
              {
                "ml-0.5": u.length > 0
              }
            ),
            onKeyDown: (m) => {
              d(m, u);
            },
            onClick: (m) => {
              m.stopPropagation();
            },
            onBlur: (m) => {
              m.preventDefault();
            }
          }
        ),
        /* @__PURE__ */ w.jsx(
          "span",
          {
            className: z(
              "absolute inset-y-0 right-0 flex items-center px-3 disabled:cursor-not-allowed",
              a
            ),
            children: u.length ? /* @__PURE__ */ w.jsx(
              "button",
              {
                onClick: (m) => {
                  m.stopPropagation(), s([]);
                },
                children: /* @__PURE__ */ w.jsx(ah, {})
              }
            ) : /* @__PURE__ */ w.jsx(Ya, { className: "text-sky.1", "aria-hidden": !0 })
          }
        )
      ] })
    }
  );
});
EN.displayName = "MultiComboboxTrigger";
const $N = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  en.Options,
  {
    ref: n,
    className: z(
      "absolute z-40 max-h-48 w-full overflow-y-auto rounded-b-[3px] border bg-white focus-visible:outline-none",
      "data-[open]:rounded-t-none data-[open]:border-sky.6 data-[open]:ring-2 data-[open]:ring-sky.6",
      e
    ),
    ...t
  }
));
$N.displayName = "MultiComboboxContent";
const TN = M(({ className: e, value: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  en.Option,
  {
    ref: r,
    className: ({ focus: o, selected: a, disabled: i }) => z(
      "cursor-pointer items-start truncate bg-white px-3 py-2.5 text-label-l text-sky.1 hover:bg-grey.7",
      {
        "opacity-50 pointer-events-none": i,
        "font-bold": a,
        "bg-grey.7": o
      },
      e
    ),
    value: t,
    ...n
  }
));
TN.displayName = "MultiComboboxItem";
const SN = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z("mt-4 flex flex-col first:mt-1", e),
    ...t
  }
));
SN.displayName = "MultiFilterDropdownGroup";
const kN = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "span",
  {
    ref: r,
    className: z(
      "block truncate px-3 text-label-s font-bold uppercase text-sky.1",
      e
    ),
    ...n,
    children: t
  }
));
kN.displayName = "MultiFilterDropdownGroupTitle";
const _N = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("ul", { ref: n, className: z("mt-2", e), ...t }));
_N.displayName = "MultiFilterDropdownGroupContent";
const CN = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z("my-l flex justify-center", e),
    ...t,
    children: /* @__PURE__ */ w.jsx(Bo, { size: "small" })
  }
));
CN.displayName = "MultiComboboxContentLoader";
const PN = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z(
      "my-l flex items-center justify-center px-1 text-label-l text-sky.cloudy",
      e
    ),
    ...t
  }
));
PN.displayName = "MultiComboboxContentEmpty";
const AN = Wn(
  "relative z-50 mx-auto flex  flex-col gap-y-4 rounded-md bg-white py-6 text-sky.1 shadow-popover duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
  {
    variants: {
      variant: {
        fullscreen: "h-full w-full overflow-y-auto",
        regular: "h-auto w-[calc(100%-2rem)] max-w-screen-lg"
      }
    },
    defaultVariants: {
      variant: "regular"
    }
  }
), aV = ou, iV = au, ON = iu, sV = Uo, C0 = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  za,
  {
    ref: n,
    className: z(
      "fixed inset-0 z-50 overflow-y-auto bg-sky.1/50 p-4 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
C0.displayName = za.displayName;
const NN = M(({ className: e, children: t, variant: n, ...r }, o) => /* @__PURE__ */ w.jsx(ON, { children: /* @__PURE__ */ w.jsx(C0, { children: /* @__PURE__ */ w.jsxs(
  Va,
  {
    ref: o,
    className: z(AN({ variant: n, className: e })),
    ...r,
    children: [
      t,
      /* @__PURE__ */ w.jsxs(Uo, { className: "absolute right-6 top-6 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus-visible:ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:cursor-not-allowed data-[state=open]:bg-transparent data-[state=open]:text-sky.1", children: [
        /* @__PURE__ */ w.jsx(l2, {}),
        /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: "Close" })
      ] })
    ]
  }
) }) }));
NN.displayName = Va.displayName;
const RN = ({
  className: e,
  ...t
}) => /* @__PURE__ */ w.jsx(
  "div",
  {
    className: z(
      "flex shrink-0 flex-col space-y-1.5 px-6 text-center sm:text-left",
      e
    ),
    ...t
  }
);
RN.displayName = "DialogHeader";
const MN = ({
  className: e,
  children: t,
  ...n
}) => /* @__PURE__ */ w.jsx("div", { className: z("flex grow flex-col px-6", e), ...n, children: t });
MN.displayName = "DialogBody";
const DN = ({
  className: e,
  ...t
}) => /* @__PURE__ */ w.jsx(
  "div",
  {
    className: z(
      "flex shrink-0 flex-col-reverse border-t border-grey.5 px-6 pt-6 sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
DN.displayName = "DialogFooter";
const IN = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Ga,
  {
    ref: n,
    className: z(
      "shrink-0 pr-10 text-left text-heading-2 tracking-tight",
      e
    ),
    ...t
  }
));
IN.displayName = Ga.displayName;
const jN = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  qa,
  {
    ref: n,
    className: z("mt-0 shrink-0 px-6 text-label-l text-grey.1", e),
    ...t
  }
));
jN.displayName = qa.displayName;
function P0({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = LN({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = wt(n), c = Ie((l) => {
    if (a) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    c
  ];
}
function LN({ defaultProp: e, onChange: t }) {
  const n = Ce(e), [r] = n, o = Z(r), a = wt(t);
  return Ee(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
function A0(e) {
  const t = e + "CollectionProvider", [n, r] = Hn(t), [o, a] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), i = (m) => {
    const { scope: b, children: x } = m, g = ce.useRef(null), k = ce.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ ce.createElement(o, {
      scope: b,
      itemMap: k,
      collectionRef: g
    }, x);
  }, s = e + "CollectionSlot", c = /* @__PURE__ */ ce.forwardRef((m, b) => {
    const { scope: x, children: g } = m, k = a(s, x), $ = ct(b, k.collectionRef);
    return /* @__PURE__ */ ce.createElement(Tr, {
      ref: $
    }, g);
  }), l = e + "CollectionItemSlot", d = "data-radix-collection-item", u = /* @__PURE__ */ ce.forwardRef((m, b) => {
    const { scope: x, children: g, ...k } = m, $ = ce.useRef(null), T = ct(b, $), S = a(l, x);
    return ce.useEffect(() => (S.itemMap.set($, {
      ref: $,
      ...k
    }), () => void S.itemMap.delete($))), /* @__PURE__ */ ce.createElement(Tr, {
      [d]: "",
      ref: T
    }, g);
  });
  function v(m) {
    const b = a(e + "CollectionConsumer", m);
    return ce.useCallback(() => {
      const g = b.collectionRef.current;
      if (!g)
        return [];
      const k = Array.from(g.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (S, C) => k.indexOf(S.ref.current) - k.indexOf(C.ref.current)
      );
    }, [
      b.collectionRef,
      b.itemMap
    ]);
  }
  return [
    {
      Provider: i,
      Slot: c,
      ItemSlot: u
    },
    v,
    r
  ];
}
function FN(e, t) {
  return mr((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const di = (e) => {
  const { present: t, children: n } = e, r = WN(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Tn.only(n), a = ct(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ fr(o, {
    ref: a
  }) : null;
};
di.displayName = "Presence";
function WN(e) {
  const [t, n] = Ce(), r = Z({}), o = Z(e), a = Z("none"), i = e ? "mounted" : "unmounted", [s, c] = FN(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const l = Li(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), qt(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, m = Li(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && v !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), qt(() => {
    if (t) {
      const l = (u) => {
        const m = Li(r.current).includes(u.animationName);
        u.target === t && m && Vr(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (a.current = Li(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Ie((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Li(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function HN({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = UN({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = wt(n), c = Ie((l) => {
    if (a) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    c
  ];
}
function UN({ defaultProp: e, onChange: t }) {
  const n = Ce(e), [r] = n, o = Z(r), a = wt(t);
  return Ee(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
const el = "rovingFocusGroup.onEntryFocus", BN = {
  bubbles: !1,
  cancelable: !0
}, pd = "RovingFocusGroup", [Wl, O0, zN] = A0(pd), [VN, ic] = Hn(pd, [
  zN
]), [GN, qN] = VN(pd), YN = /* @__PURE__ */ M((e, t) => /* @__PURE__ */ I(Wl.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ I(Wl.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ I(KN, oe({}, e, {
  ref: t
}))))), KN = /* @__PURE__ */ M((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: a, currentTabStopId: i, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: c, onEntryFocus: l, ...d } = e, u = Z(null), v = ct(t, u), m = Ks(a), [b = null, x] = HN({
    prop: i,
    defaultProp: s,
    onChange: c
  }), [g, k] = Ce(!1), $ = wt(l), T = O0(n), S = Z(!1), [C, N] = Ce(0);
  return Ee(() => {
    const U = u.current;
    if (U)
      return U.addEventListener(el, $), () => U.removeEventListener(el, $);
  }, [
    $
  ]), /* @__PURE__ */ I(GN, {
    scope: n,
    orientation: r,
    dir: m,
    loop: o,
    currentTabStopId: b,
    onItemFocus: Ie(
      (U) => x(U),
      [
        x
      ]
    ),
    onItemShiftTab: Ie(
      () => k(!0),
      []
    ),
    onFocusableItemAdd: Ie(
      () => N(
        (U) => U + 1
      ),
      []
    ),
    onFocusableItemRemove: Ie(
      () => N(
        (U) => U - 1
      ),
      []
    )
  }, /* @__PURE__ */ I(lt.div, oe({
    tabIndex: g || C === 0 ? -1 : 0,
    "data-orientation": r
  }, d, {
    ref: v,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: Le(e.onMouseDown, () => {
      S.current = !0;
    }),
    onFocus: Le(e.onFocus, (U) => {
      const L = !S.current;
      if (U.target === U.currentTarget && L && !g) {
        const j = new CustomEvent(el, BN);
        if (U.currentTarget.dispatchEvent(j), !j.defaultPrevented) {
          const q = T().filter(
            (X) => X.focusable
          ), V = q.find(
            (X) => X.active
          ), Q = q.find(
            (X) => X.id === b
          ), H = [
            V,
            Q,
            ...q
          ].filter(Boolean).map(
            (X) => X.ref.current
          );
          N0(H);
        }
      }
      S.current = !1;
    }),
    onBlur: Le(
      e.onBlur,
      () => k(!1)
    )
  })));
}), XN = "RovingFocusGroupItem", ZN = /* @__PURE__ */ M((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: a, ...i } = e, s = Ln(), c = a || s, l = qN(XN, n), d = l.currentTabStopId === c, u = O0(n), { onFocusableItemAdd: v, onFocusableItemRemove: m } = l;
  return Ee(() => {
    if (r)
      return v(), () => m();
  }, [
    r,
    v,
    m
  ]), /* @__PURE__ */ I(Wl.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: o
  }, /* @__PURE__ */ I(lt.span, oe({
    tabIndex: d ? 0 : -1,
    "data-orientation": l.orientation
  }, i, {
    ref: t,
    onMouseDown: Le(e.onMouseDown, (b) => {
      r ? l.onItemFocus(c) : b.preventDefault();
    }),
    onFocus: Le(
      e.onFocus,
      () => l.onItemFocus(c)
    ),
    onKeyDown: Le(e.onKeyDown, (b) => {
      if (b.key === "Tab" && b.shiftKey) {
        l.onItemShiftTab();
        return;
      }
      if (b.target !== b.currentTarget)
        return;
      const x = eR(b, l.orientation, l.dir);
      if (x !== void 0) {
        b.preventDefault();
        let k = u().filter(
          ($) => $.focusable
        ).map(
          ($) => $.ref.current
        );
        if (x === "last")
          k.reverse();
        else if (x === "prev" || x === "next") {
          x === "prev" && k.reverse();
          const $ = k.indexOf(b.currentTarget);
          k = l.loop ? tR(k, $ + 1) : k.slice($ + 1);
        }
        setTimeout(
          () => N0(k)
        );
      }
    })
  })));
}), QN = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function JN(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function eR(e, t, n) {
  const r = JN(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return QN[r];
}
function N0(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function tR(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const R0 = YN, M0 = ZN, Hl = [
  "Enter",
  " "
], nR = [
  "ArrowDown",
  "PageUp",
  "Home"
], D0 = [
  "ArrowUp",
  "PageDown",
  "End"
], rR = [
  ...nR,
  ...D0
], oR = {
  ltr: [
    ...Hl,
    "ArrowRight"
  ],
  rtl: [
    ...Hl,
    "ArrowLeft"
  ]
}, aR = {
  ltr: [
    "ArrowLeft"
  ],
  rtl: [
    "ArrowRight"
  ]
}, sc = "Menu", [Wa, iR, sR] = A0(sc), [Eo, I0] = Hn(sc, [
  sR,
  Go,
  ic
]), cc = Go(), j0 = ic(), [L0, Yr] = Eo(sc), [cR, fi] = Eo(sc), lR = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: i = !0 } = e, s = cc(t), [c, l] = Ce(null), d = Z(!1), u = wt(a), v = Ks(o);
  return Ee(() => {
    const m = () => {
      d.current = !0, document.addEventListener("pointerdown", b, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", b, {
        capture: !0,
        once: !0
      });
    }, b = () => d.current = !1;
    return document.addEventListener("keydown", m, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", m, {
        capture: !0
      }), document.removeEventListener("pointerdown", b, {
        capture: !0
      }), document.removeEventListener("pointermove", b, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ I(Fs, s, /* @__PURE__ */ I(L0, {
    scope: t,
    open: n,
    onOpenChange: u,
    content: c,
    onContentChange: l
  }, /* @__PURE__ */ I(cR, {
    scope: t,
    onClose: Ie(
      () => u(!1),
      [
        u
      ]
    ),
    isUsingKeyboardRef: d,
    dir: v,
    modal: i
  }, r)));
}, F0 = /* @__PURE__ */ M((e, t) => {
  const { __scopeMenu: n, ...r } = e, o = cc(n);
  return /* @__PURE__ */ I(Ws, oe({}, o, r, {
    ref: t
  }));
}), W0 = "MenuPortal", [uR, H0] = Eo(W0, {
  forceMount: void 0
}), dR = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = Yr(W0, t);
  return /* @__PURE__ */ I(uR, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ I(di, {
    present: n || a.open
  }, /* @__PURE__ */ I(Ss, {
    asChild: !0,
    container: o
  }, r)));
}, Yn = "MenuContent", [fR, hd] = Eo(Yn), mR = /* @__PURE__ */ M((e, t) => {
  const n = H0(Yn, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Yr(Yn, e.__scopeMenu), i = fi(Yn, e.__scopeMenu);
  return /* @__PURE__ */ I(Wa.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ I(di, {
    present: r || a.open
  }, /* @__PURE__ */ I(Wa.Slot, {
    scope: e.__scopeMenu
  }, i.modal ? /* @__PURE__ */ I(pR, oe({}, o, {
    ref: t
  })) : /* @__PURE__ */ I(hR, oe({}, o, {
    ref: t
  })))));
}), pR = /* @__PURE__ */ M((e, t) => {
  const n = Yr(Yn, e.__scopeMenu), r = Z(null), o = ct(t, r);
  return Ee(() => {
    const a = r.current;
    if (a)
      return nu(a);
  }, []), /* @__PURE__ */ I(vd, oe({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: Le(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), hR = /* @__PURE__ */ M((e, t) => {
  const n = Yr(Yn, e.__scopeMenu);
  return /* @__PURE__ */ I(vd, oe({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), vd = /* @__PURE__ */ M((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: o, onOpenAutoFocus: a, onCloseAutoFocus: i, disableOutsidePointerEvents: s, onEntryFocus: c, onEscapeKeyDown: l, onPointerDownOutside: d, onFocusOutside: u, onInteractOutside: v, onDismiss: m, disableOutsideScroll: b, ...x } = e, g = Yr(Yn, n), k = fi(Yn, n), $ = cc(n), T = j0(n), S = iR(n), [C, N] = Ce(null), U = Z(null), L = ct(t, U, g.onContentChange), j = Z(0), q = Z(""), V = Z(0), Q = Z(null), ke = Z("right"), H = Z(0), X = b ? tu : Jt, he = b ? {
    as: Tr,
    allowPinchZoom: !0
  } : void 0, $e = (fe) => {
    var Y, O;
    const G = q.current + fe, W = S().filter(
      (ne) => !ne.disabled
    ), ae = document.activeElement, te = (Y = W.find(
      (ne) => ne.ref.current === ae
    )) === null || Y === void 0 ? void 0 : Y.textValue, se = W.map(
      (ne) => ne.textValue
    ), Se = DR(se, G, te), me = (O = W.find(
      (ne) => ne.textValue === Se
    )) === null || O === void 0 ? void 0 : O.ref.current;
    (function ne(ye) {
      q.current = ye, window.clearTimeout(j.current), ye !== "" && (j.current = window.setTimeout(
        () => ne(""),
        1e3
      ));
    })(G), me && setTimeout(
      () => me.focus()
    );
  };
  Ee(() => () => window.clearTimeout(j.current), []), eu();
  const Te = Ie((fe) => {
    var Y, O;
    return ke.current === ((Y = Q.current) === null || Y === void 0 ? void 0 : Y.side) && jR(fe, (O = Q.current) === null || O === void 0 ? void 0 : O.area);
  }, []);
  return /* @__PURE__ */ I(fR, {
    scope: n,
    searchRef: q,
    onItemEnter: Ie((fe) => {
      Te(fe) && fe.preventDefault();
    }, [
      Te
    ]),
    onItemLeave: Ie((fe) => {
      var Y;
      Te(fe) || ((Y = U.current) === null || Y === void 0 || Y.focus(), N(null));
    }, [
      Te
    ]),
    onTriggerLeave: Ie((fe) => {
      Te(fe) && fe.preventDefault();
    }, [
      Te
    ]),
    pointerGraceTimerRef: V,
    onPointerGraceIntentChange: Ie((fe) => {
      Q.current = fe;
    }, [])
  }, /* @__PURE__ */ I(X, he, /* @__PURE__ */ I(Jl, {
    asChild: !0,
    trapped: o,
    onMountAutoFocus: Le(a, (fe) => {
      var Y;
      fe.preventDefault(), (Y = U.current) === null || Y === void 0 || Y.focus();
    }),
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ I(Ba, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: l,
    onPointerDownOutside: d,
    onFocusOutside: u,
    onInteractOutside: v,
    onDismiss: m
  }, /* @__PURE__ */ I(R0, oe({
    asChild: !0
  }, T, {
    dir: k.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: C,
    onCurrentTabStopIdChange: N,
    onEntryFocus: Le(c, (fe) => {
      k.isUsingKeyboardRef.current || fe.preventDefault();
    })
  }), /* @__PURE__ */ I(Nu, oe({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": q0(g.open),
    "data-radix-menu-content": "",
    dir: k.dir
  }, $, x, {
    ref: L,
    style: {
      outline: "none",
      ...x.style
    },
    onKeyDown: Le(x.onKeyDown, (fe) => {
      const O = fe.target.closest("[data-radix-menu-content]") === fe.currentTarget, G = fe.ctrlKey || fe.altKey || fe.metaKey, W = fe.key.length === 1;
      O && (fe.key === "Tab" && fe.preventDefault(), !G && W && $e(fe.key));
      const ae = U.current;
      if (fe.target !== ae || !rR.includes(fe.key))
        return;
      fe.preventDefault();
      const se = S().filter(
        (Se) => !Se.disabled
      ).map(
        (Se) => Se.ref.current
      );
      D0.includes(fe.key) && se.reverse(), RR(se);
    }),
    onBlur: Le(e.onBlur, (fe) => {
      fe.currentTarget.contains(fe.target) || (window.clearTimeout(j.current), q.current = "");
    }),
    onPointerMove: Le(e.onPointerMove, Ha((fe) => {
      const Y = fe.target, O = H.current !== fe.clientX;
      if (fe.currentTarget.contains(Y) && O) {
        const G = fe.clientX > H.current ? "right" : "left";
        ke.current = G, H.current = fe.clientX;
      }
    }))
  })))))));
}), vR = /* @__PURE__ */ M((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ I(lt.div, oe({
    role: "group"
  }, r, {
    ref: t
  }));
}), gR = /* @__PURE__ */ M((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ I(lt.div, oe({}, r, {
    ref: t
  }));
}), Ul = "MenuItem", Zm = "menu.itemSelect", gd = /* @__PURE__ */ M((e, t) => {
  const { disabled: n = !1, onSelect: r, ...o } = e, a = Z(null), i = fi(Ul, e.__scopeMenu), s = hd(Ul, e.__scopeMenu), c = ct(t, a), l = Z(!1), d = () => {
    const u = a.current;
    if (!n && u) {
      const v = new CustomEvent(Zm, {
        bubbles: !0,
        cancelable: !0
      });
      u.addEventListener(
        Zm,
        (m) => r == null ? void 0 : r(m),
        {
          once: !0
        }
      ), wp(u, v), v.defaultPrevented ? l.current = !1 : i.onClose();
    }
  };
  return /* @__PURE__ */ I(U0, oe({}, o, {
    ref: c,
    disabled: n,
    onClick: Le(e.onClick, d),
    onPointerDown: (u) => {
      var v;
      (v = e.onPointerDown) === null || v === void 0 || v.call(e, u), l.current = !0;
    },
    onPointerUp: Le(e.onPointerUp, (u) => {
      var v;
      l.current || (v = u.currentTarget) === null || v === void 0 || v.click();
    }),
    onKeyDown: Le(e.onKeyDown, (u) => {
      const v = s.searchRef.current !== "";
      n || v && u.key === " " || Hl.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
    })
  }));
}), U0 = /* @__PURE__ */ M((e, t) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, i = hd(Ul, n), s = j0(n), c = Z(null), l = ct(t, c), [d, u] = Ce(!1), [v, m] = Ce("");
  return Ee(() => {
    const b = c.current;
    if (b) {
      var x;
      m(((x = b.textContent) !== null && x !== void 0 ? x : "").trim());
    }
  }, [
    a.children
  ]), /* @__PURE__ */ I(Wa.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: o ?? v
  }, /* @__PURE__ */ I(M0, oe({
    asChild: !0
  }, s, {
    focusable: !r
  }), /* @__PURE__ */ I(lt.div, oe({
    role: "menuitem",
    "data-highlighted": d ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, a, {
    ref: l,
    onPointerMove: Le(e.onPointerMove, Ha((b) => {
      r ? i.onItemLeave(b) : (i.onItemEnter(b), b.defaultPrevented || b.currentTarget.focus());
    })),
    onPointerLeave: Le(e.onPointerLeave, Ha(
      (b) => i.onItemLeave(b)
    )),
    onFocus: Le(
      e.onFocus,
      () => u(!0)
    ),
    onBlur: Le(
      e.onBlur,
      () => u(!1)
    )
  }))));
}), bR = /* @__PURE__ */ M((e, t) => {
  const { checked: n = !1, onCheckedChange: r, ...o } = e;
  return /* @__PURE__ */ I(z0, {
    scope: e.__scopeMenu,
    checked: n
  }, /* @__PURE__ */ I(gd, oe({
    role: "menuitemcheckbox",
    "aria-checked": bs(n) ? "mixed" : n
  }, o, {
    ref: t,
    "data-state": bd(n),
    onSelect: Le(
      o.onSelect,
      () => r == null ? void 0 : r(bs(n) ? !0 : !n),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), yR = "MenuRadioGroup", [xR, wR] = Eo(yR, {
  value: void 0,
  onValueChange: () => {
  }
}), ER = /* @__PURE__ */ M((e, t) => {
  const { value: n, onValueChange: r, ...o } = e, a = wt(r);
  return /* @__PURE__ */ I(xR, {
    scope: e.__scopeMenu,
    value: n,
    onValueChange: a
  }, /* @__PURE__ */ I(vR, oe({}, o, {
    ref: t
  })));
}), $R = "MenuRadioItem", TR = /* @__PURE__ */ M((e, t) => {
  const { value: n, ...r } = e, o = wR($R, e.__scopeMenu), a = n === o.value;
  return /* @__PURE__ */ I(z0, {
    scope: e.__scopeMenu,
    checked: a
  }, /* @__PURE__ */ I(gd, oe({
    role: "menuitemradio",
    "aria-checked": a
  }, r, {
    ref: t,
    "data-state": bd(a),
    onSelect: Le(r.onSelect, () => {
      var i;
      return (i = o.onValueChange) === null || i === void 0 ? void 0 : i.call(o, n);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), B0 = "MenuItemIndicator", [z0, SR] = Eo(B0, {
  checked: !1
}), kR = /* @__PURE__ */ M((e, t) => {
  const { __scopeMenu: n, forceMount: r, ...o } = e, a = SR(B0, n);
  return /* @__PURE__ */ I(di, {
    present: r || bs(a.checked) || a.checked === !0
  }, /* @__PURE__ */ I(lt.span, oe({}, o, {
    ref: t,
    "data-state": bd(a.checked)
  })));
}), _R = /* @__PURE__ */ M((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ I(lt.div, oe({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: t
  }));
}), V0 = "MenuSub", [CR, G0] = Eo(V0), PR = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = Yr(V0, t), i = cc(t), [s, c] = Ce(null), [l, d] = Ce(null), u = wt(o);
  return Ee(() => (a.open === !1 && u(!1), () => u(!1)), [
    a.open,
    u
  ]), /* @__PURE__ */ I(Fs, i, /* @__PURE__ */ I(L0, {
    scope: t,
    open: r,
    onOpenChange: u,
    content: l,
    onContentChange: d
  }, /* @__PURE__ */ I(CR, {
    scope: t,
    contentId: Ln(),
    triggerId: Ln(),
    trigger: s,
    onTriggerChange: c
  }, n)));
}, Fi = "MenuSubTrigger", AR = /* @__PURE__ */ M((e, t) => {
  const n = Yr(Fi, e.__scopeMenu), r = fi(Fi, e.__scopeMenu), o = G0(Fi, e.__scopeMenu), a = hd(Fi, e.__scopeMenu), i = Z(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = a, l = {
    __scopeMenu: e.__scopeMenu
  }, d = Ie(() => {
    i.current && window.clearTimeout(i.current), i.current = null;
  }, []);
  return Ee(
    () => d,
    [
      d
    ]
  ), Ee(() => {
    const u = s.current;
    return () => {
      window.clearTimeout(u), c(null);
    };
  }, [
    s,
    c
  ]), /* @__PURE__ */ I(F0, oe({
    asChild: !0
  }, l), /* @__PURE__ */ I(U0, oe({
    id: o.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": n.open,
    "aria-controls": o.contentId,
    "data-state": q0(n.open)
  }, e, {
    ref: Ts(t, o.onTriggerChange),
    onClick: (u) => {
      var v;
      (v = e.onClick) === null || v === void 0 || v.call(e, u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
    },
    onPointerMove: Le(e.onPointerMove, Ha((u) => {
      a.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
        n.onOpenChange(!0), d();
      }, 100));
    })),
    onPointerLeave: Le(e.onPointerLeave, Ha((u) => {
      var v;
      d();
      const m = (v = n.content) === null || v === void 0 ? void 0 : v.getBoundingClientRect();
      if (m) {
        var b;
        const x = (b = n.content) === null || b === void 0 ? void 0 : b.dataset.side, g = x === "right", k = g ? -5 : 5, $ = m[g ? "left" : "right"], T = m[g ? "right" : "left"];
        a.onPointerGraceIntentChange({
          area: [
            // consistently within polygon bounds
            {
              x: u.clientX + k,
              y: u.clientY
            },
            {
              x: $,
              y: m.top
            },
            {
              x: T,
              y: m.top
            },
            {
              x: T,
              y: m.bottom
            },
            {
              x: $,
              y: m.bottom
            }
          ],
          side: x
        }), window.clearTimeout(s.current), s.current = window.setTimeout(
          () => a.onPointerGraceIntentChange(null),
          300
        );
      } else {
        if (a.onTriggerLeave(u), u.defaultPrevented)
          return;
        a.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: Le(e.onKeyDown, (u) => {
      const v = a.searchRef.current !== "";
      if (!(e.disabled || v && u.key === " ") && oR[r.dir].includes(u.key)) {
        var m;
        n.onOpenChange(!0), (m = n.content) === null || m === void 0 || m.focus(), u.preventDefault();
      }
    })
  })));
}), OR = "MenuSubContent", NR = /* @__PURE__ */ M((e, t) => {
  const n = H0(Yn, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Yr(Yn, e.__scopeMenu), i = fi(Yn, e.__scopeMenu), s = G0(OR, e.__scopeMenu), c = Z(null), l = ct(t, c);
  return /* @__PURE__ */ I(Wa.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ I(di, {
    present: r || a.open
  }, /* @__PURE__ */ I(Wa.Slot, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ I(vd, oe({
    id: s.contentId,
    "aria-labelledby": s.triggerId
  }, o, {
    ref: l,
    align: "start",
    side: i.dir === "rtl" ? "left" : "right",
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    trapFocus: !1,
    onOpenAutoFocus: (d) => {
      var u;
      i.isUsingKeyboardRef.current && ((u = c.current) === null || u === void 0 || u.focus()), d.preventDefault();
    },
    onCloseAutoFocus: (d) => d.preventDefault(),
    onFocusOutside: Le(e.onFocusOutside, (d) => {
      d.target !== s.trigger && a.onOpenChange(!1);
    }),
    onEscapeKeyDown: Le(e.onEscapeKeyDown, (d) => {
      i.onClose(), d.preventDefault();
    }),
    onKeyDown: Le(e.onKeyDown, (d) => {
      const u = d.currentTarget.contains(d.target), v = aR[i.dir].includes(d.key);
      if (u && v) {
        var m;
        a.onOpenChange(!1), (m = s.trigger) === null || m === void 0 || m.focus(), d.preventDefault();
      }
    })
  })))));
});
function q0(e) {
  return e ? "open" : "closed";
}
function bs(e) {
  return e === "indeterminate";
}
function bd(e) {
  return bs(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function RR(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function MR(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function DR(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = MR(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter(
    (l) => l !== n
  ));
  const c = i.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function IR(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, c = t[a].y, l = t[i].x, d = t[i].y;
    c > r != d > r && n < (l - s) * (r - c) / (d - c) + s && (o = !o);
  }
  return o;
}
function jR(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return IR(n, t);
}
function Ha(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const LR = lR, FR = F0, WR = dR, HR = mR, UR = gR, BR = gd, zR = bR, VR = ER, GR = TR, qR = kR, YR = _R, KR = PR, XR = AR, ZR = NR, Y0 = "DropdownMenu", [QR, cV] = Hn(Y0, [
  I0
]), kn = I0(), [JR, K0] = QR(Y0), e4 = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: o, defaultOpen: a, onOpenChange: i, modal: s = !0 } = e, c = kn(t), l = Z(null), [d = !1, u] = P0({
    prop: o,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ I(JR, {
    scope: t,
    triggerId: Ln(),
    triggerRef: l,
    contentId: Ln(),
    open: d,
    onOpenChange: u,
    onOpenToggle: Ie(
      () => u(
        (v) => !v
      ),
      [
        u
      ]
    ),
    modal: s
  }, /* @__PURE__ */ I(LR, oe({}, c, {
    open: d,
    onOpenChange: u,
    dir: r,
    modal: s
  }), n));
}, t4 = "DropdownMenuTrigger", n4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = K0(t4, n), i = kn(n);
  return /* @__PURE__ */ I(FR, oe({
    asChild: !0
  }, i), /* @__PURE__ */ I(lt.button, oe({
    type: "button",
    id: a.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": a.open,
    "aria-controls": a.open ? a.contentId : void 0,
    "data-state": a.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, o, {
    ref: Ts(t, a.triggerRef),
    onPointerDown: Le(e.onPointerDown, (s) => {
      !r && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
    }),
    onKeyDown: Le(e.onKeyDown, (s) => {
      r || ([
        "Enter",
        " "
      ].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), r4 = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = kn(t);
  return /* @__PURE__ */ I(WR, oe({}, r, n));
}, o4 = "DropdownMenuContent", a4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = K0(o4, n), a = kn(n), i = Z(!1);
  return /* @__PURE__ */ I(HR, oe({
    id: o.contentId,
    "aria-labelledby": o.triggerId
  }, a, r, {
    ref: t,
    onCloseAutoFocus: Le(e.onCloseAutoFocus, (s) => {
      var c;
      i.current || (c = o.triggerRef.current) === null || c === void 0 || c.focus(), i.current = !1, s.preventDefault();
    }),
    onInteractOutside: Le(e.onInteractOutside, (s) => {
      const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, d = c.button === 2 || l;
      (!o.modal || d) && (i.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), i4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(UR, oe({}, o, r, {
    ref: t
  }));
}), s4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(BR, oe({}, o, r, {
    ref: t
  }));
}), c4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(zR, oe({}, o, r, {
    ref: t
  }));
}), l4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(VR, oe({}, o, r, {
    ref: t
  }));
}), u4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(GR, oe({}, o, r, {
    ref: t
  }));
}), d4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(qR, oe({}, o, r, {
    ref: t
  }));
}), f4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(YR, oe({}, o, r, {
    ref: t
  }));
}), m4 = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, i = kn(t), [s = !1, c] = P0({
    prop: r,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ I(KR, oe({}, i, {
    open: s,
    onOpenChange: c
  }), n);
}, p4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(XR, oe({}, o, r, {
    ref: t
  }));
}), h4 = /* @__PURE__ */ M((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = kn(n);
  return /* @__PURE__ */ I(ZR, oe({}, o, r, {
    ref: t,
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), v4 = e4, g4 = n4, X0 = r4, Z0 = a4, Q0 = i4, J0 = s4, eb = c4, b4 = l4, tb = u4, y4 = d4, nb = f4, x4 = m4, rb = p4, ob = h4;
function w4(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function E4(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ab(...e) {
  return (t) => e.forEach((n) => E4(n, t));
}
function $4(...e) {
  return P.useCallback(ab(...e), e);
}
function T4(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = P.createContext(i), c = n.length;
    n = [...n, i];
    function l(u) {
      const { scope: v, children: m, ...b } = u, x = (v == null ? void 0 : v[e][c]) || s, g = P.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ w.jsx(x.Provider, { value: g, children: m });
    }
    function d(u, v) {
      const m = (v == null ? void 0 : v[e][c]) || s, b = P.useContext(m);
      if (b)
        return b;
      if (i !== void 0)
        return i;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = n.map((i) => P.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return P.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, S4(o, ...t)];
}
function S4(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(a)[`__scope${l}`];
        return { ...s, ...u };
      }, {});
      return P.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var ib = P.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = P.Children.toArray(n), a = o.find(_4);
  if (a) {
    const i = a.props.children, s = o.map((c) => c === a ? P.Children.count(i) > 1 ? P.Children.only(null) : P.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ w.jsx(Bl, { ...r, ref: t, children: P.isValidElement(i) ? P.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ w.jsx(Bl, { ...r, ref: t, children: n });
});
ib.displayName = "Slot";
var Bl = P.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (P.isValidElement(n)) {
    const o = P4(n);
    return P.cloneElement(n, {
      ...C4(r, n.props),
      // @ts-ignore
      ref: t ? ab(t, o) : o
    });
  }
  return P.Children.count(n) > 1 ? P.Children.only(null) : null;
});
Bl.displayName = "SlotClone";
var k4 = ({ children: e }) => /* @__PURE__ */ w.jsx(w.Fragment, { children: e });
function _4(e) {
  return P.isValidElement(e) && e.type === k4;
}
function C4(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function P4(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var A4 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], sb = A4.reduce((e, t) => {
  const n = P.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? ib : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w.jsx(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), yd = "Switch", [O4, lV] = T4(yd), [N4, R4] = O4(yd), cb = P.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      ...d
    } = e, [u, v] = P.useState(null), m = $4(t, ($) => v($)), b = P.useRef(!1), x = u ? !!u.closest("form") : !0, [g = !1, k] = ni({
      prop: o,
      defaultProp: a,
      onChange: l
    });
    return /* @__PURE__ */ w.jsxs(N4, { scope: n, checked: g, disabled: s, children: [
      /* @__PURE__ */ w.jsx(
        sb.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": g,
          "aria-required": i,
          "data-state": db(g),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...d,
          ref: m,
          onClick: w4(e.onClick, ($) => {
            k((T) => !T), x && (b.current = $.isPropagationStopped(), b.current || $.stopPropagation());
          })
        }
      ),
      x && /* @__PURE__ */ w.jsx(
        M4,
        {
          control: u,
          bubbles: !b.current,
          name: r,
          value: c,
          checked: g,
          required: i,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
cb.displayName = yd;
var lb = "SwitchThumb", ub = P.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = R4(lb, n);
    return /* @__PURE__ */ w.jsx(
      sb.span,
      {
        "data-state": db(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
ub.displayName = lb;
var M4 = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...o } = e, a = P.useRef(null), i = Bu(n), s = Uu(t);
  return P.useEffect(() => {
    const c = a.current, l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== n && u) {
      const v = new Event("click", { bubbles: r });
      u.call(c, n), c.dispatchEvent(v);
    }
  }, [i, n, r]), /* @__PURE__ */ w.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function db(e) {
  return e ? "checked" : "unchecked";
}
var fb = cb, D4 = ub;
const mb = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  fb,
  {
    className: z(
      "inline-flex h-[24px] w-[48px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-sky.1 data-[state=unchecked]:bg-grey.6",
      e
    ),
    ...t,
    ref: n,
    children: /* @__PURE__ */ w.jsx(
      D4,
      {
        className: z(
          "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
mb.displayName = fb.displayName;
const uV = v4, dV = g4, fV = b4, I4 = M(({ className: e, sideOffset: t = 16, ...n }, r) => /* @__PURE__ */ w.jsx(X0, { children: /* @__PURE__ */ w.jsx(
  Z0,
  {
    ref: r,
    sideOffset: t,
    className: z(
      "group z-50 select-none list-none rounded-[9px] bg-white py-[9px] text-sky.1 shadow-popover",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-top-2",
      e
    ),
    ...n
  }
) }));
I4.displayName = Z0.displayName;
const j4 = Wn(
  "group flex h-auto w-full min-w-[10rem] max-w-[80vw] cursor-pointer items-center justify-start gap-3 px-[15px] py-[9px] text-left text-sm no-underline hover:bg-grey.7 focus:bg-grey.7 focus:outline-none focus:ring-0 active:bg-grey.7 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
  {
    variants: { variant: { default: "text-sky.1", danger: "text-berry.1" } },
    defaultVariants: { variant: "default" }
  }
), L4 = M(({ className: e, variant: t = "default", ...n }, r) => /* @__PURE__ */ w.jsx(
  J0,
  {
    ref: r,
    className: z(j4({ variant: t }), e),
    ...n
  }
));
L4.displayName = J0.displayName;
const F4 = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("span", { ref: n, className: z("ml-8 text-grey.2", e), ...t }));
F4.displayName = "DropdownMenuShortcut";
const mV = x4, W4 = M(({ className: e, sideOffset: t = 4, alignOffset: n = -9, ...r }, o) => /* @__PURE__ */ w.jsx(X0, { children: /* @__PURE__ */ w.jsx(
  ob,
  {
    ref: o,
    sideOffset: t,
    alignOffset: n,
    className: z(
      "group z-50 select-none list-none rounded-[9px] bg-white py-[9px] text-sky.1 shadow-popover",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-top-2",
      e
    ),
    ...r
  }
) }));
W4.displayName = ob.displayName;
const H4 = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsxs(
  rb,
  {
    ref: r,
    className: z(
      "group flex h-auto w-full min-w-[10rem] max-w-[80vw] cursor-pointer items-center justify-between gap-3 px-[15px] py-[9px] text-left text-sm text-sky.1 no-underline hover:bg-grey.7 focus:bg-grey.7 focus:outline-none focus:ring-0 active:bg-grey.7 data-[disabled]:pointer-events-none data-[state=open]:bg-grey.7 data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ w.jsx("span", { className: "flex items-center gap-3", children: t }),
      /* @__PURE__ */ w.jsx(o2, {})
    ]
  }
));
H4.displayName = rb.displayName;
const U4 = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Q0,
  {
    ref: n,
    className: z("px-3 pt-2 text-sm font-semibold", e),
    ...t
  }
));
U4.displayName = Q0.displayName;
const B4 = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  nb,
  {
    ref: n,
    className: z("my-[7px] h-[1px] bg-grey.6", e),
    ...t
  }
));
B4.displayName = nb.displayName;
const z4 = M(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ w.jsxs(
  eb,
  {
    ref: o,
    className: z(
      "group flex h-auto w-full min-w-[10rem] max-w-[80vw] cursor-pointer items-center justify-between gap-3 px-[15px] py-[9px] text-left text-sm text-sky.1 no-underline hover:bg-grey.7 focus:bg-grey.7 focus:outline-none focus:ring-0 active:bg-grey.7 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    onSelect: (a) => {
      a.preventDefault();
    },
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ w.jsx("span", { className: "flex items-center gap-3", children: t }),
      /* @__PURE__ */ w.jsx(mb, { checked: n })
    ]
  }
));
z4.displayName = eb.displayName;
const V4 = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsxs(
  tb,
  {
    ref: r,
    className: z(
      "group flex h-auto w-full min-w-[10rem] max-w-[80vw] cursor-pointer items-center justify-between gap-3 px-[15px] py-[9px] text-left text-sm text-sky.1 no-underline hover:bg-grey.7 focus:bg-grey.7 focus:outline-none focus:ring-0 active:bg-grey.7 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ w.jsx(y4, { children: /* @__PURE__ */ w.jsx(e2, { className: "text-sky.4" }) })
    ]
  }
));
V4.displayName = tb.displayName;
function G4() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = e.filter(Boolean);
  if (n.length <= 1) {
    var r = n[0];
    return r || null;
  }
  return function(a) {
    n.forEach(function(i) {
      typeof i == "function" ? i(a) : i && (i.current = a);
    });
  };
}
const pb = ({ children: e, className: t }) => (
  // eslint-disable-next-line tailwindcss/no-custom-classname
  /* @__PURE__ */ w.jsx("div", { className: z("input-group group relative flex h-10 w-full", t), children: e })
), pV = ({
  children: e,
  className: t
}) => /* @__PURE__ */ w.jsx(
  "div",
  {
    className: z(
      "absolute inset-y-0 left-0 flex items-center pl-3 text-sky.1",
      t
    ),
    children: e
  }
), hb = ({
  children: e,
  className: t
}) => /* @__PURE__ */ w.jsx(
  "div",
  {
    className: z(
      "absolute inset-y-0 right-0 flex items-center pr-3 text-sky.1 [--input-right-padding:2.5rem]",
      t
    ),
    children: e
  }
), xd = M(
  ({ className: e, type: t, ...n }, r) => /* @__PURE__ */ w.jsx(
    "input",
    {
      type: t,
      className: z(
        "flex h-10 w-full rounded border border-grey.6 bg-white py-2 text-sm text-sky.1 transition-colors placeholder:text-sky.cloudy hover:border-sky.cloudy focus-visible:border-sky.6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky.6 disabled:cursor-not-allowed disabled:border-grey.6 disabled:bg-grey.8 disabled:text-sky.cloudy",
        "px-3 group-[.input-group]:px-10 group-[.input-group]:first:pl-3 group-[.input-group]:last:pr-3",
        e
      ),
      ref: r,
      ...n
    }
  )
);
xd.displayName = "Input";
const wd = Et({
  variant: "default"
}), q4 = M(({ variant: e, by: t = "value", ...n }, r) => /* @__PURE__ */ w.jsx(wd.Provider, { value: { variant: e }, children: /* @__PURE__ */ w.jsx(en, { ref: r, as: "div", by: t, multiple: !0, ...n }) }));
q4.displayName = "MultiFilterDropdown";
const Y4 = Wn(
  "flex h-[2.75rem] items-center justify-between gap-x-3 rounded-[0.1875rem] bg-transparent px-3 transition-colors focus:bg-white focus:outline-none focus-visible:border-sky.6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky.6 disabled:cursor-not-allowed disabled:text-sky.cloudy",
  {
    variants: {
      variant: {
        default: "min-w-[8rem] max-w-[20rem] border border-grey.6 bg-white hover:border-sky.cloudy disabled:border-grey.6 disabled:bg-grey.7",
        simple: "border border-transparent hover:bg-white data-[open]:rounded-b-none data-[open]:bg-white"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), K4 = M(
  ({ className: e, icon: t, title: n, label: r, value: o, moreValuesLabel: a, ...i }, s) => {
    const { variant: c } = Ye(wd), l = Z(null);
    Ee(() => {
      l.current && l.current.setAttribute("tabIndex", "auto");
    }, [l]);
    const d = () => c === "simple" || !(o != null && o.length) ? r : o.length === 1 && o[0] !== void 0 ? o[0].label : a ?? r;
    return /* @__PURE__ */ w.jsxs(
      en.Button,
      {
        ref: G4(
          l,
          s
        ),
        className: z(Y4({ variant: c, className: e })),
        ...i,
        children: [
          !!t && /* @__PURE__ */ w.jsx("span", { className: "shrink-0", children: t }),
          /* @__PURE__ */ w.jsxs("span", { className: "flex flex-1 flex-col overflow-hidden text-left", children: [
            n && /* @__PURE__ */ w.jsx("span", { className: "truncate text-label-s font-bold", children: n }),
            /* @__PURE__ */ w.jsx(
              "span",
              {
                className: z(
                  "truncate",
                  n ? "text-label-s" : "py-1.5 text-label-l"
                ),
                children: d()
              }
            )
          ] }),
          /* @__PURE__ */ w.jsx(
            Ya,
            {
              className: "shrink-0 text-sky.1",
              "aria-hidden": !0
            }
          )
        ]
      }
    );
  }
);
K4.displayName = "MultiFilterDropdownTrigger";
const X4 = M(
  ({
    query: e,
    onQueryChange: t,
    placeholder: n = "Search",
    className: r,
    children: o,
    ...a
  }, i) => {
    const { variant: s } = Ye(wd), c = (d) => {
      typeof t == "function" && t(d.target.value);
    }, l = () => {
      typeof t == "function" && t("");
    };
    return /* @__PURE__ */ w.jsxs(
      en.Options,
      {
        ref: i,
        className: z(
          "absolute min-w-[22.5rem] max-w-[25rem] list-none rounded-md bg-white p-3 text-sm leading-4 shadow-md focus-visible:outline-none",
          "data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[open]:slide-in-from-top-2",
          s === "simple" ? "rounded-tl-none" : "mt-1.5",
          r
        ),
        ...a,
        children: [
          /* @__PURE__ */ w.jsx("li", { className: "mb-2.5", children: /* @__PURE__ */ w.jsxs(pb, { children: [
            /* @__PURE__ */ w.jsx(
              en.Input,
              {
                as: xd,
                onChange: c,
                placeholder: n,
                value: e
              }
            ),
            /* @__PURE__ */ w.jsx(hb, { children: e ? /* @__PURE__ */ w.jsxs("button", { type: "button", onClick: l, children: [
              /* @__PURE__ */ w.jsx(oh, {}),
              /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: "Clear" })
            ] }) : /* @__PURE__ */ w.jsx(ih, {}) })
          ] }) }),
          /* @__PURE__ */ w.jsx(Qs, { children: /* @__PURE__ */ w.jsx(Js, { className: "max-h-80", children: o }) })
        ]
      }
    );
  }
);
X4.displayName = "MultiFilterDropdownContent";
const Z4 = M(({ value: e, className: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  en.Option,
  {
    ref: r,
    value: e,
    className: ({ focus: o, selected: a, disabled: i }) => z(
      "group/option flex cursor-pointer items-center rounded-[0.1875rem] px-1 py-2 target:bg-grey.8 hover:bg-grey.8",
      {
        "opacity-50 pointer-events-none": i,
        "bg-grey.8": o,
        "font-bold": a
      },
      t
    ),
    ...n,
    children: ({ selected: o }) => /* @__PURE__ */ w.jsxs("div", { className: "flex items-center space-x-2", children: [
      /* @__PURE__ */ w.jsx(
        Tg,
        {
          checked: o,
          className: z("border-none", {
            "bg-grey.7": !o && !e.color
          }),
          color: e.color
        }
      ),
      /* @__PURE__ */ w.jsx(ri, { className: "cursor-pointer leading-4 text-sky.1", children: e.label })
    ] })
  }
));
Z4.displayName = "MultiFilterDropdownItem";
const Q4 = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z("mt-4 flex flex-col first:mt-1", e),
    ...t
  }
));
Q4.displayName = "MultiFilterDropdownGroup";
const J4 = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "span",
  {
    ref: r,
    className: z(
      "mb-2 block truncate text-label-s font-bold uppercase text-sky.1",
      e
    ),
    ...n,
    children: t
  }
));
J4.displayName = "MultiFilterDropdownGroupTitle";
const eM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("ul", { ref: n, className: e, ...t }));
eM.displayName = "MultiFilterDropdownGroupContent";
const tM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z("my-l flex justify-center", e),
    ...t,
    children: /* @__PURE__ */ w.jsx(Bo, { size: "small" })
  }
));
tM.displayName = "MultiFilterDropdownLoading";
const nM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z(
      "my-l flex items-center justify-center px-1 text-label-l text-sky.cloudy",
      e
    ),
    ...t
  }
));
nM.displayName = "MultiFilterDropdownEmpty";
const rM = M(({ by: e = "value", ...t }, n) => /* @__PURE__ */ w.jsx(en, { ref: n, as: "div", by: e, ...t }));
rM.displayName = "SingleFilterDropdown";
const oM = M(({ className: e, icon: t, title: n, label: r, value: o, ...a }, i) => /* @__PURE__ */ w.jsxs(
  en.Button,
  {
    ref: i,
    className: z(
      "flex h-[2.75rem] min-w-[8rem] max-w-[20rem] items-center justify-between gap-x-3 rounded-[0.1875rem] border border-grey.6 bg-white px-3 transition-colors hover:border-sky.cloudy focus:bg-white focus:outline-none focus-visible:border-sky.6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky.6 disabled:cursor-not-allowed disabled:border-grey.6 disabled:bg-grey.7 disabled:text-sky.cloudy",
      e
    ),
    ...a,
    children: [
      !!t && /* @__PURE__ */ w.jsx("span", { className: "shrink-0", children: t }),
      /* @__PURE__ */ w.jsxs("span", { className: "flex flex-1 flex-col overflow-hidden text-left", children: [
        n && /* @__PURE__ */ w.jsx("span", { className: "truncate text-label-s font-bold", children: n }),
        /* @__PURE__ */ w.jsx(
          "span",
          {
            className: z(
              "truncate",
              n ? "text-label-s" : "py-1.5 text-label-l"
            ),
            children: (o == null ? void 0 : o.label) || r
          }
        )
      ] }),
      /* @__PURE__ */ w.jsx(Ya, { className: "shrink-0 text-sky.1", "aria-hidden": !0 })
    ]
  }
));
oM.displayName = "SingleFilterDropdownTrigger";
const aM = M(
  ({
    children: e,
    className: t,
    onQueryChange: n,
    placeholder: r = "Search",
    searchable: o = !1,
    query: a,
    ...i
  }, s) => {
    const c = (d) => {
      typeof n == "function" && n(d.target.value);
    }, l = () => {
      typeof n == "function" && n("");
    };
    return /* @__PURE__ */ w.jsxs(
      en.Options,
      {
        ref: s,
        className: z(
          "absolute mt-1.5 min-w-[12.5rem] max-w-[25rem] list-none rounded-md bg-white py-[0.9375rem] text-sm leading-4 shadow-md focus-visible:outline-none",
          "data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[open]:slide-in-from-top-2",
          { "min-w-[22.5rem]": o },
          t
        ),
        ...i,
        children: [
          o && /* @__PURE__ */ w.jsx("li", { className: "mb-2.5 px-3", children: /* @__PURE__ */ w.jsxs(pb, { children: [
            /* @__PURE__ */ w.jsx(
              en.Input,
              {
                as: xd,
                onChange: c,
                placeholder: r,
                value: a
              }
            ),
            /* @__PURE__ */ w.jsx(hb, { children: a ? /* @__PURE__ */ w.jsxs("button", { type: "button", onClick: l, children: [
              /* @__PURE__ */ w.jsx(oh, {}),
              /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: "Clear" })
            ] }) : /* @__PURE__ */ w.jsx(ih, {}) })
          ] }) }),
          /* @__PURE__ */ w.jsx(Qs, { className: "max-h-80", children: /* @__PURE__ */ w.jsx(Js, { className: "max-h-80", children: e }) })
        ]
      }
    );
  }
);
aM.displayName = "SingleFilterDropdownContent";
const iM = M(({ value: e, className: t }, n) => /* @__PURE__ */ w.jsx(
  en.Option,
  {
    ref: n,
    className: ({ focus: r, disabled: o, selected: a }) => z(
      "flex cursor-pointer items-center px-3 py-[0.8125rem] text-sky.1 hover:bg-grey.8",
      {
        "opacity-50 pointer-events-none": o,
        "bg-grey.8": r,
        "font-bold bg-grey.8": a
      },
      t
    ),
    value: e,
    children: e.label
  }
));
iM.displayName = "SingleFilterDropdownItem";
const sM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z("mt-4 flex flex-col first:mt-1", e),
    ...t
  }
));
sM.displayName = "SingleFilterDropdownGroup";
const cM = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  "span",
  {
    ref: r,
    className: z(
      "mb-2 block truncate px-3 text-label-s font-bold uppercase text-sky.1",
      e
    ),
    ...n,
    children: t
  }
));
cM.displayName = "SingleFilterDropdownGroupTitle";
const lM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("ul", { ref: n, className: e, ...t }));
lM.displayName = "SingleFilterDropdownGroupContent";
const uM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z("my-l flex justify-center", e),
    ...t,
    children: /* @__PURE__ */ w.jsx(Bo, { size: "small" })
  }
));
uM.displayName = "SingleFilterDropdownLoading";
const dM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z(
      "my-l flex items-center justify-center px-1 text-label-l text-sky.cloudy",
      e
    ),
    ...t
  }
));
dM.displayName = "SingleFilterDropdownEmpty";
let Wi;
const fM = new Uint8Array(16);
function mM() {
  if (!Wi && (Wi = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Wi))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Wi(fM);
}
const tn = [];
for (let e = 0; e < 256; ++e)
  tn.push((e + 256).toString(16).slice(1));
function pM(e, t = 0) {
  return tn[e[t + 0]] + tn[e[t + 1]] + tn[e[t + 2]] + tn[e[t + 3]] + "-" + tn[e[t + 4]] + tn[e[t + 5]] + "-" + tn[e[t + 6]] + tn[e[t + 7]] + "-" + tn[e[t + 8]] + tn[e[t + 9]] + "-" + tn[e[t + 10]] + tn[e[t + 11]] + tn[e[t + 12]] + tn[e[t + 13]] + tn[e[t + 14]] + tn[e[t + 15]];
}
const hM = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Qm = {
  randomUUID: hM
};
function vM(e, t, n) {
  if (Qm.randomUUID && !t && !e)
    return Qm.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || mM)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let o = 0; o < 16; ++o)
      t[n + o] = r[o];
    return t;
  }
  return pM(r);
}
const Ed = () => {
  const e = Ye(vb), t = Ye(gb), { getFieldState: n, formState: r } = Es(), o = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: a } = t;
  return {
    id: a,
    name: e.name,
    formItemId: `${a}-form-item`,
    formMessageId: `${a}-form-item-message`,
    ...o
  };
}, hV = f1, vb = Et(
  {}
), vV = ({
  ...e
}) => /* @__PURE__ */ w.jsx(vb.Provider, { value: { name: e.name }, children: /* @__PURE__ */ w.jsx(E1, { ...e }) }), gb = Et(
  {}
), gM = M(
  ({ className: e, ...t }, n) => {
    const r = vM();
    return /* @__PURE__ */ w.jsx(gb.Provider, { value: { id: r }, children: /* @__PURE__ */ w.jsx("div", { ref: n, className: z("space-y-1.5", e), ...t }) });
  }
);
gM.displayName = "FormItem";
const bM = M(({ ...e }, t) => {
  const { formItemId: n } = Ed();
  return /* @__PURE__ */ w.jsx(
    ri,
    {
      className: "block text-sky.1",
      ref: t,
      htmlFor: n,
      ...e
    }
  );
});
bM.displayName = "FormLabel";
const yM = M(({ ...e }, t) => {
  const { error: n, formItemId: r, formMessageId: o } = Ed();
  return /* @__PURE__ */ w.jsx(
    Tr,
    {
      ref: t,
      "aria-describedby": o,
      "aria-invalid": !!n,
      ...e,
      id: r
    }
  );
});
yM.displayName = "FormControl";
const xM = M(({ className: e, children: t, ...n }, r) => {
  const { error: o, formMessageId: a } = Ed(), i = o ? String(o.message) : t;
  return i ? /* @__PURE__ */ w.jsx(
    "p",
    {
      ref: r,
      id: a,
      className: z("mt-1.5 text-sm text-berry.3", e),
      ...n,
      children: i
    }
  ) : null;
});
xM.displayName = "FormMessage";
var wM = "Expected a function", Jm = 0 / 0, EM = "[object Symbol]", $M = /^\s+|\s+$/g, TM = /^[-+]0x[0-9a-f]+$/i, SM = /^0b[01]+$/i, kM = /^0o[0-7]+$/i, _M = parseInt, CM = typeof jt == "object" && jt && jt.Object === Object && jt, PM = typeof self == "object" && self && self.Object === Object && self, AM = CM || PM || Function("return this")(), OM = Object.prototype, NM = OM.toString, RM = Math.max, MM = Math.min, tl = function() {
  return AM.Date.now();
};
function DM(e, t, n) {
  var r, o, a, i, s, c, l = 0, d = !1, u = !1, v = !0;
  if (typeof e != "function")
    throw new TypeError(wM);
  t = ep(t) || 0, zl(n) && (d = !!n.leading, u = "maxWait" in n, a = u ? RM(ep(n.maxWait) || 0, t) : a, v = "trailing" in n ? !!n.trailing : v);
  function m(N) {
    var U = r, L = o;
    return r = o = void 0, l = N, i = e.apply(L, U), i;
  }
  function b(N) {
    return l = N, s = setTimeout(k, t), d ? m(N) : i;
  }
  function x(N) {
    var U = N - c, L = N - l, j = t - U;
    return u ? MM(j, a - L) : j;
  }
  function g(N) {
    var U = N - c, L = N - l;
    return c === void 0 || U >= t || U < 0 || u && L >= a;
  }
  function k() {
    var N = tl();
    if (g(N))
      return $(N);
    s = setTimeout(k, x(N));
  }
  function $(N) {
    return s = void 0, v && r ? m(N) : (r = o = void 0, i);
  }
  function T() {
    s !== void 0 && clearTimeout(s), l = 0, r = c = o = s = void 0;
  }
  function S() {
    return s === void 0 ? i : $(tl());
  }
  function C() {
    var N = tl(), U = g(N);
    if (r = arguments, o = this, c = N, U) {
      if (s === void 0)
        return b(c);
      if (u)
        return s = setTimeout(k, t), m(c);
    }
    return s === void 0 && (s = setTimeout(k, t)), i;
  }
  return C.cancel = T, C.flush = S, C;
}
function zl(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function IM(e) {
  return !!e && typeof e == "object";
}
function jM(e) {
  return typeof e == "symbol" || IM(e) && NM.call(e) == EM;
}
function ep(e) {
  if (typeof e == "number")
    return e;
  if (jM(e))
    return Jm;
  if (zl(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = zl(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace($M, "");
  var n = SM.test(e);
  return n || kM.test(e) ? _M(e.slice(2), n ? 2 : 8) : TM.test(e) ? Jm : +e;
}
var LM = DM;
const tp = /* @__PURE__ */ $s(LM);
function FM(e) {
  const t = Z(e);
  t.current = e, Ee(
    () => () => {
      t.current();
    },
    []
  );
}
function WM(e, t = 500, n) {
  const r = Z();
  FM(() => {
    r.current && r.current.cancel();
  });
  const o = qe(() => {
    const a = tp(e, t, n), i = (...s) => a(...s);
    return i.cancel = () => {
      a.cancel();
    }, i.isPending = () => !!r.current, i.flush = () => a.flush(), i;
  }, [e, t, n]);
  return Ee(() => {
    r.current = tp(e, t, n);
  }, [e, t, n]), o;
}
const $d = Et({
  scroll: () => {
  },
  leftScrollButtonHidden: !1,
  rightScrollButtonHidden: !1
}), gV = ({
  children: e,
  visibleCells: t = 6,
  scrollSpeed: n = 2,
  className: r,
  ...o
}) => {
  const a = Z(null), [i, s] = Ce(!0), [c, l] = Ce(!0), d = Ie(() => {
    const m = a.current;
    if (!m)
      return;
    const b = m.clientWidth / t;
    s(m.scrollLeft < b * 0.3), l(
      m.scrollWidth - (m.scrollLeft + m.clientWidth) < b * 0.3
    );
  }, [t]), u = WM(
    d,
    50
  );
  Ee(() => {
    u();
  }, [u]), Ee(() => {
    const m = a.current;
    if (!m)
      return;
    const b = new ResizeObserver(u);
    return b.observe(m), m.addEventListener("scroll", u), () => {
      m.removeEventListener("scroll", u), b.disconnect();
    };
  }, [u]);
  const v = (m) => {
    const b = a.current;
    if (!b)
      return;
    const x = b.clientWidth / t;
    b.scrollLeft += m === "left" ? -x * n : x * n;
  };
  return /* @__PURE__ */ w.jsxs(Ku, { className: z("mb-5", r), ...o, children: [
    /* @__PURE__ */ w.jsx(
      Xu,
      {
        ref: a,
        className: "scroll-smooth",
        children: /* @__PURE__ */ w.jsx(
          $d.Provider,
          {
            value: {
              scroll: v,
              leftScrollButtonHidden: i,
              rightScrollButtonHidden: c
            },
            children: e
          }
        )
      }
    ),
    /* @__PURE__ */ w.jsx(e6, { orientation: "horizontal" })
  ] });
}, bV = ({
  className: e,
  onClick: t,
  ...n
}) => {
  const { leftScrollButtonHidden: r, scroll: o } = Ye($d);
  return /* @__PURE__ */ w.jsx(
    "button",
    {
      type: "button",
      onClick: (a) => {
        o("left"), t == null || t(a);
      },
      className: z(
        "group/scrollButton absolute left-0 top-0 flex h-full w-12 items-center bg-gradient-to-r from-white to-transparent transition-opacity",
        {
          "opacity-0 pointer-events-none": r
        },
        e
      ),
      ...n,
      children: /* @__PURE__ */ w.jsx("span", { className: "flex h-7 w-7 items-center justify-center rounded-sm border border-transparent transition-colors group-hover/scrollButton:border-grey.6 group-hover/scrollButton:bg-white", children: /* @__PURE__ */ w.jsx(n2, {}) })
    }
  );
}, yV = ({
  className: e,
  onClick: t,
  ...n
}) => {
  const { rightScrollButtonHidden: r, scroll: o } = Ye(
    $d
  );
  return /* @__PURE__ */ w.jsx(
    "button",
    {
      type: "button",
      onClick: (a) => {
        o("right"), t == null || t(a);
      },
      className: z(
        "group/scrollButton absolute right-0 top-0 flex h-full w-12 items-center justify-end bg-gradient-to-l from-white to-transparent transition-opacity",
        {
          "opacity-0 pointer-events-none": r
        },
        e
      ),
      ...n,
      children: /* @__PURE__ */ w.jsx("span", { className: "flex h-7 w-7 items-center justify-center rounded-sm border border-transparent transition-colors group-hover/scrollButton:border-grey.6 group-hover/scrollButton:bg-white", children: /* @__PURE__ */ w.jsx(a2, {}) })
    }
  );
}, xV = ({
  className: e = "",
  ...t
}) => /* @__PURE__ */ w.jsx("ul", { className: z("flex list-none space-x-6", e), ...t }), HM = M(
  ({
    invalidValues: e,
    onValuesChange: t,
    input: n,
    onInputChange: r,
    placeholder: o,
    values: a,
    isInvalid: i = !1,
    className: s,
    ...c
  }, l) => {
    const [d, u] = Ce(!1), v = Z(null);
    t1(l, () => v.current);
    const m = (T) => {
      t([...a, T]), r("");
    }, b = (T) => {
      t(a.filter((S, C) => C !== T));
    }, x = (T) => {
      r(T.target.value);
    }, g = (T) => {
      const { key: S } = T;
      if (S === "Backspace" && !n.length && a.length) {
        b(a.length - 1);
        return;
      }
      const C = n.trim();
      (S === "," || S === " ") && C.length && (T.preventDefault(), m(C));
    }, k = (T) => {
      T.preventDefault();
      const C = T.clipboardData.getData("text").split(",").map((N) => N.trim()).filter((N) => N.length);
      t([...a, ...C]);
    }, $ = () => {
      var T;
      return (T = v.current) == null ? void 0 : T.focus();
    };
    return (
      /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
      /* @__PURE__ */ w.jsxs(
        "div",
        {
          className: z(
            "flex min-h-[2.5rem] w-full max-w-full cursor-text flex-wrap gap-1.5 rounded border border-solid border-grey.6 px-2.5 py-2 text-sm text-sky.1",
            {
              "border-sky.6 outline-none ring-2 ring-sky.6": d,
              "border-berry.3 ring-transparent": i
            },
            s
          ),
          onClick: $,
          children: [
            a.map((T, S) => /* @__PURE__ */ w.jsxs(
              "div",
              {
                className: z(
                  "flex h-6 max-w-full items-center justify-between gap-1.5 rounded bg-sky.1 py-1 pl-1.5 text-sm leading-[0.938rem] text-white hover:text-white/60",
                  {
                    "border border-berry.1 text-berry.1 bg-transparent hover:text-berry.1": e == null ? void 0 : e.includes(T)
                  }
                ),
                title: T,
                children: [
                  /* @__PURE__ */ w.jsx("span", { className: "truncate", children: T }),
                  /* @__PURE__ */ w.jsxs(
                    "button",
                    {
                      type: "button",
                      className: "flex cursor-pointer items-center justify-center p-1",
                      onClick: () => {
                        b(S);
                      },
                      children: [
                        /* @__PURE__ */ w.jsx(rh, {}),
                        /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: "Delete" })
                      ]
                    }
                  )
                ]
              },
              S
            )),
            /* @__PURE__ */ w.jsx(
              "input",
              {
                className: "ml-1 flex-1 focus-visible:outline-none",
                onBlur: () => {
                  u(!1);
                },
                onChange: x,
                onFocus: () => {
                  u(!0);
                },
                onPaste: k,
                onKeyDown: g,
                ref: v,
                value: n,
                ...!a.length && { placeholder: o },
                ...c
              }
            )
          ]
        }
      )
    );
  }
);
HM.displayName = "Multi";
const UM = M(
  ({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
    "nav",
    {
      ref: n,
      role: "navigation",
      "aria-label": "pagination",
      className: z("flex flex-row items-center", e),
      ...t
    }
  )
);
UM.displayName = "Pagination";
const BM = M(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ w.jsxs(
  vo,
  {
    type: "button",
    size: "icon",
    variant: "outline",
    ref: r,
    className: z(
      "rounded-none rounded-l border-r-transparent focus:z-[1]",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ w.jsx(r2, { "aria-hidden": !0 }),
      /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: t ?? "Previous" })
    ]
  }
));
BM.displayName = "PaginationPrevious";
const zM = M(
  ({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
    vo,
    {
      type: "button",
      variant: "outline",
      ref: n,
      className: z("rounded-none focus:z-[1]", e),
      ...t
    }
  )
);
zM.displayName = "PaginationControl";
const VM = M(
  ({
    type: e = "button",
    size: t = "icon",
    variant: n = "outline",
    className: r,
    children: o,
    ...a
  }, i) => /* @__PURE__ */ w.jsxs(
    vo,
    {
      type: e,
      size: t,
      variant: n,
      ref: i,
      className: z(
        "rounded-none rounded-r border-l-transparent focus:z-[1]",
        r
      ),
      ...a,
      children: [
        /* @__PURE__ */ w.jsx(i2, { "aria-hidden": !0 }),
        /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: o ?? "Next" })
      ]
    }
  )
);
VM.displayName = "PaginationNext";
const GM = ({
  label: e,
  highlight: t,
  isSelected: n,
  onClick: r,
  value: o,
  className: a
}) => {
  const i = ny(e, t || "");
  return /* @__PURE__ */ w.jsx(
    "button",
    {
      className: pp(
        "h-10 w-max rounded border-0 px-3 text-label-l",
        {
          "text-white bg-sky.1": n,
          "text-sky.1 bg-grey.7": !n
        },
        a
      ),
      "data-testid": "pillOptionButton",
      onClick: () => {
        r(o);
      },
      type: "button",
      children: /* @__PURE__ */ w.jsx("span", { dangerouslySetInnerHTML: { __html: i } })
    }
  );
};
GM.displayName = "PillOption";
const qM = M(
  ({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
    mN,
    {
      ref: n,
      as: "div",
      className: z("group/select relative", e),
      ...t
    }
  )
);
qM.displayName = "Select";
const YM = M(({ displayValue: e, placeholder: t, className: n, ...r }, o) => /* @__PURE__ */ w.jsx(
  $0,
  {
    ref: o,
    className: z(
      "relative flex h-10 w-full items-center gap-x-1 rounded-[3px] border border-solid border-grey.6 bg-white px-3 text-left text-label-l transition-colors hover:border-sky.cloudy focus:outline-none focus-visible:border-sky.6 focus-visible:ring-2 focus-visible:ring-sky.6 disabled:cursor-not-allowed disabled:border-grey.6 disabled:bg-grey.8",
      "data-[open]:rounded-b-none data-[open]:border-sky.6 data-[open]:ring-2 data-[open]:ring-sky.6",
      n
    ),
    ...r,
    children: ({ value: a, disabled: i }) => /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
      /* @__PURE__ */ w.jsx(
        "span",
        {
          className: "pointer-events-none absolute inset-x-0 -bottom-0.5 z-50 hidden h-1 bg-white group-data-[open]/select:block",
          "aria-hidden": !0
        }
      ),
      /* @__PURE__ */ w.jsx(
        "span",
        {
          className: z("w-full truncate text-grey.4", {
            "text-sky.1": !!a,
            "text-sky.cloudy": !!a && i
          }),
          children: a ? typeof e == "function" ? e(a) : a : t
        }
      ),
      /* @__PURE__ */ w.jsx(Ya, { className: "text-sky.1", "aria-hidden": !0 })
    ] })
  }
));
YM.displayName = "SelectTrigger";
const KM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  T0,
  {
    ref: n,
    className: z(
      "absolute z-40 max-h-48 w-full overflow-y-auto rounded-b-[3px] border bg-white focus-visible:outline-none",
      "data-[open]:rounded-t-none data-[open]:border-sky.6 data-[open]:ring-2 data-[open]:ring-sky.6",
      e
    ),
    ...t
  }
));
KM.displayName = "SelectContent";
const XM = M(({ value: e, className: t, ...n }, r) => /* @__PURE__ */ w.jsx(
  S0,
  {
    ref: r,
    className: ({ focus: o, selected: a, disabled: i }) => z(
      "cursor-pointer items-start truncate bg-white px-3 py-2.5 text-label-l text-sky.1 hover:bg-grey.7",
      {
        "opacity-50 pointer-events-none": i,
        "font-bold": a,
        "bg-grey.7": o
      },
      t
    ),
    value: e,
    ...n
  }
));
XM.displayName = "SelectItem";
const ZM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z("my-l flex justify-center", e),
    ...t,
    children: /* @__PURE__ */ w.jsx(Bo, { size: "small" })
  }
));
ZM.displayName = "SelectContentLoader";
const QM = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "li",
  {
    ref: n,
    className: z(
      "my-l flex items-center justify-center px-1 text-label-l text-sky.cloudy",
      e
    ),
    ...t
  }
));
QM.displayName = "SelectContentEmpty";
function JM(e) {
  return go({ tag: "svg", attr: { viewBox: "0 0 1024 1024", fill: "currentColor", fillRule: "evenodd" }, child: [{ tag: "path", attr: { d: "M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z" } }] })(e);
}
const wV = ou, EV = au, $V = Uo, eD = iu, bb = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  za,
  {
    className: z(
      "fixed inset-0 z-50 bg-sky.1/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
bb.displayName = za.displayName;
const tD = Wn(
  "fixed z-50 gap-4 bg-white p-7 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-lg",
        right: "inset-y-0 right-0 h-full w-3/4 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-lg"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), nD = M(({ side: e = "right", className: t, children: n, ...r }, o) => /* @__PURE__ */ w.jsxs(eD, { children: [
  /* @__PURE__ */ w.jsx(bb, {}),
  /* @__PURE__ */ w.jsxs(
    Va,
    {
      ref: o,
      className: z(tD({ side: e }), t),
      ...r,
      children: [
        n,
        /* @__PURE__ */ w.jsxs(Uo, { className: "absolute right-7 top-8 rounded-sm text-sky.1 opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-sky.6 focus:ring-offset-2 disabled:pointer-events-none", children: [
          /* @__PURE__ */ w.jsx(JM, { className: "h-5 w-5" }),
          /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
nD.displayName = Va.displayName;
const rD = ({
  className: e,
  ...t
}) => /* @__PURE__ */ w.jsx(
  "div",
  {
    className: z(
      "mb-7 flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
rD.displayName = "SheetHeader";
const oD = ({
  className: e,
  ...t
}) => /* @__PURE__ */ w.jsx(
  "div",
  {
    className: z(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
oD.displayName = "SheetFooter";
const aD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Ga,
  {
    ref: n,
    className: z("text-xl font-normal text-sky.1", e),
    ...t
  }
));
aD.displayName = Ga.displayName;
const iD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  qa,
  {
    ref: n,
    className: z("text-sm text-sky.1", e),
    ...t
  }
));
iD.displayName = qa.displayName;
const sD = M(
  ({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("table", { ref: n, className: z("w-full", e), ...t })
);
sD.displayName = "Table";
const cD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("thead", { ref: n, className: e, ...t }));
cD.displayName = "TableHeader";
const lD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "tbody",
  {
    ref: n,
    className: z("divide-y divide-grey.6", e),
    ...t
  }
));
lD.displayName = "TableBody";
const uD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "tfoot",
  {
    ref: n,
    className: z("border-t font-medium", e),
    ...t
  }
));
uD.displayName = "TableFooter";
const dD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("tr", { ref: n, className: e, ...t }));
dD.displayName = "TableRow";
const fD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  "th",
  {
    ref: n,
    className: z("h-12 text-left align-middle font-medium", e),
    ...t
  }
));
fD.displayName = "TableHead";
const mD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("td", { ref: n, className: z("align-middle", e), ...t }));
mD.displayName = "TableCell";
const pD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx("caption", { ref: n, className: z("mt-4 text-sm", e), ...t }));
pD.displayName = "TableCaption";
function hD(e, t) {
  return mr((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const yb = (e) => {
  const { present: t, children: n } = e, r = vD(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : Tn.only(n), a = ct(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ fr(o, {
    ref: a
  }) : null;
};
yb.displayName = "Presence";
function vD(e) {
  const [t, n] = Ce(), r = Z({}), o = Z(e), a = Z("none"), i = e ? "mounted" : "unmounted", [s, c] = hD(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Ee(() => {
    const l = Hi(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [
    s
  ]), qt(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const v = a.current, m = Hi(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && v !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    c
  ]), qt(() => {
    if (t) {
      const l = (u) => {
        const m = Hi(r.current).includes(u.animationName);
        u.target === t && m && Vr(
          () => c("ANIMATION_END")
        );
      }, d = (u) => {
        u.target === t && (a.current = Hi(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: Ie((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Hi(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function gD({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = bD({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, i = a ? e : r, s = wt(n), c = Ie((l) => {
    if (a) {
      const u = typeof l == "function" ? l(e) : l;
      u !== e && s(u);
    } else
      o(l);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    i,
    c
  ];
}
function bD({ defaultProp: e, onChange: t }) {
  const n = Ce(e), [r] = n, o = Z(r), a = wt(t);
  return Ee(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
const xb = "Tabs", [yD, TV] = Hn(xb, [
  ic
]), wb = ic(), [xD, Td] = yD(xb), wD = /* @__PURE__ */ M((e, t) => {
  const { __scopeTabs: n, value: r, onValueChange: o, defaultValue: a, orientation: i = "horizontal", dir: s, activationMode: c = "automatic", ...l } = e, d = Ks(s), [u, v] = gD({
    prop: r,
    onChange: o,
    defaultProp: a
  });
  return /* @__PURE__ */ I(xD, {
    scope: n,
    baseId: Ln(),
    value: u,
    onValueChange: v,
    orientation: i,
    dir: d,
    activationMode: c
  }, /* @__PURE__ */ I(lt.div, oe({
    dir: d,
    "data-orientation": i
  }, l, {
    ref: t
  })));
}), ED = "TabsList", $D = /* @__PURE__ */ M((e, t) => {
  const { __scopeTabs: n, loop: r = !0, ...o } = e, a = Td(ED, n), i = wb(n);
  return /* @__PURE__ */ I(R0, oe({
    asChild: !0
  }, i, {
    orientation: a.orientation,
    dir: a.dir,
    loop: r
  }), /* @__PURE__ */ I(lt.div, oe({
    role: "tablist",
    "aria-orientation": a.orientation
  }, o, {
    ref: t
  })));
}), TD = "TabsTrigger", SD = /* @__PURE__ */ M((e, t) => {
  const { __scopeTabs: n, value: r, disabled: o = !1, ...a } = e, i = Td(TD, n), s = wb(n), c = Eb(i.baseId, r), l = $b(i.baseId, r), d = r === i.value;
  return /* @__PURE__ */ I(M0, oe({
    asChild: !0
  }, s, {
    focusable: !o,
    active: d
  }), /* @__PURE__ */ I(lt.button, oe({
    type: "button",
    role: "tab",
    "aria-selected": d,
    "aria-controls": l,
    "data-state": d ? "active" : "inactive",
    "data-disabled": o ? "" : void 0,
    disabled: o,
    id: c
  }, a, {
    ref: t,
    onMouseDown: Le(e.onMouseDown, (u) => {
      !o && u.button === 0 && u.ctrlKey === !1 ? i.onValueChange(r) : u.preventDefault();
    }),
    onKeyDown: Le(e.onKeyDown, (u) => {
      [
        " ",
        "Enter"
      ].includes(u.key) && i.onValueChange(r);
    }),
    onFocus: Le(e.onFocus, () => {
      const u = i.activationMode !== "manual";
      !d && !o && u && i.onValueChange(r);
    })
  })));
}), kD = "TabsContent", _D = /* @__PURE__ */ M((e, t) => {
  const { __scopeTabs: n, value: r, forceMount: o, children: a, ...i } = e, s = Td(kD, n), c = Eb(s.baseId, r), l = $b(s.baseId, r), d = r === s.value, u = Z(d);
  return Ee(() => {
    const v = requestAnimationFrame(
      () => u.current = !1
    );
    return () => cancelAnimationFrame(v);
  }, []), /* @__PURE__ */ I(
    yb,
    {
      present: o || d
    },
    ({ present: v }) => /* @__PURE__ */ I(lt.div, oe({
      "data-state": d ? "active" : "inactive",
      "data-orientation": s.orientation,
      role: "tabpanel",
      "aria-labelledby": c,
      hidden: !v,
      id: l,
      tabIndex: 0
    }, i, {
      ref: t,
      style: {
        ...e.style,
        animationDuration: u.current ? "0s" : void 0
      }
    }), v && a)
  );
});
function Eb(e, t) {
  return `${e}-trigger-${t}`;
}
function $b(e, t) {
  return `${e}-content-${t}`;
}
const CD = wD, Tb = $D, Sb = SD, kb = _D, SV = CD, PD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Tb,
  {
    ref: n,
    className: z(
      "inline-flex h-12 w-full items-center space-x-3 overflow-x-auto overflow-y-hidden pb-2 text-sky.1",
      e
    ),
    ...t
  }
));
PD.displayName = Tb.displayName;
const AD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Sb,
  {
    ref: n,
    className: z(
      "inline-flex items-center justify-center whitespace-nowrap border-b-2 border-b-transparent p-1 text-sm transition-all focus-visible:outline-none focus-visible:ring focus-visible:ring-sky.6 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-b-2 data-[state=active]:border-b-sky.1",
      e
    ),
    ...t
  }
));
AD.displayName = Sb.displayName;
const OD = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  kb,
  {
    ref: n,
    className: z(
      "mt-2 focus-visible:outline-none focus-visible:ring focus-visible:ring-sky.6",
      e
    ),
    ...t
  }
));
OD.displayName = kb.displayName;
const ND = M(
  ({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
    "textarea",
    {
      className: z(
        "flex min-h-[16px] w-full rounded border border-grey.6 bg-white px-3 py-2 text-sm text-sky.1 focus-visible:border-sky.6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky.6 disabled:cursor-not-allowed disabled:border-grey.6 disabled:bg-grey.8 disabled:text-sky.9",
        e
      ),
      ref: n,
      ...t
    }
  )
);
ND.displayName = "Textarea";
function ir(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function RD(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function _b(...e) {
  return (t) => e.forEach((n) => RD(n, t));
}
function ys(...e) {
  return P.useCallback(_b(...e), e);
}
function Cb(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = P.createContext(i), c = n.length;
    n = [...n, i];
    function l(u) {
      const { scope: v, children: m, ...b } = u, x = (v == null ? void 0 : v[e][c]) || s, g = P.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ w.jsx(x.Provider, { value: g, children: m });
    }
    function d(u, v) {
      const m = (v == null ? void 0 : v[e][c]) || s, b = P.useContext(m);
      if (b)
        return b;
      if (i !== void 0)
        return i;
      throw new Error(`\`${u}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = n.map((i) => P.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return P.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, MD(o, ...t)];
}
function MD(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const u = c(a)[`__scope${l}`];
        return { ...s, ...u };
      }, {});
      return P.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var xs = P.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = P.Children.toArray(n), a = o.find(ID);
  if (a) {
    const i = a.props.children, s = o.map((c) => c === a ? P.Children.count(i) > 1 ? P.Children.only(null) : P.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ w.jsx(Vl, { ...r, ref: t, children: P.isValidElement(i) ? P.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ w.jsx(Vl, { ...r, ref: t, children: n });
});
xs.displayName = "Slot";
var Vl = P.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (P.isValidElement(n)) {
    const o = LD(n);
    return P.cloneElement(n, {
      ...jD(r, n.props),
      // @ts-ignore
      ref: t ? _b(t, o) : o
    });
  }
  return P.Children.count(n) > 1 ? P.Children.only(null) : null;
});
Vl.displayName = "SlotClone";
var DD = ({ children: e }) => /* @__PURE__ */ w.jsx(w.Fragment, { children: e });
function ID(e) {
  return P.isValidElement(e) && e.type === DD;
}
function jD(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function LD(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function FD(e) {
  const t = e + "CollectionProvider", [n, r] = Cb(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: b, children: x } = m, g = ce.useRef(null), k = ce.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ w.jsx(o, { scope: b, itemMap: k, collectionRef: g, children: x });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", c = ce.forwardRef(
    (m, b) => {
      const { scope: x, children: g } = m, k = a(s, x), $ = ys(b, k.collectionRef);
      return /* @__PURE__ */ w.jsx(xs, { ref: $, children: g });
    }
  );
  c.displayName = s;
  const l = e + "CollectionItemSlot", d = "data-radix-collection-item", u = ce.forwardRef(
    (m, b) => {
      const { scope: x, children: g, ...k } = m, $ = ce.useRef(null), T = ys(b, $), S = a(l, x);
      return ce.useEffect(() => (S.itemMap.set($, { ref: $, ...k }), () => void S.itemMap.delete($))), /* @__PURE__ */ w.jsx(xs, { [d]: "", ref: T, children: g });
    }
  );
  u.displayName = l;
  function v(m) {
    const b = a(e + "CollectionConsumer", m);
    return ce.useCallback(() => {
      const g = b.collectionRef.current;
      if (!g)
        return [];
      const k = Array.from(g.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (S, C) => k.indexOf(S.ref.current) - k.indexOf(C.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: u },
    v,
    r
  ];
}
var WD = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], $o = WD.reduce((e, t) => {
  const n = P.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? xs : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w.jsx(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function HD(e, t) {
  e && Wr.flushSync(() => e.dispatchEvent(t));
}
var Pb = globalThis != null && globalThis.document ? P.useLayoutEffect : () => {
}, UD = "Portal", Ab = P.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, a] = P.useState(!1);
  Pb(() => a(!0), []);
  const i = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? ap.createPortal(/* @__PURE__ */ w.jsx($o.div, { ...r, ref: t }), i) : null;
});
Ab.displayName = UD;
function ws(e) {
  const t = P.useRef(e);
  return P.useEffect(() => {
    t.current = e;
  }), P.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function BD(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function zD(...e) {
  return (t) => e.forEach((n) => BD(n, t));
}
var Ob = P.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = P.Children.toArray(n), a = o.find(GD);
  if (a) {
    const i = a.props.children, s = o.map((c) => c === a ? P.Children.count(i) > 1 ? P.Children.only(null) : P.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ w.jsx(Gl, { ...r, ref: t, children: P.isValidElement(i) ? P.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ w.jsx(Gl, { ...r, ref: t, children: n });
});
Ob.displayName = "Slot";
var Gl = P.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (P.isValidElement(n)) {
    const o = YD(n);
    return P.cloneElement(n, {
      ...qD(r, n.props),
      // @ts-ignore
      ref: t ? zD(t, o) : o
    });
  }
  return P.Children.count(n) > 1 ? P.Children.only(null) : null;
});
Gl.displayName = "SlotClone";
var VD = ({ children: e }) => /* @__PURE__ */ w.jsx(w.Fragment, { children: e });
function GD(e) {
  return P.isValidElement(e) && e.type === VD;
}
function qD(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function YD(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var KD = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], XD = KD.reduce((e, t) => {
  const n = P.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? Ob : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w.jsx(s, { ...i, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), ZD = "VisuallyHidden", Sd = P.forwardRef(
  (e, t) => /* @__PURE__ */ w.jsx(
    XD.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Sd.displayName = ZD;
var kd = "ToastProvider", [_d, QD, JD] = FD("Toast"), [Nb, kV] = Cb("Toast", [JD]), [eI, lc] = Nb(kd), Rb = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    children: i
  } = e, [s, c] = P.useState(null), [l, d] = P.useState(0), u = P.useRef(!1), v = P.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${kd}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ w.jsx(_d.Provider, { scope: t, children: /* @__PURE__ */ w.jsx(
    eI,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: l,
      viewport: s,
      onViewportChange: c,
      onToastAdd: P.useCallback(() => d((m) => m + 1), []),
      onToastRemove: P.useCallback(() => d((m) => m - 1), []),
      isFocusedToastEscapeKeyDownRef: u,
      isClosePausedRef: v,
      children: i
    }
  ) });
};
Rb.displayName = kd;
var Mb = "ToastViewport", tI = ["F8"], ql = "toast.viewportPause", Yl = "toast.viewportResume", Db = P.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = tI,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, i = lc(Mb, n), s = QD(n), c = P.useRef(null), l = P.useRef(null), d = P.useRef(null), u = P.useRef(null), v = ys(t, u, i.onViewportChange), m = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), b = i.toastCount > 0;
    P.useEffect(() => {
      const g = (k) => {
        var T;
        r.every((S) => k[S] || k.code === S) && ((T = u.current) == null || T.focus());
      };
      return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
    }, [r]), P.useEffect(() => {
      const g = c.current, k = u.current;
      if (b && g && k) {
        const $ = () => {
          if (!i.isClosePausedRef.current) {
            const N = new CustomEvent(ql);
            k.dispatchEvent(N), i.isClosePausedRef.current = !0;
          }
        }, T = () => {
          if (i.isClosePausedRef.current) {
            const N = new CustomEvent(Yl);
            k.dispatchEvent(N), i.isClosePausedRef.current = !1;
          }
        }, S = (N) => {
          !g.contains(N.relatedTarget) && T();
        }, C = () => {
          g.contains(document.activeElement) || T();
        };
        return g.addEventListener("focusin", $), g.addEventListener("focusout", S), g.addEventListener("pointermove", $), g.addEventListener("pointerleave", C), window.addEventListener("blur", $), window.addEventListener("focus", T), () => {
          g.removeEventListener("focusin", $), g.removeEventListener("focusout", S), g.removeEventListener("pointermove", $), g.removeEventListener("pointerleave", C), window.removeEventListener("blur", $), window.removeEventListener("focus", T);
        };
      }
    }, [b, i.isClosePausedRef]);
    const x = P.useCallback(
      ({ tabbingDirection: g }) => {
        const $ = s().map((T) => {
          const S = T.ref.current, C = [S, ...hI(S)];
          return g === "forwards" ? C : C.reverse();
        });
        return (g === "forwards" ? $.reverse() : $).flat();
      },
      [s]
    );
    return P.useEffect(() => {
      const g = u.current;
      if (g) {
        const k = ($) => {
          var C, N, U;
          const T = $.altKey || $.ctrlKey || $.metaKey;
          if ($.key === "Tab" && !T) {
            const L = document.activeElement, j = $.shiftKey;
            if ($.target === g && j) {
              (C = l.current) == null || C.focus();
              return;
            }
            const Q = x({ tabbingDirection: j ? "backwards" : "forwards" }), ke = Q.findIndex((H) => H === L);
            nl(Q.slice(ke + 1)) ? $.preventDefault() : j ? (N = l.current) == null || N.focus() : (U = d.current) == null || U.focus();
          }
        };
        return g.addEventListener("keydown", k), () => g.removeEventListener("keydown", k);
      }
    }, [s, x]), /* @__PURE__ */ w.jsxs(
      Ty,
      {
        ref: c,
        role: "region",
        "aria-label": o.replace("{hotkey}", m),
        tabIndex: -1,
        style: { pointerEvents: b ? void 0 : "none" },
        children: [
          b && /* @__PURE__ */ w.jsx(
            Kl,
            {
              ref: l,
              onFocusFromOutsideViewport: () => {
                const g = x({
                  tabbingDirection: "forwards"
                });
                nl(g);
              }
            }
          ),
          /* @__PURE__ */ w.jsx(_d.Slot, { scope: n, children: /* @__PURE__ */ w.jsx($o.ol, { tabIndex: -1, ...a, ref: v }) }),
          b && /* @__PURE__ */ w.jsx(
            Kl,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const g = x({
                  tabbingDirection: "backwards"
                });
                nl(g);
              }
            }
          )
        ]
      }
    );
  }
);
Db.displayName = Mb;
var Ib = "ToastFocusProxy", Kl = P.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, a = lc(Ib, n);
    return /* @__PURE__ */ w.jsx(
      Sd,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          var l;
          const s = i.relatedTarget;
          !((l = a.viewport) != null && l.contains(s)) && r();
        }
      }
    );
  }
);
Kl.displayName = Ib;
var uc = "Toast", nI = "toast.swipeStart", rI = "toast.swipeMove", oI = "toast.swipeCancel", aI = "toast.swipeEnd", jb = P.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: a, ...i } = e, [s = !0, c] = ni({
      prop: r,
      defaultProp: o,
      onChange: a
    });
    return /* @__PURE__ */ w.jsx(Ys, { present: n || s, children: /* @__PURE__ */ w.jsx(
      cI,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => c(!1),
        onPause: ws(e.onPause),
        onResume: ws(e.onResume),
        onSwipeStart: ir(e.onSwipeStart, (l) => {
          l.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: ir(e.onSwipeMove, (l) => {
          const { x: d, y: u } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${u}px`);
        }),
        onSwipeCancel: ir(e.onSwipeCancel, (l) => {
          l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: ir(e.onSwipeEnd, (l) => {
          const { x: d, y: u } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${u}px`), c(!1);
        })
      }
    ) });
  }
);
jb.displayName = uc;
var [iI, sI] = Nb(uc, {
  onClose() {
  }
}), cI = P.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: a,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: c,
      onResume: l,
      onSwipeStart: d,
      onSwipeMove: u,
      onSwipeCancel: v,
      onSwipeEnd: m,
      ...b
    } = e, x = lc(uc, n), [g, k] = P.useState(null), $ = ys(t, (H) => k(H)), T = P.useRef(null), S = P.useRef(null), C = o || x.duration, N = P.useRef(0), U = P.useRef(C), L = P.useRef(0), { onToastAdd: j, onToastRemove: q } = x, V = ws(() => {
      var X;
      (g == null ? void 0 : g.contains(document.activeElement)) && ((X = x.viewport) == null || X.focus()), i();
    }), Q = P.useCallback(
      (H) => {
        !H || H === 1 / 0 || (window.clearTimeout(L.current), N.current = (/* @__PURE__ */ new Date()).getTime(), L.current = window.setTimeout(V, H));
      },
      [V]
    );
    P.useEffect(() => {
      const H = x.viewport;
      if (H) {
        const X = () => {
          Q(U.current), l == null || l();
        }, he = () => {
          const $e = (/* @__PURE__ */ new Date()).getTime() - N.current;
          U.current = U.current - $e, window.clearTimeout(L.current), c == null || c();
        };
        return H.addEventListener(ql, he), H.addEventListener(Yl, X), () => {
          H.removeEventListener(ql, he), H.removeEventListener(Yl, X);
        };
      }
    }, [x.viewport, C, c, l, Q]), P.useEffect(() => {
      a && !x.isClosePausedRef.current && Q(C);
    }, [a, C, x.isClosePausedRef, Q]), P.useEffect(() => (j(), () => q()), [j, q]);
    const ke = P.useMemo(() => g ? Bb(g) : null, [g]);
    return x.viewport ? /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
      ke && /* @__PURE__ */ w.jsx(
        lI,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: ke
        }
      ),
      /* @__PURE__ */ w.jsx(iI, { scope: n, onClose: V, children: Wr.createPortal(
        /* @__PURE__ */ w.jsx(_d.ItemSlot, { scope: n, children: /* @__PURE__ */ w.jsx(
          $y,
          {
            asChild: !0,
            onEscapeKeyDown: ir(s, () => {
              x.isFocusedToastEscapeKeyDownRef.current || V(), x.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ w.jsx(
              $o.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": x.swipeDirection,
                ...b,
                ref: $,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: ir(e.onKeyDown, (H) => {
                  H.key === "Escape" && (s == null || s(H.nativeEvent), H.nativeEvent.defaultPrevented || (x.isFocusedToastEscapeKeyDownRef.current = !0, V()));
                }),
                onPointerDown: ir(e.onPointerDown, (H) => {
                  H.button === 0 && (T.current = { x: H.clientX, y: H.clientY });
                }),
                onPointerMove: ir(e.onPointerMove, (H) => {
                  if (!T.current)
                    return;
                  const X = H.clientX - T.current.x, he = H.clientY - T.current.y, $e = !!S.current, Te = ["left", "right"].includes(x.swipeDirection), fe = ["left", "up"].includes(x.swipeDirection) ? Math.min : Math.max, Y = Te ? fe(0, X) : 0, O = Te ? 0 : fe(0, he), G = H.pointerType === "touch" ? 10 : 2, W = { x: Y, y: O }, ae = { originalEvent: H, delta: W };
                  $e ? (S.current = W, Ui(rI, u, ae, {
                    discrete: !1
                  })) : np(W, x.swipeDirection, G) ? (S.current = W, Ui(nI, d, ae, {
                    discrete: !1
                  }), H.target.setPointerCapture(H.pointerId)) : (Math.abs(X) > G || Math.abs(he) > G) && (T.current = null);
                }),
                onPointerUp: ir(e.onPointerUp, (H) => {
                  const X = S.current, he = H.target;
                  if (he.hasPointerCapture(H.pointerId) && he.releasePointerCapture(H.pointerId), S.current = null, T.current = null, X) {
                    const $e = H.currentTarget, Te = { originalEvent: H, delta: X };
                    np(X, x.swipeDirection, x.swipeThreshold) ? Ui(aI, m, Te, {
                      discrete: !0
                    }) : Ui(
                      oI,
                      v,
                      Te,
                      {
                        discrete: !0
                      }
                    ), $e.addEventListener("click", (fe) => fe.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        x.viewport
      ) })
    ] }) : null;
  }
), lI = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = lc(uc, t), [a, i] = P.useState(!1), [s, c] = P.useState(!1);
  return mI(() => i(!0)), P.useEffect(() => {
    const l = window.setTimeout(() => c(!0), 1e3);
    return () => window.clearTimeout(l);
  }, []), s ? null : /* @__PURE__ */ w.jsx(Ab, { asChild: !0, children: /* @__PURE__ */ w.jsx(Sd, { ...r, children: a && /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, uI = "ToastTitle", Lb = P.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ w.jsx($o.div, { ...r, ref: t });
  }
);
Lb.displayName = uI;
var dI = "ToastDescription", fI = P.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ w.jsx($o.div, { ...r, ref: t });
  }
);
fI.displayName = dI;
var Fb = "ToastAction", Wb = P.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ w.jsx(Ub, { altText: n, asChild: !0, children: /* @__PURE__ */ w.jsx(Cd, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Fb}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Wb.displayName = Fb;
var Hb = "ToastClose", Cd = P.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = sI(Hb, n);
    return /* @__PURE__ */ w.jsx(Ub, { asChild: !0, children: /* @__PURE__ */ w.jsx(
      $o.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ir(e.onClick, o.onClose)
      }
    ) });
  }
);
Cd.displayName = Hb;
var Ub = P.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ w.jsx(
    $o.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function Bb(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), pI(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const i = r.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...Bb(r));
    }
  }), t;
}
function Ui(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? HD(o, a) : o.dispatchEvent(a);
}
var np = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), a = r > o;
  return t === "left" || t === "right" ? a && r > n : !a && o > n;
};
function mI(e = () => {
}) {
  const t = ws(e);
  Pb(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function pI(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function hI(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function nl(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var vI = Rb, zb = Db, Vb = jb, Gb = Lb, qb = Wb, Yb = Cd;
const _V = vI, Kb = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  zb,
  {
    ref: n,
    className: z(
      "fixed right-4 top-4 z-[100] flex flex-col items-end rounded focus-visible:outline-none focus-visible:ring focus-visible:ring-sky.6",
      e
    ),
    ...t
  }
));
Kb.displayName = zb.displayName;
const gI = Wn(
  "mb-4 flex max-w-[25rem] rounded border font-medium shadow-md focus-visible:outline-none focus-visible:ring focus-visible:ring-sky.6 data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-right-full data-[state=open]:sm:slide-in-from-right-full",
  {
    variants: {
      variant: {
        success: "border-spring.1 bg-spring.2 text-spring.1",
        destructive: "border-berry.2 bg-berry.6 text-berry.2"
      }
    },
    defaultVariants: {
      variant: "success"
    }
  }
), Xb = M(({ className: e, variant: t, children: n, ...r }, o) => /* @__PURE__ */ w.jsxs(
  Vb,
  {
    ref: o,
    className: z(gI({ variant: t }), e),
    ...r,
    children: [
      /* @__PURE__ */ w.jsx("div", { className: "flex shrink-0 items-center justify-center px-3", children: t === "destructive" ? /* @__PURE__ */ w.jsx(d2, {}) : /* @__PURE__ */ w.jsx(Jw, {}) }),
      /* @__PURE__ */ w.jsx(
        "div",
        {
          className: z(
            "flex items-center divide-x",
            t === "destructive" ? "divide-berry.2" : "divide-spring.1"
          ),
          children: n
        }
      )
    ]
  }
));
Xb.displayName = Vb.displayName;
const bI = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  qb,
  {
    ref: n,
    className: z(
      "h-5 w-5 shrink-0 cursor-pointer rounded transition-colors focus-visible:outline-none focus-visible:ring focus-visible:ring-sky.6",
      e
    ),
    ...t
  }
));
bI.displayName = qb.displayName;
const Zb = M(({ ...e }, t) => /* @__PURE__ */ w.jsxs(
  Yb,
  {
    ref: t,
    className: z(
      "flex h-full cursor-pointer items-center rounded-r px-3 py-2.5 focus-visible:outline-none focus-visible:ring focus-visible:ring-sky.6"
    ),
    ...e,
    children: [
      /* @__PURE__ */ w.jsx(c2, { className: "text-sky.1" }),
      /* @__PURE__ */ w.jsx("span", { className: "sr-only", children: "Dismiss" })
    ]
  }
));
Zb.displayName = Yb.displayName;
const Qb = M(({ className: e, ...t }, n) => /* @__PURE__ */ w.jsx(
  Gb,
  {
    ref: n,
    className: z("break-words py-2 pr-3 text-label-l font-medium", e),
    ...t
  }
));
Qb.displayName = Gb.displayName;
const yI = 4, xI = 3e3;
let rl = 0;
function wI() {
  return rl = (rl + 1) % Number.MAX_VALUE, rl.toString();
}
const ol = /* @__PURE__ */ new Map(), rp = (e) => {
  if (ol.has(e))
    return;
  const t = setTimeout(() => {
    ol.delete(e), Aa({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, xI);
  ol.set(e, t);
}, EI = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, yI)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === t.toast.id ? { ...n, ...t.toast } : n
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? rp(n) : e.toasts.forEach((r) => {
        rp(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, Ki = [];
let Xi = { toasts: [] };
function Aa(e) {
  Xi = EI(Xi, e), Ki.forEach((t) => {
    t(Xi);
  });
}
function $I({ ...e }) {
  const t = wI(), n = (o) => {
    Aa({
      type: "UPDATE_TOAST",
      toast: { ...o, id: t }
    });
  }, r = () => {
    Aa({ type: "DISMISS_TOAST", toastId: t });
  };
  return Aa({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function TI() {
  const [e, t] = Ce(Xi);
  return Ee(() => (Ki.push(t), () => {
    const n = Ki.indexOf(t);
    n > -1 && Ki.splice(n, 1);
  }), [e]), {
    ...e,
    toast: $I,
    dismiss: (n) => {
      Aa({ type: "DISMISS_TOAST", toastId: n });
    }
  };
}
function CV() {
  const { toasts: e } = TI();
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    e.map(({ id: t, title: n, variant: r, ...o }) => /* @__PURE__ */ w.jsxs(Xb, { variant: r, ...o, children: [
      /* @__PURE__ */ w.jsx(Qb, { children: n }),
      /* @__PURE__ */ w.jsx(Zb, {})
    ] }, t)),
    /* @__PURE__ */ w.jsx(Kb, {})
  ] });
}
const PV = ({
  children: e,
  value: t
}) => /* @__PURE__ */ w.jsx(bo.Provider, { value: t, children: e }), Oo = {
  id_site: 3208,
  id_article: 20823,
  hidden: !1,
  position: 1,
  equalgroup: 7017626149,
  countrycode: "DK",
  countryname: "Denmark",
  site_rank: {
    rank_global: 40554,
    rank_country: 233
  },
  unix_timestamp: 1719919897,
  mediatype: {
    timemap: !1,
    clip: !1,
    hastext: !0,
    haslogo: !1,
    paywall: !0,
    fulltext: !0,
    text: "WEB"
  },
  reach: 1832,
  adprice: 2444,
  stimestamp: 427563750,
  stimestamp_index: 427563750,
  internal_search_reply: {
    id_site: 3208,
    id_article: 20823,
    text: "(otb++) 9:268623881:538572809:537917449:540008457:536958985:539064329:540100617:540139529:539215881:537198601:537139209: (otb--)"
  },
  local_time: {
    GMT: 1,
    text: "20240702T13:31:37+0200"
  },
  local_rcf822_time: {
    text: "Tue, 02 Jul 2024 13:31:37 +0200"
  },
  distribute_conditions: "",
  content_protected: 1,
  language: {
    encoding: "iso-639",
    translatable: !0,
    text: "en"
  },
  orig_language: {
    text: "da"
  },
  word_count: 254,
  translated: 1,
  GTranslate_url: "https://translate.google.com/translate?sl=da&tl=en&js=y&prev=_t&hl=en&ie=UTF-8&u=https%3A%2F%2Fkforum.dk%2Fnyheder%2Fnyheder%2Farticle17247854.ece&edit-text=&act=url",
  first_source: {
    id: 12991,
    name: "Kommunikations Forum",
    sitename: "Kommunikations Forum",
    url: "https://kforum.dk",
    siteurl: "https://kforum.dk"
  },
  almost_identical: [
    {
      id_site: 19854,
      id_article: 59484,
      sim: 99
    }
  ],
  meta_data: {},
  meta_data_pending: !1,
  header: {
    matches: !0,
    text: "<match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskab"
  },
  short_header: {
    matches: !0,
    length: 39,
    removed: 0,
    text: "<match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskab"
  },
  summary: {
    matches: !0,
    text: "Infomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> kalder det et ”logisk næste skridt” for selskabet at fusionere med <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>, der ejes af <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> og <match color='0' ent='20,46,6256,8932,27479'>norsk</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match>."
  },
  short_summary: {
    matches: !0,
    length: 150,
    removed: 0,
    text: "Infomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> kalder det et ”logisk næste skridt” for selskabet at fusionere med <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>, der ejes af <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> og <match color='0' ent='20,46,6256,8932,27479'>norsk</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match>."
  },
  body: {
    matches: !0,
    text: "<p> Medieovervågnings- og analyseselskabet <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match>, der er ejet af <match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match>, fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>. Det oplyser <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> i en pressemeddelelse.</p> <p> De to medieovervågningsselskaber opererer i et marked, som ”konstant ændrer sig” på grund af nye teknologier og globale konkurrenter, og fusionen skal dermed gøre dem bedre rustet til at investere i udvikling og ny teknologi indenfor medieanalyse, hedder det.</p> <p> Fusionen trådte i kraft 28. juni.</p> <p> <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> Groups <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> <match color='0' ent='301231308'>Martin Ove Rasmussen</match> kalder det for et ”logisk næste skridt” for selskabet.</p> <p> ”Vi vil kunne drage nytte af begge virksomheders respektive kompetencer og ressourcer og skabe bedre betingelser for sammen at forbedre vores services,” udtaler <match color='0' ent='301231308'>Martin Ove Rasmussen</match> i meddelelsen.</p> <p> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match> ejes af det <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='754,112099,179164,664609,3624078,13107770'>TT</match> og det <match color='0' ent='20,46,6256,8932,27479'>norske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='1312586,20,192283,4830453'>NTB</match>.</p> <p> Der vil blive oprettet et nyt holdingselskab, som vil være ejet i fællesskab af Infomedias ejere - altså <match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match> - og <match color='5'>Retriever</match> Groups ejere.</p> <p> <match color='0' ent='24088544,30,205375,6581097,17125263'>Rober</match> Söderling, der er <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> for <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>, bliver topchef for det nye selskab, mens <match color='0' ent='301231308'>Martin Ove Rasmussen</match> vil blive en del af den øverste ledelse.</p> <p> ”Fusionen muliggør de investeringer, der kræves i de kommende år for fortsat at kunne tilbyde de bedste produkter og services til vores kunder,” udtaler <match color='0' ent='80910,30,39631,593644,2919046,6581097'>Robert</match> Söderling i meddelelsen.</p> <p> (Denne artikel er leveret af <match color='0' ent='310774290'>Kforums</match> søstermedie <match color='0' ent='6806225,431603'>MediaWatch</match></p>"
  },
  short_body: {
    matches: !0,
    length: 1529,
    removed: 0,
    text: " Medieovervågnings- og analyseselskabet <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match>, der er ejet af <match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match>, fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>. Det oplyser <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> i en pressemeddelelse.  De to medieovervågningsselskaber opererer i et marked, som ”konstant ændrer sig” på grund af nye teknologier og globale konkurrenter, og fusionen skal dermed gøre dem bedre rustet til at investere i udvikling og ny teknologi indenfor medieanalyse, hedder det.  Fusionen trådte i kraft 28. juni.  <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> Groups <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> <match color='0' ent='301231308'>Martin Ove Rasmussen</match> kalder det for et ”logisk næste skridt” for selskabet.  ”Vi vil kunne drage nytte af begge virksomheders respektive kompetencer og ressourcer og skabe bedre betingelser for sammen at forbedre vores services,” udtaler <match color='0' ent='301231308'>Martin Ove Rasmussen</match> i meddelelsen.  <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match> ejes af det <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='754,112099,179164,664609,3624078,13107770'>TT</match> og det <match color='0' ent='20,46,6256,8932,27479'>norske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='1312586,20,192283,4830453'>NTB</match>.  Der vil blive oprettet et nyt holdingselskab, som vil være ejet i fællesskab af Infomedias ejere - altså <match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match> - og <match color='5'>Retriever</match> Groups ejere.  <match color='0' ent='24088544,30,205375,6581097,17125263'>Rober</match> Söderling, der er <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> for <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>, bliver topchef for det nye selskab, mens <match color='0' ent='301231308'>Martin Ove Rasmussen</match> vil blive en del af den øverste ledelse.  ”Fusionen muliggør de investeringer, der kræves i de kommende år for fortsat at kunne tilbyde de bedste produkter og services til vores kunder,” udtaler <match color='0' ent='80910,30,39631,593644,2919046,6581097'>Robert</match> Söderling i meddelelsen.  (Denne artikel er leveret af <match color='0' ent='310774290'>Kforums</match> søstermedie <match color='0' ent='6806225,431603'>MediaWatch</match>"
  },
  articleimages: {
    count: 1,
    articleimage: [
      {
        caption: {
          matches: !0,
          text: "<p><match color='4'>Infomedia</match> fusionerer med det svenske selskab <match color='5'>Retriever</match>. | Foto: <match color='4'>Infomedia</match>. </p> "
        },
        url: "https://photos.watchmedier.dk/OUt5S9Fd_ZPam0TLhlezKcTb1_TFHrdpJfZnJAATGnM/resize:fill:960:0:0/plain/https%3A%2F%2Fphotos.watchmedier.dk%2FImages%2F17245150%2Fjvl0ok%2FALTERNATES%2Fschema-16_9%2Finfomedia-retriever-png"
      }
    ]
  },
  author: "Susanne Ingemann Terney",
  caption: {
    text: "<p><match color='4'>Infomedia</match> fusionerer med det svenske selskab <match color='5'>Retriever</match>. | Foto: <match color='4'>Infomedia</match>. </p> "
  },
  matches: [
    {
      type: "word",
      color: 4,
      text: "Infomedia"
    },
    {
      type: "word",
      color: 5,
      text: "Retriever"
    },
    {
      type: "word",
      color: 6,
      text: "norske"
    },
    {
      type: "word",
      color: 6,
      text: "Group"
    },
    {
      type: "word",
      color: 6,
      text: "adm. direktør"
    },
    {
      type: "word",
      color: 6,
      text: "Martin Ove Rasmussen"
    },
    {
      type: "word",
      color: 6,
      text: "svenske"
    },
    {
      type: "word",
      color: 6,
      text: "nyhedsbureau"
    },
    {
      type: "word",
      color: 6,
      text: "Berlingske Media"
    },
    {
      type: "word",
      color: 6,
      text: "JP/Politikens Hus"
    },
    {
      type: "word",
      color: 6,
      text: "norsk"
    },
    {
      type: "word",
      color: 6,
      text: "svensk"
    },
    {
      type: "word",
      color: 6,
      text: "TT"
    },
    {
      type: "word",
      color: 6,
      text: "NTB"
    },
    {
      type: "word",
      color: 6,
      text: "Rober"
    },
    {
      type: "word",
      color: 6,
      text: "Robert"
    },
    {
      type: "word",
      color: 6,
      text: "Kforums"
    },
    {
      type: "word",
      color: 6,
      text: "MediaWatch"
    }
  ],
  matches_table: {
    rows: 3,
    columns: 2,
    row: [
      [
        {
          rowspan: 1,
          colspan: 1,
          type: "word",
          color: 4,
          active: !0,
          length: 51,
          removed: 0,
          text: "Infomedia"
        }
      ],
      [
        {
          rowspan: 1,
          colspan: 1,
          type: "word",
          color: 5,
          active: !0,
          length: 46,
          removed: 0,
          text: "Retriever"
        }
      ],
      [
        {
          rowspan: 1,
          colspan: 1,
          type: "word",
          color: 6,
          active: !0,
          length: 33,
          removed: 0,
          text: "norske"
        }
      ],
      [
        {
          rowspan: 1,
          colspan: 1,
          type: "word",
          color: 10,
          active: !0,
          length: 115,
          removed: 0,
          text: "Martin Ove Rasmussen"
        }
      ],
      [
        {
          rowspan: 1,
          colspan: 1,
          type: "word",
          color: 8,
          active: !0,
          length: 30,
          removed: 0,
          text: "Group"
        }
      ],
      [
        {
          rowspan: 1,
          colspan: 1,
          type: "word",
          color: 9,
          active: !0,
          length: 69,
          removed: 0,
          text: "adm. direktør"
        }
      ]
    ]
  },
  quotes: [
    {
      matches: !0,
      text: "<match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match>, fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>. Det oplyser <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> i en pressemeddelelse."
    },
    {
      matches: !0,
      text: "<match color='0' ent='301231308'>Martin Ove Rasmussen</match> i meddelelsen.  <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match> ejes af det <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='754,112099,179164,664609,3624078,13107770'>TT</match> og det <match color='0' ent='20,46,6256,8932,27479'>norske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='1312586,20,192283,4830453'>NTB</match>."
    }
  ],
  colorbar: {
    maxlength: 4009,
    minlength: 1588,
    length: "59.6%",
    item: [
      {
        from: 1,
        to: 11,
        length: "1.2%",
        middle: "1%",
        color: 4,
        quote: {
          matches: !0,
          text: " <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskab Infomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match>"
        }
      },
      {
        from: 10,
        to: 26,
        length: "1.0%",
        middle: "2%",
        color: 0,
        quote: {
          matches: !0,
          text: " <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskab Infomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match>"
        }
      },
      {
        from: 26,
        to: 32,
        length: "0.8%",
        middle: "4%",
        color: 0,
        quote: {
          matches: !0,
          text: " <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskab Infomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> kalder det et ”logisk"
        }
      },
      {
        from: 32,
        to: 40,
        length: "0.8%",
        middle: "5%",
        color: 0,
        quote: {
          matches: !0,
          text: " <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskab Infomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> kalder det et ”logisk"
        }
      },
      {
        from: 40,
        to: 133,
        length: "3.8%",
        middle: "9%",
        color: 1
      },
      {
        from: 133,
        to: 142,
        length: "1.0%",
        middle: "13%",
        color: 5,
        quote: {
          matches: !0,
          text: "næste skridt” for selskabet at fusionere med <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>, der ejes af <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> og <match color='0' ent='20,46,6256,8932,27479'>norsk</match>"
        }
      },
      {
        from: 142,
        to: 191,
        length: "1.8%",
        middle: "15%",
        color: 1
      },
      {
        from: 191,
        to: 235,
        length: "1.6%",
        middle: "18%",
        color: 2
      },
      {
        from: 235,
        to: 244,
        length: "1.0%",
        middle: "20%",
        color: 4,
        quote: {
          matches: !0,
          text: " Medieovervågnings- og analyseselskabet <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match>, der er ejet af <match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske</match>"
        }
      },
      {
        from: 244,
        to: 261,
        length: "0.8%",
        middle: "22%",
        color: 2
      },
      {
        from: 261,
        to: 323,
        length: "2.0%",
        middle: "24%",
        color: 3,
        quote: {
          matches: !0,
          text: "<match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match>, fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>. Det oplyser <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> i en pressemeddelelse."
        }
      },
      {
        from: 323,
        to: 332,
        length: "1.0%",
        middle: "27%",
        color: 5,
        quote: {
          matches: !0,
          text: "<match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match>, fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>. Det oplyser <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> i en pressemeddelelse."
        }
      },
      {
        from: 332,
        to: 352,
        length: "1.0%",
        middle: "28%",
        color: 3,
        quote: {
          matches: !0,
          text: "<match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match>, fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>. Det oplyser <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> i en pressemeddelelse."
        }
      },
      {
        from: 352,
        to: 361,
        length: "1.0%",
        middle: "30%",
        color: 4,
        quote: {
          matches: !0,
          text: "<match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match>, fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>. Det oplyser <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> i en pressemeddelelse."
        }
      },
      {
        from: 361,
        to: 384,
        length: "0.8%",
        middle: "32%",
        color: 3,
        quote: {
          matches: !0,
          text: "<match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match>, fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>. Det oplyser <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> i en pressemeddelelse."
        }
      },
      {
        from: 384,
        to: 703,
        length: "7.8%",
        middle: "39%",
        color: 2
      },
      {
        from: 703,
        to: 712,
        length: "1.0%",
        middle: "46%",
        color: 4,
        quote: {
          matches: !0,
          text: " Fusionen trådte i kraft 28. juni.  <match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> Groups <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> <match color='0' ent='301231308'>Martin Ove Rasmussen</match> kalder"
        }
      },
      {
        from: 712,
        to: 979,
        length: "6.0%",
        middle: "52%",
        color: 2
      },
      {
        from: 979,
        to: 1023,
        length: "1.2%",
        middle: "58%",
        color: 3,
        quote: {
          matches: !0,
          text: "<match color='0' ent='301231308'>Martin Ove Rasmussen</match> i meddelelsen.  <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match> ejes af det <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='754,112099,179164,664609,3624078,13107770'>TT</match> og det <match color='0' ent='20,46,6256,8932,27479'>norske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='1312586,20,192283,4830453'>NTB</match>."
        }
      },
      {
        from: 1023,
        to: 1032,
        length: "1.0%",
        middle: "60%",
        color: 5,
        quote: {
          matches: !0,
          text: "<match color='0' ent='301231308'>Martin Ove Rasmussen</match> i meddelelsen.  <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match> ejes af det <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='754,112099,179164,664609,3624078,13107770'>TT</match> og det <match color='0' ent='20,46,6256,8932,27479'>norske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='1312586,20,192283,4830453'>NTB</match>."
        }
      },
      {
        from: 1032,
        to: 1106,
        length: "1.6%",
        middle: "62%",
        color: 3,
        quote: {
          matches: !0,
          text: "<match color='0' ent='301231308'>Martin Ove Rasmussen</match> i meddelelsen.  <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match> ejes af det <match color='0' ent='34,6256,21195,52062,3624078'>svenske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='754,112099,179164,664609,3624078,13107770'>TT</match> og det <match color='0' ent='20,46,6256,8932,27479'>norske</match> <match color='0' ent='192283,166118,1193236,1331793'>nyhedsbureau</match> <match color='0' ent='1312586,20,192283,4830453'>NTB</match>."
        }
      },
      {
        from: 1106,
        to: 1263,
        length: "3.4%",
        middle: "66%",
        color: 2
      },
      {
        from: 1263,
        to: 1272,
        length: "1.0%",
        middle: "70%",
        color: 5,
        quote: {
          matches: !0,
          text: "- altså <match color='0' ent='3156941,35,2085381'>JP/Politikens Hus</match> og <match color='0' ent='821913,35,11033,2085381'>Berlingske Media</match> - og <match color='5'>Retriever</match> Groups ejere."
        }
      },
      {
        from: 1272,
        to: 1337,
        length: "1.6%",
        middle: "72%",
        color: 2
      },
      {
        from: 1337,
        to: 1346,
        length: "1.0%",
        middle: "74%",
        color: 5,
        quote: {
          matches: !0,
          text: " <match color='0' ent='24088544,30,205375,6581097,17125263'>Rober</match> Söderling, der er <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> for <match color='5' ent='320589777'>Retriever</match> <match color='0' ent='320589777'>Group</match>, bliver topchef for det nye selskab, mens"
        }
      },
      {
        from: 1346,
        to: 1721,
        length: "8.0%",
        middle: "82%",
        color: 2
      },
      {
        from: 1721,
        to: 1725,
        length: "0.8%",
        middle: "89%",
        color: 2
      },
      {
        from: 1725,
        to: 1734,
        length: "1.0%",
        middle: "91%",
        color: 4,
        quote: {
          matches: !0,
          text: " (Denne artikel er leveret af <match color='0' ent='310774290'>Kforums</match> søstermedie <match color='0' ent='6806225,431603'>MediaWatch</match> <match color='4'>Infomedia</match> fusionerer med det svenske selskab <match color='5'>Retriever</match>. | Foto: <match color='4'>Infomedia</match>. "
        }
      },
      {
        from: 1734,
        to: 1770,
        length: "1.0%",
        middle: "92%",
        color: 2
      },
      {
        from: 1770,
        to: 1779,
        length: "1.0%",
        middle: "94%",
        color: 5,
        quote: {
          matches: !0,
          text: "<match color='4'>Infomedia</match> fusionerer med det svenske selskab <match color='5'>Retriever</match>. | Foto: <match color='4'>Infomedia</match>.  "
        }
      },
      {
        from: 1779,
        to: 1789,
        length: "0.8%",
        middle: "96%",
        color: 2
      },
      {
        from: 1789,
        to: 1798,
        length: "1.0%",
        middle: "97%",
        color: 4,
        quote: {
          matches: !0,
          text: "<match color='4'>Infomedia</match> fusionerer med det svenske selskab <match color='5'>Retriever</match>. | Foto: <match color='4'>Infomedia</match>.  "
        }
      },
      {
        from: 1798,
        to: 1805,
        length: "0.8%",
        middle: "99%",
        color: 2
      }
    ]
  },
  url: "http://redir.opoint.com/?key=XqM0qSTdM5NdTrBhTcXB",
  orig_url: "https://kforum.dk/nyheder/nyheder/article17247854.ece",
  url_common: "kforum.dk",
  topics: [
    {
      id: 14,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 2,
      metacat_level: 0,
      text: "Rank 4"
    },
    {
      id: 20,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 3,
      metacat_level: 0,
      text: "Open"
    },
    {
      id: 52,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 5,
      metacat_level: 0,
      text: "Europe"
    },
    {
      id: 151,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 5,
      metacat_level: 1,
      text: "Nordic Counties"
    },
    {
      id: 404,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 9,
      metacat_level: 0,
      text: "Continuously"
    },
    {
      id: 508,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 4,
      metacat_level: 1,
      text: "Net Magazine"
    },
    {
      id: 572,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 4,
      metacat_level: 0,
      text: "Medietype: Editorial Media"
    },
    {
      id: 575,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 6,
      metacat_level: 0,
      text: "Mediatype: Web"
    },
    {
      id: 1074,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 5,
      metacat_level: 2,
      text: "Denmark"
    },
    {
      id: 4605,
      linktype_max: 1,
      linktype_now: 1,
      metacat: 1,
      metacat_level: 0,
      text: "Infomedia feed"
    }
  ],
  screenshots: [],
  exist_in_basket: "",
  topics_and_entities: {
    sentiment: yr.Positive,
    sentiment_score: 0.7971,
    topics: [
      {
        label: "economy, business and finance>products and services>media and entertainment industry",
        mediatopic_id: "20000304",
        score: 0.506
      },
      {
        label: "arts, culture, entertainment and media>mass media",
        mediatopic_id: "20000045",
        score: 0.4579
      },
      {
        label: "arts, culture, entertainment and media>mass media>newspaper",
        mediatopic_id: "20000047",
        score: 0.4144
      },
      {
        label: "politics",
        mediatopic_id: "11000000",
        score: 0.4082
      },
      {
        label: "science and technology",
        mediatopic_id: "13000000",
        score: 0.3623
      },
      {
        label: "arts, culture, entertainment and media>mass media>news media",
        mediatopic_id: "20000046",
        score: 0.3599
      }
    ],
    entities: {
      location: [
        {
          entity: "Norge",
          wikidata_id: "Q20",
          sentiment: yr.Neutral
        },
        {
          entity: "Sverige",
          wikidata_id: "Q34",
          sentiment: yr.Neutral
        }
      ],
      organization: [
        {
          entity: "Sverige",
          wikidata_id: "Q34",
          sentiment: yr.Neutral
        },
        {
          entity: "Berlingske Media",
          wikidata_id: "Q821913"
        },
        {
          entity: "JP/Politikens Hus",
          wikidata_id: "Q3156941"
        },
        {
          entity: "Administrerende direktør",
          wikidata_id: "Q484876"
        },
        {
          entity: "Nyhedsbureau",
          wikidata_id: "Q192283",
          sentiment: yr.Positive
        },
        {
          entity: "Infomedia",
          wikidata_id: "Q12318284"
        },
        {
          entity: "Retriever Group",
          wikidata_id: "Q320589777"
        },
        {
          entity: "Trinidad och Tobago",
          wikidata_id: "Q754",
          sentiment: yr.Positive
        },
        {
          entity: "Norsk Telegrambyrå",
          wikidata_id: "Q1312586",
          sentiment: yr.Positive
        },
        {
          entity: "Kforums",
          wikidata_id: "Q310774290"
        },
        {
          entity: "MediaWatch",
          wikidata_id: "Q6806225"
        }
      ],
      person: [
        {
          entity: "Martin Ove Rasmussen",
          wikidata_id: "Q301231308"
        },
        {
          entity: "Rober Söderling"
        },
        {
          entity: "Robert Söderling"
        },
        {
          entity: "Rober",
          wikidata_id: "Q24088544"
        },
        {
          entity: "Robert",
          wikidata_id: "Q80910"
        }
      ]
    }
  },
  identical_documents: {
    cnt: 1,
    document: [
      {
        id_site: 19854,
        id_article: 59484,
        hidden: !1,
        position: 1,
        equalgroup: 7017626149,
        extract: !0,
        countrycode: "DK",
        countryname: "Denmark",
        site_rank: {
          rank_global: 20254,
          rank_country: 115
        },
        unix_timestamp: 1719826141,
        version_number: 1,
        mediatype: {
          timemap: !1,
          clip: !1,
          hastext: !0,
          haslogo: !1,
          usedlogin: !0,
          paywall: !0,
          fulltext: !0,
          text: "WEB"
        },
        reach: 1415,
        adprice: 2211,
        stimestamp: 427657506,
        stimestamp_index: 427657506,
        internal_search_reply: {
          id_site: 19854,
          id_article: 59484,
          text: "(otb++) 9:268623881:538572809:539869193:537917449:539961353:540000265:536958985:539064329:539215881:537198601:537139209: (otb--)"
        },
        local_time: {
          GMT: 1,
          text: "20240701T11:29:01+0200"
        },
        local_rcf822_time: {
          text: "Mon, 01 Jul 2024 11:29:01 +0200"
        },
        distribute_conditions: "",
        content_protected: 1,
        language: {
          encoding: "iso-639",
          translatable: !0,
          text: "en"
        },
        orig_language: {
          text: "da"
        },
        word_count: 246,
        translated: 1,
        GTranslate_url: "https://translate.google.com/translate?sl=da&tl=en&js=y&prev=_t&hl=en&ie=UTF-8&u=https%3A%2F%2Fmediawatch.dk%2FMedienyt%2Farticle17244961.ece&edit-text=&act=url",
        first_source: {
          id: 117424,
          name: "MediaWatch.dk",
          sitename: "MediaWatch.dk",
          url: "https://mediawatch.dk",
          siteurl: "https://mediawatch.dk"
        },
        almost_identical: [
          {
            id_site: 3208,
            id_article: 20823,
            sim: 99
          }
        ],
        meta_data: {},
        meta_data_pending: !1,
        header: {
          matches: !0,
          text: "<match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskab"
        },
        short_header: {
          matches: !0,
          length: 39,
          removed: 0,
          text: "<match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskab"
        },
        summary: {
          matches: !0,
          text: "Infomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> kalder det et ”logisk næste skridt” for "
        },
        short_summary: {
          matches: !0,
          length: 150,
          removed: 0,
          text: "Infomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> kalder det et ”logisk næste skridt” for "
        },
        body: {
          matches: !0,
          text: ""
        },
        short_body: {
          matches: !0,
          length: 1461,
          removed: 0,
          text: ""
        },
        articleimages: {
          count: 1,
          articleimage: [
            {
              caption: {
                matches: !0,
                text: ""
              },
              url: "https://photos.watchmedier.dk/7BDH3hP3OinoBPlZJFqaTSRUdnLc1oPecVhoDkBCaHY/resize:fill:960:0:0/plain/https%3A%2F%2Fphotos.watchmedier.dk%2FImages%2F17245077%2Fhpguhh%2FALTERNATES%2Fschema-16_9%2Finfomedia-png"
            }
          ]
        },
        caption: {
          text: ""
        },
        matches: [
          {
            type: "word",
            color: 4,
            text: "Infomedia"
          },
          {
            type: "word",
            color: 5,
            text: "Retriever"
          },
          {
            type: "word",
            color: 6,
            text: "norske"
          },
          {
            type: "word",
            color: 6,
            text: "Group"
          },
          {
            type: "word",
            color: 6,
            text: "adm. direktør"
          },
          {
            type: "word",
            color: 6,
            text: "Martin Ove Rasmussen"
          },
          {
            type: "word",
            color: 6,
            text: "svenske"
          },
          {
            type: "word",
            color: 6,
            text: "nyhedsbureau"
          },
          {
            type: "word",
            color: 6,
            text: "Berlingske Media"
          },
          {
            type: "word",
            color: 6,
            text: "JP/Politikens Hus"
          },
          {
            type: "word",
            color: 6,
            text: "norsk"
          },
          {
            type: "word",
            color: 6,
            text: "svensk"
          },
          {
            type: "word",
            color: 6,
            text: "TT"
          },
          {
            type: "word",
            color: 6,
            text: "NTB"
          },
          {
            type: "word",
            color: 6,
            text: "Rober"
          },
          {
            type: "word",
            color: 6,
            text: "Robert"
          }
        ],
        matches_table: {
          rows: 3,
          columns: 2,
          row: [
            [
              {
                rowspan: 1,
                colspan: 1,
                type: "word",
                color: 4,
                active: !0,
                length: 51,
                removed: 0,
                text: "Infomedia"
              }
            ],
            [
              {
                rowspan: 1,
                colspan: 1,
                type: "word",
                color: 5,
                active: !0,
                length: 46,
                removed: 0,
                text: "Retriever"
              }
            ],
            [
              {
                rowspan: 1,
                colspan: 1,
                type: "word",
                color: 6,
                active: !0,
                length: 33,
                removed: 0,
                text: "norske"
              }
            ],
            [
              {
                rowspan: 1,
                colspan: 1,
                type: "word",
                color: 10,
                active: !0,
                length: 115,
                removed: 0,
                text: "Martin Ove Rasmussen"
              }
            ],
            [
              {
                rowspan: 1,
                colspan: 1,
                type: "word",
                color: 8,
                active: !0,
                length: 30,
                removed: 0,
                text: "Group"
              }
            ],
            [
              {
                rowspan: 1,
                colspan: 1,
                type: "word",
                color: 9,
                active: !0,
                length: 69,
                removed: 0,
                text: "adm. direktør"
              }
            ]
          ]
        },
        quotes: [
          {
            matches: !0,
            text: ""
          },
          {
            matches: !0,
            text: ""
          }
        ],
        colorbar: {
          maxlength: 4009,
          minlength: 1588,
          length: "58.2%",
          item: [
            {
              from: 1,
              to: 11,
              length: "1.2%",
              middle: "1%",
              color: 4,
              quote: {
                matches: !0,
                text: "<match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskabInfomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match>"
              }
            },
            {
              from: 10,
              to: 26,
              length: "1.0%",
              middle: "2%",
              color: 0,
              quote: {
                matches: !0,
                text: "<match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskabInfomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match>"
              }
            },
            {
              from: 26,
              to: 32,
              length: "0.8%",
              middle: "4%",
              color: 0,
              quote: {
                matches: !0,
                text: "<match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskabInfomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> kalder det et ”logisk"
              }
            },
            {
              from: 32,
              to: 40,
              length: "0.8%",
              middle: "5%",
              color: 0,
              quote: {
                matches: !0,
                text: "<match color='4' ent='12318284,35,4830453,6881511'>Infomedia</match> fusionerer med <match color='0' ent='34,6256,21195,52062,3624078'>svensk</match> selskabInfomedias <match color='0' ent='484876,1072363,11488158'>adm. direktør</match> kalder det et ”logisk"
              }
            },
            {
              from: 40,
              to: 133,
              length: "3.8%",
              middle: "9%",
              color: 1
            },
            {
              from: 133,
              to: 142,
              length: "1.0%",
              middle: "13%",
              color: 5,
              quote: {
                matches: !0,
                text: "næste skridt” for "
              }
            },
            {
              from: 142,
              to: 191,
              length: "1.8%",
              middle: "16%",
              color: 1
            },
            {
              from: 191,
              to: 235,
              length: "1.6%",
              middle: "19%",
              color: 2
            },
            {
              from: 235,
              to: 244,
              length: "1.0%",
              middle: "21%",
              color: 4,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 244,
              to: 261,
              length: "0.8%",
              middle: "23%",
              color: 2
            },
            {
              from: 261,
              to: 323,
              length: "2.0%",
              middle: "25%",
              color: 3,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 323,
              to: 332,
              length: "1.0%",
              middle: "27%",
              color: 5,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 332,
              to: 352,
              length: "1.0%",
              middle: "29%",
              color: 3,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 352,
              to: 361,
              length: "1.0%",
              middle: "31%",
              color: 4,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 361,
              to: 384,
              length: "0.8%",
              middle: "32%",
              color: 3,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 384,
              to: 703,
              length: "7.8%",
              middle: "40%",
              color: 2
            },
            {
              from: 703,
              to: 712,
              length: "1.0%",
              middle: "47%",
              color: 4,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 712,
              to: 979,
              length: "6.0%",
              middle: "53%",
              color: 2
            },
            {
              from: 979,
              to: 1023,
              length: "1.2%",
              middle: "60%",
              color: 3,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 1023,
              to: 1032,
              length: "1.0%",
              middle: "61%",
              color: 5,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 1032,
              to: 1106,
              length: "1.6%",
              middle: "64%",
              color: 3,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 1106,
              to: 1263,
              length: "3.4%",
              middle: "68%",
              color: 2
            },
            {
              from: 1263,
              to: 1272,
              length: "1.0%",
              middle: "72%",
              color: 5,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 1272,
              to: 1337,
              length: "1.6%",
              middle: "74%",
              color: 2
            },
            {
              from: 1337,
              to: 1346,
              length: "1.0%",
              middle: "76%",
              color: 5,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 1346,
              to: 1653,
              length: "6.6%",
              middle: "83%",
              color: 2
            },
            {
              from: 1653,
              to: 1657,
              length: "0.8%",
              middle: "89%",
              color: 2
            },
            {
              from: 1657,
              to: 1666,
              length: "1.0%",
              middle: "91%",
              color: 4,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 1666,
              to: 1702,
              length: "1.0%",
              middle: "92%",
              color: 2
            },
            {
              from: 1702,
              to: 1711,
              length: "1.0%",
              middle: "94%",
              color: 5,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 1711,
              to: 1721,
              length: "0.8%",
              middle: "96%",
              color: 2
            },
            {
              from: 1721,
              to: 1730,
              length: "1.0%",
              middle: "97%",
              color: 4,
              quote: {
                matches: !0,
                text: ""
              }
            },
            {
              from: 1730,
              to: 1737,
              length: "0.8%",
              middle: "99%",
              color: 2
            }
          ]
        },
        url: "http://redir.opoint.com/?key=rB8A6epWJr48pQaxZnmn",
        orig_url: "https://mediawatch.dk/Medienyt/article17244961.ece",
        url_common: "mediawatch.dk",
        topics: [
          {
            id: 13,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 2,
            metacat_level: 0,
            text: "Rank 3"
          },
          {
            id: 21,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 3,
            metacat_level: 0,
            text: "Restricted"
          },
          {
            id: 22,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 3,
            metacat_level: 1,
            text: "Source Policy"
          },
          {
            id: 24,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 3,
            metacat_level: 2,
            text: "Subscription"
          },
          {
            id: 52,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 5,
            metacat_level: 0,
            text: "Europe"
          },
          {
            id: 151,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 5,
            metacat_level: 1,
            text: "Nordic Counties"
          },
          {
            id: 404,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 9,
            metacat_level: 0,
            text: "Continuously"
          },
          {
            id: 501,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 4,
            metacat_level: 1,
            text: "Newspapers"
          },
          {
            id: 572,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 4,
            metacat_level: 0,
            text: "Medietype: Editorial Media"
          },
          {
            id: 575,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 6,
            metacat_level: 0,
            text: "Mediatype: Web"
          },
          {
            id: 580,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 4,
            metacat_level: 0,
            text: "Coverage: National"
          },
          {
            id: 600,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 1,
            metacat_level: 0,
            text: "Landsdækkende"
          },
          {
            id: 718,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 1,
            metacat_level: 0,
            text: "Telegrambureauer"
          },
          {
            id: 827,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 1,
            metacat_level: 0,
            text: "Nyhedsdistribution"
          },
          {
            id: 829,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 1,
            metacat_level: 0,
            text: "PR, marketing og kommunikation"
          },
          {
            id: 1074,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 5,
            metacat_level: 2,
            text: "Denmark"
          },
          {
            id: 4605,
            linktype_max: 1,
            linktype_now: 1,
            metacat: 1,
            metacat_level: 0,
            text: "Infomedia feed"
          }
        ],
        screenshots: [],
        exist_in_basket: "",
        tags: [],
        topics_and_entities: {
          sentiment: "Positive",
          sentiment_score: 0.7993,
          topics: [
            {
              label: "economy, business and finance>products and services>media and entertainment industry",
              mediatopic_id: "20000304",
              score: 0.506
            },
            {
              label: "arts, culture, entertainment and media>mass media",
              mediatopic_id: "20000045",
              score: 0.4579
            },
            {
              label: "arts, culture, entertainment and media>mass media>newspaper",
              mediatopic_id: "20000047",
              score: 0.4144
            },
            {
              label: "politics",
              mediatopic_id: "11000000",
              score: 0.4082
            },
            {
              label: "science and technology",
              mediatopic_id: "13000000",
              score: 0.3623
            },
            {
              label: "arts, culture, entertainment and media>mass media>news media",
              mediatopic_id: "20000046",
              score: 0.3599
            }
          ],
          entities: {
            location: [
              {
                entity: "Norge",
                wikidata_id: "Q20",
                sentiment: "Neutral"
              },
              {
                entity: "Sverige",
                wikidata_id: "Q34",
                sentiment: "Neutral"
              }
            ],
            organization: [
              {
                entity: "Sverige",
                wikidata_id: "Q34",
                sentiment: "Neutral"
              },
              {
                entity: "Berlingske Media",
                wikidata_id: "Q821913"
              },
              {
                entity: "JP/Politikens Hus",
                wikidata_id: "Q3156941"
              },
              {
                entity: "Administrerende direktør",
                wikidata_id: "Q484876"
              },
              {
                entity: "Nyhedsbureau",
                wikidata_id: "Q192283",
                sentiment: "Neutral"
              },
              {
                entity: "Infomedia",
                wikidata_id: "Q12318284"
              },
              {
                entity: "Retriever Group",
                wikidata_id: "Q320589777"
              },
              {
                entity: "Trinidad och Tobago",
                wikidata_id: "Q754",
                sentiment: "Neutral"
              },
              {
                entity: "Norsk Telegrambyrå",
                wikidata_id: "Q1312586",
                sentiment: "Neutral"
              }
            ],
            person: [
              {
                entity: "Martin Ove Rasmussen",
                wikidata_id: "Q301231308"
              },
              {
                entity: "Rober Söderling"
              },
              {
                entity: "Robert Söderling"
              },
              {
                entity: "Rober",
                wikidata_id: "Q24088544"
              },
              {
                entity: "Robert",
                wikidata_id: "Q80910"
              }
            ]
          }
        }
      }
    ]
  }
}, AV = {
  id_site: 42881,
  id_article: 129418997,
  hidden: !1,
  position: 1,
  unix_timestamp: 1721390401,
  mediatype: {
    timemap: !1,
    clip: !1,
    hastext: !0,
    haslogo: !0,
    paywall: !1,
    fulltext: !0,
    text: "SOCIAL"
  },
  stimestamp: 426093246,
  stimestamp_index: 426093246,
  internal_search_reply: {
    id_site: 42881,
    id_article: 129418997,
    text: "(otb++) 537266188:537407491: (otb--)"
  },
  local_time: {
    GMT: 1,
    text: "20240719T14:00:01+0200"
  },
  local_rcf822_time: {
    text: "Fri, 19 Jul 2024 14:00:01 +0200"
  },
  distribute_conditions: "",
  content_protected: 5,
  language: {
    encoding: "iso-639",
    text: "en"
  },
  word_count: 44,
  first_source: {
    id: 1077116,
    name: "Twitter - UNDESA",
    sitename: "Twitter",
    url: "http://www.twitter.com",
    siteurl: "http://www.twitter.com"
  },
  meta_data: {},
  meta_data_pending: !1,
  header: {
    matches: !0,
    text: "Undesa"
  },
  short_header: {
    matches: !0,
    length: 6,
    removed: 0,
    text: "Undesa"
  },
  summary: {
    matches: !0,
    text: " Forcibly displaced persons reached an unprecedented 120 million in May 2024.  Amid rising conflicts, we need peace and cooperation to alleviate human suffering and promote the <match color='4'>#GlobalGoals</match>."
  },
  short_summary: {
    matches: !0,
    length: 190,
    removed: 0,
    text: " Forcibly displaced persons reached an unprecedented 120 million in May 2024.  Amid rising conflicts, we need peace and cooperation to alleviate human suffering and promote the <match color='4'>#GlobalGoals</match>."
  },
  body: {
    matches: !0,
    text: " <p>Learn more about the current status of #<match color='5'>SDG</match>16: https://t.co/CVdX5HMefN https://t.co/ufOkAnR9td</p>"
  },
  short_body: {
    matches: !0,
    length: 109,
    removed: 0,
    text: " Learn more about the current status of #<match color='5'>SDG</match>16: https://t.co/CVdX5HMefN https://t.co/ufOkAnR9td"
  },
  caption: {
    text: " "
  },
  matches: [
    {
      type: "word",
      color: 4,
      text: "#GlobalGoals"
    },
    {
      type: "word",
      color: 5,
      text: "SDG"
    }
  ],
  matches_table: {
    rows: 2,
    columns: 1,
    row: [
      [
        {
          rowspan: 1,
          colspan: 1,
          type: "word",
          color: 4,
          active: !0,
          length: 68,
          removed: 0,
          text: "#GlobalGoals"
        }
      ],
      [
        {
          rowspan: 1,
          colspan: 1,
          type: "word",
          color: 5,
          active: !0,
          length: 23,
          removed: 0,
          text: "SDG"
        }
      ]
    ]
  },
  quotes: [
    {
      matches: !0,
      text: "Amid rising conflicts, we need peace and cooperation to alleviate human suffering and promote the <match color='4'>#GlobalGoals</match>.  Learn more about the current status"
    }
  ],
  colorbar: {
    maxlength: 308,
    minlength: 308,
    length: "87.8%",
    item: [
      {
        from: 1,
        to: 8,
        length: "4.8%",
        middle: "2%",
        color: 0
      },
      {
        from: 7,
        to: 87,
        length: "33.2%",
        middle: "24%",
        color: 1
      },
      {
        from: 87,
        to: 185,
        length: "29.8%",
        middle: "60%",
        color: 3,
        quote: {
          matches: !0,
          text: "Amid rising conflicts, we need peace and cooperation to alleviate human suffering and promote the <match color='4'>#GlobalGoals</match>.  Learn more about the current status"
        }
      },
      {
        from: 185,
        to: 197,
        length: "3.6%",
        middle: "79%",
        color: 4,
        quote: {
          matches: !0,
          text: "Amid rising conflicts, we need peace and cooperation to alleviate human suffering and promote the <match color='4'>#GlobalGoals</match>.  Learn more about the current status"
        }
      },
      {
        from: 197,
        to: 245,
        length: "14.0%",
        middle: "89%",
        color: 3,
        quote: {
          matches: !0,
          text: "Amid rising conflicts, we need peace and cooperation to alleviate human suffering and promote the <match color='4'>#GlobalGoals</match>.  Learn more about the current status"
        }
      },
      {
        from: 245,
        to: 253,
        length: "2.4%",
        middle: "98%",
        color: 5,
        quote: {
          matches: !0,
          text: " Learn more about the current status of #<match color='5'>SDG</match>16: https://t.co/CVdX5HMefN https://t.co/ufOkAnR9td"
        }
      }
    ]
  },
  url: "https://twitter.com/UNDESA/status/1814268959081808034",
  orig_url: "https://twitter.com/UNDESA/status/1814268959081808034",
  url_common: "twitter.com",
  topics: [
    {
      id: 12,
      linktype_max: 5,
      linktype_now: 0,
      metacat: 2,
      metacat_level: 0,
      text: "Rank 2"
    },
    {
      id: 21,
      linktype_max: 5,
      linktype_now: 0,
      metacat: 3,
      metacat_level: 0,
      text: "Restricted"
    },
    {
      id: 23,
      linktype_max: 5,
      linktype_now: 0,
      metacat: 3,
      metacat_level: 1,
      text: "Opoint Policy"
    },
    {
      id: 27,
      linktype_max: 5,
      linktype_now: 0,
      metacat: 3,
      metacat_level: 2,
      text: "Exclusive"
    },
    {
      id: 404,
      linktype_max: 5,
      linktype_now: 0,
      metacat: 9,
      metacat_level: 0,
      text: "Continuously"
    },
    {
      id: 563,
      linktype_max: 5,
      linktype_now: 0,
      metacat: 6,
      metacat_level: 1,
      text: "SM: Twitter"
    },
    {
      id: 573,
      linktype_max: 5,
      linktype_now: 0,
      metacat: 4,
      metacat_level: 0,
      text: "Medietype: Social Media"
    },
    {
      id: 575,
      linktype_max: 5,
      linktype_now: 0,
      metacat: 6,
      metacat_level: 0,
      text: "Mediatype: Web"
    }
  ],
  screenshots: [],
  social_meta: {
    content_type: "photo",
    author: {
      username: "UNDESA",
      display_name: "UN DESA",
      profile_image: "https://pbs.twimg.com/profile_images/1125385772335607813/wkhguLgJ.png",
      verified: !0
    }
  },
  author: "UNDESA",
  exist_in_basket: "",
  topics_and_entities: {
    sentiment: yr.Neutral,
    sentiment_score: -0.1693,
    topics: [
      {
        label: "politics",
        mediatopic_id: "11000000",
        score: 0.6653
      },
      {
        label: "crime, law and justice>law",
        mediatopic_id: "20000121",
        score: 0.5285
      },
      {
        label: "politics>government policy>migration policy",
        mediatopic_id: "20000634",
        score: 0.516
      },
      {
        label: "crime, law and justice>crime",
        mediatopic_id: "20000082",
        score: 0.4814
      },
      {
        label: "crime, law and justice>law>international law",
        mediatopic_id: "20000126",
        score: 0.4442
      },
      {
        label: "society>immigration",
        mediatopic_id: "20000771",
        score: 0.44
      },
      {
        label: "politics>fundamental rights>human rights",
        mediatopic_id: "20000592",
        score: 0.4133
      },
      {
        label: "politics>international relations>refugees and internally displaced people",
        mediatopic_id: "20000645",
        score: 0.4024
      },
      {
        label: "society>values>ethics",
        mediatopic_id: "20000814",
        score: 0.3748
      },
      {
        label: "science and technology>social sciences>geography",
        mediatopic_id: "20000746",
        score: 0.3727
      }
    ],
    entities: {
      person: [
        {
          entity: "UNDESA"
        }
      ]
    }
  },
  identical_documents: {
    cnt: 0,
    document: []
  }
}, OV = {
  ...Oo,
  identical_documents: {
    cnt: 14,
    document: Array.from({ length: 14 }).map((e, t) => ({
      ...Oo,
      id_site: Oo.id_site + t,
      id_article: Oo.id_article + t,
      first_source: {
        ...Oo.first_source,
        name: Oo.first_source.name
      },
      identical_documents: {
        cnt: 0,
        documents: []
      }
    }))
  }
}, NV = "https://files.opoint.com/imageproxy";
var SI = /* @__PURE__ */ ((e) => (e.PINK = "pink", e.RED = "red", e.TURQUOISE = "turquoise", e.DARKBLUE = "darkblue", e.LIGHTGREEN = "lightgreen", e.GREEN = "green", e.YELLOW = "yellow", e.ORANGE = "orange", e.BLUE = "blue", e))(SI || {}), kI = /* @__PURE__ */ ((e) => (e[e.MODERN = 0] = "MODERN", e[e.SEARCH_ENGINE = 1] = "SEARCH_ENGINE", e[e.EMAIL = 2] = "EMAIL", e[e.ARCHIVE_RIGHT = 3] = "ARCHIVE_RIGHT", e[e.ARCHIVE_LEFT = 4] = "ARCHIVE_LEFT", e[e.INTRO = 5] = "INTRO", e))(kI || {});
const _I = typeof window < "u" ? Ua : Ee;
function RV(e, t, n, r) {
  const o = Z(t);
  _I(() => {
    o.current = t;
  }, [t]), Ee(() => {
    const a = (n == null ? void 0 : n.current) ?? window, i = (s) => {
      o.current(s);
    };
    return a.addEventListener(e, i, r), () => {
      a.removeEventListener(e, i, r);
    };
  }, [e, n, r]);
}
export {
  im as ARTICLE_COLORBAR_OFFSET,
  oy as Alert,
  iy as AlertDescription,
  Vz as AlertDialog,
  rw as AlertDialogAction,
  nw as AlertDialogCancel,
  ow as AlertDialogContent,
  cw as AlertDialogDescription,
  iw as AlertDialogFooter,
  aw as AlertDialogHeader,
  Yp as AlertDialogOverlay,
  tw as AlertDialogPortal,
  sw as AlertDialogTitle,
  Gz as AlertDialogTrigger,
  ay as AlertTitle,
  Kt as ArticleComponentType,
  k2 as ArticleItem,
  n6 as ArticleItemActiveSource,
  o6 as ArticleItemActiveSourceDate,
  L2 as ArticleItemAuthor,
  F2 as ArticleItemContent,
  W2 as ArticleItemContentHead,
  Xp as ArticleItemContext,
  AS as ArticleItemExcerpt,
  DS as ArticleItemImage,
  Qz as ArticleItemMentionsBar,
  FS as ArticleItemSimilarArticlesListing,
  Sv as ArticleItemSource,
  Fu as ArticleItemSourceDate,
  Vs as ArticleItemSourceIcon,
  a6 as ArticleItemSourceRow,
  Wu as ArticleItemSourceText,
  jS as ArticleItemSubtitle,
  IS as ArticleItemTitle,
  E6 as ArticlePreviewAuthor,
  k6 as ArticlePreviewBody,
  T6 as ArticlePreviewExcerpt,
  S6 as ArticlePreviewImage,
  x6 as ArticlePreviewRoot,
  w6 as ArticlePreviewSourceDate,
  $6 as ArticlePreviewTitle,
  pv as ArticleSourceAvatar,
  mv as ArticleSourceAvatarIcon,
  vo as Button,
  Tg as Checkbox,
  hN as Combobox,
  gN as ComboboxContent,
  xN as ComboboxContentEmpty,
  yN as ComboboxContentLoader,
  bN as ComboboxItem,
  vN as ComboboxTrigger,
  dP as DATE_FNS_LOCALES,
  aV as Dialog,
  MN as DialogBody,
  sV as DialogClose,
  NN as DialogContent,
  jN as DialogDescription,
  DN as DialogFooter,
  RN as DialogHeader,
  C0 as DialogOverlay,
  ON as DialogPortal,
  IN as DialogTitle,
  iV as DialogTrigger,
  uV as DropdownMenu,
  I4 as DropdownMenuContent,
  L4 as DropdownMenuItem,
  U4 as DropdownMenuLabel,
  fV as DropdownMenuRadioGroup,
  V4 as DropdownMenuRadioItem,
  B4 as DropdownMenuSeparator,
  F4 as DropdownMenuShortcut,
  mV as DropdownMenuSub,
  W4 as DropdownMenuSubContent,
  H4 as DropdownMenuSubTrigger,
  z4 as DropdownMenuSwitchItem,
  dV as DropdownMenuTrigger,
  gS as FACEBOOK_HASHTAG_URL,
  vS as FACEBOOK_URL,
  hV as Form,
  yM as FormControl,
  vV as FormField,
  vb as FormFieldContext,
  gM as FormItem,
  gb as FormItemContext,
  bM as FormLabel,
  xM as FormMessage,
  am as HighlightedEntity,
  qf as HighlightedMatch,
  Lo as HighlightedMatchesAndEntities,
  xV as HorizontalScrollContent,
  bV as HorizontalScrollLeftButton,
  yV as HorizontalScrollRightButton,
  gV as HorizontalScrollRoot,
  yS as INSTAGRAM_HASHTAG_URL,
  bS as INSTAGRAM_URL,
  xd as Input,
  pb as InputGroup,
  pV as InputLeftElement,
  hb as InputRightElement,
  ri as Label,
  Hr as LayoutModeKey,
  kI as ListingStyle,
  Bo as Loader,
  P$ as MATCH_CLASSNAME,
  NV as MOCK_IMAGE_PROXY_URL,
  Oo as MOCK_REGULAR_ARTICLE,
  OV as MOCK_REGULAR_ARTICLE_MULTIPLE_SOURCES,
  AV as MOCK_SOCIAL_ARTICLE,
  HM as Multi,
  wN as MultiCombobox,
  $N as MultiComboboxContent,
  PN as MultiComboboxContentEmpty,
  CN as MultiComboboxContentLoader,
  SN as MultiComboboxGroup,
  _N as MultiComboboxGroupContent,
  kN as MultiComboboxGroupTitle,
  TN as MultiComboboxItem,
  EN as MultiComboboxTrigger,
  q4 as MultiFilterDropdown,
  X4 as MultiFilterDropdownContent,
  nM as MultiFilterDropdownEmpty,
  Q4 as MultiFilterDropdownGroup,
  eM as MultiFilterDropdownGroupContent,
  J4 as MultiFilterDropdownGroupTitle,
  Z4 as MultiFilterDropdownItem,
  tM as MultiFilterDropdownLoading,
  K4 as MultiFilterDropdownTrigger,
  UM as Pagination,
  zM as PaginationControl,
  VM as PaginationNext,
  BM as PaginationPrevious,
  GM as PillOption,
  MP as Popover,
  jP as PopoverAnchor,
  Nv as PopoverContent,
  IP as PopoverTitle,
  DP as PopoverTrigger,
  ng as RadioGroup,
  Gu as RadioGroupItem,
  R7 as RadioInput,
  pf as SOCIAL_SOURCES,
  fv as SOCIAL_URLS,
  Qs as ScrollArea,
  Js as ScrollAreaViewPort,
  fg as ScrollBar,
  qM as Select,
  KM as SelectContent,
  QM as SelectContentEmpty,
  ZM as SelectContentLoader,
  XM as SelectItem,
  YM as SelectTrigger,
  yr as SentimentType,
  wV as Sheet,
  $V as SheetClose,
  nD as SheetContent,
  iD as SheetDescription,
  oD as SheetFooter,
  rD as SheetHeader,
  aD as SheetTitle,
  EV as SheetTrigger,
  rM as SingleFilterDropdown,
  aM as SingleFilterDropdownContent,
  dM as SingleFilterDropdownEmpty,
  sM as SingleFilterDropdownGroup,
  lM as SingleFilterDropdownGroupContent,
  cM as SingleFilterDropdownGroupTitle,
  iM as SingleFilterDropdownItem,
  uM as SingleFilterDropdownLoading,
  oM as SingleFilterDropdownTrigger,
  PV as StorybookProvider,
  mb as Switch,
  wS as TWITTER_HASHTAG_URL,
  xS as TWITTER_URL,
  sD as Table,
  lD as TableBody,
  pD as TableCaption,
  mD as TableCell,
  uD as TableFooter,
  fD as TableHead,
  cD as TableHeader,
  dD as TableRow,
  SV as Tabs,
  OD as TabsContent,
  PD as TabsList,
  AD as TabsTrigger,
  SI as TagColor,
  ND as Textarea,
  Xb as Toast,
  bI as ToastAction,
  Zb as ToastClose,
  _V as ToastProvider,
  Qb as ToastTitle,
  Kb as ToastViewport,
  CV as Toaster,
  Bs as Tooltip,
  zs as TooltipContent,
  ju as TooltipPortal,
  Xz as TooltipProvider,
  Iu as TooltipTrigger,
  S2 as alterSoMeSummary,
  su as buttonVariants,
  z as cn,
  j4 as dropdownMenuItemVariants,
  Yz as extractIdenticalArticles,
  us as formatDate,
  Kp as fullArticleComponentsConfiguration,
  OS as getAppleIconUrl,
  lu as getArticleIcon,
  Qt as getArticleId,
  du as getArticleMediaTypeForIcon,
  Xa as getArticleSocialSource,
  uh as getArticlesWithSimilarities,
  qz as getIndexOfIdenticalArticleSource,
  Zz as getPreviewThumbnailUrl,
  RS as getProxiedImageUrl,
  uu as getSimilarArticles,
  NS as getThumbnailUrl,
  E2 as hasSimilarArticles,
  vn as isArticleItemComponentEnabled,
  Ka as isSocialArticle,
  EI as reducer,
  w2 as splitBodyTextToParagraphs,
  $I as toast,
  Za as txNativeInstance,
  Rn as useArticleItemContext,
  RV as useEventListener,
  Es as useFormContext,
  Ed as useFormField,
  TI as useToast
};
